import React, { useState, useEffect, useRef, forwardRef } from 'react'
import { Row, Col, Container, Form, Button, Modal, Badge, InputGroup, Table } from 'react-bootstrap'
import Card from '../../../components/Card'
import { useNavigate, useLocation } from 'react-router-dom'
import { apiHandler, getApiErrorMessage } from '../../../api/apihandler';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
    TEACHERS_ASSIGN_GAMES_NAME_API, TEACHERS_GET_ASSIGNED_GAMES_API, TEACHERS_GAME_STATS_API, TEACHERS_LUNCH_PLAN_WAIVER_API,
    TEACHER_GAME_REPORT_LIST,
    TEACHERS_MEDICATION_API, TEACHERS_NON_MEDICATION_API, TEACHERS_PEANUT_POLICY_API, TEACHERS_ROOMS_API,
    TEACHERS_ROOMS_STUDENTS_API, TEACHERS_ROOMS_STUDENTS_ATTENDANCE_API, TEACHERS_ASSIGN_GAME_API, TEACHERS_UNASSIGN_GAME_API,
    TEACHERS_OBSERVATION_API, TEACHERS_OBSERVATION_SAVE_API, TEACHERS_OBSERVATION_PICKER_DATA_API,
    TEACHERS_LEARNING_PATH_GENERATE_API, TEACHERS_LEARNING_PATH_GET_API,
    TEACHERS_LEARNING_PATH_UPDATE_API, TEACHERS_PARENT_REPORT_SEND_EMAIL_API,
    TEACHERS_PARENT_REPORT_POST_TO_FEED_API, DAILY_REPORT_STORE, DAILY_REPORT_VIEW,
    DAILY_REPORT_GENERATE_NOTE, DAILY_REPORT_GENERATE_COMMENT,
    TEACHERS_MEDICATION_LOG_STORE_API, TEACHERS_MEDICATION_LOG_API, TEACHERS_NON_MEDICATION_LOG_STORE_API,
    TEACHERS_NON_MEDICATION_LOG_API, PROFILE_DETAILS, CHILD_REGISTRATION_VIEW,
    ACCIDENT_REPORTS_LIST, ACCIDENT_REPORT_STORE, ACCIDENT_REPORT_DELETE, ACCIDENT_REPORT_SIGNATURE, ACCIDENT_REPORT_SUBMIT,
    ILLNESS_REPORTS_LIST, ILLNESS_REPORT_STORE, ILLNESS_REPORT_DELETE, ILLNESS_REPORT_SIGNATURE, ILLNESS_REPORT_SUBMIT,
    TEACHERS_ROOM_ASSIGN_INFO_API, TEACHERS_ROOM_CANCEL_SWAP_API,
    TEACHERS_ROOM_QUICK_ASSIGN_API, TEACHERS_ROOM_QUICK_SWAP_API
} from "../../../api/constants";
import Moment from 'moment';
import { formatDisplayDate, formatDisplayTime } from '../../../utilities/displayFormat';
import loader from '../../../assets/images/page-img/page-load-loader.gif'
import NoDataFound from '../../../components/noDataFound';
import Swal from 'sweetalert2'
import { useSelector, useDispatch } from 'react-redux';
import SignatureCanvas from 'react-signature-canvas';
import { handleImageUpload } from '../../../api/uploads';
import RegistrationDetailModal from '../../../components/registrationPacket/RegistrationDetailModal';
import DOMPurify from 'isomorphic-dompurify';
import AIContentCreatorModal from '../../../components/ai/AIContentCreatorModal';
import TeacherWeeklyReportModal, { isFailedResponse } from '../../../components/ai/TeacherWeeklyReportModal';
import { getVariableColor } from '../../../utilities/root-var';
import Announcement from '../../../components/announcement';
import AllergyModal from '../../../components/modals/AllergyModal';
import LunchPlanWaiverModal from '../../../components/modals/LunchPlanWaiverModal';
import PeanutPolicyModal from '../../../components/modals/PeanutPolicyModal';
import MedicationModal from '../../../components/modals/MedicationModal';
import NonMedicationModal from '../../../components/modals/NonMedicationModal';
import { isTeacherLoginProfile } from '../../../utilities/teacherModulePermissions';
import { fetchStudentCompletedGames } from '../../../utilities/studentCompletedGames';
import LearningGameCard from '../../../components/common/LearningGameCard';
import '../../../assets/css/student-dashboard.css';

const EMPTY_LEARNING_PATH_FORM = {
    id: null,
    selected_link_ids: [],
    scores: {},
    flags: [],
    celebrate: '',
    nurture: '',
    activities: ''
};

const EMPTY_PARENT_REPORT_FORM = {
    id: null,
    thriving: '',
    focus: '',
    home_activities: '',
    email_sent: 0,
    posted_to_feed: 0
};

// General settings store the school's opening/closing time per weekday as
// plain "HH:mm" strings (e.g. monday_start_time, monday_end_time). Used to
// clamp the time pickers below (attendance check-in/exit, daily report
// diaper/meal/sleep times, accident times) so a teacher can't log something
// as happening outside the school's own hours for that day.
const parseSchoolTimeToDate = (timeStr) => {
    if (!timeStr) return null;
    const parsed = Moment(timeStr, 'HH:mm');
    return parsed.isValid() ? parsed.toDate() : null;
};

const getSchoolHoursRange = (generalSettingsData, forDate) => {
    if (!generalSettingsData) return null;
    const dayName = Moment(forDate || new Date()).format('dddd').toLowerCase();
    const minTime = parseSchoolTimeToDate(generalSettingsData[`${dayName}_start_time`]);
    const maxTime = parseSchoolTimeToDate(generalSettingsData[`${dayName}_end_time`]);
    if (!minTime || !maxTime) return null;
    return { minTime, maxTime };
};

const AttendanceDateTrigger = forwardRef(({ onClick }, ref) => (
    <button type="button" className="att-date-change-btn" onClick={onClick} ref={ref} aria-label="Change Date" title="Change Date">
        <i className="ri-calendar-line"></i>
    </button>
));

AttendanceDateTrigger.displayName = 'AttendanceDateTrigger';

// Shared by the Medication and Non-Medication quick-view modals - a
// student can have several prescriptions on file (past, current, and
// scheduled to start later), so clicking the quick-action button lists all
// of them, ongoing first, before drilling into any one record's details.
// Fixed width/height + borderRadius: '50%' (rather than Bootstrap's
// <Badge>, whose padding/line-height stretches wider than tall for a
// 2-digit number and renders as an oval instead of a circle).
const countBadgeStyle = {
    position: 'absolute',
    top: '-6px',
    right: '-6px',
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    background: '#dc2626',
    color: '#fff',
    fontSize: '9px',
    fontWeight: '700',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
};

const MEDICATION_BUCKET_META = {
    ongoing: { label: 'Ongoing', bg: '#dcfce7', color: '#166534', icon: 'ri-checkbox-circle-fill' },
    upcoming: { label: 'Upcoming', bg: '#fef9c3', color: '#854d0e', icon: 'ri-time-line' },
    past: { label: 'Past', bg: '#f3f4f6', color: '#6b7280', icon: 'ri-history-line' },
};

const MedicationRecordList = ({ records, onSelect }) => {
    if (!records || records.length === 0) {
        return (
            <div style={{ textAlign: 'center', padding: '40px' }}>
                <i className="ri-medicine-bottle-line" style={{ fontSize: '48px', color: '#ccc', marginBottom: '16px' }}></i>
                <p>No records available</p>
            </div>
        );
    }
    return (
        <div>
            {records.map((record) => {
                const meta = MEDICATION_BUCKET_META[record._bucket] || MEDICATION_BUCKET_META.past;
                return (
                    <div key={record.id}
                        onClick={() => onSelect(record)}
                        style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            padding: '12px 16px', marginBottom: '8px', borderRadius: '8px',
                            border: '1px solid #e5e7eb', background: 'white', cursor: 'pointer',
                            transition: 'box-shadow 0.15s ease'
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.boxShadow = 'none'; }}
                    >
                        <div>
                            <div style={{ fontSize: '14px', fontWeight: '700', color: '#111827' }}>
                                {record.medication_name || 'Medication'}
                            </div>
                            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>
                                {formatDisplayDate(record.date_start)}
                                {' - '}
                                {formatDisplayDate(record.date_end)}
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <span style={{
                                fontSize: '11px', fontWeight: '700', padding: '4px 10px', borderRadius: '20px',
                                background: meta.bg, color: meta.color, whiteSpace: 'nowrap'
                            }}>
                                <i className={meta.icon} style={{ marginRight: '4px' }}></i>{meta.label}
                            </span>
                            <i className="ri-arrow-right-s-line" style={{ fontSize: '18px', color: '#9ca3af' }}></i>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

const AttendancePage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    let profileData = useSelector((state) => state.setting.setting.user_data);
    profileData = profileData ? JSON.parse(profileData) : null;
    const isTeacherLogin = isTeacherLoginProfile(profileData);
    let generalSettingsData = useSelector((state) => state.setting.setting.general_settings);
    generalSettingsData = generalSettingsData ? JSON.parse(generalSettingsData) : null;
    const organizationInfo = useSelector((state) => state.setting.setting.organization_info) || {};
    const [students, setStudents] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedDate, setSelectedDate] = useState(new Date());
    const attendanceSchoolHours = getSchoolHoursRange(generalSettingsData, selectedDate);
    const [loading, setLoading] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [rooms, setRooms] = useState([]);
    const [selectedRoom, setSelectedRoom] = useState(null);
    // Room Management modal — lets a teacher move one or more students to a
    // different room (assign) or temporarily swap them with another room
    // (swap), mirroring the assign-info/assign/swap API trio. Shared by both
    // entry points (the per-row "Room" action and the Rooms panel's
    // multi-select "Manage Rooms" action) — roomModalStudents holds whoever
    // it was opened for (one student for the row action, one or more for a
    // checked selection), rather than each entry point having its own
    // separate modal implementation.
    const [showRoomModal, setShowRoomModal] = useState(false);
    const [roomModalStudents, setRoomModalStudents] = useState([]);
    // Which section the modal opens focused on - 'assign' (Move to Room
    // only), 'swap' (Swap Room only), or null (both sections - used by the
    // bulk "Manage Rooms" entry point, where either action can make sense
    // for the selection). The per-row Assign Room/Swap Room buttons pass an
    // explicit mode so each opens on just its own section.
    const [roomModalMode, setRoomModalMode] = useState(null);
    const [roomAssignInfo, setRoomAssignInfo] = useState(null);
    const [roomAssignInfoLoading, setRoomAssignInfoLoading] = useState(false);
    const [roomAssignTargetId, setRoomAssignTargetId] = useState('');
    const [roomSwapMainId, setRoomSwapMainId] = useState('');
    const [roomSwapTargetId, setRoomSwapTargetId] = useState('');
    const [roomSwapNote, setRoomSwapNote] = useState('');
    // 'assign' | 'swap' | false — tracks which action is in-flight so only the
    // button that was clicked shows a spinner.
    const [roomActionSaving, setRoomActionSaving] = useState(false);
    // Disables the Rooms-panel Assign/Swap buttons while a quick-assign/
    // quick-swap loop is running across the checked students.
    const [bulkRoomActionRunning, setBulkRoomActionRunning] = useState(false);
    // Student ids checked via the per-row checkbox for the Rooms panel's
    // Assign/Swap actions — a teacher picks specific students, then acts on
    // just that set (rather than the whole room roster).
    const [roomSelectedStudentIds, setRoomSelectedStudentIds] = useState([]);
    const [scheduleInfo, setScheduleInfo] = useState(null);
    const [hasSchedule, setHasSchedule] = useState(false);
    const [totalStudents, setTotalStudents] = useState(0);
    const [canTakeAttendance, setCanTakeAttendance] = useState(true);
    const [showEmergencyModal, setShowEmergencyModal] = useState(false);
    const [selectedEmergencyContacts, setSelectedEmergencyContacts] = useState([]);
    const [showObservationModal, setShowObservationModal] = useState(false);
    const [observationModalOpening, setObservationModalOpening] = useState(false);
    const [viewDataLoading, setViewDataLoading] = useState(false);
    const [savingDailyReport, setSavingDailyReport] = useState(false);
    const [savingObservation, setSavingObservation] = useState(false);
    const [submittingAccidentReport, setSubmittingAccidentReport] = useState(false);
    const [submittingIllnessReport, setSubmittingIllnessReport] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [observationNotes, setObservationNotes] = useState('');
    const [observationText, setObservationText] = useState('');
    const [showObservationPickerModal, setShowObservationPickerModal] = useState(false);
    const [observationPickerLoading, setObservationPickerLoading] = useState(false);
    const [observationGenerateLoading, setObservationGenerateLoading] = useState(false);
    const [observationCategories, setObservationCategories] = useState([]);
    const [activeObservationCategoryId, setActiveObservationCategoryId] = useState(null);
    const [selectedObservationLinks, setSelectedObservationLinks] = useState([]);
    const [showObservationRegenerateButton, setShowObservationRegenerateButton] = useState(false);
    const [observationPrimaryTab, setObservationPrimaryTab] = useState('observation');
    const [observationActiveTab, setObservationActiveTab] = useState('observation');
    const [hdlhTargetTab, setHdlhTargetTab] = useState('observation');
    const [learningPathLoading, setLearningPathLoading] = useState(false);
    const [learningPathSaving, setLearningPathSaving] = useState(false);
    const [parentReportEmailSending, setParentReportEmailSending] = useState(false);
    const [parentReportFeedPosting, setParentReportFeedPosting] = useState(false);
    const [learningPathData, setLearningPathData] = useState(EMPTY_LEARNING_PATH_FORM);
    const [parentReportData, setParentReportData] = useState(EMPTY_PARENT_REPORT_FORM);
    const [showExitTimeModal, setShowExitTimeModal] = useState(false);
    const [exitTime, setExitTime] = useState('');
    const [showAttendanceTimeModal, setShowAttendanceTimeModal] = useState(false);
    const [attendanceTimeEdit, setAttendanceTimeEdit] = useState('');
    // Individual per-icon save (Present asks for confirmation + editable time,
    // Absent saves immediately) - replaces having to mark everyone then press
    // the separate bulk "Save Attendance" button for that student to count.
    const [showPresentConfirmModal, setShowPresentConfirmModal] = useState(false);
    const [presentConfirmStudent, setPresentConfirmStudent] = useState(null);
    const [presentConfirmTime, setPresentConfirmTime] = useState('');
    const [savingStudentIds, setSavingStudentIds] = useState(new Set());
    const [showDailyReportModal, setShowDailyReportModal] = useState(false);
    const [dailyReportData, setDailyReportData] = useState(null);
    const [showMedicationModal, setShowMedicationModal] = useState(false);
    const [medicationData, setMedicationData] = useState(null);
    // Bucketed/sorted (ongoing -> upcoming -> past) list of every active
    // medication record for the student the modal is open for. Showing the
    // list first (instead of jumping straight to whichever record the
    // backend happened to return) - null shows the list, an id shows that
    // record's detail via medicationData.
    const [medicationRecords, setMedicationRecords] = useState([]);
    const [selectedMedicationRecordId, setSelectedMedicationRecordId] = useState(null);
    const [showNonMedicationModal, setShowNonMedicationModal] = useState(false);
    const [nonMedicationData, setNonMedicationData] = useState(null);
    const [nonMedicationRecords, setNonMedicationRecords] = useState([]);
    const [selectedNonMedicationRecordId, setSelectedNonMedicationRecordId] = useState(null);
    const [showMedicationLogFormModal, setShowMedicationLogFormModal] = useState(false);
    const [showMedicationLogViewModal, setShowMedicationLogViewModal] = useState(false);
    const [selectedMedicationLog, setSelectedMedicationLog] = useState(null);
    const [showNonMedicationLogViewModal, setShowNonMedicationLogViewModal] = useState(false);
    const [selectedNonMedicationLog, setSelectedNonMedicationLog] = useState(null);
    const [showPeanutPolicyModal, setShowPeanutPolicyModal] = useState(false);
    const [peanutPolicyData, setPeanutPolicyData] = useState(null);
    const [showLunchPlanModal, setShowLunchPlanModal] = useState(false);
    const [lunchPlanData, setLunchPlanData] = useState(null);
    const [showGameModal, setShowGameModal] = useState(false);
    const [gameData, setGameData] = useState(null);
    const [gameNames, setGameNames] = useState([]);
    const [selectedGame, setSelectedGame] = useState('');
    const [isAssigningGame, setIsAssigningGame] = useState(false);
    const [unassigningGameIds, setUnassigningGameIds] = useState(new Set());
    const [showGameStatsModal, setShowGameStatsModal] = useState(false);
    const [gameStatsData, setGameStatsData] = useState(null);
    const [gameStatsLoading, setGameStatsLoading] = useState(false);
    // Every learning game the student has completed (all dates), shown under
    // the day's activity in the Game Stats modal.
    const [statsCompletedGames, setStatsCompletedGames] = useState([]);
    const [statsCompletedGamesLoading, setStatsCompletedGamesLoading] = useState(false);
    const [statsCompletedGamesError, setStatsCompletedGamesError] = useState(null);
    // AI weekly game reports for the Game Stats modal's "Weekly Reports" button
    const [weeklyReports, setWeeklyReports] = useState([]);
    const [weeklyReportsLoading, setWeeklyReportsLoading] = useState(false);
    const [showWeeklyReportModal, setShowWeeklyReportModal] = useState(false);
    const weeklyReportsStudentRef = useRef(null);
    const [showObservationViewModal, setShowObservationViewModal] = useState(false);
    const [observationData, setObservationData] = useState(null);
    const [showDailyReportFormModal, setShowDailyReportFormModal] = useState(false);
    const [isEditingDailyReport, setIsEditingDailyReport] = useState(false);
    const [currentDailyReportData, setCurrentDailyReportData] = useState(null);
    const [dailyReportStatusByStudent, setDailyReportStatusByStudent] = useState({});
    const [activeMealTab, setActiveMealTab] = useState(0);
    const [activeViewMealTab, setActiveViewMealTab] = useState(0);
    const [showAllergyModal, setShowAllergyModal] = useState(false);
    const [allergyData, setAllergyData] = useState(null);
    const [showMeditationModal, setShowMeditationModal] = useState(false);
    const [meditationData, setMeditationData] = useState(null);
    const [parentInfoData, setParentInfoData] = useState(null);
    const [showRegistrationModal, setShowRegistrationModal] = useState(false);
    const [registrationData, setRegistrationData] = useState(null);
    const [registrationLoading, setRegistrationLoading] = useState(false);
    const [showAIContentModal, setShowAIContentModal] = useState(false);
    const [aiModalConfig, setAiModalConfig] = useState({
        field: '',
        title: 'AI Content Creation',
        targetLabel: 'content',
        defaultKeywords: ''
    });

    const getReportDate = () => Moment(selectedDate).format('YYYY-MM-DD');

    const ATTENDANCE_ALLOWED_STATUSES = ['present', 'absent', 'on_leave'];
    const TIME_24H_REGEX = /^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/;

    const isStudentOnLeave = (student = {}) => {
        const leaveFlag = student?.is_on_leave;
        const normalizedLeaveFlag =
            leaveFlag === true || leaveFlag === 1 || leaveFlag === '1' || String(leaveFlag).toLowerCase() === 'true';

        return (
            normalizedLeaveFlag ||
            student?.attendance_status === 2 ||
            student?.attendance_status === '2' ||
            student?.attendance === 'on_leave' ||
            student?.status === 'on_leave'
        );
    };

    const isValidAttendanceTime = (value) => {
        if (!value) return true;
        return TIME_24H_REGEX.test(String(value).trim());
    };

    const hydrateLearningPathAndParentReport = (data = {}) => {
        const incomingLearningPath = data?.learning_path || {};
        const incomingParentReport = data?.parent_report || {};
        const selectedLinks = Array.isArray(incomingLearningPath?.selected_link_ids)
            ? incomingLearningPath.selected_link_ids
            : [];

        setLearningPathData({
            id: incomingLearningPath?.id || null,
            selected_link_ids: selectedLinks,
            scores: incomingLearningPath?.scores || {},
            flags: incomingLearningPath?.flags || [],
            celebrate: incomingLearningPath?.celebrate || '',
            nurture: incomingLearningPath?.nurture || '',
            activities: incomingLearningPath?.activities || ''
        });

        setParentReportData({
            id: incomingParentReport?.id || null,
            thriving: incomingParentReport?.thriving || '',
            focus: incomingParentReport?.focus || '',
            home_activities: incomingParentReport?.home_activities || '',
            email_sent: incomingParentReport?.email_sent || 0,
            posted_to_feed: incomingParentReport?.posted_to_feed || 0
        });

        setSelectedObservationLinks(selectedLinks);
    };

    const loadLearningPathAndParentReport = async (studentId, showErrors = false) => {
        if (!studentId) {
            return null;
        }

        setLearningPathLoading(true);
        try {
            const response = await apiHandler(TEACHERS_LEARNING_PATH_GET_API, 'POST', {
                student_id: studentId,
                report_date: getReportDate()
            });

            if (response?.data?.response?.status === 200) {
                const data = response?.data?.data || {};
                if (data?.exists) {
                    hydrateLearningPathAndParentReport(data);
                    return data;
                }
            } else if (showErrors) {
                throw new Error(response?.data?.response?.message || 'Unable to load learning path');
            }
        } catch (error) {
            if (showErrors) {
                Swal.fire({
                    title: 'Error',
                    text: error?.message || 'Failed to load learning path details',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        } finally {
            setLearningPathLoading(false);
        }

        return null;
    };

    // Medication Log Management States
    const [showMedicationLogForm, setShowMedicationLogForm] = useState(false);
    const [isEditingMedicationLog, setIsEditingMedicationLog] = useState(false);
    const [medicationLogData, setMedicationLogData] = useState({
        medication_date: '',
        medication: '',
        is_dosage_given: 1,
        time_given: '',
        staff_signiture: '',
        comments: ''
    });
    const [medicationLogs, setMedicationLogs] = useState([]);
    const [showLogViewModal, setShowLogViewModal] = useState(false);
    const [selectedLog, setSelectedLog] = useState(null);
    const [isLoadingLogs, setIsLoadingLogs] = useState(false);
    
    // Non-Medication Log Management States
    const [showNonMedicationLogFormModal, setShowNonMedicationLogFormModal] = useState(false);
    const [isEditingNonMedicationLog, setIsEditingNonMedicationLog] = useState(false);
    const [nonMedicationLogData, setNonMedicationLogData] = useState({
        medication_date: '',
        medication: '',
        is_dosage_given: 1,
        time_given: '',
        staff_signiture: '',
        comments: ''
    });

    // Signature pad refs
    const medicationSignaturePadRef = useRef(null);
    const nonMedicationSignaturePadRef = useRef(null);

    const [dailyReportFormData, setDailyReportFormData] = useState({
        feeling_id: 1,
        learned: '',
        comments: '',
        diapers: [],
        meals: [],
        sleeps: [],
        bring_diapers: false,
        bring_wipes: false,
        bring_ointment: false,
        bring_clothes: false,
        bring_blanket: false,
        other_item: ''
    });
    const [hasDraft, setHasDraft] = useState(false);
    const [isDraftMode, setIsDraftMode] = useState(false);

    // Draft management functions
    const getDraftKey = (studentId, date) => {
        return `dailyReport_draft_${studentId}_${date}`;
    };

    const saveDraftToLocalStorage = (studentId, date, formData) => {
        const draftKey = getDraftKey(studentId, date);
        const draftData = {
            ...formData,
            savedAt: new Date().toISOString()
        };
        localStorage.setItem(draftKey, JSON.stringify(draftData));
        setHasDraft(true);
        console.log('Draft saved to localStorage:', draftKey, draftData);
    };

    const loadDraftFromLocalStorage = (studentId, date, dailyReportApiData = dailyReportData) => {
        const draftKey = getDraftKey(studentId, date);
        const draftData = localStorage.getItem(draftKey);
        console.log('Attempting to load draft from localStorage:', draftKey);
        if (draftData) {
            try {
                const parsed = JSON.parse(draftData);
                delete parsed.savedAt; // Remove metadata
                setHasDraft(true);
                const normalizedDraft = normalizeDraftDailyReportFormData(parsed, dailyReportApiData);
                console.log('Draft loaded successfully:', normalizedDraft);
                return normalizedDraft;
            } catch (error) {
                console.error('Error parsing draft:', error);
                return null;
            }
        }
        console.log('No draft found in localStorage for key:', draftKey);
        setHasDraft(false);
        return null;
    };

    const clearDraftFromLocalStorage = (studentId, date) => {
        const draftKey = getDraftKey(studentId, date);
        localStorage.removeItem(draftKey);
        setHasDraft(false);
    };

    const checkDraftExists = (studentId, date) => {
        const draftKey = getDraftKey(studentId, date);
        return localStorage.getItem(draftKey) !== null;
    };

    // Accident and Illness Report States
    const [showAccidentReportsModal, setShowAccidentReportsModal] = useState(false);
    const [showIllnessReportsModal, setShowIllnessReportsModal] = useState(false);
    const [accidentReports, setAccidentReports] = useState([]);
    const [illnessReports, setIllnessReports] = useState([]);
    const [loadingAccidentReports, setLoadingAccidentReports] = useState(false);
    const [loadingIllnessReports, setLoadingIllnessReports] = useState(false);
    const [showAccidentSignatureModal, setShowAccidentSignatureModal] = useState(false);
    const [showIllnessSignatureModal, setShowIllnessSignatureModal] = useState(false);
    const [selectedAccidentReport, setSelectedAccidentReport] = useState(null);
    const [selectedIllnessReport, setSelectedIllnessReport] = useState(null);
    const [accidentSignatureDate, setAccidentSignatureDate] = useState('');
    const [illnessSignatureDate, setIllnessSignatureDate] = useState('');
    const accidentSignaturePadRef = useRef(null);
    const illnessSignaturePadRef = useRef(null);

    // Create/Edit Accident Report States
    const [showCreateAccidentModal, setShowCreateAccidentModal] = useState(false);
    const [isEditingAccidentReport, setIsEditingAccidentReport] = useState(false);
    const [editingAccidentReportId, setEditingAccidentReportId] = useState(null);
    const [accidentFormData, setAccidentFormData] = useState({
        classroom: '',
        child_name: '',
        incident_date: '',
        incident_time: '',
        location: '',
        incident_description: '',
        first_aid: '',
        parent_contacted: false,
        parent_contacted_time: '',
        follow_up_information: '',
        staff_name: '',
        staff_position: '',
        existing_staff_signature: '',
        existing_supervisor_signature: ''
    });
    const accidentSchoolHours = getSchoolHoursRange(generalSettingsData, accidentFormData.incident_date);
    const [accidentClassroomOptions, setAccidentClassroomOptions] = useState([]);
    const accidentStaffSignaturePadRef = useRef(null);
    const accidentSupervisorSignaturePadRef = useRef(null);

    // Create/Edit Illness Report States
    const [showCreateIllnessModal, setShowCreateIllnessModal] = useState(false);
    const [isEditingIllnessReport, setIsEditingIllnessReport] = useState(false);
    const [editingIllnessReportId, setEditingIllnessReportId] = useState(null);
    const [illnessFormData, setIllnessFormData] = useState({
        classroom: '',
        student_name: '',
        symptoms: '',
        requested_action_parent: '',
        return_date: '',
        teacher_signature_date: '',
        existing_teacher_signature: ''
    });
    const illnessTeacherSignaturePadRef = useRef(null);

    // Check if attendance can be edited.
    //
    // The date picker only ever lets a teacher land on today or an earlier
    // date (DatePicker maxDate={new Date()} below rules out the future), so
    // every date reachable here is one a teacher should be able to take or
    // backfill attendance for — that's the whole point of supporting past
    // dates. The backend's `canTakeAttendance` flag on the room-students
    // response was written to guard genuinely out-of-window dates, but it
    // was also coming back false for ordinary past dates and locking the
    // whole page into permanent view-only mode even though the save endpoint
    // (TEACHERS_ROOMS_STUDENTS_ATTENDANCE_API) accepts them. So it's no
    // longer treated as a blocker for today/past — it's only still honored
    // as a hard "no" for the one case it can't reach through the UI: a date
    // somehow ending up in the future.
    const canEditAttendance = () => {
        if (Moment(selectedDate).isAfter(Moment(), 'day')) {
            return canTakeAttendance;
        }
        return true;
    };

    const buildAccidentClassroomOptions = (student) => {
        const collectedNames = [];

        const addClassroomName = (value) => {
            if (typeof value !== 'string') return;
            const normalizedValue = value.trim();
            if (!normalizedValue) return;
            if (!collectedNames.includes(normalizedValue)) {
                collectedNames.push(normalizedValue);
            }
        };

        const collectFromSource = (source) => {
            if (!source) return;

            if (Array.isArray(source)) {
                source.forEach(collectFromSource);
                return;
            }

            if (typeof source === 'string') {
                addClassroomName(source);
                return;
            }

            if (typeof source === 'object') {
                addClassroomName(source.classroom);
                addClassroomName(source.class_name);
                addClassroomName(source.room_name);
                addClassroomName(source.name);
                addClassroomName(source.label);
                collectFromSource(source.class);
                collectFromSource(source.room);
                collectFromSource(source.rooms);
                collectFromSource(source.classrooms);
            }
        };

        collectFromSource(student?.classroom);
        collectFromSource(student?.class_name);
        collectFromSource(student?.room_name);
        collectFromSource(student?.class);
        collectFromSource(student?.room);
        collectFromSource(student?.rooms);
        collectFromSource(student?.classrooms);
        collectFromSource(student?.swap_room);

        const selectedRoomName = rooms.find((room) => Number(room.id) === Number(selectedRoom))?.room_name;
        addClassroomName(selectedRoomName);
        addClassroomName(scheduleInfo?.class_name);

        return collectedNames.map((name) => ({ label: name, value: name }));
    };

    // Format time to 12-hour format with AM/PM
    const formatTime = (time) => {
        if (!time) return '';
        return formatDisplayTime(time);
    };

    const DAILY_REPORT_FALLBACK_FEELINGS = [
        { id: 1, name: 'Happy', status: 1 },
        { id: 2, name: 'Sick', status: 1 }
    ];

    const DAILY_REPORT_MEAL_AMOUNT_OPTIONS = [
        { value: 0, label: 'None' },
        { value: 1, label: 'Some' },
        { value: 2, label: 'Half' },
        { value: 3, label: 'Most' },
        { value: 4, label: 'All' },
        { value: 5, label: 'All+' }
    ];

    const normalizeDailyReportTime = (time) => {
        if (!time) return '';
        if (Moment(time, 'HH:mm:ss', true).isValid()) {
            return Moment(time, 'HH:mm:ss').format('HH:mm');
        }
        if (Moment(time, 'HH:mm', true).isValid()) {
            return Moment(time, 'HH:mm').format('HH:mm');
        }
        return '';
    };

    const formatDailyReportApiTime = (time) => {
        if (!time) return '';
        if (Moment(time, 'HH:mm:ss', true).isValid()) {
            return Moment(time, 'HH:mm:ss').format('HH:mm:ss');
        }
        if (Moment(time, 'HH:mm', true).isValid()) {
            return Moment(time, 'HH:mm').format('HH:mm:ss');
        }
        return '';
    };

    const normalizeMealAmount = (mealAmount) => {
        if (typeof mealAmount === 'string') {
            const normalizedLabel = mealAmount.trim().toLowerCase();
            const matchedOption = DAILY_REPORT_MEAL_AMOUNT_OPTIONS.find((option) => option.label.toLowerCase() === normalizedLabel);
            if (matchedOption) {
                return matchedOption.value;
            }
        }

        const amount = Number(mealAmount);
        if (Number.isNaN(amount) || amount < 0) {
            return 0;
        }
        if (amount <= 5) {
            return amount;
        }
        if (amount === 100) {
            return 4;
        }
        if (amount >= 75) {
            return 3;
        }
        if (amount >= 50) {
            return 2;
        }
        if (amount > 0) {
            return 1;
        }
        return 0;
    };

    const getMealAmountLabel = (mealAmount) => {
        return DAILY_REPORT_MEAL_AMOUNT_OPTIONS.find((option) => option.value === normalizeMealAmount(mealAmount))?.label || 'None';
    };

    const getAvailableDailyReportFeelings = (dailyReportApiData = dailyReportData) => {
        const feelings = dailyReportApiData?.all_feelings?.filter((feeling) => feeling?.status === 1) || [];
        return feelings.length > 0 ? feelings : DAILY_REPORT_FALLBACK_FEELINGS;
    };

    const getAvailableWeekMenuMeals = (dailyReportApiData = dailyReportData) => {
        const groupedMeals = dailyReportApiData?.week_menu_meals || [];
        const flattenedMeals = [];

        groupedMeals.forEach((group) => {
            if (Array.isArray(group?.items)) {
                const mealTypeName = group?.menu_type || group?.meal_type || 'Meal';
                const mealTypeId = group?.menu_type_id || group?.meal_type_id || '';

                group.items.forEach((item) => {
                    flattenedMeals.push({
                        ...item,
                        id: item?.menu_meal_id || item?.id,
                        menu_meal_id: item?.menu_meal_id || item?.id,
                        menu_name: item?.menu_name || item?.name || '',
                        meal_type_id: item?.meal_type_id || item?.menu_type_id || mealTypeId,
                        menu_type_id: item?.menu_type_id || mealTypeId,
                        meal_type_name: item?.meal_type_name || mealTypeName,
                        menu_type_name: item?.menu_type_name || mealTypeName,
                        ingredients: item?.ingredients || '',
                        calorie_count: item?.calorie_count || ''
                    });
                });
                return;
            }

            flattenedMeals.push(group);
        });

        return flattenedMeals;
    };

    const getDailyReportDefaultFeelingId = (dailyReportApiData = dailyReportData) => {
        return getAvailableDailyReportFeelings(dailyReportApiData)?.[0]?.id || 1;
    };

    const findWeekMealByIdOrName = (weekMeals = [], meal = {}) => {
        const mealId = meal?.menu_meal_id || meal?.week_menu_meal_id || meal?.menu_meal?.id || meal?.week_menu_meal?.id || meal?.id;
        const idMatch = weekMeals.find((weekMeal) => String(weekMeal?.menu_meal_id || weekMeal?.id) === String(mealId));
        if (idMatch) {
            return idMatch;
        }

        const rawMealName = (meal?.menu_name || meal?.menu?.name || meal?.name || '').trim().toLowerCase();
        const mealName = ['menu item', 'meal', ''].includes(rawMealName) ? '' : rawMealName;
        const rawMealTypeName = (meal?.meal_type_name || meal?.menu_type_name || meal?.menu_type?.name || meal?.menu_type || '').trim().toLowerCase();
        const mealTypeName = ['meal', 'menu type', ''].includes(rawMealTypeName) ? '' : rawMealTypeName;

        if (!mealName) {
            return null;
        }

        return weekMeals.find((weekMeal) => {
            const weekName = (weekMeal?.menu_name || weekMeal?.menu?.name || weekMeal?.name || '').trim().toLowerCase();
            const weekType = (weekMeal?.meal_type_name || weekMeal?.menu_type_name || weekMeal?.menu_type?.name || weekMeal?.menu_type || '').trim().toLowerCase();

            if (weekName !== mealName) {
                return false;
            }

            return !mealTypeName || !weekType || weekType === mealTypeName;
        }) || null;
    };

    const getWeekMealLabel = (weekMeal) => {
        if (!weekMeal) return 'Meal';
        const mealTypeName = weekMeal?.meal_type_name || weekMeal?.menu_type_name || weekMeal?.menu_type?.name || weekMeal?.menu_type || weekMeal?.meal_type?.name || 'Meal';
        const mealName = weekMeal?.menu_name || weekMeal?.menu?.name || weekMeal?.name || 'Menu Item';
        return `${mealTypeName} - ${mealName}`;
    };

    const buildDailyReportMealRow = (weekMeal, existingMeal = {}) => ({
        meal_time: normalizeDailyReportTime(existingMeal.meal_time),
        menu_meal_id: existingMeal.menu_meal_id || weekMeal?.menu_meal_id || weekMeal?.id || '',
        meal_type_id: existingMeal.meal_type_id || weekMeal?.meal_type_id || weekMeal?.menu_type_id || weekMeal?.menu_type?.id || '',
        meal_amount: normalizeMealAmount(existingMeal.meal_amount),
        menu_label: existingMeal.menu_label || getWeekMealLabel(weekMeal),
        menu_name: existingMeal.menu_name || weekMeal?.menu_name || weekMeal?.menu?.name || weekMeal?.name || existingMeal.menu?.name || '',
        meal_type_name: existingMeal.meal_type_name || weekMeal?.meal_type_name || weekMeal?.menu_type_name || weekMeal?.menu_type?.name || existingMeal.menu_type?.name || '',
        ingredients: existingMeal.ingredients || weekMeal?.ingredients || '',
        calorie_count: existingMeal.calorie_count || weekMeal?.calorie_count || ''
    });

    const flattenDailyReportMealEntries = (reportMeals = []) => {
        const flattenedMeals = [];

        (reportMeals || []).forEach((meal) => {
            if (Array.isArray(meal?.items)) {
                const fallbackMealTypeName = meal?.meal_type_name || meal?.menu_type || meal?.menu_type?.name || 'Meal';

                meal.items.forEach((item) => {
                    flattenedMeals.push({
                        ...item,
                        meal_time: item?.meal_time || meal?.meal_time || '',
                        meal_amount: typeof item?.meal_amount === 'undefined' ? meal?.meal_amount : item?.meal_amount,
                        menu_name: item?.menu_name || item?.name || item?.menu?.name || '',
                        menu_meal_id: item?.menu_meal_id || item?.id || '',
                        meal_type_id: item?.meal_type_id || meal?.menu_type_id || meal?.meal_type_id || '',
                        meal_type_name: item?.meal_type_name || fallbackMealTypeName
                    });
                });
                return;
            }

            flattenedMeals.push(meal);
        });

        return flattenedMeals;
    };

    const getDailyReportMealTypeGroups = (reportMeals = []) => {
        const groupsMap = new Map();

        (reportMeals || []).forEach((mealGroup) => {
            if (Array.isArray(mealGroup?.items)) {
                const groupKey = String(mealGroup?.menu_type_id || mealGroup?.meal_type_id || mealGroup?.menu_type || mealGroup?.meal_type || 'meal');
                const groupName = mealGroup?.menu_type || mealGroup?.meal_type || mealGroup?.meal_type_name || 'Meal';

                if (!groupsMap.has(groupKey)) {
                    groupsMap.set(groupKey, {
                        key: groupKey,
                        mealTypeName: groupName,
                        items: []
                    });
                }

                const existingGroup = groupsMap.get(groupKey);
                mealGroup.items.forEach((item) => {
                    existingGroup.items.push({
                        ...item,
                        meal_type_name: item?.meal_type_name || groupName
                    });
                });
                return;
            }

            const fallbackType = mealGroup?.meal_type_name || mealGroup?.menu_type || mealGroup?.menu_meal?.menu_type?.name || mealGroup?.week_menu_meal?.menu_type?.name || mealGroup?.menu_type?.name || 'Meal';
            const groupKey = String(mealGroup?.meal_type_id || mealGroup?.menu_type_id || fallbackType);

            if (!groupsMap.has(groupKey)) {
                groupsMap.set(groupKey, {
                    key: groupKey,
                    mealTypeName: fallbackType,
                    items: []
                });
            }

            groupsMap.get(groupKey).items.push(mealGroup);
        });

        return Array.from(groupsMap.values());
    };

    const getDailyReportFormMealTypeGroups = (formMeals = [], weekMeals = []) => {
        const groupsMap = new Map();

        (formMeals || []).forEach((meal, mealIndex) => {
            const matchedWeekMeal = findWeekMealByIdOrName(weekMeals, meal);
            const mealTypeNameRaw = matchedWeekMeal?.meal_type_name || matchedWeekMeal?.menu_type_name || meal?.meal_type_name || meal?.menu_type_name || meal?.menu_type || 'Meal';
            const mealTypeName = String(mealTypeNameRaw || 'Meal').trim() || 'Meal';
            const mealTypeId = meal?.meal_type_id || matchedWeekMeal?.meal_type_id || matchedWeekMeal?.menu_type_id || mealTypeName;
            const groupKey = String(mealTypeId);

            if (!groupsMap.has(groupKey)) {
                groupsMap.set(groupKey, {
                    key: groupKey,
                    mealTypeName: mealTypeName.toUpperCase(),
                    items: []
                });
            }

            groupsMap.get(groupKey).items.push({
                ...meal,
                _formIndex: mealIndex,
                meal_type_name: mealTypeName.toUpperCase(),
                ingredients: meal?.ingredients || matchedWeekMeal?.ingredients || '',
                calorie_count: meal?.calorie_count || matchedWeekMeal?.calorie_count || ''
            });
        });

        return Array.from(groupsMap.values());
    };

    const isMeaningfulMealEntry = (meal = {}) => {
        if (!meal) return false;

        const hasMealId = !!(meal.menu_meal_id || meal.week_menu_meal_id || meal.menu_meal?.id || meal.week_menu_meal?.id || meal.id);
        const normalizedMealName = String(meal.menu_name || meal.menu?.name || meal.name || '').trim().toLowerCase();
        const normalizedMealType = String(meal.meal_type_name || meal.menu_type_name || meal.menu_type?.name || meal.menu_type || '').trim().toLowerCase();
        const hasMealName = !!normalizedMealName && !['menu item', 'meal'].includes(normalizedMealName);
        const hasMealType = !!normalizedMealType && !['meal', 'menu type'].includes(normalizedMealType);
        const hasMealTime = !!String(meal.meal_time || '').trim();
        const hasAmount = normalizeMealAmount(meal.meal_amount) > 0;

        return hasMealId || hasMealName || (hasMealType && hasMealName) || ((hasMealTime || hasAmount) && hasMealName);
    };

    const normalizeDailyReportMeals = (reportMeals = [], weekMenuMeals = []) => {
        const normalizedSavedMeals = flattenDailyReportMealEntries(reportMeals)
            .filter((meal) => isMeaningfulMealEntry(meal))
            .map((meal) => buildDailyReportMealRow(
                findWeekMealByIdOrName(weekMenuMeals, meal),
                {
                    meal_time: meal.meal_time,
                    menu_meal_id: meal.menu_meal_id || meal.week_menu_meal_id || meal.menu_meal?.id || meal.week_menu_meal?.id || meal.id,
                    meal_type_id: meal.meal_type_id || meal.menu_type_id || meal.menu_meal?.menu_type_id || meal.week_menu_meal?.menu_type_id || meal.menu_type?.id,
                    meal_amount: meal.meal_amount,
                    menu_label: getWeekMealLabel(meal.menu_meal || meal.week_menu_meal || meal),
                    menu_name: meal.menu_name || meal.menu?.name || meal.menu_meal?.menu?.name || meal.week_menu_meal?.menu?.name || meal.name,
                    meal_type_name: meal.meal_type_name || meal.menu_type_name || meal.menu_type?.name || meal.menu_meal?.menu_type?.name || meal.week_menu_meal?.menu_type?.name || meal.menu_type
                }
            ));

        if (!weekMenuMeals.length) {
            return normalizedSavedMeals;
        }

        const mergedMeals = [...normalizedSavedMeals];
        weekMenuMeals.forEach((weekMeal) => {
            const exists = mergedMeals.some((meal) => String(meal.menu_meal_id) === String(weekMeal.menu_meal_id || weekMeal.id));
            if (!exists) {
                mergedMeals.push(buildDailyReportMealRow(weekMeal));
            }
        });

        return mergedMeals;
    };

    const getDailyReportDefaultFormData = (dailyReportApiData = dailyReportData) => ({
        feeling_id: getDailyReportDefaultFeelingId(dailyReportApiData),
        learned: '',
        comments: '',
        diapers: [],
        meals: normalizeDailyReportMeals([], getAvailableWeekMenuMeals(dailyReportApiData)),
        sleeps: [],
        bring_diapers: false,
        bring_wipes: false,
        bring_ointment: false,
        bring_clothes: false,
        bring_blanket: false,
        other_item: ''
    });

    const normalizeDraftDailyReportFormData = (draftData = {}, dailyReportApiData = dailyReportData) => {
        const defaults = getDailyReportDefaultFormData(dailyReportApiData);
        const safeDraft = draftData || {};

        return {
            ...defaults,
            ...safeDraft,
            diapers: Array.isArray(safeDraft.diapers) ? safeDraft.diapers : defaults.diapers,
            meals: normalizeDailyReportMeals(safeDraft.meals || [], getAvailableWeekMenuMeals(dailyReportApiData)),
            sleeps: Array.isArray(safeDraft.sleeps) ? safeDraft.sleeps : defaults.sleeps,
            bring_diapers: !!safeDraft.bring_diapers,
            bring_wipes: !!safeDraft.bring_wipes,
            bring_ointment: !!safeDraft.bring_ointment,
            bring_clothes: !!safeDraft.bring_clothes,
            bring_blanket: !!safeDraft.bring_blanket
        };
    };

    const buildDailyReportFormDataFromReport = (reportData, dailyReportApiData = dailyReportData) => ({
        feeling_id: reportData?.daily_report_fealings?.[0]?.fealing_id || getDailyReportDefaultFeelingId(dailyReportApiData),
        learned: reportData?.learned ? reportData.learned.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ') : '',
        comments: reportData?.comments ? reportData.comments.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ') : '',
        diapers: reportData?.daily_report_diapers?.map((diaper) => ({
            diaper_time: normalizeDailyReportTime(diaper.diaper_time),
            diaper_check: diaper.diaper_check
        })) || [],
        meals: normalizeDailyReportMeals(reportData?.daily_report_meals, getAvailableWeekMenuMeals(dailyReportApiData)),
        sleeps: reportData?.daily_report_sleeps?.map((sleep) => ({
            start_time: normalizeDailyReportTime(sleep.start_time),
            end_time: normalizeDailyReportTime(sleep.end_time)
        })) || [],
        bring_diapers: reportData?.daily_report_bring_mores?.some((item) => item.things === 1) || false,
        bring_wipes: reportData?.daily_report_bring_mores?.some((item) => item.things === 2) || false,
        bring_ointment: reportData?.daily_report_bring_mores?.some((item) => item.things === 3) || false,
        bring_clothes: reportData?.daily_report_bring_mores?.some((item) => item.things === 4) || false,
        bring_blanket: reportData?.daily_report_bring_mores?.some((item) => item.things === 5) || false,
        other_item: reportData?.daily_report_bring_mores?.find((item) => item.things === 6)?.other || ''
    });

    // Helper function to render modal field values
    const renderFieldValue = (key, value) => {
        if (value === null || value === undefined || value === '') {
            return 'N/A';
        }

        // Check if it's an image URL
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg'];
        const isImage = typeof value === 'string' && imageExtensions.some(ext => value.toLowerCase().includes(ext));

        if (isImage || (typeof value === 'string' && (value.includes('http') && (key.toLowerCase().includes('image') || key.toLowerCase().includes('photo') || key.toLowerCase().includes('picture') || key.toLowerCase().includes('signature'))))) {
            return (
                <img
                    src={value}
                    alt={key}
                    style={{
                        maxWidth: '100%',
                        maxHeight: '300px',
                        borderRadius: '8px',
                        objectFit: 'contain',
                        border: '1px solid #dee2e6'
                    }}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = value;
                    }}
                />
            );
        }

        // Check if it's an array
        if (Array.isArray(value)) {
            return (
                <div>
                    {value.map((item, index) => (
                        <div key={index} style={{ marginBottom: '8px', padding: '8px', background: '#ffffff', borderRadius: '6px', border: '1px solid #dee2e6' }}>
                            {typeof item === 'object' ? (
                                Object.entries(item).map(([k, v]) => (
                                    <div key={k} style={{ marginBottom: '4px' }}>
                                        <strong style={{ fontSize: '12px', color: '#6c757d', textTransform: 'capitalize' }}>
                                            {k.replace(/_/g, ' ')}:
                                        </strong>{' '}
                                        <span style={{ fontSize: '13px' }}>{renderFieldValue(k, v)}</span>
                                    </div>
                                ))
                            ) : (
                                <span>{item}</span>
                            )}
                        </div>
                    ))}
                </div>
            );
        }

        // Check if it's an object
        if (typeof value === 'object') {
            return (
                <div style={{ padding: '8px', background: '#ffffff', borderRadius: '6px', border: '1px solid #dee2e6' }}>
                    {Object.entries(value).map(([k, v]) => (
                        <div key={k} style={{ marginBottom: '4px' }}>
                            <strong style={{ fontSize: '12px', color: '#6c757d', textTransform: 'capitalize' }}>
                                {k.replace(/_/g, ' ')}:
                            </strong>{' '}
                            <span style={{ fontSize: '13px' }}>{renderFieldValue(k, v)}</span>
                        </div>
                    ))}
                </div>
            );
        }

        // For regular text values
        return String(value);
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        const initializePage = async () => {
            setLoading(true);
            await loadRooms();
            setLoading(false);
        };
        initializePage();
    }, []);

    useEffect(() => {
        if (selectedRoom && selectedDate) {
            loadAttendanceData();
        }
    }, [selectedDate, selectedRoom]);

    // A checked student only makes sense for the roster currently on screen —
    // drop the selection whenever the room/date being viewed changes so a
    // stale id from a previously viewed room can't get swept into an action.
    useEffect(() => {
        setRoomSelectedStudentIds([]);
    }, [selectedRoom, selectedDate]);

    useEffect(() => {
        if (!students.length || !selectedRoom) {
            setDailyReportStatusByStudent({});
            return;
        }

        fetchDailyReportStatusRows();
    }, [students, selectedDate, selectedRoom]);

    const loadRooms = async () => {
        try {
            const response = await apiHandler(TEACHERS_ROOMS_API, 'POST', {});
            console.log('=== ROOMS API RESPONSE ===');
            console.log('Full Response:', response);
            console.log('Status:', response.data?.response?.status);
            console.log('Rooms Data:', response.data?.data);

            // apiHandler doesn't throw on HTTP errors — its catch(e) resolves
            // with the raw Axios error instead of rejecting, so a real server
            // failure (e.g. 403 permission-denied) still lands here, not in
            // the catch block below. That raw error has no top-level `.data`
            // (the body lives under `.response.data`), so `response.data?...`
            // reads as undefined rather than 200 - detect the real HTTP
            // status first so this surfaces the actual reason instead of
            // silently rendering an empty room list.
            const httpStatus = response?.response?.status;
            if (httpStatus && httpStatus !== 200) {
                const serverMessage = getApiErrorMessage(response, 'Failed to load rooms. Please try again.');
                console.error('✗ Rooms API request failed:', httpStatus, serverMessage);
                Swal.fire({
                    title: httpStatus === 403 ? 'Access Denied' : 'Error',
                    text: serverMessage,
                    icon: httpStatus === 403 ? 'warning' : 'error',
                    confirmButtonText: 'OK',
                });
                return;
            }

            if (response.data?.response?.status === 200) {
                const roomsData = response.data?.data?.rooms || [];
                console.log('✓ Rooms extracted:', roomsData);
                console.log('✓ Number of rooms:', roomsData.length);
                
                setRooms(roomsData);
                
                const hasSelectedRoom = roomsData.some((room) => Number(room.id) === Number(selectedRoom));

                // Auto-select first room if available
                if (roomsData.length > 0 && (!selectedRoom || !hasSelectedRoom)) {
                    console.log('✓ Auto-selecting first room:', roomsData[0].id, roomsData[0].room_name);
                    setSelectedRoom(Number(roomsData[0].id));
                } else if (roomsData.length === 0) {
                    console.warn('⚠ No rooms found in response');
                }
            } else {
                console.error('✗ Room API returned non-200 status:', response.data);
            }
        } catch (error) {
            console.error('✗ ERROR loading rooms:', error);
            console.error('Error stack:', error.stack);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load rooms. Please refresh the page.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    // ---- Room Management (assign / swap) ----------------------------------
    // The assign-info response shape isn't guaranteed field-for-field, so pull
    // a room reference out of whatever object/flat-id-and-name pair is present
    // rather than assuming one exact key — same defensive approach as
    // buildAccidentClassroomOptions above.
    const extractRoomRef = (source) => {
        if (!source || typeof source !== 'object') return null;
        const id = source.id ?? source.room_id ?? null;
        const name = source.room_name ?? source.name ?? source.label ?? null;
        if (id === null && !name) return null;
        return { id: id !== null ? Number(id) : null, name: name || null };
    };

    // assign-info returns the full school-wide room list (not just the rooms
    // this teacher is assigned to, which is all `rooms`/teacher-rooms gives
    // us) — mirrors the same normalization the mobile app uses for its Room
    // picker. Falls back to the teacher's own room list wherever this is
    // missing/empty so the picker still works if the backend omits it.
    const normalizeRoomsList = (list) => {
        if (!Array.isArray(list)) return [];
        return list
            .map((room) => {
                const id = room?.id ?? room?.room_id;
                if (id === undefined || id === null) return null;
                return { id: Number(id), room_name: room.room_name || room.name || room.label || `Room ${id}` };
            })
            .filter(Boolean);
    };

    const parseRoomAssignInfo = (data) => {
        if (!data || typeof data !== 'object') {
            return { mainRoom: null, swapRoom: null, isSwapped: false, allRooms: [], allSwapRooms: [] };
        }

        const mainRoom =
            extractRoomRef(data.main_room) ||
            extractRoomRef(data.current_room) ||
            extractRoomRef(data.room) ||
            extractRoomRef(data.assigned_room) ||
            (data.main_room_id || data.room_id || data.main_room_name || data.room_name
                ? { id: (data.main_room_id ?? data.room_id) !== undefined ? Number(data.main_room_id ?? data.room_id) : null, name: data.main_room_name || data.room_name || null }
                : null);

        const swapRoom =
            extractRoomRef(data.swap_room) ||
            extractRoomRef(data.swapped_room) ||
            (data.swap_room_id || data.swap_room_name
                ? { id: data.swap_room_id !== undefined ? Number(data.swap_room_id) : null, name: data.swap_room_name || null }
                : null);

        const isSwapped = Boolean(data.is_swapped ?? data.swapped ?? (swapRoom && data.status === 'swapped'));
        const allRooms = normalizeRoomsList(data.rooms);
        // Swap deliberately gets the full, unrestricted room list rather than
        // the grade-scoped `rooms` above - see the comment on getAssignRoomInfo
        // in AttendanceController.ts for why (grade-scoping made "Swap With"
        // come back empty in the common case of a grade mapping to only the
        // student's own room). Falls back to the grade-scoped list if the
        // backend didn't send it, so this still degrades gracefully.
        const allSwapRooms = normalizeRoomsList(data.swap_rooms).length
            ? normalizeRoomsList(data.swap_rooms)
            : allRooms;

        return { mainRoom, swapRoom, isSwapped, allRooms, allSwapRooms };
    };

    // Loads the grade-scoped room list + "current room"/swap status for the
    // modal. The current-room/swap-status display is always the first
    // (primary) student's — with more than one student selected, the room
    // list is the union of every selected student's grade-scoped rooms (so
    // a room only disappears from the picker if it doesn't fit ANY of them),
    // since a bulk selection can span more than one grade even though they
    // were all checked from the same room's roster.
    const loadRoomAssignInfoForStudents = async (targetStudents) => {
        const primary = targetStudents[0];
        let primaryInfo = { mainRoom: null, swapRoom: null, isSwapped: false, allRooms: [], allSwapRooms: [] };
        try {
            const response = await apiHandler(TEACHERS_ROOM_ASSIGN_INFO_API, 'POST', { student_id: primary.id });
            if (response.data?.response?.status === 200) {
                primaryInfo = parseRoomAssignInfo(response.data?.data);
            }
        } catch (error) {
            console.error('Error loading room assignment info:', error);
        }

        if (targetStudents.length === 1) {
            return primaryInfo;
        }

        // Fetch and union BOTH room lists for every other selected student -
        // an earlier version of this only unioned `rooms` (the assign list),
        // leaving `allSwapRooms` as just the first (primary) student's list.
        // For a bulk Swap Room action across students spanning more than one
        // class/grade, that silently dropped rooms valid for everyone except
        // the primary student from the "Swap With" picker.
        const extraInfoLists = await Promise.all(
            targetStudents.slice(1).map((student) =>
                apiHandler(TEACHERS_ROOM_ASSIGN_INFO_API, 'POST', { student_id: student.id })
                    .then((res) => ({
                        rooms: normalizeRoomsList(res.data?.data?.rooms),
                        swapRooms: normalizeRoomsList(res.data?.data?.swap_rooms),
                    }))
                    .catch(() => ({ rooms: [], swapRooms: [] }))
            )
        );

        const roomMap = new Map();
        [...primaryInfo.allRooms, ...extraInfoLists.flatMap((info) => info.rooms)]
            .forEach((room) => roomMap.set(room.id, room));

        const swapRoomMap = new Map();
        [...primaryInfo.allSwapRooms, ...extraInfoLists.flatMap((info) => info.swapRooms)]
            .forEach((room) => swapRoomMap.set(room.id, room));

        return {
            ...primaryInfo,
            allRooms: Array.from(roomMap.values()),
            allSwapRooms: Array.from(swapRoomMap.values()),
        };
    };

    const closeRoomModal = () => {
        if (roomActionSaving) return;
        setShowRoomModal(false);
        setRoomModalStudents([]);
        setRoomAssignInfo(null);
        setRoomAssignTargetId('');
        setRoomSwapMainId('');
        setRoomSwapTargetId('');
        setRoomSwapNote('');
    };

    // Opens the shared Room Management modal for one student (the per-row
    // Assign Room/Swap Room actions) or several (the Rooms panel's
    // checked-selection Assign Room/Swap Room actions) — both entry points
    // pass an explicit mode ('assign' | 'swap') so the modal opens focused
    // on just that one section; mode defaults to null (both sections) only
    // as a fallback for any future caller that doesn't specify one.
    const openRoomModal = async (studentOrStudents, mode = null) => {
        const targetStudents = Array.isArray(studentOrStudents) ? studentOrStudents : [studentOrStudents];
        if (!targetStudents.length) return;

        if (!isToday(selectedDate)) {
            Swal.fire({
                title: 'Not Allowed',
                text: 'Room assignment can only be changed for today.',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        setRoomModalStudents(targetStudents);
        setRoomModalMode(mode);
        setRoomAssignInfo(null);
        setRoomAssignTargetId('');
        setRoomSwapTargetId('');
        setRoomSwapNote('');
        setRoomSwapMainId(selectedRoom ? String(selectedRoom) : '');
        setShowRoomModal(true);
        setRoomAssignInfoLoading(true);

        try {
            const info = await loadRoomAssignInfoForStudents(targetStudents);
            setRoomAssignInfo(info);
            // Only fall back to the primary student's own backend-reported
            // "main room" if there's no currently-selected room to go by -
            // selectedRoom is the room every one of these students was
            // actually selected from (the room being managed right now),
            // which is what a swap should always be FROM. Letting
            // info.mainRoom.id override an already-valid selectedRoom could
            // show the wrong "Main Room" whenever the primary student's
            // backend main-room field doesn't match the room they're
            // currently being viewed in (e.g. an existing swap in effect).
            if (!selectedRoom && info.mainRoom?.id) {
                setRoomSwapMainId(String(info.mainRoom.id));
            }
        } finally {
            setRoomAssignInfoLoading(false);
        }
    };

    // Opens the shared modal for the students checked via the Rooms panel's
    // per-row checkboxes (the old Assign/Swap toolbar buttons each opened
    // their own separate SweetAlert form — now both actions live in the one
    // modal, same as the per-row entry point). Takes an explicit mode
    // ('assign' | 'swap') so the "Assign Room"/"Swap Room" buttons below
    // open the modal focused on just that one section, the same as the
    // per-row Assign Room/Swap Room buttons already do for a single student.
    const openRoomModalForSelected = (mode) => {
        const targetStudents = students.filter((student) => roomSelectedStudentIds.includes(student.id));
        if (!targetStudents.length) {
            Swal.fire({ title: 'No Students Selected', text: 'Please select at least one student first.', icon: 'info', confirmButtonText: 'OK' });
            return;
        }
        openRoomModal(targetStudents, mode);
    };

    // Loops the lightweight quick-assign/quick-swap endpoints across
    // whichever students the modal is open for (one for the per-row action,
    // one or more for a checked selection). Runs sequentially so a slow/
    // failing request for one student can't stall or corrupt the requests
    // for the rest, and so the success/fail tally stays accurate. Shared by
    // submitRoomAssign/submitRoomSwap below, so the single-student and
    // bulk-selection cases go through identical save/error/refresh logic.
    const runBulkRoomAction = async (mode, extraParams, targetStudents) => {
        if (!targetStudents.length) return;

        setBulkRoomActionRunning(true);
        setRoomActionSaving(mode);
        const api = mode === 'assign' ? TEACHERS_ROOM_QUICK_ASSIGN_API : TEACHERS_ROOM_QUICK_SWAP_API;
        let successCount = 0;
        let failCount = 0;
        let firstErrorMessage = '';

        for (const student of targetStudents) {
            try {
                const response = await apiHandler(api, 'POST', { student_id: student.id, ...extraParams });
                if (response.data?.response?.status === 200) {
                    successCount += 1;
                } else {
                    failCount += 1;
                    firstErrorMessage = firstErrorMessage
                        || response.data?.data?.message
                        || response.data?.response?.message
                        || '';
                }
            } catch (error) {
                console.error(`Error running bulk room ${mode} for student`, student.id, error);
                failCount += 1;
            }
        }

        setBulkRoomActionRunning(false);
        setRoomActionSaving(false);
        setRoomSelectedStudentIds([]);

        const actionLabel = mode === 'assign' ? 'assign' : 'swap';
        const isSingleStudent = successCount + failCount === 1;
        Swal.fire({
            title: failCount === 0 ? 'Success!' : (successCount === 0 ? 'Error' : 'Completed With Errors'),
            text: isSingleStudent
                ? (failCount === 0
                    ? `Room ${actionLabel === 'assign' ? 'assigned' : 'swapped'} successfully!`
                    : (firstErrorMessage || `Failed to ${actionLabel} room`))
                : `${successCount} student${successCount !== 1 ? 's' : ''} updated successfully${failCount ? `, ${failCount} failed` : ''}.`,
            icon: failCount === 0 ? 'success' : (successCount === 0 ? 'error' : 'warning'),
            timer: failCount === 0 ? 2000 : undefined,
            showConfirmButton: failCount !== 0,
            confirmButtonText: 'OK'
        });

        if (successCount > 0) {
            closeRoomModal();
        }

        // Intentionally not calling loadRooms() here — the set of rooms
        // doesn't change from assigning/swapping a student, and re-fetching
        // teacher-rooms right after this action can come back scoped to
        // just the acted-on room, wiping the room chips list. Just refresh
        // the roster for the room currently being viewed.
        await loadAttendanceData();
    };

    const submitRoomAssign = async () => {
        if (!roomModalStudents.length || !roomAssignTargetId) return;
        await runBulkRoomAction('assign', { room_id: Number(roomAssignTargetId) }, roomModalStudents);
    };

    const submitRoomSwap = async () => {
        if (!roomModalStudents.length || !roomSwapMainId || !roomSwapTargetId) return;

        if (String(roomSwapMainId) === String(roomSwapTargetId)) {
            Swal.fire({
                title: 'Invalid Selection',
                text: 'Main room and swap room must be different.',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        await runBulkRoomAction(
            'swap',
            { main_room_id: Number(roomSwapMainId), swap_room_id: Number(roomSwapTargetId), note: roomSwapNote || '' },
            roomModalStudents
        );
    };

    // Undoes an active swap (mistaken room, changed plans, ...), putting the
    // student back in their main room for the day. Only offered when the
    // modal is open for exactly one student — "which swap?" is ambiguous
    // for a bulk selection. Confirms first since this immediately changes
    // where the student is recorded for the rest of today - a stray click
    // shouldn't silently undo an intentional swap.
    const cancelRoomSwap = async () => {
        const student = roomModalStudents.length === 1 ? roomModalStudents[0] : null;
        if (!student) return;

        const confirmResult = await Swal.fire({
            title: 'Cancel this swap?',
            text: `${student.name || 'This student'} will be moved back to their main room.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, cancel swap',
            cancelButtonText: 'No, keep it',
            confirmButtonColor: '#dc2626',
            cancelButtonColor: '#95a5a6'
        });
        if (!confirmResult.isConfirmed) return;

        setRoomActionSaving('cancel-swap');
        try {
            const response = await apiHandler(TEACHERS_ROOM_CANCEL_SWAP_API, 'POST', {
                student_id: student.id
            });

            if (response.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Swap Cancelled',
                    text: response.data?.data?.message || 'Room swap cancelled successfully!',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                closeRoomModal();
                await loadAttendanceData();
            } else {
                Swal.fire({
                    title: 'Error',
                    text: response.data?.data?.message || response.data?.response?.message || 'Failed to cancel room swap',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error cancelling room swap:', error);
            const apiError = error?.response?.data;
            Swal.fire({
                title: 'Error',
                text: apiError?.data?.message || apiError?.response?.message || 'Failed to cancel room swap',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setRoomActionSaving(false);
        }
    };

    // Selection helpers for the Rooms panel's checkbox multi-select, feeding
    // openRoomModalForSelected (defined above, alongside openRoomModal).
    const toggleRoomStudentSelection = (studentId) => {
        setRoomSelectedStudentIds((prev) =>
            prev.includes(studentId) ? prev.filter((id) => id !== studentId) : [...prev, studentId]
        );
    };

    const toggleSelectAllForRoom = () => {
        const visibleIds = filteredStudents.map((student) => student.id);
        const allSelected = visibleIds.length > 0 && visibleIds.every((id) => roomSelectedStudentIds.includes(id));
        setRoomSelectedStudentIds(allSelected ? [] : visibleIds);
    };

    const loadAttendanceData = async () => {
        if (!selectedRoom) return;

        setLoading(true);
        try {
            // Use the same local-calendar-date formatting as getReportDate()
            // everywhere a date is sent/keyed off selectedDate — .toISOString()
            // converts to UTC first, which silently rolls the date backward or
            // forward a day for any timezone offset once the local time is
            // near midnight, so the backend (and localStorage cache) can end
            // up keyed to a different date than the one the teacher actually
            // has open on screen.
            const requestPayload = {
                room_id: selectedRoom,
                attendance_date: getReportDate()
            };
            // Add optional parameters if available
            if (profileData?.id || profileData?.user_id) {
                requestPayload.teacher_id = profileData?.id || profileData?.user_id;
            }
            if (profileData?.class_id || profileData?.class?.id) {
                requestPayload.class_id = profileData?.class_id || profileData?.class?.id;
            }
            console.log('Loading attendance with payload:', requestPayload);
            
            const response = await apiHandler(TEACHERS_ROOMS_STUDENTS_API, 'POST', requestPayload);

            if (response.data?.response?.status === 200) {
                const studentsData = response.data?.data?.students || [];
                console.log('Raw students data from API:', studentsData);
                
                // Check if we have cached attendance data
                const cacheKey = `attendance_${selectedRoom}_${getReportDate()}`;
                const cachedAttendance = localStorage.getItem(cacheKey);
                const attendanceCache = cachedAttendance ? JSON.parse(cachedAttendance) : {};
                console.log('Loaded attendance from localStorage:', cacheKey, attendanceCache);
                
                const mappedStudents = studentsData.map(student => {
                    console.log('Processing student:', student.name, 'Raw attendance_status:', student.attendance_status);
                    
                    // Normalize on-leave values to avoid API shape differences.
                    const isOnLeave = isStudentOnLeave(student);
                    
                    // Check multiple possible field names for attendance status.
                    // Use ?? instead of || here: attendance_status can legitimately be 0
                    // (absent), and 0 is falsy, so || would skip past it and lose the value.
                    let attendanceStatus = student.attendance_status ?? student.attendance ?? student.status;
                    let attendanceTime = student.attendance_time;
                    let exitTime = student.exit_time;
                    
                    // If API returns null but we have cached data, use it
                    if (attendanceCache[student.id] && !attendanceStatus && !student.attendance_time) {
                        console.log('Using cached attendance for', student.name, attendanceCache[student.id]);
                        attendanceStatus = attendanceCache[student.id].attendance === 'present' ? 1 : 0;
                        attendanceTime = attendanceCache[student.id].attendance_time;
                        exitTime = attendanceCache[student.id].exit_time;
                    }

                    // If status is numeric (0 or 1), convert to text
                    if (attendanceStatus === 1 || attendanceStatus === '1') {
                        attendanceStatus = 'present';
                    } else if (attendanceStatus === 0 || attendanceStatus === '0') {
                        attendanceStatus = 'absent';
                    } else if (attendanceStatus === 2 || attendanceStatus === '2') {
                        attendanceStatus = 'on_leave';
                    }

                    // If no status but has attendance_time, it means attendance was marked as present
                    if (!attendanceStatus && student.attendance_time) {
                        attendanceStatus = 'present';
                    }

                    // Whether this student already has a real, teacher-set status at
                    // this point (from the API or a saved cache) versus is about to
                    // fall back to the "absent" default below. The Present/Absent
                    // buttons use this to stay neutral for a student nobody has
                    // actually marked yet - otherwise every unmarked student loads
                    // with its Absent button already showing full red/active, so
                    // clicking Absent on it produces no visible change at all.
                    const hasConfirmedStatus = Boolean(attendanceStatus);

                    // Default to absent only if no status is provided and not on leave
                    if (!attendanceStatus && !isOnLeave) {
                        attendanceStatus = 'absent';
                    } else if (isOnLeave && !attendanceStatus) {
                        attendanceStatus = 'on_leave';
                    }

                    // Ensure valid status
                    if (!ATTENDANCE_ALLOWED_STATUSES.includes(attendanceStatus)) {
                        console.log('Invalid attendance status for student:', student.name, 'Status:', attendanceStatus);
                        attendanceStatus = 'absent';
                    }

                    // The backend can send a stale/default attendance_time and exit_time
                    // (e.g. "00:00:00") even for a student who is not present - trust the
                    // resolved status, not whatever raw time value came back, so an
                    // absent/on-leave student never displays a check-in or exit time.
                    if (attendanceStatus !== 'present') {
                        attendanceTime = null;
                        exitTime = null;
                    }

                    console.log('Final mapped status for', student.name, ':', attendanceStatus);

                    return {
                        id: student.id,
                        name: student.name,
                        rollNumber: `ST${String(student.id).padStart(3, '0')}`,
                        avatar: student.photo || "https://uzone360live.s3.amazonaws.com/noimage.png",
                        attendance: attendanceStatus,
                        attendance_confirmed: hasConfirmedStatus || isOnLeave,
                        attendance_time: attendanceTime,
                        exit_time: exitTime,
                        has_medication: student.has_medication,
                        has_non_medication: student.has_non_medication,
                        medication_count: student.medication_count || 0,
                        non_medication_count: student.non_medication_count || 0,
                        lunch_plan_waiver_id: student.lunch_plan_waiver_id,
                        peanut_policy_id: student.peanut_policy_id,
                        allergy_report_id: student.allergy_report_id,
                        emergency_contacts: student.emergency_contacts || [],
                        classroom: student.classroom,
                        class_name: student.class_name,
                        room_name: student.room_name,
                        class: student.class,
                        room: student.room,
                        rooms: student.rooms,
                        classrooms: student.classrooms,
                        swap_room: student.swap_room,
                        is_on_leave: isOnLeave,
                        daily_report_status: student.daily_report_status
                    };
                });

                setStudents(mappedStudents);
                setTotalStudents(response.data?.data?.total || 0);
                setHasSchedule(response.data?.data?.hasSchedule || false);
                setScheduleInfo(response.data?.data?.scheduleInfo || null);
                setCanTakeAttendance(response.data?.data?.canTakeAttendance !== undefined ? response.data?.data?.canTakeAttendance : true);
            } else {
                setStudents([]);
                setTotalStudents(0);
            }
        } catch (error) {
            console.error('Error loading attendance:', error);
            setStudents([]);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load students',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (date) => {
        return date.toLocaleDateString('en-US', {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const openStudentProfile = (student) => {
        const studentIdentifier = student?.profileSlug || student?.id;
        if (!studentIdentifier) return;
        navigate(`/dashboard/app/friend-profile/${studentIdentifier}`);
    };

    // Superseded by saveSingleAttendance (defined below saveAttendance) - the
    // Present/Absent icons now persist immediately instead of only mutating
    // local state, so this local-only mutator is no longer called.

    const saveAttendance = async () => {
        // Validate that can take attendance
        if (!canEditAttendance()) {
            Swal.fire({
                title: 'Not Allowed',
                text: 'You cannot save attendance for this date. This is view-only mode.',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#FFA500'
            });
            return;
        }

        if (!selectedRoom) {
            Swal.fire({
                title: 'Warning',
                text: 'Please select a room first',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        if (students.length === 0) {
            Swal.fire({
                title: 'Warning',
                text: 'No students to save attendance for',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        if (!selectedDate || !Moment(selectedDate).isValid()) {
            Swal.fire({
                title: 'Warning',
                text: 'Please select a valid attendance date',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        const invalidStudents = students
            .filter((student) => !isStudentOnLeave(student))
            .filter((student) => !['present', 'absent'].includes(student.attendance));

        if (invalidStudents.length > 0) {
            Swal.fire({
                title: 'Validation Error',
                text: 'Some students have invalid attendance status. Please re-mark and try again.',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        try {
            setLoading(true);

            // Map students to attendance array with proper status values, excluding students on leave
            const attendanceArray = students
                .filter(student => !isStudentOnLeave(student)) // Exclude students on leave
                .map(student => ({
                    student_id: student.id,
                    status: student.attendance === 'present' ? 1 : 0,
                    // Only stamp an attendance time for present students - an absent
                    // student was never checked in, so this must stay null instead of
                    // falling back to the current time.
                    attendance_time: student.attendance === 'present'
                        ? (student.attendance_time || Moment().format('HH:mm:ss'))
                        : null,
                    // Exit time only makes sense for a student who actually attended.
                    exit_time: student.attendance === 'present' ? (student.exit_time || null) : null
                }));

            const hasInvalidTime = attendanceArray.some((item) =>
                !isValidAttendanceTime(item.attendance_time) || !isValidAttendanceTime(item.exit_time)
            );

            if (hasInvalidTime) {
                setLoading(false);
                Swal.fire({
                    title: 'Validation Error',
                    text: 'Attendance or exit time format is invalid. Please use HH:mm or HH:mm:ss.',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                return;
            }

            // Validate attendance array
            if (attendanceArray.length === 0) {
                setLoading(false);
                Swal.fire({
                    title: 'Warning',
                    text: 'No active students to save attendance for',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                return;
            }

            // Prepare payload with fallback values - use scheduleInfo class_id if available
            const payload = {
                class_id: scheduleInfo?.class_id || profileData?.class_id || profileData?.class?.id || 1,
                room_id: selectedRoom,
                teacher_id: profileData?.id || profileData?.user_id || 1,
                attendance_date: getReportDate(),
                attendance: attendanceArray
            };

            const response = await apiHandler(TEACHERS_ROOMS_STUDENTS_ATTENDANCE_API, 'POST', payload);

            if (response.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Success!',
                    text: 'Attendance saved successfully!',
                    icon: 'success',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#3498DB',
                    timer: 2000
                });
                
                // Store current state before reload with metadata
                const cacheKey = `attendance_${selectedRoom}_${getReportDate()}`;
                const attendanceCache = {};
                students.filter(s => !isStudentOnLeave(s)).forEach(student => {
                    attendanceCache[student.id] = {
                        attendance: student.attendance,
                        attendance_time: student.attendance_time,
                        exit_time: student.exit_time
                    };
                });
                // Save the exact class_id and room_id used for this save
                const metaCache = {
                    class_id: payload.class_id,
                    room_id: payload.room_id,
                    teacher_id: payload.teacher_id
                };
                localStorage.setItem(cacheKey, JSON.stringify(attendanceCache));
                localStorage.setItem(`${cacheKey}_meta`, JSON.stringify(metaCache));
                console.log('Saved attendance to localStorage:', cacheKey, attendanceCache);
                console.log('Saved meta info:', metaCache);
                
                // Add delay to ensure backend has processed the save
                await new Promise(resolve => setTimeout(resolve, 1500));
                
                // Reload attendance data after save using SAME parameters as save
                setLoading(true);
                const reloadPayload = {
                    room_id: selectedRoom,
                    attendance_date: getReportDate(),
                    class_id: payload.class_id,  // Use same class_id as save
                    teacher_id: payload.teacher_id  // Use same teacher_id as save
                };
                console.log('Reloading attendance with payload (should match save):', reloadPayload);
                console.log('Original save payload was:', payload);
                const reloadResponse = await apiHandler(TEACHERS_ROOMS_STUDENTS_API, 'POST', reloadPayload);
                
                if (reloadResponse.data?.response?.status === 200) {
                    const studentsData = reloadResponse.data?.data?.students || [];
                    
                    // Check if backend returned attendance data
                    const hasAttendanceData = studentsData.some(s => 
                        s.attendance_status !== null || s.attendance_time !== null
                    );
                    
                    if (hasAttendanceData) {
                        // Backend returned the data, proceed with normal load
                        await loadAttendanceData();
                    } else {
                        console.warn('Backend did not return saved attendance data, using localStorage cache');
                        // Load cached attendance from localStorage
                        const cacheKey = `attendance_${selectedRoom}_${getReportDate()}`;
                        const cachedData = localStorage.getItem(cacheKey);
                        const attendanceCacheData = cachedData ? JSON.parse(cachedData) : {};
                        console.log('Using cached attendance data:', attendanceCacheData);
                        
                        // Merge cached attendance with student data
                        const mappedStudents = studentsData.map(student => {
                            const savedData = attendanceCacheData[student.id];
                            const isOnLeave = student.attendance_status === 2 || student.attendance_status === '2' || student.is_on_leave === true;
                            const resolvedAttendance = savedData ? savedData.attendance : (isOnLeave ? 'on_leave' : 'absent');
                            // Same rule as the main mapper: never trust a raw time value
                            // for a student who isn't resolved as present.
                            const resolvedAttendanceTime = resolvedAttendance === 'present'
                                ? (savedData ? savedData.attendance_time : student.attendance_time)
                                : null;
                            const resolvedExitTime = resolvedAttendance === 'present'
                                ? (savedData ? savedData.exit_time : student.exit_time)
                                : null;

                            return {
                                id: student.id,
                                profileSlug: student.slug || student.user_slug || student?.user?.slug || null,
                                name: student.name,
                                rollNumber: `ST${String(student.id).padStart(3, '0')}`,
                                avatar: student.photo || "https://uzone360live.s3.amazonaws.com/noimage.png",
                                attendance: resolvedAttendance,
                                attendance_confirmed: Boolean(savedData) || isOnLeave,
                                attendance_time: resolvedAttendanceTime,
                                exit_time: resolvedExitTime,
                                has_medication: student.has_medication,
                                has_non_medication: student.has_non_medication,
                                medication_count: student.medication_count || 0,
                                non_medication_count: student.non_medication_count || 0,
                                lunch_plan_waiver_id: student.lunch_plan_waiver_id,
                                peanut_policy_id: student.peanut_policy_id,
                                allergy_report_id: student.allergy_report_id,
                                emergency_contacts: student.emergency_contacts || [],
                                classroom: student.classroom,
                                class_name: student.class_name,
                                room_name: student.room_name,
                                class: student.class,
                                room: student.room,
                                rooms: student.rooms,
                                classrooms: student.classrooms,
                                swap_room: student.swap_room,
                                is_on_leave: isOnLeave
                            };
                        });
                        
                        setStudents(mappedStudents);
                        setTotalStudents(reloadResponse.data?.data?.total || 0);
                        setHasSchedule(reloadResponse.data?.data?.hasSchedule || false);
                        setScheduleInfo(reloadResponse.data?.data?.scheduleInfo || null);
                        setCanTakeAttendance(reloadResponse.data?.data?.canTakeAttendance !== undefined ? reloadResponse.data?.data?.canTakeAttendance : true);
                    }
                }
                setLoading(false);
            } else {
                setLoading(false);
                const errorMessage = response.data?.response?.message || response.data?.message || 'Failed to save attendance';
                console.error('API Error Response:', response.data);
                throw new Error(errorMessage);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error saving attendance:', error);
            console.error('Error details:', {
                message: error.message,
                response: error.response,
                data: error.response?.data
            });
            Swal.fire({
                title: 'Error!',
                text: error.message || error.response?.data?.message || 'Failed to save attendance. Please check the console for details.',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#E74C3C'
            });
        }
    };

    // Saves ONE student's attendance immediately (used by the Present-confirm
    // modal's "Yes" and by the Absent icon) instead of relying on the bulk
    // "Save Attendance" button. Reuses the same store endpoint the bulk save
    // uses - the backend already loops per-student and fires the
    // present/absent notification only to that one student.
    const saveSingleAttendance = async (studentId, status, attendanceTimeValue, exitTimeValue, successMessage) => {
        if (!canEditAttendance()) {
            Swal.fire({
                title: 'Not Allowed',
                text: 'You cannot save attendance for this date. This is view-only mode.',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#FFA500'
            });
            return;
        }

        const student = students.find(s => s.id === studentId);
        if (!student || isStudentOnLeave(student)) return;

        const attendanceTime = status === 'present' ? (attendanceTimeValue || Moment().format('HH:mm:ss')) : null;
        const exitTime = status === 'present' ? (exitTimeValue || null) : null;

        if (!isValidAttendanceTime(attendanceTime) || !isValidAttendanceTime(exitTime)) {
            Swal.fire({
                title: 'Validation Error',
                text: 'Attendance or exit time format is invalid. Please use HH:mm or HH:mm:ss.',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        setSavingStudentIds(prev => new Set(prev).add(studentId));

        try {
            const payload = {
                class_id: scheduleInfo?.class_id || profileData?.class_id || profileData?.class?.id || 1,
                room_id: selectedRoom,
                teacher_id: profileData?.id || profileData?.user_id || 1,
                attendance_date: getReportDate(),
                attendance: [{
                    student_id: studentId,
                    status: status === 'present' ? 1 : 0,
                    attendance_time: attendanceTime,
                    exit_time: exitTime
                }]
            };

            const response = await apiHandler(TEACHERS_ROOMS_STUDENTS_ATTENDANCE_API, 'POST', payload);

            // apiHandler() never throws - a failed request resolves with the
            // raw axios error instead, so this check is required or a 4xx/5xx
            // would silently look like success below.
            if (response?.isAxiosError || (response?.response && response?.data === undefined)) {
                throw new Error(response?.response?.data?.response?.message || response?.message || 'Failed to save attendance');
            }

            if (response.data?.response?.status === 200) {
                setStudents(prev => prev.map(s => s.id === studentId
                    ? { ...s, attendance: status, attendance_confirmed: true, attendance_time: attendanceTime, exit_time: exitTime }
                    : s));

                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: successMessage || (status === 'present' ? 'Marked present - parent notified' : 'Marked absent - parent notified'),
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true
                });
            } else {
                throw new Error(response.data?.response?.message || response.data?.message || 'Failed to save attendance');
            }
        } catch (error) {
            console.error('Error saving individual attendance:', error);
            Swal.fire({
                title: 'Error!',
                text: error.message || 'Failed to save attendance. Please try again.',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#E74C3C'
            });
        } finally {
            setSavingStudentIds(prev => {
                const next = new Set(prev);
                next.delete(studentId);
                return next;
            });
        }
    };

    const handlePresentIconClick = (student) => {
        if (!canEditAttendance() || isStudentOnLeave(student)) return;
        setPresentConfirmStudent(student);
        setPresentConfirmTime(
            student.attendance === 'present' && student.attendance_time
                ? Moment(student.attendance_time, 'HH:mm:ss').format('HH:mm')
                : Moment().format('HH:mm')
        );
        setShowPresentConfirmModal(true);
    };

    const confirmMarkPresent = () => {
        if (!presentConfirmStudent) return;
        if (!presentConfirmTime || !isValidAttendanceTime(presentConfirmTime)) {
            Swal.fire({ title: 'Validation Error', text: 'Please enter a valid time.', icon: 'warning', confirmButtonText: 'OK' });
            return;
        }
        const studentId = presentConfirmStudent.id;
        const exitTime = presentConfirmStudent.exit_time || null;
        const normalizedTime = presentConfirmTime.length === 5 ? `${presentConfirmTime}:00` : presentConfirmTime;
        setShowPresentConfirmModal(false);
        setPresentConfirmStudent(null);
        saveSingleAttendance(studentId, 'present', normalizedTime, exitTime);
    };

    const handleAbsentIconClick = (student) => {
        if (!canEditAttendance() || isStudentOnLeave(student)) return;
        saveSingleAttendance(student.id, 'absent', null, null);
    };

    const filteredStudents = students.filter(student =>
        student.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        student.rollNumber.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const getAttendanceStats = () => {
        // Exclude students on leave from attendance statistics
        const eligibleStudents = students.filter(s => !s.is_on_leave);
        const present = eligibleStudents.filter(s => s.attendance === 'present').length;
        const absent = eligibleStudents.filter(s => s.attendance === 'absent').length;
        const onLeave = students.filter(s => s.is_on_leave).length;
        const total = eligibleStudents.length;
        return { present, absent, onLeave, total };
    };

    const stats = getAttendanceStats();

    const renderDateSelector = () => (
        <Row className="g-2 align-items-stretch mb-1" aria-label="Attendance summary">
            <Col lg={9}>
                <Card className="h-100 att-top-card att-control-card mb-0">
                    <Card.Header className="py-1">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                            <div>
                                <h5 className="card-title mb-0 fw-bold att-title-with-icon">
                                    <i className="ri-team-line"></i>
                                    <span>Student Attendance</span>
                                </h5>
                            </div>
                            <span className="att-total-students">{totalStudents || students.length} Students</span>
                        </div>
                    </Card.Header>
                    <Card.Body className="p-1">
                        <div className="att-toolbar-shell">
                            <div className="att-date-panel">
                                <div className="att-panel-kicker">
                                    <i className="ri-calendar-event-line"></i>
                                    <span>Attendance Date</span>
                                </div>
                                <div className="att-date-panel-row">
                                    <div className="att-date-value">{formatDate(selectedDate)}</div>
                                    <div className="att-date-action">
                                        <DatePicker
                                            selected={selectedDate}
                                            onChange={(date) => {
                                                if (date) {
                                                    setSelectedDate(date);
                                                }
                                            }}
                                            maxDate={new Date()}
                                            dateFormat="yyyy-MM-dd"
                                            customInput={<AttendanceDateTrigger />}
                                            popperPlacement="bottom-end"
                                            popperClassName="att-top-date-popper"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="att-room-panel">
                                <div className="att-room-panel-header" style={{ justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px' }}>
                                    <div className="att-panel-kicker mb-0">
                                        <i className="ri-door-open-line"></i>
                                        <span>Rooms</span>
                                    </div>

                                    {isToday(selectedDate) && (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'nowrap' }}>
                                            {roomSelectedStudentIds.length > 0 && (
                                                <span style={{ fontSize: '9px', fontWeight: '700', color: '#0e7490', background: '#ecfeff', border: '1px solid #a5f3fc', borderRadius: '999px', padding: '3px 7px', whiteSpace: 'nowrap', flexShrink: 0 }}>
                                                    {roomSelectedStudentIds.length} selected
                                                </span>
                                            )}
                                            <button
                                                type="button"
                                                onClick={toggleSelectAllForRoom}
                                                disabled={!filteredStudents.length}
                                                title="Select or clear all students currently listed"
                                                style={{ display: 'inline-flex', alignItems: 'center', gap: '3px', fontSize: '9px', fontWeight: '700', color: '#4b5563', background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '999px', padding: '3px 7px', cursor: filteredStudents.length ? 'pointer' : 'not-allowed', opacity: filteredStudents.length ? 1 : 0.5, whiteSpace: 'nowrap', flexShrink: 0 }}
                                            >
                                                <i className="ri-checkbox-multiple-line" style={{ fontSize: '10px' }}></i>
                                                <span>{filteredStudents.length > 0 && filteredStudents.every((student) => roomSelectedStudentIds.includes(student.id)) ? 'Clear All' : 'Select All'}</span>
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => openRoomModalForSelected('assign')}
                                                disabled={!roomSelectedStudentIds.length || bulkRoomActionRunning}
                                                title="Assign a room for selected students"
                                                style={{ display: 'inline-flex', alignItems: 'center', gap: '3px', fontSize: '9px', fontWeight: '700', color: '#ffffff', background: !roomSelectedStudentIds.length || bulkRoomActionRunning ? '#94d3de' : '#0e7490', border: 'none', borderRadius: '999px', padding: '3px 7px', cursor: !roomSelectedStudentIds.length || bulkRoomActionRunning ? 'not-allowed' : 'pointer', whiteSpace: 'nowrap', flexShrink: 0 }}
                                            >
                                                <i className="ri-door-open-line" style={{ fontSize: '10px' }}></i>
                                                <span>Assign</span>
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => openRoomModalForSelected('swap')}
                                                disabled={!roomSelectedStudentIds.length || bulkRoomActionRunning}
                                                title="Swap rooms for selected students"
                                                style={{ display: 'inline-flex', alignItems: 'center', gap: '3px', fontSize: '9px', fontWeight: '700', color: '#ffffff', background: !roomSelectedStudentIds.length || bulkRoomActionRunning ? '#c4b5fd' : '#7C3AED', border: 'none', borderRadius: '999px', padding: '3px 7px', cursor: !roomSelectedStudentIds.length || bulkRoomActionRunning ? 'not-allowed' : 'pointer', whiteSpace: 'nowrap', flexShrink: 0 }}
                                            >
                                                <i className="ri-swap-line" style={{ fontSize: '10px' }}></i>
                                                <span>Swap</span>
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {rooms.length === 0 ? (
                                    <div className="att-room-empty-state">
                                        <i className="ri-hotel-line"></i>
                                        <span>No rooms available yet</span>
                                    </div>
                                ) : (
                                    <div className="att-room-scroll-wrap">
                                        <div className="att-room-scroll" role="tablist" aria-label="Room selection">
                                            {rooms.map((room) => {
                                                const isActive = Number(selectedRoom) === Number(room.id);

                                                return (
                                                    <button
                                                        key={room.id}
                                                        type="button"
                                                        className={`att-room-chip ${isActive ? 'is-active' : ''}`}
                                                        onClick={() => setSelectedRoom(Number(room.id))}
                                                    >
                                                        <span className="att-room-chip-name">{room.room_name}</span>
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="att-overview-meta">
                            <div className="att-summary-right-item att-summary-chip-time">
                                <i className="ri-time-line"></i>
                                <span>
                                    {hasSchedule && scheduleInfo
                                        ? `${formatTime(scheduleInfo.start_time)} - ${formatTime(scheduleInfo.end_time)}`
                                        : 'Time N/A'}
                                </span>
                            </div>

                            <div className={`att-summary-right-item ${canEditAttendance() ? 'att-summary-chip-editable' : 'att-summary-chip-view'}`}>
                                <i className={canEditAttendance() ? 'ri-lock-unlock-line' : 'ri-lock-line'}></i>
                                <span>{canEditAttendance() ? 'Editable' : 'View Only'}</span>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Col>

            <Col lg={3}>
                <Card className="h-100 att-top-card att-stats-card mb-0">
                    <Card.Header className="py-1">
                        <h5 className="card-title mb-0 fw-bold att-title-with-icon">
                            <i className="ri-bar-chart-box-line"></i>
                            <span>Statistics</span>
                        </h5>
                    </Card.Header>
                    <Card.Body className="p-1">
                        <div className="att-summary-grid">
                            <div className="att-summary-square att-stat-primary">
                                <span className="att-summary-icon">
                                    <i className="ri-checkbox-circle-line"></i>
                                </span>
                                <strong>{stats.present}</strong>
                                <span className="att-summary-square-label">Present</span>
                            </div>

                            <div className="att-summary-square att-stat-danger">
                                <span className="att-summary-icon">
                                    <i className="ri-close-circle-line"></i>
                                </span>
                                <strong>{stats.absent}</strong>
                                <span className="att-summary-square-label">Absent</span>
                            </div>

                            <div className="att-summary-square att-stat-secondary">
                                <span className="att-summary-icon">
                                    <i className="ri-plane-line"></i>
                                </span>
                                <strong>{stats.onLeave}</strong>
                                <span className="att-summary-square-label">On Leave</span>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );

    const renderStatsCards = () => null;

    const renderSearchBar = () => (
        <Card className="mb-3">
            <Card.Body>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    background: '#f8f9fa',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    border: '1px solid #e9ecef'
                }}>
                    <i className="ri-search-line" style={{
                        fontSize: '20px',
                        color: '#6c757d',
                        marginRight: '12px'
                    }}></i>
                    <input
                        type="text"
                        placeholder="Search students by name or roll number..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                            flex: 1,
                            border: 'none',
                            outline: 'none',
                            fontSize: '14px',
                            color: '#212529',
                            background: 'transparent'
                        }}
                    />
                    {searchQuery && (
                        <button
                            onClick={() => setSearchQuery('')}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '4px',
                                marginLeft: '8px'
                            }}
                        >
                            <i className="ri-close-line" style={{
                                fontSize: '20px',
                                color: '#6c757d'
                            }}></i>
                        </button>
                    )}
                </div>
            </Card.Body>
        </Card>
    );

    const renderStudentsPanel = () => (
        <Card>
            <Card.Body className="p-2">
                {/* Search Bar */}
                <div className="mb-2">
                    <div className="d-flex align-items-center bg-light py-1 px-2 rounded border att-search-bar">
                        <i className="ri-search-line text-muted me-2" style={{ fontSize: '16px' }}></i>
                        <input
                            type="text"
                            placeholder="Search students..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="form-control form-control-sm border-0 bg-transparent shadow-none"
                            style={{ fontSize: '12px' }}
                        />
                        {searchQuery && (
                            <button
                                onClick={() => setSearchQuery('')}
                                className="btn btn-sm p-0 border-0"
                                style={{ background: 'transparent' }}
                            >
                                <i className="ri-close-line text-muted" style={{ fontSize: '16px' }}></i>
                            </button>
                        )}
                    </div>
                </div>

                {/* Students count label */}
                <div className="mb-2" style={{ fontSize: '12px', fontWeight: '600', color: '#6b7280' }}>
                    Students ({filteredStudents.length})
                </div>

                {/* Students List */}
                {!selectedRoom ? (
                    <div className="text-center py-5 text-muted">
                        <i className="material-symbols-outlined" style={{ fontSize: '48px', opacity: 0.3 }}>meeting_room</i>
                        <p className="mt-2 mb-0" style={{ fontSize: '13px' }}>Please select a room to view students</p>
                    </div>
                ) : filteredStudents.length === 0 ? (
                    <div className="text-center py-5 text-muted">
                        <i className="material-symbols-outlined" style={{ fontSize: '48px', opacity: 0.3 }}>group_off</i>
                        <p className="mt-2 mb-0" style={{ fontSize: '13px' }}>No students found for this room</p>
                    </div>
                ) : (
                    <div>
                        {filteredStudents.map((student, index) => renderStudentItem(student, index))}
                    </div>
                )}

                {/* Divider */}
                <hr className="my-2" />

                {/* Save Attendance Button - commented out for now. Present/Absent
                    icons save individually and immediately, so this bulk save
                    is no longer needed for that; it's only kept here (disabled)
                    in case Mark All Present/Absent still needs a persist step.
                <Button
                    onClick={saveAttendance}
                    disabled={loading || students.length === 0 || !canEditAttendance()}
                    variant="primary"
                    className="w-100 py-2 att-save-btn"
                    style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        boxShadow: (loading || students.length === 0 || !canEditAttendance()) ? 'none' : '0 2px 8px rgba(80, 180, 152, 0.3)'
                    }}
                    title={!canEditAttendance() ? 'This attendance is view-only and cannot be modified' : ''}
                >
                    {loading ? (
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    ) : (
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                            <i className="material-symbols-outlined" style={{ fontSize: '20px' }}>save</i>
                            Save Attendance
                        </span>
                    )}
                </Button>
                */}
            </Card.Body>
        </Card>
    );

    const handleSetExitTime = (student) => {
        // Check if editing is allowed for this date
        if (!canEditAttendance()) {
            Swal.fire({
                title: 'Not Allowed',
                text: 'Cannot set exit time for past dates. This is view-only mode.',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#FFA500'
            });
            return;
        }

        if (isStudentOnLeave(student)) {
            Swal.fire({
                title: 'Not Allowed',
                text: 'Cannot set exit time for students on leave.',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#FFA500'
            });
            return;
        }

        if (student.attendance !== 'present') {
            Swal.fire({
                title: 'Not Allowed',
                text: 'Cannot set exit time for a student who is marked absent.',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#FFA500'
            });
            return;
        }

        setSelectedStudent(student);
        setExitTime(student.exit_time || Moment().format('HH:mm'));
        setShowExitTimeModal(true);
    };

    const saveExitTime = () => {
        // Double-check if editing is allowed
        if (!canEditAttendance()) {
            Swal.fire({
                title: 'Not Allowed',
                text: 'Cannot set exit time for past dates. This is view-only mode.',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#FFA500'
            });
            setShowExitTimeModal(false);
            return;
        }

        if (selectedStudent && isStudentOnLeave(selectedStudent)) {
            Swal.fire({
                title: 'Not Allowed',
                text: 'Cannot set exit time for students on leave.',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#FFA500'
            });
            setShowExitTimeModal(false);
            return;
        }

        if (selectedStudent && selectedStudent.attendance !== 'present') {
            Swal.fire({
                title: 'Not Allowed',
                text: 'Cannot set exit time for a student who is marked absent.',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#FFA500'
            });
            setShowExitTimeModal(false);
            return;
        }

        if (exitTime && !isValidAttendanceTime(exitTime)) {
            Swal.fire({
                title: 'Validation Error',
                text: 'Invalid exit time format. Please use HH:mm or HH:mm:ss.',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        if (selectedStudent && exitTime) {
            // Was only mutating local React state - never actually persisted to
            // the backend, so the edited time reverted the moment the page
            // reloaded or the attendance list refetched. Route through the same
            // save endpoint saveSingleAttendance already uses, preserving the
            // student's existing check-in time rather than resetting it.
            const newExitTime = exitTime.length === 5 ? `${exitTime}:00` : exitTime;
            const studentId = selectedStudent.id;
            const preservedAttendanceTime = selectedStudent.attendance_time;
            setShowExitTimeModal(false);
            setSelectedStudent(null);
            setExitTime('');
            saveSingleAttendance(studentId, 'present', preservedAttendanceTime, newExitTime, 'Exit time updated successfully!');
        }
    };

    const handleEditAttendanceTime = (student) => {
        if (!canEditAttendance()) {
            Swal.fire({
                title: 'Not Allowed',
                text: 'Cannot change attendance time for past dates. This is view-only mode.',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#FFA500'
            });
            return;
        }

        if (isStudentOnLeave(student)) {
            return;
        }

        if (student.attendance !== 'present') {
            Swal.fire({
                title: 'Not Allowed',
                text: 'Mark the student present before setting a time.',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        setSelectedStudent(student);
        setAttendanceTimeEdit(student.attendance_time
            ? Moment(student.attendance_time, 'HH:mm:ss').format('HH:mm')
            : Moment().format('HH:mm'));
        setShowAttendanceTimeModal(true);
    };

    const saveAttendanceTimeEdit = () => {
        if (!canEditAttendance()) {
            Swal.fire({
                title: 'Not Allowed',
                text: 'Cannot change attendance time for past dates. This is view-only mode.',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#FFA500'
            });
            setShowAttendanceTimeModal(false);
            return;
        }

        if (attendanceTimeEdit && !isValidAttendanceTime(attendanceTimeEdit)) {
            Swal.fire({
                title: 'Validation Error',
                text: 'Invalid attendance time format. Please use HH:mm or HH:mm:ss.',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        if (selectedStudent && attendanceTimeEdit) {
            // Was only mutating local React state - never actually persisted to
            // the backend, so the edited time reverted the moment the page
            // reloaded or the attendance list refetched. Route through the same
            // save endpoint saveSingleAttendance already uses, preserving the
            // student's existing exit time rather than clearing it.
            const newAttendanceTime = attendanceTimeEdit.length === 5 ? `${attendanceTimeEdit}:00` : attendanceTimeEdit;
            const studentId = selectedStudent.id;
            const preservedExitTime = selectedStudent.exit_time;
            setShowAttendanceTimeModal(false);
            setSelectedStudent(null);
            setAttendanceTimeEdit('');
            saveSingleAttendance(studentId, 'present', newAttendanceTime, preservedExitTime, 'Attendance time updated successfully!');
        }
    };

    // API Functions for viewing data
    const viewDailyReport = async (student) => {
        setViewDataLoading(true);
        try {
            const response = await apiHandler(DAILY_REPORT_VIEW, 'POST', {
                student_id: student.id,
                class_id: scheduleInfo?.class_id || profileData?.class_id || profileData?.class?.id,
                report_date: getReportDate()
            });
            if (response.data?.response?.status === 200) {
                setDailyReportData(response.data?.data || {});
                setCurrentDailyReportData(response.data?.data?.daily_report || null);
                setSelectedStudent(student);
                setActiveViewMealTab(0);
                setShowDailyReportModal(true);
            } else {
                setSelectedStudent(student);
                setCurrentDailyReportData(null);
                setDailyReportData({
                    student: { name: student?.name || 'N/A' },
                    class: { name: scheduleInfo?.class_name || 'N/A' },
                    report_date: getReportDate(),
                    is_present: student?.attendance === 'present',
                    daily_report: null,
                    all_feelings: DAILY_REPORT_FALLBACK_FEELINGS,
                    week_menu_meals: []
                });
                setActiveViewMealTab(0);
                setShowDailyReportModal(true);
            }
        } catch (error) {
            console.error('Error loading daily report:', error);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load daily report',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setViewDataLoading(false);
        }
    };

    const openDailyReportForm = async (student, isEdit = false) => {
        setSelectedStudent(student);
        setIsEditingDailyReport(isEdit);
        const reportDate = getReportDate();

        if (isEdit) {
            setViewDataLoading(true);
            try {
                const response = await apiHandler(DAILY_REPORT_VIEW, 'POST', {
                    student_id: student.id,
                    class_id: scheduleInfo?.class_id || profileData?.class_id || profileData?.class?.id,
                    report_date: reportDate
                });
                if (response.data?.response?.status === 200 && response.data?.data?.daily_report) {
                    const reportData = response.data.data.daily_report;
                    setDailyReportData(response.data?.data || {});
                    const loadedData = buildDailyReportFormDataFromReport(reportData, response.data?.data);
                    setDailyReportFormData(loadedData);
                    // Check if this is a draft (status === 0)
                    setIsDraftMode(reportData.status === 0);
                    if (reportData.status === 0) {
                        setHasDraft(true);
                    }
                } else {
                    // No saved report, check for draft in localStorage
                    const draftData = loadDraftFromLocalStorage(student.id, reportDate, response.data?.data);
                    if (draftData) {
                        setDailyReportData(response.data?.data || {});
                        setDailyReportFormData(draftData);
                        setIsDraftMode(true);
                    } else {
                        setDailyReportData(response.data?.data || {});
                        resetDailyReportForm(response.data?.data);
                        setIsDraftMode(false);
                    }
                }
            } catch (error) {
                console.error('Error loading daily report for edit:', error);
                // Check for draft in localStorage as fallback
                const draftData = loadDraftFromLocalStorage(student.id, reportDate);
                if (draftData) {
                    setDailyReportFormData(draftData);
                    setIsDraftMode(true);
                } else {
                    resetDailyReportForm();
                    setIsDraftMode(false);
                }
            } finally {
                setViewDataLoading(false);
            }
        } else {
            // New report - check for draft in localStorage
            const draftData = loadDraftFromLocalStorage(student.id, reportDate);
            if (draftData) {
                setDailyReportFormData(draftData);
                setIsDraftMode(true);
                // Ask user if they want to continue with draft
                Swal.fire({
                    title: 'Draft Found',
                    text: 'A draft report exists for this student. Do you want to continue with the draft?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Continue with Draft',
                    cancelButtonText: 'Start Fresh',
                    confirmButtonColor: 'var(--bs-primary)'
                }).then((result) => {
                    if (!result.isConfirmed) {
                        // User wants to start fresh
                        clearDraftFromLocalStorage(student.id, reportDate);
                        resetDailyReportForm();
                        setIsDraftMode(false);
                    }
                });
            } else {
                resetDailyReportForm();
                setIsDraftMode(false);
            }
        }
        setActiveMealTab(0);
        setShowDailyReportFormModal(true);
    };

    const printDailyReport = () => {
        const printWindow = window.open('', '_blank');
        const printMeals = flattenDailyReportMealEntries(dailyReportData?.daily_report?.daily_report_meals || []);
        const printMealGroups = getDailyReportMealTypeGroups(dailyReportData?.daily_report?.daily_report_meals || []);
        const printMealCount = printMealGroups.reduce((count, group) => count + group.items.length, 0);
        const printWeekMeals = getAvailableWeekMenuMeals(dailyReportData);
        const themeColors = getVariableColor() || {};
        const themePrimary = themeColors.primary || '#2563eb';
        const themePrimaryLight = themeColors.primary_light || '#dbeafe';
        const reportDateLabel = dailyReportData?.report_date
            ? Moment(dailyReportData.report_date, ['YYYY-MM-DD', Moment.ISO_8601], true).isValid()
                ? Moment(dailyReportData.report_date, ['YYYY-MM-DD', Moment.ISO_8601], true).format('dddd, MMMM D, YYYY')
                : Moment(dailyReportData.report_date).format('dddd, MMMM D, YYYY')
            : new Date().toLocaleDateString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

        const schoolName =
            dailyReportData?.school?.name ||
            profileData?.user_setting?.school_name ||
            organizationInfo?.name ||
            generalSettingsData?.app_name ||
            'Harmony Daycare';

        const schoolLogo =
            dailyReportData?.school?.logo ||
            profileData?.user_setting?.school_logo ||
            organizationInfo?.logo ||
            profileData?.user_setting?.photo ||
            '';

        const reportContent = `
            <html>
                <head>
                    <title>Daily Report - ${selectedStudent?.name}</title>
                    <style>
                        * { box-sizing: border-box; }
                        body {
                            margin: 0;
                            padding: 16px;
                            font-family: '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
                            color: #2d3748;
                            background: #f8f9fa;
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                            line-height: 1.5;
                        }
                        .report-sheet {
                            max-width: 1100px;
                            margin: 0 auto;
                            background: #ffffff;
                            border-radius: 20px;
                            padding: 16px 18px;
                            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
                        }
                        .header {
                            background: linear-gradient(135deg, ${themePrimary}08 0%, ${themePrimaryLight} 100%);
                            border: none;
                            border-radius: 16px;
                            padding: 16px 18px;
                            margin-bottom: 14px;
                            position: relative;
                            overflow: hidden;
                        }
                        .header::before {
                            content: '';
                            position: absolute;
                            top: 0;
                            right: -50px;
                            width: 300px;
                            height: 300px;
                            background: radial-gradient(circle, ${themePrimaryLight}20 0%, transparent 70%);
                            border-radius: 50%;
                        }
                        .header::after {
                            content: '';
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            right: 0;
                            height: 2px;
                            background: linear-gradient(90deg, transparent 0%, #ffffff 24%, #ffffff 50%, #ffffff 76%, transparent 100%);
                        }
                        .header-top {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            gap: 12px;
                            flex-wrap: wrap;
                            position: relative;
                            z-index: 1;
                        }
                        .school-brand {
                            display: flex;
                            align-items: center;
                            gap: 10px;
                            min-width: 0;
                            flex: 1;
                        }
                        .school-logo {
                            width: 52px;
                            height: 52px;
                            object-fit: contain;
                            border-radius: 12px;
                            background: #ffffff;
                            border: 1px solid #e2e8f0;
                            padding: 4px;
                            flex-shrink: 0;
                            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
                        }
                        .brand-copy { min-width: 0; }
                        .school-name {
                            margin: 0;
                            font-size: 20px;
                            line-height: 1.1;
                            color: #1a202c;
                            font-weight: 800;
                            letter-spacing: -0.02em;
                        }
                        .report-kicker {
                            margin: 2px 0 0 0;
                            font-size: 10px;
                            color: #718096;
                            letter-spacing: 0.08em;
                            text-transform: uppercase;
                            font-weight: 700;
                        }
                        .header-meta {
                            display: flex;
                            gap: 8px;
                            flex-wrap: wrap;
                            justify-content: flex-end;
                        }
                        .meta-pill {
                            display: inline-flex;
                            align-items: center;
                            gap: 6px;
                            padding: 6px 10px;
                            border-radius: 8px;
                            background: #ffffff;
                            border: 1px solid #e7edf5;
                            color: #2d3748;
                            font-size: 10px;
                            font-weight: 700;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
                        }
                        .report-title {
                            margin: 10px 0 0 0;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            gap: 10px;
                            flex-wrap: wrap;
                            position: relative;
                            z-index: 1;
                        }
                        .report-title h2 {
                            margin: 0;
                            font-size: 18px;
                            color: #1a202c;
                            letter-spacing: -0.02em;
                            font-weight: 800;
                        }
                        .report-title .date-badge {
                            padding: 6px 12px;
                            border-radius: 8px;
                            background: ${themePrimary};
                            color: #ffffff;
                            font-size: 10px;
                            font-weight: 800;
                            letter-spacing: 0.04em;
                            box-shadow: 0 2px 8px ${themePrimary}30;
                        }
                        .summary-strip {
                            display: grid;
                            grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
                            gap: 8px;
                            margin-top: 10px;
                            position: relative;
                            z-index: 1;
                        }
                        .summary-card {
                            display: flex;
                            align-items: flex-start;
                            gap: 8px;
                            padding: 10px 12px;
                            border: 1px solid #e2e8f0;
                            border-radius: 10px;
                            background: #ffffff;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
                            min-width: 0;
                        }
                        .summary-mark {
                            width: 10px;
                            height: 10px;
                            border-radius: 50%;
                            background: ${themePrimary};
                            flex-shrink: 0;
                            margin-top: 2px;
                        }
                        .summary-copy { min-width: 0; }
                        .summary-label {
                            display: block;
                            font-size: 9px;
                            color: #718096;
                            text-transform: uppercase;
                            letter-spacing: 0.06em;
                            font-weight: 800;
                            margin-bottom: 2px;
                        }
                        .summary-value {
                            display: block;
                            font-size: 12px;
                            color: #1a202c;
                            font-weight: 700;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        .section { margin-bottom: 12px; }
                        .section-card {
                            border: 1px solid #edf2f7;
                            border-radius: 12px;
                            overflow: hidden;
                            background: #ffffff;
                            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
                        }
                        .section-title {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            gap: 10px;
                            background: linear-gradient(90deg, #ffffff 0%, #fbfcfe 100%);
                            color: #1a202c;
                            padding: 10px 14px;
                            font-weight: 800;
                            letter-spacing: 0.01em;
                            border-bottom: 1px solid #eef2f7;
                            position: relative;
                            font-size: 13px;
                        }
                        .section-title::before {
                            content: '';
                            display: inline-block;
                            width: 3px;
                            height: 16px;
                            border-radius: 999px;
                            background: linear-gradient(180deg, #e8edf4 0%, #f4f7fb 100%);
                            margin-right: 8px;
                            flex-shrink: 0;
                        }
                        .section-title .section-count {
                            font-size: 9px;
                            padding: 4px 8px;
                            border-radius: 6px;
                            background: #fafbfd;
                            border: 1px solid #e9eef5;
                            color: #64748b;
                            font-weight: 800;
                        }
                        .section-body { padding: 12px 14px 14px; }
                        .info-grid {
                            display: grid;
                            grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
                            gap: 10px;
                        }
                        .info-item {
                            padding: 10px 12px;
                            background: linear-gradient(135deg, #f9fafb 0%, #ffffff 100%);
                            border: 1px solid #e2e8f0;
                            border-radius: 10px;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
                        }
                        .info-label {
                            font-size: 9px;
                            color: #718096;
                            text-transform: uppercase;
                            letter-spacing: 0.06em;
                            font-weight: 800;
                            margin-bottom: 4px;
                        }
                        .info-value {
                            font-size: 13px;
                            font-weight: 800;
                            color: #1a202c;
                            line-height: 1.3;
                        }
                        .content-text {
                            padding: 12px 14px;
                            background: linear-gradient(135deg, #fafbfc 0%, #ffffff 100%);
                            border-radius: 10px;
                            line-height: 1.6;
                            border: 1px solid #e2e8f0;
                            color: #2d3748;
                            font-size: 12px;
                        }
                        .feeling-badges { display: flex; flex-wrap: wrap; gap: 8px; }
                        .feeling-badge {
                            display: inline-flex;
                            align-items: center;
                            gap: 6px;
                            padding: 7px 12px;
                            border-radius: 8px;
                            color: #ffffff;
                            font-weight: 700;
                            font-size: 11px;
                            letter-spacing: 0.01em;
                            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
                        }
                        .happy { background: linear-gradient(135deg, #10b981 0%, #14b8a6 100%); }
                        .sick { background: linear-gradient(135deg, #ef4444 0%, #f97316 100%); }
                        .bring-items {
                            display: grid;
                            grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
                            gap: 8px;
                        }
                        .bring-item {
                            padding: 10px 12px;
                            background: linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%);
                            border: 1.5px solid ${themePrimaryLight};
                            border-radius: 10px;
                            text-align: center;
                            font-weight: 700;
                            color: ${themePrimary};
                            font-size: 11px;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
                        }
                        .meal-group-title {
                            font-size: 12px;
                            font-weight: 800;
                            color: #1a202c;
                            margin: 10px 0 6px 0;
                            padding-bottom: 6px;
                            border-bottom: 2px solid #e2e8f0;
                        }
                        .meal-table-wrap { overflow: hidden; border-radius: 10px; border: 1px solid #e2e8f0; }
                        table { width: 100%; border-collapse: collapse; margin-top: 0; font-size: 11px; }
                        th, td {
                            padding: 8px 10px;
                            border-bottom: 1px solid #e2e8f0;
                            text-align: left;
                            vertical-align: top;
                        }
                        th {
                            background: linear-gradient(90deg, #f7fafc 0%, #edf2f7 100%);
                            color: #2d3748;
                            font-size: 10px;
                            text-transform: uppercase;
                            letter-spacing: 0.04em;
                            font-weight: 800;
                            border-bottom: 2px solid #cbd5e0;
                        }
                        tbody tr:nth-child(odd) td { background: #fafbfc; }
                        tbody tr:nth-child(even) td { background: #ffffff; }
                        tbody tr:last-child td { border-bottom: none; }
                        .meal-name { font-size: 11px; font-weight: 800; color: #1a202c; }
                        .empty-state {
                            padding: 12px;
                            border: 1.5px dashed #cbd5e0;
                            border-radius: 10px;
                            color: #718096;
                            background: #f9fafb;
                            text-align: center;
                            font-size: 12px;
                        }
                        @media print {
                            body { 
                                padding: 0; 
                                background: #ffffff; 
                                margin: 0;
                            }
                            .report-sheet { 
                                max-width: none; 
                                box-shadow: none; 
                                border-radius: 0; 
                                padding: 12px;
                            }
                            .header, .section-card, .info-item, .bring-item, .content-text { box-shadow: none; }
                            .section { 
                                break-inside: avoid; 
                                page-break-inside: avoid;
                                margin-bottom: 10px;
                            }
                            .section-card { break-inside: avoid; page-break-inside: avoid; }
                            tr { break-inside: avoid; page-break-inside: avoid; }
                            .header { page-break-after: avoid; }
                        }
                    </style>
                </head>
                <body>
                    <div class="report-sheet">
                    <div class="header">
                        <div class="header-top">
                            <div class="school-brand">
                                ${schoolLogo ? `<img class="school-logo" src="${schoolLogo}" alt="${schoolName} logo" />` : ''}
                                <div class="brand-copy">
                                    <h1 class="school-name">${schoolName}</h1>
                                    <p class="report-kicker">Daily child report</p>
                                </div>
                            </div>
                            <div class="header-meta">
                                <div class="meta-pill">Student: ${selectedStudent?.name || 'N/A'}</div>
                                <div class="meta-pill">Date: ${reportDateLabel}</div>
                            </div>
                        </div>
                        <div class="report-title">
                            <h2>Daily Report</h2>
                            <div class="date-badge">${dailyReportData?.is_present ? 'Present' : 'Absent'}</div>
                        </div>
                        <div class="summary-strip">
                            <div class="summary-card">
                                <span class="summary-mark"></span>
                                <div class="summary-copy">
                                    <span class="summary-label">Student</span>
                                    <span class="summary-value">${selectedStudent?.name || dailyReportData?.student?.name || 'N/A'}</span>
                                </div>
                            </div>
                            <div class="summary-card">
                                <span class="summary-mark"></span>
                                <div class="summary-copy">
                                    <span class="summary-label">Class</span>
                                    <span class="summary-value">${dailyReportData?.class?.name || 'N/A'}</span>
                                </div>
                            </div>
                            <div class="summary-card">
                                <span class="summary-mark"></span>
                                <div class="summary-copy">
                                    <span class="summary-label">Report Date</span>
                                    <span class="summary-value">${reportDateLabel}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="section section-card">
                        <div class="section-title">Student Information</div>
                        <div class="section-body">
                            <div class="info-grid">
                                <div class="info-item">
                                    <div class="info-label">Student Name</div>
                                    <div class="info-value">${dailyReportData?.student?.name || 'N/A'}</div>
                                </div>
                                <div class="info-item">
                                    <div class="info-label">Class</div>
                                    <div class="info-value">${dailyReportData?.class?.name || 'N/A'}</div>
                                </div>
                                <div class="info-item">
                                    <div class="info-label">Attendance</div>
                                    <div class="info-value">${dailyReportData?.is_present ? 'Present' : 'Absent'}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    ${dailyReportData?.daily_report ? `
                        ${dailyReportData.daily_report.daily_report_fealings && dailyReportData.daily_report.daily_report_fealings.length > 0 ? `
                            <div class="section section-card">
                                <div class="section-title">Today I Felt</div>
                                <div class="section-body">
                                    <div class="feeling-badges">
                                        ${dailyReportData.daily_report.daily_report_fealings.map(feeling =>
            `<span class="feeling-badge ${feeling.fealing.name === 'Happy' ? 'happy' : 'sick'}">${feeling.fealing.name}</span>`
        ).join('')}
                                    </div>
                                </div>
                            </div>
                        ` : ''}

                        ${dailyReportData.daily_report.learned ? `
                            <div class="section section-card">
                                <div class="section-title">Today I Learned</div>
                                <div class="section-body">
                                    <div class="content-text">${dailyReportData.daily_report.learned.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ')}</div>
                                </div>
                            </div>
                        ` : ''}

                        ${printMeals.length > 0 ? `
                            <div class="section section-card">
                                <div class="section-title">Meals <span class="section-count">${printMealCount} entries</span></div>
                                <div class="section-body">
                                ${printMealGroups.map(group => `
                                    <div class="meal-group-title">${group.mealTypeName}</div>
                                    <div class="meal-table-wrap">
                                        <table>
                                            <thead>
                                                <tr><th>Menu Name</th><th>Time</th><th>Amount</th></tr>
                                            </thead>
                                            <tbody>
                                                ${group.items.map(meal => `
                                                    ${(() => {
                                                        return `
                                                    <tr>
                                                        <td>
                                                            <div class="meal-name">${meal.menu_name || meal.name || meal.menu?.name || 'Menu Item'}</div>
                                                        </td>
                                                        <td>${formatTime(meal.meal_time) || 'N/A'}</td>
                                                        <td>${getMealAmountLabel(meal.meal_amount)}</td>
                                                    </tr>
                                                `;
                                                    })()}
                                                `).join('')}
                                            </tbody>
                                        </table>
                                    </div>
                                `).join('')}
                                </div>
                            </div>
                        ` : ''}

                        ${dailyReportData.daily_report.daily_report_diapers && dailyReportData.daily_report.daily_report_diapers.length > 0 ? `
                            <div class="section section-card">
                                <div class="section-title">Diapers/Toilet <span class="section-count">${dailyReportData.daily_report.daily_report_diapers.length} entries</span></div>
                                <div class="section-body">
                                    <div class="meal-table-wrap">
                                        <table>
                                            <thead>
                                                <tr><th>Time</th><th>Check</th></tr>
                                            </thead>
                                            <tbody>
                                                ${dailyReportData.daily_report.daily_report_diapers.map(diaper => `
                                                    <tr>
                                                        <td>${new Date(`2000-01-01T${diaper.diaper_time}`).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}</td>
                                                        <td>${diaper.diaper_check === 1 ? 'D/T' : diaper.diaper_check === 2 ? 'Dry' : diaper.diaper_check === 3 ? 'Wet' : 'BM'}</td>
                                                    </tr>
                                                `).join('')}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        ` : ''}

                        ${dailyReportData.daily_report.daily_report_sleeps && dailyReportData.daily_report.daily_report_sleeps.length > 0 ? `
                            <div class="section section-card">
                                <div class="section-title">Sleep <span class="section-count">${dailyReportData.daily_report.daily_report_sleeps.length} entries</span></div>
                                <div class="section-body">
                                    <div class="meal-table-wrap">
                                        <table>
                                            <thead>
                                                <tr><th>Start Time</th><th>End Time</th><th>Duration</th></tr>
                                            </thead>
                                            <tbody>
                                                ${dailyReportData.daily_report.daily_report_sleeps.map(sleep => {
            const start = new Date(`2000-01-01T${sleep.start_time}`);
            const end = new Date(`2000-01-01T${sleep.end_time}`);
            const duration = Math.abs(end - start) / (1000 * 60);
            const hours = Math.floor(duration / 60);
            const minutes = Math.floor(duration % 60);
            return `
                                                    <tr>
                                                        <td>${start.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}</td>
                                                        <td>${end.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}</td>
                                                        <td>${hours > 0 ? `${hours}h ` : ''}${minutes}m</td>
                                                    </tr>
                                                `;
        }).join('')}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        ` : ''}

                        ${dailyReportData.daily_report.daily_report_bring_mores && dailyReportData.daily_report.daily_report_bring_mores.length > 0 ? `
                            <div class="section section-card">
                                <div class="section-title">Please Bring More</div>
                                <div class="section-body">
                                    <div class="bring-items">
                                        ${dailyReportData.daily_report.daily_report_bring_mores.map(item => {
            const names = { 1: 'Diapers', 2: 'Wipes', 3: 'Ointment', 4: 'Clothes', 5: 'Blanket', 6: item.other || 'Other' };
            return `<div class="bring-item">${names[item.things] || 'Unknown'}</div>`;
        }).join('')}
                                    </div>
                                </div>
                            </div>
                        ` : ''}

                        ${dailyReportData.daily_report.comments ? `
                            <div class="section section-card">
                                <div class="section-title">Comments</div>
                                <div class="section-body">
                                    <div class="content-text">${dailyReportData.daily_report.comments.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ')}</div>
                                </div>
                            </div>
                        ` : ''}
                    ` : '<div class="section section-card"><div class="section-body"><div class="empty-state">No daily report data available.</div></div></div>'}
                    </div>
                </body>
            </html>
        `;

        printWindow.document.write(reportContent);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
        }, 500);
    };

    const isToday = (dateValue) => {
        if (!dateValue) return true; // If no date, assume today for new reports

        let parsedDate;
        if (dateValue instanceof Date || Moment.isMoment(dateValue)) {
            parsedDate = Moment(dateValue);
        } else if (typeof dateValue === 'string') {
            parsedDate = Moment(dateValue, ['YYYY-MM-DD', Moment.ISO_8601], true);
            if (!parsedDate.isValid()) {
                parsedDate = Moment(dateValue);
            }
        } else {
            parsedDate = Moment(dateValue);
        }

        if (!parsedDate.isValid()) {
            return false;
        }

        return parsedDate.format('YYYY-MM-DD') === Moment().format('YYYY-MM-DD');
    };

    const editDailyReport = (student) => {
        if (!dailyReportData?.daily_report || (!isTeacherLogin && !isToday(dailyReportData.report_date))) {
            Swal.fire({
                icon: 'warning',
                title: 'Cannot Edit',
                text: 'You can only edit today\'s reports.',
                confirmButtonColor: 'var(--bs-primary)'
            });
            return;
        }

        setSelectedStudent(student || selectedStudent);
        setDailyReportFormData(buildDailyReportFormDataFromReport(dailyReportData.daily_report, dailyReportData));
        setIsEditingDailyReport(true);
        setShowDailyReportModal(false);
        setActiveMealTab(0);
        setShowDailyReportFormModal(true);
    };

    const handleAddReport = async (student) => {
        setSelectedStudent(student);
        const reportDate = getReportDate();

        // Check if student already has a report for today by loading it
        try {
            const response = await apiHandler(DAILY_REPORT_VIEW, 'POST', {
                student_id: student.id,
                class_id: scheduleInfo?.class_id || profileData?.class_id || profileData?.class?.id,
                report_date: reportDate
            });

            if (response.data?.response?.status === 200 && response.data?.data?.daily_report) {
                // Set the daily report data for use in edit
                setDailyReportData(response.data?.data || {});
                setCurrentDailyReportData(response.data?.data?.daily_report || null);

                // Load existing report data for editing using the same logic as editDailyReport
                const reportData = response.data.data.daily_report;
                setDailyReportFormData(buildDailyReportFormDataFromReport(reportData, response.data?.data));
                setIsEditingDailyReport(true);
                
                // Check if this is a draft (status === 0)
                setIsDraftMode(reportData.status === 0);
                if (reportData.status === 0) {
                    setHasDraft(true);
                }

                // Show success message for editing
                Swal.fire({
                    title: reportData.status === 0 ? 'Draft Found' : 'Existing Report Found',
                    text: reportData.status === 0 ? 'Loading draft report for editing.' : 'Loading existing report for editing.',
                    icon: 'info',
                    timer: 1500,
                    showConfirmButton: false
                });
            } else {
                // No existing report on server, check for draft in localStorage
                const draftData = loadDraftFromLocalStorage(student.id, reportDate, response.data?.data);
                if (draftData) {
                    setDailyReportData(response.data?.data || {});
                    setDailyReportFormData(draftData);
                    setIsEditingDailyReport(false);
                    setIsDraftMode(true);
                    
                    // Ask user if they want to continue with draft
                    Swal.fire({
                        title: 'Draft Found',
                        text: 'A draft report exists for this student. Do you want to continue with the draft?',
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Continue with Draft',
                        cancelButtonText: 'Start Fresh',
                        confirmButtonColor: 'var(--bs-primary)'
                    }).then((result) => {
                        if (!result.isConfirmed) {
                            // User wants to start fresh
                            clearDraftFromLocalStorage(student.id, reportDate);
                            resetDailyReportForm(response.data?.data);
                            setIsDraftMode(false);
                        }
                    });
                } else {
                    // No draft found, create new one
                    setDailyReportData(response.data?.data || {});
                    resetDailyReportForm(response.data?.data);
                    setIsEditingDailyReport(false);
                    setIsDraftMode(false);
                }
            }

            setActiveMealTab(0);
            setShowDailyReportFormModal(true);
        } catch (error) {
            console.error('Error checking for existing report:', error);
            // If there's an error (likely no report exists), check for draft in localStorage
            const draftData = loadDraftFromLocalStorage(student.id, reportDate);
            if (draftData) {
                setDailyReportFormData(draftData);
                setIsEditingDailyReport(false);
                setIsDraftMode(true);
                
                // Ask user if they want to continue with draft
                Swal.fire({
                    title: 'Draft Found',
                    text: 'A draft report exists for this student. Do you want to continue with the draft?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Continue with Draft',
                    cancelButtonText: 'Start Fresh',
                    confirmButtonColor: 'var(--bs-primary)'
                }).then((result) => {
                    if (!result.isConfirmed) {
                        // User wants to start fresh
                        clearDraftFromLocalStorage(student.id, reportDate);
                        resetDailyReportForm();
                        setIsDraftMode(false);
                    }
                });
            } else {
                // No draft found, create new one
                resetDailyReportForm();
                setIsEditingDailyReport(false);
                setIsDraftMode(false);
            }
            setActiveMealTab(0);
            setShowDailyReportFormModal(true);
        }
    };

    const resetDailyReportForm = (dailyReportApiData = dailyReportData) => {
        setDailyReportFormData(getDailyReportDefaultFormData(dailyReportApiData));
        // Don't reset selectedStudent and isEditingDailyReport here to preserve form context
    };

    const handleCloseDailyReportModal = () => {
        // Check if form has any data
        const hasData = dailyReportFormData.learned || 
                       dailyReportFormData.comments || 
                       dailyReportFormData.diapers.length > 0 || 
                       dailyReportFormData.meals.length > 0 || 
                       dailyReportFormData.sleeps.length > 0 ||
                       dailyReportFormData.bring_diapers ||
                       dailyReportFormData.bring_wipes ||
                       dailyReportFormData.bring_ointment ||
                       dailyReportFormData.bring_clothes ||
                       dailyReportFormData.bring_blanket ||
                       dailyReportFormData.other_item;

        if (hasData && selectedStudent) {
            // Auto-save draft to localStorage
            const reportDate = getReportDate();
            saveDraftToLocalStorage(selectedStudent.id, reportDate, dailyReportFormData);
        }
        
        setShowDailyReportFormModal(false);
        resetDailyReportForm();
        setIsDraftMode(false);
    };

    const saveDailyReport = async (saveAsDraft = false) => {
        if (!selectedStudent) {
            Swal.fire({
                title: 'Error',
                text: 'Please select a student',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        // For draft, we don't need strict validation
        if (!saveAsDraft) {
            // Validate required fields for publish
            if (!dailyReportFormData.feeling_id) {
                Swal.fire({
                    title: 'Validation Error',
                    text: 'Please select how the student felt today',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                return;
            }
        }

        setSavingDailyReport(true);
        try {
            const reportDate = getReportDate();
            if (!isToday(reportDate) && !isTeacherLogin) {
                if (saveAsDraft) {
                    saveDraftToLocalStorage(selectedStudent.id, reportDate, dailyReportFormData);
                    setIsDraftMode(true);
                    Swal.fire({
                        title: 'Saved As Local Draft',
                        text: 'The server only allows today\'s daily reports. Your changes were saved locally as a draft for reference.',
                        icon: 'info',
                        confirmButtonText: 'OK'
                    });
                    return;
                }

                Swal.fire({
                    title: 'Today Only',
                    text: 'Daily reports can only be published for today\'s date. Switch to today or save a local draft instead.',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                return;
            }

            const payload = {
                student_id: selectedStudent.id,
                class_id: scheduleInfo?.class_id || profileData?.class_id || profileData?.class?.id,
                report_date: reportDate,
                comments: dailyReportFormData.comments || '',
                learned: dailyReportFormData.learned || '',
                feeling_id: dailyReportFormData.feeling_id || 1,
                status: saveAsDraft ? 0 : 1, // 0 for draft, 1 for published
                diapers: (dailyReportFormData.diapers || [])
                    .filter((diaper) => diaper.diaper_time && diaper.diaper_check)
                    .map((diaper) => ({
                        diaper_time: formatDailyReportApiTime(diaper.diaper_time),
                        diaper_check: diaper.diaper_check
                    })),
                meals: (dailyReportFormData.meals || [])
                    .filter((meal) => meal.menu_meal_id && meal.meal_type_id)
                    .map((meal) => ({
                        meal_time: formatDailyReportApiTime(meal.meal_time) || Moment().format('HH:mm:ss'),
                        menu_meal_id: Number(meal.menu_meal_id),
                        meal_type_id: Number(meal.meal_type_id),
                        meal_amount: normalizeMealAmount(meal.meal_amount)
                    })),
                sleeps: (dailyReportFormData.sleeps || [])
                    .filter((sleep) => sleep.start_time && sleep.end_time)
                    .map((sleep) => ({
                        start_time: formatDailyReportApiTime(sleep.start_time),
                        end_time: formatDailyReportApiTime(sleep.end_time)
                    })),
                bring_diapers: dailyReportFormData.bring_diapers || false,
                bring_wipes: dailyReportFormData.bring_wipes || false,
                bring_ointment: dailyReportFormData.bring_ointment || false,
                bring_clothes: dailyReportFormData.bring_clothes || false,
                bring_blanket: dailyReportFormData.bring_blanket || false,
                other_item: dailyReportFormData.other_item || ''
            };

            console.log('Saving daily report with payload:', payload);

            const response = await apiHandler(DAILY_REPORT_STORE, 'POST', payload);

            console.log('Daily report response:', response);

            if (response.data?.response?.status === 200) {
                if (saveAsDraft) {
                    // Save draft to localStorage for quick access
                    saveDraftToLocalStorage(selectedStudent.id, reportDate, dailyReportFormData);
                    setIsDraftMode(true);
                } else {
                    // Clear draft from localStorage on successful publish
                    clearDraftFromLocalStorage(selectedStudent.id, reportDate);
                    Swal.fire({
                        title: 'Success!',
                        text: response.data?.data?.message || 'Daily report published successfully!',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setIsDraftMode(false);
                }
                setShowDailyReportFormModal(false);
                resetDailyReportForm();
                setSelectedStudent(null);
                setIsEditingDailyReport(false);
                // Refresh the attendance data to show the new report
                await loadAttendanceData();
            } else {
                throw new Error(response.data?.response?.message || response.data?.data?.message || 'Failed to save daily report');
            }
        } catch (error) {
            console.error('Error saving daily report:', error);
            const backendMessage = error?.response?.data?.data?.message || error?.response?.data?.response?.message || error.message;
            if (error?.response?.status === 403 || /today's date/i.test(backendMessage || '')) {
                Swal.fire({
                    title: 'Today Only',
                    text: backendMessage || 'The server only allows updating daily reports for today.',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                return;
            }
            Swal.fire({
                title: 'Error',
                text: backendMessage || 'Failed to save daily report',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setSavingDailyReport(false);
        }
    };

    const getDailyReportPublishStatusLabel = (statusValue) => {
        if (statusValue === null || typeof statusValue === 'undefined' || statusValue === '') {
            return 'not_created';
        }

        const normalizedStatus = String(statusValue).trim().toLowerCase();

        if (normalizedStatus === 'published' || normalizedStatus === '1') {
            return 'published';
        }

        if (normalizedStatus === 'draft' || normalizedStatus === '0') {
            return 'draft';
        }

        return 'not_created';
    };

    // Feeds the per-student "Report Published/Draft/Not Created" badge shown
    // on each student's card (see dailyReportStatusByStudent) — kept in sync
    // automatically whenever the roster, date, or room changes.
    const fetchDailyReportStatusRows = async () => {
        if (!students.length) {
            setDailyReportStatusByStudent({});
            return;
        }

        const statusMap = students
            .filter((student) => !isStudentOnLeave(student))
            .reduce((acc, student) => {
                acc[student.id] = getDailyReportPublishStatusLabel(student.daily_report_status);
                return acc;
            }, {});

        setDailyReportStatusByStudent(statusMap);
    };

    // Flattens one raw medication/non-medication record from the API into
    // the shape the existing detail Card reads (medicationData/
    // nonMedicationData) - factored out so both the single-record open and
    // picking a record from the list use the exact same mapping.
    const buildMedicationDetailData = (medication, studentData, student) => ({
        student_id: student.id,
        first_name: studentData?.name?.split(' ')[0] || student.name.split(' ')[0],
        last_name: studentData?.name?.split(' ').slice(1).join(' ') || student.name.split(' ').slice(1).join(' '),
        student_email: studentData?.email || student.email,
        date_of_birth: 'N/A',
        class_name: 'N/A',
        parent_name: medication.parent_name || 'N/A',
        medication_name: medication.medication_name || 'N/A',
        times_to_be_administered: medication.times_to_be_administered ? (medication.times_to_be_administered.includes(':') ? formatDisplayTime(medication.times_to_be_administered) : medication.times_to_be_administered) : 'N/A',
        date_start: medication.date_start || null,
        date_end: medication.date_end || null,
        expiry_date: medication.expiry_date || null,
        parents_consent_and_instruction: medication.parents_consent_and_instruction || 'N/A',
        additional_instructions: medication.additional_instructions || 'N/A',
        reason_for_administering: medication.reason_for_administering || 'N/A',
        doctor_note: medication.doctor_note || null,
        signiture_of_parent: medication.signiture_of_parent || null,
        signature_date: formatDisplayDate(medication.signature_date),
        medication_id: medication.id,
        status: medication.status
    });

    // Ongoing = today falls inside [date_start, date_end]; upcoming =
    // date_start is still in the future; past = date_end has already
    // passed. Used to both label and order the record list (ongoing first,
    // then upcoming, then past) so a teacher sees what's active right now
    // before anything else.
    const getMedicationRecordBucket = (record) => {
        const today = Moment().startOf('day');
        const start = record.date_start ? Moment(record.date_start).startOf('day') : null;
        const end = record.date_end ? Moment(record.date_end).endOf('day') : null;
        if (start && start.isAfter(today)) return 'upcoming';
        if (end && end.isBefore(today)) return 'past';
        return 'ongoing';
    };

    const bucketAndSortMedicationRecords = (records) => {
        const order = { ongoing: 0, upcoming: 1, past: 2 };
        return [...records]
            .map((r) => ({ ...r, _bucket: getMedicationRecordBucket(r) }))
            .sort((a, b) => {
                if (order[a._bucket] !== order[b._bucket]) return order[a._bucket] - order[b._bucket];
                if (a._bucket === 'past') return Moment(b.date_end).valueOf() - Moment(a.date_end).valueOf();
                return Moment(a.date_start).valueOf() - Moment(b.date_start).valueOf();
            });
    };

    // MedicationModal (components/modals/MedicationModal.js) fetches its own
    // data from studentId and owns its own log add/edit/delete state now -
    // shared with notification.js so a teacher sees and manages the exact
    // same modal from either page.
    const viewMedication = (student) => {
        setSelectedStudent(student);
        setShowMedicationModal(true);
    };

    const selectMedicationRecord = (record) => {
        setMedicationData(record._detail);
        setSelectedMedicationRecordId(record.id);
    };

    const selectNonMedicationRecord = (record) => {
        setNonMedicationData(record._detail);
        setSelectedNonMedicationRecordId(record.id);
    };

    // Medication Log Functions
    const handleAddMedicationLog = () => {
        // Reset form data
        setMedicationLogData({
            medication_date: new Date().toISOString().split('T')[0],
            medication: medicationData?.medication?.medication_name || '',
            is_dosage_given: 1,
            time_given: new Date().toTimeString().slice(0, 8),
            staff_signiture: '',
            comments: ''
        });
        setShowMedicationLogForm(true);
    };

    const saveMedicationLog = async () => {
        if (!medicationLogData.medication_date || !medicationLogData.medication) {
            Swal.fire({
                title: 'Validation Error',
                text: 'Please fill in medication date and medication name',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        try {
            setIsLoadingLogs(true);
            
            // Handle signature from canvas
            let signatureUrl = medicationLogData.staff_signiture;
            const hasNewSignature = medicationSignaturePadRef.current && !medicationSignaturePadRef.current.isEmpty();
            
            if (hasNewSignature) {
                const signatureDataURL = medicationSignaturePadRef.current.toDataURL('image/png');
                const signatureBlob = await fetch(signatureDataURL).then(res => res.blob());
                const signatureFile = new File([signatureBlob], `staff_signature_${Date.now()}.png`, { type: 'image/png' });
                signatureUrl = await handleImageUpload(signatureFile, 'signatures/', 'image/png');
            }
            
            const payload = {
                user_id: selectedStudent.id,
                administration_medication_id: medicationData.medication_id,
                medication_date: medicationLogData.medication_date,
                medication: medicationLogData.medication,
                is_dosage_given: medicationLogData.is_dosage_given
            };
            
            // Only include optional fields if they have values
            if (medicationLogData.time_given) {
                payload.time_given = medicationLogData.time_given;
            }
            if (signatureUrl) {
                payload.staff_signiture = signatureUrl;
            }
            if (medicationLogData.comments) {
                payload.comments = medicationLogData.comments;
            }

            let response;
            if (isEditingMedicationLog && medicationLogData.id) {
                // Update existing log
                response = await apiHandler(`${TEACHERS_MEDICATION_LOG_API}${medicationLogData.id}`, 'POST', payload);
            } else {
                // Create new log
                response = await apiHandler(TEACHERS_MEDICATION_LOG_STORE_API, 'POST', payload);
            }

            if (response.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Success',
                    text: isEditingMedicationLog ? 'Medication log updated successfully' : 'Medication log added successfully',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                setShowMedicationLogFormModal(false);
                setIsEditingMedicationLog(false);
                // Reload medication data to get updated logs
                await viewMedication(selectedStudent);
            } else {
                throw new Error(response.data?.response?.message || 'Failed to save medication log');
            }
        } catch (error) {
            console.error('Error saving medication log:', error);
            Swal.fire({
                title: 'Error',
                text: error.message || 'Failed to save medication log',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setIsLoadingLogs(false);
        }
    };

    const viewMedicationLog = (log) => {
        setSelectedLog(log);
        setShowLogViewModal(true);
    };

    const deleteMedicationLog = async (logId, medicationId) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'This medication log will be permanently deleted.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await apiHandler(`users/v1/attendance/medication/log/${logId}`, 'DELETE');

                if (response.data?.response?.status === 200) {
                    Swal.fire({
                        title: 'Deleted!',
                        text: 'Medication log has been deleted successfully.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });

                    // Reload medication data
                    await viewMedication(selectedStudent);
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: response.data?.response?.message || 'Failed to delete medication log',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }
            } catch (error) {
                console.error('Error deleting medication log:', error);
                Swal.fire({
                    title: 'Network Error',
                    text: 'Unable to connect to the server. Please check your internet connection.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        }
    };

    const editMedicationLog = (log) => {
        setMedicationLogData({
            id: log.id,
            medication_date: log.medication_date ? Moment(log.medication_date).format('YYYY-MM-DD') : '',
            medication: log.medication || '',
            is_dosage_given: log.is_dosage_given || 1,
            time_given: log.time_given || '',
            staff_signiture: log.staff_signiture || '',
            comments: log.comments || ''
        });
        setIsEditingMedicationLog(true);
        setShowMedicationLogFormModal(true);
    };

    // Non-Medication Log Functions
    const saveNonMedicationLog = async () => {
        if (!nonMedicationLogData.medication_date || !nonMedicationLogData.medication) {
            Swal.fire({
                title: 'Validation Error',
                text: 'Please fill in medication date and medication name',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        try {
            setIsLoadingLogs(true);
            
            // Handle signature from canvas
            let signatureUrl = nonMedicationLogData.staff_signiture;
            const hasNewSignature = nonMedicationSignaturePadRef.current && !nonMedicationSignaturePadRef.current.isEmpty();
            
            if (hasNewSignature) {
                const signatureDataURL = nonMedicationSignaturePadRef.current.toDataURL('image/png');
                const signatureBlob = await fetch(signatureDataURL).then(res => res.blob());
                const signatureFile = new File([signatureBlob], `staff_signature_${Date.now()}.png`, { type: 'image/png' });
                signatureUrl = await handleImageUpload(signatureFile, 'signatures/', 'image/png');
            }
            
            const payload = {
                user_id: selectedStudent.id,
                administration_non_medication_id: nonMedicationData.non_medication_id,
                medication_date: nonMedicationLogData.medication_date,
                medication: nonMedicationLogData.medication,
                is_dosage_given: nonMedicationLogData.is_dosage_given
            };
            
            // Only include optional fields if they have values
            if (nonMedicationLogData.time_given) {
                payload.time_given = nonMedicationLogData.time_given;
            }
            if (signatureUrl) {
                payload.staff_signiture = signatureUrl;
            }
            if (nonMedicationLogData.comments) {
                payload.comments = nonMedicationLogData.comments;
            }

            let response;
            if (isEditingNonMedicationLog && nonMedicationLogData.id) {
                // Update existing log
                response = await apiHandler(`${TEACHERS_NON_MEDICATION_LOG_API}${nonMedicationLogData.id}`, 'POST', payload);
            } else {
                // Create new log
                response = await apiHandler(TEACHERS_NON_MEDICATION_LOG_STORE_API, 'POST', payload);
            }

            if (response.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Success',
                    text: isEditingNonMedicationLog ? 'Non-medication log updated successfully' : 'Non-medication log added successfully',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                setShowNonMedicationLogFormModal(false);
                setIsEditingNonMedicationLog(false);
                // Reload non-medication data to get updated logs
                await viewNonMedication(selectedStudent);
            } else {
                throw new Error(response.data?.response?.message || 'Failed to save non-medication log');
            }
        } catch (error) {
            console.error('Error saving non-medication log:', error);
            Swal.fire({
                title: 'Error',
                text: error.message || 'Failed to save non-medication log',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setIsLoadingLogs(false);
        }
    };

    const deleteNonMedicationLog = async (logId) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'This non-medication log will be permanently deleted.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await apiHandler(`${TEACHERS_NON_MEDICATION_LOG_API}${logId}`, 'DELETE');

                if (response.data?.response?.status === 200) {
                    Swal.fire({
                        title: 'Deleted!',
                        text: 'Non-medication log has been deleted successfully.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });

                    // Reload non-medication data
                    await viewNonMedication(selectedStudent);
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: response.data?.response?.message || 'Failed to delete non-medication log',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }
            } catch (error) {
                console.error('Error deleting non-medication log:', error);
                Swal.fire({
                    title: 'Network Error',
                    text: 'Unable to connect to the server. Please check your internet connection.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        }
    };

    const editNonMedicationLog = (log) => {
        setNonMedicationLogData({
            id: log.id,
            medication_date: log.medication_date ? Moment(log.medication_date).format('YYYY-MM-DD') : '',
            medication: log.medication || '',
            is_dosage_given: log.is_dosage_given || 1,
            time_given: log.time_given || '',
            staff_signiture: log.staff_signiture || '',
            comments: log.comments || ''
        });
        setIsEditingNonMedicationLog(true);
        setShowNonMedicationLogFormModal(true);
    };

    const buildNonMedicationDetailData = (non_medication, studentData, student, non_medication_logs) => ({
        student_id: student.id,
        student_name: studentData?.name || student.name,
        student_email: studentData?.email || student.email,
        parent_name: non_medication.parent_name || 'N/A',
        medication_name: non_medication.medication_name || 'N/A',
        times_to_be_administered: non_medication.times_to_be_administered ? (non_medication.times_to_be_administered.includes(':') ? formatDisplayTime(non_medication.times_to_be_administered) : non_medication.times_to_be_administered) : 'N/A',
        date_start: non_medication.date_start || null,
        date_end: non_medication.date_end || null,
        expiry_date: non_medication.expiry_date || null,
        parents_consent_and_instruction: non_medication.parents_consent_and_instruction || 'N/A',
        additional_instructions: non_medication.additional_instructions || 'N/A',
        reason_for_administering: non_medication.reason_for_administering || 'N/A',
        doctor_note: non_medication.doctor_note || null,
        signiture_of_parent: non_medication.signiture_of_parent || null,
        signature_date: formatDisplayDate(non_medication.signature_date),
        non_medication_id: non_medication.id,
        non_medication_logs: non_medication_logs || [],
        status: non_medication.status
    });

    // NonMedicationModal (components/modals/NonMedicationModal.js) fetches
    // its own data from studentId and owns its own log add/edit/delete state
    // now - shared with notification.js.
    const viewNonMedication = (student) => {
        setSelectedStudent(student);
        setShowNonMedicationModal(true);
    };

    // AllergyModal (components/modals/AllergyModal.js) fetches its own data
    // from studentId now - shared with notification.js so a teacher sees the
    // exact same modal from either page instead of two separately-maintained
    // copies.
    const viewAllergy = (student) => {
        setSelectedStudent(student);
        setShowAllergyModal(true);
        if (document.activeElement) {
            document.activeElement.blur();
        }
    };

    const viewRegistration = async (student) => {
        setRegistrationLoading(true);
        setShowRegistrationModal(true);
        try {
            const response = await apiHandler(CHILD_REGISTRATION_VIEW, 'POST', {
                student_id: student.id
            });
            if (response.data?.response?.status === 200) {
                // Extract and flatten the nested data structure
                const apiData = response.data?.data?.data || response.data?.data || {};
                const userDetails = apiData.user_details || {};
                const registrationPackage = apiData.registration_package || {};
                
                console.log('Raw API Response:', apiData);
                console.log('User Details:', userDetails);
                console.log('Registration Package:', registrationPackage);
                
                // Merge user_details and registration_package into a flat structure
                const flattenedData = {
                    ...registrationPackage,
                    user_details: userDetails,
                    // Child Info
                    child_first_name: userDetails.first_name || registrationPackage.child_first_name,
                    child_last_name: userDetails.last_name || registrationPackage.child_last_name,
                    child_email: userDetails.email || registrationPackage.child_email,
                    child_dob: userDetails.user_setting?.dob || registrationPackage.child_dob || registrationPackage.child_date_of_birth,
                    child_gender: userDetails.user_setting?.gender || registrationPackage.child_gender,
                    child_photo: userDetails.user_setting?.photo || registrationPackage.child_photo,
                    child_age: registrationPackage.child_age,
                    child_home_address: userDetails.user_setting?.address || registrationPackage.child_home_address || registrationPackage.child_address,
                    child_city: registrationPackage.child_city,
                    child_province: registrationPackage.child_province,
                    child_state: registrationPackage.child_state,
                    child_postal_code: registrationPackage.child_postal_code,
                    // Mother/Parent 1
                    mother_name: registrationPackage.mother_name || registrationPackage.parent1_name,
                    mother_home_phone: registrationPackage.mother_home_phone || registrationPackage.parent1_home_phone,
                    mother_cell: registrationPackage.mother_cell || registrationPackage.parent1_cell,
                    mother_email: registrationPackage.mother_email || registrationPackage.parent1_email,
                    mother_home_address: registrationPackage.mother_home_address || registrationPackage.parent1_home_address,
                    mother_city: registrationPackage.mother_city || registrationPackage.parent1_city,
                    mother_province: registrationPackage.mother_province || registrationPackage.parent1_province,
                    mother_state: registrationPackage.mother_state || registrationPackage.parent1_state,
                    mother_postal_code: registrationPackage.mother_postal_code || registrationPackage.parent1_postal_code,
                    mother_work_phone: registrationPackage.mother_work_phone || registrationPackage.parent1_work_phone,
                    // Father/Parent 2
                    father_name: registrationPackage.father_name || registrationPackage.parent2_name,
                    father_home_phone: registrationPackage.father_home_phone || registrationPackage.parent2_home_phone,
                    father_cell: registrationPackage.father_cell || registrationPackage.parent2_cell,
                    father_email: registrationPackage.father_email || registrationPackage.parent2_email,
                    father_home_address: registrationPackage.father_home_address || registrationPackage.parent2_home_address,
                    father_city: registrationPackage.father_city || registrationPackage.parent2_city,
                    father_province: registrationPackage.father_province || registrationPackage.parent2_province,
                    father_state: registrationPackage.father_state || registrationPackage.parent2_state,
                    father_postal_code: registrationPackage.father_postal_code || registrationPackage.parent2_postal_code,
                    father_work_phone: registrationPackage.father_work_phone || registrationPackage.parent2_work_phone,
                    same_address: registrationPackage.same_address,
                    // Emergency Contact
                    emergency_contact_name: registrationPackage.emergency_contact_name,
                    emergency_contact_relationship: registrationPackage.emergency_contact_relationship || registrationPackage.emergency_contact_relation,
                    emergency_contact_phone: registrationPackage.emergency_contact_phone || registrationPackage.emergency_contact_home_phone,
                    emergency_contact_cell: registrationPackage.emergency_contact_cell,
                    emergency_contact_email: registrationPackage.emergency_contact_email,
                    emergency_contact_home_address: registrationPackage.emergency_contact_home_address || registrationPackage.emergency_contact_address,
                    emergency_contact_city: registrationPackage.emergency_contact_city,
                    emergency_contact_province: registrationPackage.emergency_contact_province,
                    emergency_contact_state: registrationPackage.emergency_contact_state,
                    emergency_contact_postal_code: registrationPackage.emergency_contact_postal_code,
                    emergency_contact_work_phone: registrationPackage.emergency_contact_work_phone,
                    emergency_contact_work_address: registrationPackage.emergency_contact_work_address,
                    // Pickup Persons
                    pickup1_name: registrationPackage.pickup1_name || registrationPackage.pickup_person1_name,
                    pickup1_relation: registrationPackage.pickup1_relation || registrationPackage.pickup_person1_relation,
                    pickup1_phone: registrationPackage.pickup1_phone || registrationPackage.pickup_person1_phone,
                    pickup1_cell: registrationPackage.pickup1_cell || registrationPackage.pickup_person1_cell,
                    pickup1_address: registrationPackage.pickup1_address || registrationPackage.pickup_person1_address,
                    pickup1_city: registrationPackage.pickup1_city || registrationPackage.pickup_person1_city,
                    pickup1_zip: registrationPackage.pickup1_zip || registrationPackage.pickup_person1_postal_code,
                    pickup2_name: registrationPackage.pickup2_name || registrationPackage.pickup_person2_name,
                    pickup2_relation: registrationPackage.pickup2_relation || registrationPackage.pickup_person2_relation,
                    pickup2_phone: registrationPackage.pickup2_phone || registrationPackage.pickup_person2_phone,
                    pickup2_cell: registrationPackage.pickup2_cell || registrationPackage.pickup_person2_cell,
                    pickup2_address: registrationPackage.pickup2_address || registrationPackage.pickup_person2_address,
                    pickup2_city: registrationPackage.pickup2_city || registrationPackage.pickup_person2_city,
                    pickup2_zip: registrationPackage.pickup2_zip || registrationPackage.pickup_person2_postal_code,
                    pickup3_name: registrationPackage.pickup3_name || registrationPackage.pickup_person3_name,
                    pickup3_relation: registrationPackage.pickup3_relation || registrationPackage.pickup_person3_relation,
                    pickup3_phone: registrationPackage.pickup3_phone || registrationPackage.pickup_person3_phone,
                    pickup3_cell: registrationPackage.pickup3_cell || registrationPackage.pickup_person3_cell,
                    pickup3_address: registrationPackage.pickup3_address || registrationPackage.pickup_person3_address,
                    pickup3_city: registrationPackage.pickup3_city || registrationPackage.pickup_person3_city,
                    pickup3_zip: registrationPackage.pickup3_zip || registrationPackage.pickup_person3_postal_code,
                    pickup4_name: registrationPackage.pickup4_name || registrationPackage.pickup_person4_name,
                    pickup4_relation: registrationPackage.pickup4_relation || registrationPackage.pickup_person4_relation,
                    pickup4_phone: registrationPackage.pickup4_phone || registrationPackage.pickup_person4_phone,
                    pickup4_cell: registrationPackage.pickup4_cell || registrationPackage.pickup_person4_cell,
                    pickup4_address: registrationPackage.pickup4_address || registrationPackage.pickup_person4_address,
                    pickup4_city: registrationPackage.pickup4_city || registrationPackage.pickup_person4_city,
                    pickup4_zip: registrationPackage.pickup4_zip || registrationPackage.pickup_person4_postal_code,
                    // Arrival and Departure
                    dropoff_time: registrationPackage.dropoff_time || registrationPackage.drop_off_time,
                    pickup_time: registrationPackage.pickup_time || registrationPackage.pick_up_time,
                    start_date: registrationPackage.start_date,
                    withdrawal_date: registrationPackage.withdrawal_date,
                    parent_guardian_signature: registrationPackage.parent_guardian_signature || registrationPackage.parent_signature,
                    executive_director_signature: registrationPackage.executive_director_signature,
                    // Medical Information
                    family_physician_name: registrationPackage.family_physician_name || registrationPackage.pediatrician_name,
                    physician_phone_number: registrationPackage.physician_phone_number || registrationPackage.pediatrician_phone,
                    physician_address: registrationPackage.physician_address,
                    current_medications: registrationPackage.current_medications || registrationPackage.medications,
                    allergies_health_info: registrationPackage.allergies_health_info || registrationPackage.allergies,
                    sleep_time_night: registrationPackage.sleep_time_night || registrationPackage.sleep_time,
                    wake_time_morning: registrationPackage.wake_time_morning || registrationPackage.wake_time,
                    child_favourite_activity: registrationPackage.child_favourite_activity,
                    emergency_auth_signature: registrationPackage.emergency_auth_signature,
                    emergency_auth_date: registrationPackage.emergency_auth_date,
                    // Child Information Page
                    agency_involvement: registrationPackage.agency_involvement || registrationPackage.child_related_agencies_involvement,
                    vision_history: registrationPackage.vision_history || registrationPackage.vision_history_glasses,
                    hearing_concerns: registrationPackage.hearing_concerns || registrationPackage.hearing_concerns_audiologist,
                    diagnoses: registrationPackage.diagnoses || registrationPackage.diagnoses_adhd_delays,
                    communicable_disease: registrationPackage.communicable_disease || registrationPackage.communicable_disease_history,
                    eating_concerns: registrationPackage.eating_concerns || registrationPackage.eating_appetite_concerns,
                    developmental_concerns: registrationPackage.developmental_concerns,
                    pets_at_home: registrationPackage.pets_at_home,
                    siblings_info: registrationPackage.siblings_info || registrationPackage.siblings_family_info,
                    favourite_toy: registrationPackage.favourite_toy || registrationPackage.child_favourite_toy_activity,
                    enrollment_date: registrationPackage.enrollment_date,
                    // Media Release Waiver
                    media_release_agree: registrationPackage.media_release_agree,
                    media_release_disagree: registrationPackage.media_release_disagree,
                    media_release_child_name: registrationPackage.media_release_child_name,
                    media_release_child_name_agree: registrationPackage.media_release_child_name_agree,
                    media_release_child_name_disagree: registrationPackage.media_release_child_name_disagree,
                    media_release_parent_name: registrationPackage.media_release_parent_name,
                    media_release_parent_name_agree: registrationPackage.media_release_parent_name_agree,
                    media_release_parent_name_disagree: registrationPackage.media_release_parent_name_disagree,
                    media_release_date: registrationPackage.media_release_date,
                    media_release_date_agree: registrationPackage.media_release_date_agree,
                    media_release_date_disagree: registrationPackage.media_release_date_disagree,
                    media_release_signature: registrationPackage.media_release_signature,
                    media_release_signature_agree: registrationPackage.media_release_signature_agree,
                    media_release_signature_disagree: registrationPackage.media_release_signature_disagree,
                    // Off-Site Permission
                    offsite_permission: registrationPackage.offsite_permission,
                    offsite_parent_name: registrationPackage.offsite_parent_name,
                    offsite_permission_parent_name: registrationPackage.offsite_permission_parent_name,
                    offsite_child_name: registrationPackage.offsite_child_name,
                    offsite_permission_child_name: registrationPackage.offsite_permission_child_name,
                    offsite_date: registrationPackage.offsite_date,
                    offsite_permission_date: registrationPackage.offsite_permission_date,
                    offsite_signature: registrationPackage.offsite_signature,
                    offsite_permission_signature: registrationPackage.offsite_permission_signature,
                    // Contract Terms
                    contract_terms_initials: registrationPackage.contract_terms_initials,
                    contract_initial_1: registrationPackage.contract_initial_1,
                    contract_initial_2: registrationPackage.contract_initial_2,
                    contract_initial_3: registrationPackage.contract_initial_3,
                    contract_initial_4: registrationPackage.contract_initial_4,
                    contract_initial_5: registrationPackage.contract_initial_5,
                    contract_initial_6: registrationPackage.contract_initial_6,
                    contract_initial_7: registrationPackage.contract_initial_7,
                    contract_initial_8: registrationPackage.contract_initial_8,
                    contract_initial_9: registrationPackage.contract_initial_9,
                    contract_initial_10: registrationPackage.contract_initial_10,
                    contract_initial_11: registrationPackage.contract_initial_11,
                    contract_initial_12: registrationPackage.contract_initial_12,
                    contract_initial_13: registrationPackage.contract_initial_13,
                    contract_parent_name: registrationPackage.contract_parent_name,
                    contract_date: registrationPackage.contract_date,
                    contract_signature: registrationPackage.contract_signature,
                    financially_responsible_name: registrationPackage.financially_responsible_name,
                    financially_responsible_agency: registrationPackage.financially_responsible_agency,
                    financially_responsible_date: registrationPackage.financially_responsible_date,
                    financially_responsible_signature: registrationPackage.financially_responsible_signature,
                    // Registration Checklist
                    checklist_submitted: registrationPackage.checklist_submitted,
                    checklist_items: registrationPackage.checklist_items,
                    checklist_registration_form: registrationPackage.checklist_registration_form,
                    checklist_emergency_form: registrationPackage.checklist_emergency_form,
                    checklist_health_forms: registrationPackage.checklist_health_forms,
                    checklist_immunization_records: registrationPackage.checklist_immunization_records,
                    checklist_physical_exam: registrationPackage.checklist_physical_exam,
                    checklist_allergy_action_plan: registrationPackage.checklist_allergy_action_plan,
                    checklist_medication_authorization: registrationPackage.checklist_medication_authorization,
                    checklist_photo_release: registrationPackage.checklist_photo_release,
                    checklist_contract_signed: registrationPackage.checklist_contract_signed,
                    checklist_tuition_payment: registrationPackage.checklist_tuition_payment,
                    checklist_no_peanut_policy: registrationPackage.checklist_no_peanut_policy,
                    checklist_offsite_permission: registrationPackage.checklist_offsite_permission,
                    checklist_meal_waiver: registrationPackage.checklist_meal_waiver,
                    checklist_parent_date: registrationPackage.checklist_parent_date,
                    checklist_parent_signature: registrationPackage.checklist_parent_signature,
                    checklist_staff_date: registrationPackage.checklist_staff_date,
                    checklist_staff_signature: registrationPackage.checklist_staff_signature
                };
                
                console.log('Flattened Registration data:', flattenedData);
                setRegistrationData(flattenedData);
                setSelectedStudent(student);
                setRegistrationLoading(false);
                // Remove focus from button
                if (document.activeElement) {
                    document.activeElement.blur();
                }
            } else {
                setRegistrationLoading(false);
                setShowRegistrationModal(false);
                Swal.fire({
                    title: 'Info',
                    text: response.data?.response?.message || 'No registration form found for this student',
                    icon: 'info',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            setRegistrationLoading(false);
            setShowRegistrationModal(false);
            console.error('Error loading registration form:', error);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load registration form',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const viewMeditationExercises = (student) => {
        setMeditationData({
            student: {
                id: student.id,
                name: student.name,
                photo: student.profile_photo_url
            },
            exercises: [
                { id: 1, name: 'Deep Breathing', duration: '5 minutes', description: 'Inhale deeply through nose, exhale through mouth' },
                { id: 2, name: 'Body Scan', duration: '10 minutes', description: 'Focus attention on different parts of the body' },
                { id: 3, name: 'Mindful Sitting', duration: '5 minutes', description: 'Sit quietly and observe thoughts without judgment' },
                { id: 4, name: 'Loving Kindness', duration: '7 minutes', description: 'Send positive wishes to self and others' }
            ]
        });
        setSelectedStudent(student);
        setShowMeditationModal(true);
        // Remove focus from button
        if (document.activeElement) {
            document.activeElement.blur();
        }
    };

    // PeanutPolicyModal (components/modals/PeanutPolicyModal.js) fetches its
    // own data from studentId now - shared with notification.js.
    const viewPeanutPolicy = (student) => {
        setSelectedStudent(student);
        setShowPeanutPolicyModal(true);
    };

    // View Accident Reports for a student
    const viewAccidentReports = async (student) => {
        setLoadingAccidentReports(true);
        setShowAccidentReportsModal(true);
        setSelectedStudent(student);
        try {
            const formData = new FormData();
            formData.append('page', 1);
            formData.append('limit', 100);
            formData.append('user_id', student.id);
            
            const response = await apiHandler(ACCIDENT_REPORTS_LIST, 'POST', formData);
            if (response.data?.response?.status === 200) {
                const reports = response.data.data.data.data || [];
                setAccidentReports(reports);
                setLoadingAccidentReports(false);
                // Opened via a notification deep-link (see the query-param
                // effect below), the caller only has the student's id, not
                // their name - backfill it from the report itself (the API
                // now snapshots student_name onto every row) once it's in.
                if (!student.name && reports[0]?.student_name) {
                    setSelectedStudent((prev) => (prev ? { ...prev, name: reports[0].student_name } : prev));
                }
            } else {
                setLoadingAccidentReports(false);
                setAccidentReports([]);
            }
        } catch (error) {
            console.error('Error loading accident reports:', error);
            setLoadingAccidentReports(false);
            setAccidentReports([]);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load accident reports',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    // View Illness Reports for a student
    const viewIllnessReports = async (student) => {
        setLoadingIllnessReports(true);
        setShowIllnessReportsModal(true);
        setSelectedStudent(student);
        try {
            const formData = new FormData();
            formData.append('page', 1);
            formData.append('limit', 100);
            formData.append('user_id', student.id);
            
            const response = await apiHandler(ILLNESS_REPORTS_LIST, 'POST', formData);
            if (response.data?.response?.status === 200) {
                const reports = response.data.data.data.data || [];
                setIllnessReports(reports);
                setLoadingIllnessReports(false);
                // Same reasoning as viewAccidentReports above - backfill the
                // student's name from the report once it's fetched, for the
                // notification deep-link path that only has an id.
                if (!student.name && reports[0]?.student_name) {
                    setSelectedStudent((prev) => (prev ? { ...prev, name: reports[0].student_name } : prev));
                }
            } else {
                setLoadingIllnessReports(false);
                setIllnessReports([]);
            }
        } catch (error) {
            console.error('Error loading illness reports:', error);
            setLoadingIllnessReports(false);
            setIllnessReports([]);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load illness reports',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    // A teacher clicking an Accident/Illness Report, Medication,
    // Non-Medication, Allergy Action Plan, Lunch Plan Waiver, or No Peanut
    // Policy notification is routed here (see notification.js's
    // generateURL, case 13/14/15/16/17/20/22) instead of that page's own
    // limited, separately-maintained modal - this page already has the real
    // ones (viewAccidentReports/viewIllnessReports/viewMedication/
    // viewNonMedication/viewAllergy/viewLunchPlan/viewPeanutPolicy above),
    // matching the actual intake forms' fields including signatures.
    // Deliberately does NOT strip the query param back off afterward (an
    // earlier version called navigate(location.pathname, {replace:true})
    // right after opening the modal) - firing a second navigation here raced
    // with the one that just brought us to this page and could resolve
    // against a stale location, sending the browser back to wherever it
    // came from instead of just cleaning the URL. A stray query param left
    // in the address bar is a much smaller cost than that.
    useEffect(() => {
        if (!location.search) return;
        const params = new URLSearchParams(location.search);
        const accidentStudentId = params.get('openAccidentReportStudentId');
        const illnessStudentId = params.get('openIllnessReportStudentId');
        const medicationStudentId = params.get('openMedicationStudentId');
        const nonMedicationStudentId = params.get('openNonMedicationStudentId');
        const allergyStudentId = params.get('openAllergyStudentId');
        const lunchPlanStudentId = params.get('openLunchPlanStudentId');
        const peanutPolicyStudentId = params.get('openPeanutPolicyStudentId');

        if (accidentStudentId) {
            viewAccidentReports({ id: Number(accidentStudentId), name: '' });
        } else if (illnessStudentId) {
            viewIllnessReports({ id: Number(illnessStudentId), name: '' });
        } else if (medicationStudentId) {
            viewMedication({ id: Number(medicationStudentId), name: '', email: '' });
        } else if (nonMedicationStudentId) {
            viewNonMedication({ id: Number(nonMedicationStudentId), name: '', email: '' });
        } else if (allergyStudentId) {
            viewAllergy({ id: Number(allergyStudentId), name: '' });
        } else if (lunchPlanStudentId) {
            viewLunchPlan({ id: Number(lunchPlanStudentId), name: '' });
        } else if (peanutPolicyStudentId) {
            viewPeanutPolicy({ id: Number(peanutPolicyStudentId), name: '' });
        }
        // Depends on location.search (not just []) so this still fires if
        // this page was already mounted (e.g. a teacher already sitting on
        // Attendance in this tab clicks a notification) and React Router
        // reuses the existing instance instead of remounting it - a bare []
        // effect would silently miss that case.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);

    // Handle signing accident report
    const handleSignAccidentReport = (report) => {
        setSelectedAccidentReport(report);
        setAccidentSignatureDate('');
        setShowAccidentSignatureModal(true);
    };

    // Submit accident report signature
    const submitAccidentReportSignature = async () => {
        if (!accidentSignaturePadRef.current || accidentSignaturePadRef.current.isEmpty()) {
            Swal.fire({
                icon: 'warning',
                title: 'Signature Required',
                text: 'Please provide your signature before submitting.'
            });
            return;
        }

        if (!accidentSignatureDate) {
            Swal.fire({
                icon: 'warning',
                title: 'Date Required',
                text: 'Please select a signature date.'
            });
            return;
        }

        try {
            const signatureDataURL = accidentSignaturePadRef.current.toDataURL('image/png');
            const response = await fetch(signatureDataURL);
            const blob = await response.blob();
            const timestamp = new Date().getTime();
            const fileName = `signature_${timestamp}.png`;
            const file = new File([blob], fileName, { type: 'image/png' });
            const signatureUrl = await handleImageUpload(file, 'signatures/', 'image/png');

            const formData = new FormData();
            formData.append('id', selectedAccidentReport.id);
            formData.append('parent_signature', signatureUrl);
            formData.append('parent_signature_date', accidentSignatureDate);

            const submitResponse = await apiHandler(ACCIDENT_REPORT_SIGNATURE, 'POST', formData);

            if (submitResponse.data?.response?.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Signature submitted successfully.',
                    timer: 2000,
                    showConfirmButton: false
                });

                setShowAccidentSignatureModal(false);
                // Reload accident reports
                await viewAccidentReports(selectedStudent);
            } else {
                throw new Error(submitResponse.data?.response?.message || 'Signature submission failed');
            }
        } catch (error) {
            console.error('Error submitting signature:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Failed to submit signature. Please try again.'
            });
        }
    };

    // Handle signing illness report
    const handleSignIllnessReport = (report) => {
        setSelectedIllnessReport(report);
        setIllnessSignatureDate('');
        setShowIllnessSignatureModal(true);
    };

    // Submit illness report signature
    const submitIllnessReportSignature = async () => {
        if (!illnessSignaturePadRef.current || illnessSignaturePadRef.current.isEmpty()) {
            Swal.fire({
                icon: 'warning',
                title: 'Signature Required',
                text: 'Please provide your signature before submitting.'
            });
            return;
        }

        if (!illnessSignatureDate) {
            Swal.fire({
                icon: 'warning',
                title: 'Date Required',
                text: 'Please select a signature date.'
            });
            return;
        }

        try {
            const signatureDataURL = illnessSignaturePadRef.current.toDataURL('image/png');
            const response = await fetch(signatureDataURL);
            const blob = await response.blob();
            const timestamp = new Date().getTime();
            const fileName = `signature_${timestamp}.png`;
            const file = new File([blob], fileName, { type: 'image/png' });
            const signatureUrl = await handleImageUpload(file, 'signatures/', 'image/png');

            const formData = new FormData();
            formData.append('id', selectedIllnessReport.id);
            formData.append('parent_signature', signatureUrl);
            formData.append('parent_signature_date', illnessSignatureDate);

            const submitResponse = await apiHandler(ILLNESS_REPORT_SIGNATURE, 'POST', formData);

            if (submitResponse.data?.response?.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Signature submitted successfully.',
                    timer: 2000,
                    showConfirmButton: false
                });

                setShowIllnessSignatureModal(false);
                // Reload illness reports
                await viewIllnessReports(selectedStudent);
            } else {
                throw new Error(submitResponse.data?.response?.message || 'Signature submission failed');
            }
        } catch (error) {
            console.error('Error submitting signature:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Failed to submit signature. Please try again.'
            });
        }
    };

    // Open create accident report modal
    const handleCreateAccidentReport = (student) => {
        const classroomOptions = buildAccidentClassroomOptions(student);
        const preferredClassroom = classroomOptions[0]?.value || '';

        setSelectedStudent(student);
        setIsEditingAccidentReport(false);
        setEditingAccidentReportId(null);
        setAccidentClassroomOptions(classroomOptions);
        setAccidentFormData({
            classroom: preferredClassroom,
            child_name: student.name,
            incident_date: Moment().format('YYYY-MM-DD'),
            incident_time: Moment().format('HH:mm'),
            location: '',
            incident_description: '',
            first_aid: '',
            parent_contacted: false,
            parent_contacted_time: '',
            follow_up_information: '',
            staff_name: profileData?.first_name + ' ' + profileData?.last_name || '',
            staff_position: '',
            existing_staff_signature: '',
            existing_supervisor_signature: ''
        });
        if (accidentStaffSignaturePadRef.current) {
            accidentStaffSignaturePadRef.current.clear();
        }
        setShowCreateAccidentModal(true);
    };

    // Open edit accident report modal
    const handleEditAccidentReport = (report) => {
        const classroomOptions = buildAccidentClassroomOptions(report);
        const resolvedClassroom = report.classroom || report.class_name || report.room_name || report?.room?.room_name || report?.class?.name || classroomOptions[0]?.value || '';
        
        setIsEditingAccidentReport(true);
        setEditingAccidentReportId(report.id);
        setAccidentClassroomOptions([]);
        setAccidentFormData({
            classroom: resolvedClassroom,
            child_name: selectedStudent?.name || report.child_name || 'Student',
            incident_date: Moment(report.incident_date).format('YYYY-MM-DD'),
            incident_time: report.incident_time || '',
            location: report.location || '',
            incident_description: (report.incident_description || '').replace(/<[^>]*>/g, ''),
            first_aid: (report.first_aid || '').replace(/<[^>]*>/g, ''),
            parent_contacted: report.parent_contacted === 1,
            parent_contacted_time: report.parent_contacted_time || '',
            follow_up_information: (report.follow_up_information || '').replace(/<[^>]*>/g, ''),
            staff_name: report.staff_name || '',
            staff_position: report.staff_position || '',
            existing_staff_signature: report.staff_signature || '',
            existing_supervisor_signature: report.supervisor_signature || ''
        });
        if (accidentStaffSignaturePadRef.current) {
            accidentStaffSignaturePadRef.current.clear();
        }
        setShowCreateAccidentModal(true);
    };

    // Submit accident report (create or update)
    const submitAccidentReport = async () => {
        // Validation
        if (!accidentFormData.incident_date || !accidentFormData.incident_time || !accidentFormData.location || !accidentFormData.incident_description) {
            Swal.fire({
                icon: 'warning',
                title: 'Required Fields',
                text: 'Please fill in all required fields: Date, Time, Location, and Description.'
            });
            return;
        }

        // Staff signature is required by the backend (AdminFormAccidentReportValidator)
        // for every report, not just new ones - unlike the illness report,
        // there's no "existing signature" this form lets you keep in place
        // while updating other fields, so this check applies to edits too.
        // Missing this client-side check (illness report already has its
        // own version) meant submitting without one skipped straight to a
        // 422 from the backend, which the generic error handler below
        // turned into an unhelpful "something went wrong".
        const hasNewSignature = accidentStaffSignaturePadRef.current && !accidentStaffSignaturePadRef.current.isEmpty();
        const hasExistingSignature = isEditingAccidentReport && accidentFormData.existing_staff_signature;
        if (!hasNewSignature && !hasExistingSignature) {
            Swal.fire({
                icon: 'warning',
                title: 'Signature Required',
                text: 'Please provide the staff signature.'
            });
            return;
        }

        setSubmittingAccidentReport(true);
        try {
            const formData = new FormData();
            formData.append('user_id', selectedStudent.id);
            formData.append('incident_date', accidentFormData.incident_date);
            formData.append('incident_time', accidentFormData.incident_time);
            formData.append('location', accidentFormData.location);
            formData.append('incident_description', accidentFormData.incident_description);
            formData.append('first_aid', accidentFormData.first_aid || '');
            formData.append('parent_contacted', accidentFormData.parent_contacted ? 1 : 0);
            formData.append('parent_contacted_time', accidentFormData.parent_contacted_time || '');
            formData.append('follow_up_information', accidentFormData.follow_up_information || '');
            formData.append('staff_name', accidentFormData.staff_name || '');
            formData.append('staff_position', accidentFormData.staff_position || '');

            // If editing, include the report ID
            if (isEditingAccidentReport && editingAccidentReportId) {
                formData.append('id', editingAccidentReportId);
            }

            // Handle staff signature
            if (accidentStaffSignaturePadRef.current && !accidentStaffSignaturePadRef.current.isEmpty()) {
                const signatureDataURL = accidentStaffSignaturePadRef.current.toDataURL('image/png');
                const response = await fetch(signatureDataURL);
                const blob = await response.blob();
                const timestamp = new Date().getTime();
                const fileName = `staff_signature_${timestamp}.png`;
                const file = new File([blob], fileName, { type: 'image/png' });
                const signatureUrl = await handleImageUpload(file, 'signatures/', 'image/png');
                formData.append('staff_signature', signatureUrl);
            } else if (isEditingAccidentReport && accidentFormData.existing_staff_signature) {
                // Keep existing signature if editing and no new signature drawn
                formData.append('staff_signature', accidentFormData.existing_staff_signature);
            }

            // Keep existing supervisor signature if present (no editing allowed)
            if (isEditingAccidentReport && accidentFormData.existing_supervisor_signature) {
                formData.append('supervisor_signature', accidentFormData.existing_supervisor_signature);
            }

            const submitResponse = await apiHandler(ACCIDENT_REPORT_STORE, 'POST', formData);

            if (submitResponse.data?.response?.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: isEditingAccidentReport ? 'Accident report updated successfully.' : 'Accident report created successfully.',
                    timer: 2000,
                    showConfirmButton: false
                });

                setShowCreateAccidentModal(false);
                setIsEditingAccidentReport(false);
                setEditingAccidentReportId(null);
                setAccidentClassroomOptions([]);
                // Reset form
                setAccidentFormData({
                    classroom: '',
                    child_name: '',
                    incident_date: '',
                    incident_time: '',
                    location: '',
                    incident_description: '',
                    first_aid: '',
                    parent_contacted: false,
                    parent_contacted_time: '',
                    follow_up_information: '',
                    staff_name: '',
                    staff_position: '',
                    existing_staff_signature: '',
                    existing_supervisor_signature: ''
                });
                // Reload reports if we're viewing the list
                if (showAccidentReportsModal) {
                    await viewAccidentReports(selectedStudent);
                }
            } else {
                throw new Error(getApiErrorMessage(submitResponse, `Failed to ${isEditingAccidentReport ? 'update' : 'create'} accident report`));
            }
        } catch (error) {
            console.error(`Error ${isEditingAccidentReport ? 'updating' : 'creating'} accident report:`, error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || `Failed to ${isEditingAccidentReport ? 'update' : 'create'} accident report. Please try again.`
            });
        } finally {
            setSubmittingAccidentReport(false);
        }
    };

    // Open create illness report modal
    const handleCreateIllnessReport = (student) => {
        const classroomOptions = buildAccidentClassroomOptions(student);
        const preferredClassroom = classroomOptions[0]?.value || '';

        setSelectedStudent(student);
        setIsEditingIllnessReport(false);
        setEditingIllnessReportId(null);
        setIllnessFormData({
            classroom: preferredClassroom,
            student_name: student.name,
            symptoms: '',
            requested_action_parent: '',
            return_date: Moment().format('YYYY-MM-DD'),
            teacher_signature_date: Moment().format('YYYY-MM-DD'),
            existing_teacher_signature: ''
        });
        if (illnessTeacherSignaturePadRef.current) {
            illnessTeacherSignaturePadRef.current.clear();
        }
        setShowCreateIllnessModal(true);
    };

    // Open edit illness report modal
    const handleEditIllnessReport = (report) => {
        const classroomOptions = buildAccidentClassroomOptions(report);
        const resolvedClassroom = report.classroom || report.class_name || report.room_name || report?.room?.room_name || report?.class?.name || classroomOptions[0]?.value || '';

        setSelectedStudent({ id: report.user_id, name: report.student_name || 'Student' });
        setIsEditingIllnessReport(true);
        setEditingIllnessReportId(report.id);
        setIllnessFormData({
            classroom: resolvedClassroom,
            student_name: report.student_name || '',
            symptoms: report.symptoms || '',
            requested_action_parent: report.requested_action_parent || '',
            return_date: Moment(report.return_date).format('YYYY-MM-DD'),
            teacher_signature_date: Moment(report.teacher_signature_date).format('YYYY-MM-DD'),
            existing_teacher_signature: report.teacher_signature || ''
        });
        if (illnessTeacherSignaturePadRef.current) {
            illnessTeacherSignaturePadRef.current.clear();
        }
        setShowCreateIllnessModal(true);
    };

    // Submit illness report (create or update)
    const submitIllnessReport = async () => {
        // Validation
        if (!illnessFormData.symptoms || !illnessFormData.requested_action_parent || !illnessFormData.return_date) {
            Swal.fire({
                icon: 'warning',
                title: 'Required Fields',
                text: 'Please fill in all required fields: Symptoms, Requested Action, and Return Date.'
            });
            return;
        }

        // Signature is required unless editing a report that already has
        // one on file (in which case leaving the pad blank just keeps it) -
        // covers both a brand new report and editing one that, for
        // whatever reason, never got a signature in the first place.
        const hasNewTeacherSignature = illnessTeacherSignaturePadRef.current && !illnessTeacherSignaturePadRef.current.isEmpty();
        const hasExistingTeacherSignature = isEditingIllnessReport && illnessFormData.existing_teacher_signature;
        if (!hasNewTeacherSignature && !hasExistingTeacherSignature) {
            Swal.fire({
                icon: 'warning',
                title: 'Signature Required',
                text: 'Please provide your teacher signature.'
            });
            return;
        }

        setSubmittingIllnessReport(true);
        try {
            const formData = new FormData();
            formData.append('user_id', selectedStudent.id);
            formData.append('symptoms', illnessFormData.symptoms);
            formData.append('requested_action_parent', illnessFormData.requested_action_parent);
            formData.append('return_date', illnessFormData.return_date);
            formData.append('teacher_signature_date', illnessFormData.teacher_signature_date);

            // If editing, include the report ID
            if (isEditingIllnessReport && editingIllnessReportId) {
                formData.append('id', editingIllnessReportId);
            }

            // Handle teacher signature (only if provided)
            if (illnessTeacherSignaturePadRef.current && !illnessTeacherSignaturePadRef.current.isEmpty()) {
                const signatureDataURL = illnessTeacherSignaturePadRef.current.toDataURL('image/png');
                const response = await fetch(signatureDataURL);
                const blob = await response.blob();
                const timestamp = new Date().getTime();
                const fileName = `teacher_signature_${timestamp}.png`;
                const file = new File([blob], fileName, { type: 'image/png' });
                const signatureUrl = await handleImageUpload(file, 'signatures/', 'image/png');
                formData.append('teacher_signature', signatureUrl);
            } else if (isEditingIllnessReport && illnessFormData.existing_teacher_signature) {
                // Keep existing signature if editing and no new signature drawn
                formData.append('teacher_signature', illnessFormData.existing_teacher_signature);
            }

            const submitResponse = await apiHandler(ILLNESS_REPORT_STORE, 'POST', formData);

            if (submitResponse.data?.response?.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: isEditingIllnessReport ? 'Illness report updated successfully.' : 'Illness report created successfully.',
                    timer: 2000,
                    showConfirmButton: false
                });

                setShowCreateIllnessModal(false);
                setIsEditingIllnessReport(false);
                setEditingIllnessReportId(null);
                // Reset form
                setIllnessFormData({
                    classroom: '',
                    student_name: '',
                    symptoms: '',
                    requested_action_parent: '',
                    return_date: '',
                    teacher_signature_date: '',
                    existing_teacher_signature: ''
                });
                if (illnessTeacherSignaturePadRef.current) {
                    illnessTeacherSignaturePadRef.current.clear();
                }
                // Reload reports if we're viewing the list
                if (showIllnessReportsModal) {
                    await viewIllnessReports(selectedStudent);
                }
            } else {
                throw new Error(getApiErrorMessage(submitResponse, `Failed to ${isEditingIllnessReport ? 'update' : 'create'} illness report`));
            }
        } catch (error) {
            console.error(`Error ${isEditingIllnessReport ? 'updating' : 'creating'} illness report:`, error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || `Failed to ${isEditingIllnessReport ? 'update' : 'create'} illness report. Please try again.`
            });
        } finally {
            setSubmittingIllnessReport(false);
        }
    };

    // Delete accident report
    const deleteAccidentReport = async (reportId) => {
        try {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to delete this accident report?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'Cancel'
            });

            if (result.isConfirmed) {
                const formData = new FormData();
                formData.append('id', reportId);

                const response = await apiHandler(ACCIDENT_REPORT_DELETE, 'DELETE', formData);

                if (response.data?.response?.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Accident report has been deleted.',
                        timer: 2000,
                        showConfirmButton: false
                    });

                    // Reload accident reports
                    await viewAccidentReports(selectedStudent);
                } else {
                    throw new Error(response.data?.response?.message || 'Failed to delete accident report');
                }
            }
        } catch (error) {
            console.error('Error deleting accident report:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Failed to delete accident report. Please try again.'
            });
        }
    };

    // Delete illness report
    const deleteIllnessReport = async (reportId) => {
        try {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to delete this illness report?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'Cancel'
            });

            if (result.isConfirmed) {
                const formData = new FormData();
                formData.append('id', reportId);

                const response = await apiHandler(ILLNESS_REPORT_DELETE, 'DELETE', formData);

                if (response.data?.response?.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Illness report has been deleted.',
                        timer: 2000,
                        showConfirmButton: false
                    });

                    // Reload illness reports
                    await viewIllnessReports(selectedStudent);
                } else {
                    throw new Error(response.data?.response?.message || 'Failed to delete illness report');
                }
            }
        } catch (error) {
            console.error('Error deleting illness report:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Failed to delete illness report. Please try again.'
            });
        }
    };

    // LunchPlanWaiverModal (components/modals/LunchPlanWaiverModal.js)
    // fetches its own data from studentId now - shared with notification.js.
    const viewLunchPlan = (student) => {
        setSelectedStudent(student);
        setShowLunchPlanModal(true);
    };

    const viewAssignedGames = async (student) => {
        setViewDataLoading(true);
        try {
            const response = await apiHandler(TEACHERS_GET_ASSIGNED_GAMES_API, 'POST', {
                student_id: student.id,
                user_id: student.id
            });
            if (response.data?.response?.status === 200) {
                const assignedGames = response.data?.data?.games || response.data?.data || {};
                setGameData(assignedGames);
                setSelectedStudent(student);
                // Load game names for assignment
                loadGameNames();
                setShowGameModal(true);
            } else {
                setGameData({});
                setSelectedStudent(student);
                loadGameNames();
                setShowGameModal(true);
                Swal.fire({
                    title: 'Info',
                    text: response.data?.data?.message || response.data?.response?.message || 'Assigned games are temporarily unavailable',
                    icon: 'info',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error loading games:', error);
            const apiError = error?.response?.data;
            setGameData({});
            setSelectedStudent(student);
            loadGameNames();
            setShowGameModal(true);
            Swal.fire({
                title: 'Info',
                text: apiError?.data?.message || apiError?.response?.message || 'Assigned games are temporarily unavailable',
                icon: 'info',
                confirmButtonText: 'OK'
            });
        } finally {
            setViewDataLoading(false);
        }
    };

    // Today's game activity for a student - which games they played, how
    // many times, and their score each time (see AttendanceController.
    // getGameStats, which reads game_sessions so it covers both static and
    // AI-adaptive play, unlike the single-row-per-day game_users data the
    // "Assigned Games" modal above uses).
    const viewGameStats = async (student) => {
        setSelectedStudent(student);
        setGameStatsData(null);
        setShowGameStatsModal(true);
        setGameStatsLoading(true);
        loadWeeklyReports(student.id);
        loadStatsCompletedGames(student.id);
        try {
            const response = await apiHandler(TEACHERS_GAME_STATS_API, 'POST', {
                student_id: student.id,
                date: getReportDate()
            });
            if (response.data?.response?.status === 200) {
                setGameStatsData(response.data?.data || { date: null, games: [] });
            } else {
                setGameStatsData({ date: null, games: [] });
                Swal.fire({
                    title: 'Info',
                    text: response.data?.data?.message || response.data?.response?.message || 'Game stats are temporarily unavailable',
                    icon: 'info',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error loading game stats:', error);
            setGameStatsData({ date: null, games: [] });
            Swal.fire({
                title: 'Info',
                text: getApiErrorMessage(error, 'Game stats are temporarily unavailable'),
                icon: 'info',
                confirmButtonText: 'OK'
            });
        } finally {
            setGameStatsLoading(false);
        }
    };

    // Fetched alongside the game stats so the Game Stats modal's "Weekly
    // Reports" button can show the count right away. Not tied to the
    // selected attendance date or the student's attendance - every student
    // gets the button.
    const loadWeeklyReports = async (studentId) => {
        weeklyReportsStudentRef.current = studentId;
        setWeeklyReports([]);
        setWeeklyReportsLoading(true);
        const res = await apiHandler(TEACHER_GAME_REPORT_LIST, 'POST', { student_id: studentId });
        // Ignore a slow response once another student's stats were opened.
        if (weeklyReportsStudentRef.current !== studentId) return;
        if (!isFailedResponse(res)) {
            const list = res?.data?.data?.reports;
            setWeeklyReports(Array.isArray(list) ? list : []);
        }
        setWeeklyReportsLoading(false);
    };

    // All of the student's completed learning games (not just the selected
    // date) - see utilities/studentCompletedGames.js.
    const completedGamesStudentRef = useRef(null);
    const loadStatsCompletedGames = async (studentId) => {
        completedGamesStudentRef.current = studentId;
        setStatsCompletedGames([]);
        setStatsCompletedGamesError(null);
        setStatsCompletedGamesLoading(true);
        const { games, failed } = await fetchStudentCompletedGames(studentId);
        // Ignore a slow response once another student's stats were opened.
        if (completedGamesStudentRef.current !== studentId) return;
        if (failed) {
            setStatsCompletedGamesError('Failed to load completed learning games.');
        } else {
            setStatsCompletedGames(games);
        }
        setStatsCompletedGamesLoading(false);
    };

    const openWeeklyReports = () => {
        if (weeklyReportsLoading) return;
        if (weeklyReports.length === 0) {
            Swal.fire({
                title: 'No Weekly Report',
                text: `No weekly report present for ${selectedStudent?.name || 'this student'} yet.`,
                icon: 'info',
                confirmButtonText: 'OK'
            });
            return;
        }
        // Swap modals instead of stacking two - the Game Stats modal comes
        // back when the weekly report modal closes.
        setShowGameStatsModal(false);
        setShowWeeklyReportModal(true);
    };

    const closeWeeklyReports = () => {
        setShowWeeklyReportModal(false);
        setShowGameStatsModal(true);
    };

    const loadGameNames = async () => {
        try {
            const response = await apiHandler(TEACHERS_ASSIGN_GAMES_NAME_API, 'POST', {});
            if (response.data?.response?.status === 200) {
                setGameNames(response.data?.data?.games || []);
            }
        } catch (error) {
            console.error('Error loading game names:', error);
        }
    };

    const assignGame = async () => {
        // Without this guard, a fast double-click fired two requests before
        // either finished - the backend's own "already assigned today?"
        // check isn't atomic against two near-simultaneous requests, so
        // both could pass it and each create their own row, producing two
        // "Assigned" cards for the exact same game.
        if (!selectedGame || !selectedStudent || isAssigningGame) return;
        setIsAssigningGame(true);
        try {
            const response = await apiHandler(TEACHERS_ASSIGN_GAME_API, 'POST', {
                student_id: selectedStudent.id,
                user_id: selectedStudent.id,
                game_name_ids: [selectedGame]
            });
            if (response.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Success!',
                    text: 'Game assigned successfully!',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                // Reload assigned games
                viewAssignedGames(selectedStudent);
            } else {
                Swal.fire({
                    title: 'Error',
                    text:
                        response.data?.data?.errors?.game_name_ids?.[0] ||
                        response.data?.response?.message ||
                        'Failed to assign game',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error assigning game:', error);
            const apiError = error?.response?.data;
            Swal.fire({
                title: 'Error',
                text:
                    apiError?.data?.errors?.game_name_ids?.[0] ||
                    apiError?.response?.message ||
                    'Failed to assign game',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setIsAssigningGame(false);
        }
    };

    // Assignment is lifetime now - a teacher who assigned something by
    // mistake, or no longer wants a student to have it, needs a real way
    // to take it back rather than waiting for it to expire on its own.
    const unassignGame = async (gameNameId, gameLabel) => {
        if (!selectedStudent || unassigningGameIds.has(gameNameId)) return;

        const result = await Swal.fire({
            title: 'Unassign game?',
            text: `${gameLabel || 'This game'} will no longer be assigned to ${selectedStudent?.name || 'this student'}.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, unassign',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#dc2626'
        });
        if (!result.isConfirmed) return;

        setUnassigningGameIds((prev) => new Set(prev).add(gameNameId));
        try {
            const response = await apiHandler(TEACHERS_UNASSIGN_GAME_API, 'POST', {
                student_id: selectedStudent.id,
                game_name_id: gameNameId
            });
            if (response.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Unassigned',
                    text: 'Game unassigned successfully!',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false
                });
                viewAssignedGames(selectedStudent);
            } else {
                Swal.fire({
                    title: 'Error',
                    text: response.data?.response?.message || 'Failed to unassign game',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error unassigning game:', error);
            Swal.fire({
                title: 'Error',
                text: getApiErrorMessage(error, 'Failed to unassign game'),
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setUnassigningGameIds((prev) => {
                const next = new Set(prev);
                next.delete(gameNameId);
                return next;
            });
        }
    };

    const viewObservation = async (student) => {
        setViewDataLoading(true);
        try {
            const response = await apiHandler(TEACHERS_OBSERVATION_API, 'POST', {
                student_id: student.id
            });
            if (response.data?.response?.status === 200) {
                setObservationData(response.data?.data || {});
                setSelectedStudent(student);
                setShowObservationViewModal(true);
            } else {
                Swal.fire({
                    title: 'Info',
                    text: response.data?.response?.message || 'No observation found',
                    icon: 'info',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error loading observation:', error);
            Swal.fire({
                title: 'Error',
                text: 'Failed to load observation',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setViewDataLoading(false);
        }
    };

    const handleShowEmergencyContacts = async (contacts, student) => {
        setSelectedEmergencyContacts(contacts);
        
        // Fetch parent information
        if (student) {
            try {
                const response = await apiHandler(PROFILE_DETAILS, 'POST', {
                    user_id: student.id
                });
                if (response.data?.response?.status === 200 && response.data.data) {
                    setParentInfoData(response.data.data || {});
                }
            } catch (error) {
                console.error('Error loading parent information:', error);
                setParentInfoData(null);
            }
        }
        
        setShowEmergencyModal(true);
    };

    const handleOpenObservation = async (student) => {
        setSelectedStudent(student);
        setObservationModalOpening(true);
        setShowObservationModal(true);
        setObservationPrimaryTab('observation');
        setObservationActiveTab('observation');
        setHdlhTargetTab('observation');
        setObservationNotes('');
        setObservationText('');
        setSelectedObservationLinks([]);
        setShowObservationRegenerateButton(false);
        setLearningPathData(EMPTY_LEARNING_PATH_FORM);
        setParentReportData(EMPTY_PARENT_REPORT_FORM);

        try {
            // Try to load existing observation data
            const response = await apiHandler(TEACHERS_OBSERVATION_API, 'POST', {
                student_id: student.id,
                report_date: getReportDate()
            });

            if (response.data?.response?.status === 200 && response.data?.data) {
                // Load existing data into form
                setObservationNotes(response.data.data.notes || '');
                setObservationText(response.data.data.observation || '');
            }
        } catch (error) {
            console.error('Error loading existing observation:', error);
            // Continue with empty form if loading fails
        }

        try {
            await loadLearningPathAndParentReport(student.id, false);
            await loadObservationPickerData(false);
        } finally {
            setObservationModalOpening(false);
        }
    };

    const loadObservationPickerData = async (showError = true) => {
        setObservationPickerLoading(true);

        try {
            const response = await apiHandler(TEACHERS_OBSERVATION_PICKER_DATA_API, 'GET');
            const categories = response?.data?.data?.categories || [];
            setObservationCategories(categories);
            setActiveObservationCategoryId(categories.length > 0 ? categories[0].id : null);
        } catch (error) {
            console.error('Error loading observation picker data:', error);
            if (showError) {
                Swal.fire({
                    title: 'Error',
                    text: 'Failed to load HDLH links. Please try again.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        } finally {
            setObservationPickerLoading(false);
        }
    };

    const openObservationPickerModal = async (targetTab = 'observation') => {
        if (!selectedStudent) {
            Swal.fire({
                title: 'Error',
                text: 'No student selected',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        setHdlhTargetTab(targetTab);
        setShowObservationPickerModal(true);
        await loadObservationPickerData(true);
    };

    const toggleObservationLink = (linkId) => {
        setSelectedObservationLinks((prev) => {
            if (prev.includes(linkId)) {
                return prev.filter((id) => id !== linkId);
            }
            return [...prev, linkId];
        });
    };

    const getSelectedObservationCountByCategory = (category) => {
        const categoryLinks = Array.isArray(category?.links) ? category.links : [];
        if (categoryLinks.length === 0 || selectedObservationLinks.length === 0) {
            return 0;
        }

        return categoryLinks.reduce((count, link) => (
            selectedObservationLinks.includes(link.id) ? count + 1 : count
        ), 0);
    };

    const selectedObservationCategoryCount = observationCategories.reduce((count, category) => (
        getSelectedObservationCountByCategory(category) > 0 ? count + 1 : count
    ), 0);
    const hasMinimumObservationSelections = selectedObservationLinks.length >= 2 && selectedObservationCategoryCount >= 2;

    const handleGenerateObservationFromLinks = async () => {
        if (!selectedStudent) {
            Swal.fire({
                title: 'Error',
                text: 'No student selected',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        if (!hasMinimumObservationSelections) {
            Swal.fire({
                title: 'Validation Error',
                text: 'Please select at least two HDLH links from two different categories',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        setObservationGenerateLoading(true);
        try {
            const response = await apiHandler(TEACHERS_LEARNING_PATH_GENERATE_API, 'POST', {
                links: selectedObservationLinks,
                student_id: selectedStudent.id,
                report_date: getReportDate()
            });

            if (response?.data?.response?.status === 200 && response?.data?.data) {
                const generatedData = response.data.data;
                if (generatedData?.observation) {
                    setObservationText(generatedData.observation);
                }
                hydrateLearningPathAndParentReport(generatedData);
                setShowObservationRegenerateButton(true);
                setShowObservationPickerModal(false);
                setShowObservationModal(true);
                // After generating from Daily Observation, surface generated learning-path result first.
                setObservationActiveTab('learningPath');
                Swal.fire({
                    title: 'Generated',
                    text: 'Daily observation, learning path, and parent report draft generated.',
                    icon: 'success',
                    timer: 1400,
                    showConfirmButton: false
                });
            } else {
                throw new Error(response?.data?.response?.message || 'Failed to generate learning path');
            }
        } catch (error) {
            console.error('Error generating observation:', error);
            Swal.fire({
                title: 'Error',
                text: error.message || 'Failed to generate learning path',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setObservationGenerateLoading(false);
        }
    };

    const saveLearningPathAndParentReport = async ({ showSuccessMessage = true } = {}) => {
        if (!selectedStudent) {
            Swal.fire({
                title: 'Error',
                text: 'No student selected',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return null;
        }

        if (!learningPathData.celebrate.trim() && !learningPathData.nurture.trim() && !learningPathData.activities.trim() &&
            !parentReportData.thriving.trim() && !parentReportData.focus.trim() && !parentReportData.home_activities.trim()) {
            Swal.fire({
                title: 'Validation Error',
                text: 'Please add content before saving learning path and parent report.',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return null;
        }

        setLearningPathSaving(true);
        try {
            let learningPathId = learningPathData.id;

            if (!learningPathId) {
                const existingResponse = await apiHandler(TEACHERS_LEARNING_PATH_GET_API, 'POST', {
                    student_id: selectedStudent.id,
                    report_date: getReportDate()
                });

                const existingLearningPath = existingResponse?.data?.data?.learning_path;
                if (existingResponse?.data?.response?.status === 200 && existingLearningPath?.id) {
                    learningPathId = existingLearningPath.id;
                    hydrateLearningPathAndParentReport(existingResponse.data.data);
                }
            }

            if (!learningPathId && selectedObservationLinks.length > 0) {
                const generateResponse = await apiHandler(TEACHERS_LEARNING_PATH_GENERATE_API, 'POST', {
                    links: selectedObservationLinks,
                    student_id: selectedStudent.id,
                    report_date: getReportDate()
                });

                if (generateResponse?.data?.response?.status === 200) {
                    const generatedData = generateResponse?.data?.data || {};
                    hydrateLearningPathAndParentReport(generatedData);
                    learningPathId = generatedData?.learning_path?.id || null;
                }
            }

            if (!learningPathId) {
                throw new Error('Learning path record not found. Please generate from HDLH links first.');
            }

            const payload = {
                learning_path_id: learningPathId,
                celebrate: learningPathData.celebrate.trim(),
                nurture: learningPathData.nurture.trim(),
                activities: learningPathData.activities.trim(),
                parent_report_id: parentReportData.id || undefined,
                thriving: parentReportData.thriving.trim(),
                focus: parentReportData.focus.trim(),
                home_activities: parentReportData.home_activities.trim(),
                student_id: selectedStudent.id,
                report_date: getReportDate()
            };

            let updateResponse = await apiHandler(TEACHERS_LEARNING_PATH_UPDATE_API, 'POST', payload);

            if (updateResponse?.data?.response?.status !== 200) {
                const errorText = `${updateResponse?.data?.data?.details || ''} ${updateResponse?.data?.data?.message || ''}`.toLowerCase();
                if (errorText.includes('row not found') && selectedObservationLinks.length > 0) {
                    const regenerateResponse = await apiHandler(TEACHERS_LEARNING_PATH_GENERATE_API, 'POST', {
                        links: selectedObservationLinks,
                        student_id: selectedStudent.id,
                        report_date: getReportDate()
                    });

                    if (regenerateResponse?.data?.response?.status === 200) {
                        const regeneratedData = regenerateResponse?.data?.data || {};
                        hydrateLearningPathAndParentReport(regeneratedData);

                        const regeneratedPathId = regeneratedData?.learning_path?.id;
                        if (regeneratedPathId) {
                            updateResponse = await apiHandler(TEACHERS_LEARNING_PATH_UPDATE_API, 'POST', {
                                ...payload,
                                learning_path_id: regeneratedPathId,
                                parent_report_id: regeneratedData?.parent_report?.id || payload.parent_report_id
                            });
                        }
                    }
                }
            }

            if (updateResponse?.data?.response?.status === 200) {
                if (showSuccessMessage) {
                    Swal.fire({
                        title: 'Success!',
                        text: updateResponse?.data?.data?.message || 'Learning path and parent report saved successfully.',
                        icon: 'success',
                        timer: 1800,
                        showConfirmButton: false
                    });
                }

                const refreshedData = await loadLearningPathAndParentReport(selectedStudent.id, false);
                return refreshedData?.parent_report?.id || parentReportData.id || payload.parent_report_id || null;
            } else {
                throw new Error(
                    updateResponse?.data?.data?.message ||
                    updateResponse?.data?.response?.message ||
                    'Failed to save learning path and parent report.'
                );
            }
        } catch (error) {
            console.error('Error saving learning path and parent report:', error);
            Swal.fire({
                title: 'Error',
                text: error?.message || 'Failed to save learning path and parent report.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return null;
        } finally {
            setLearningPathSaving(false);
        }
    };

    const ensureParentReportId = async () => {
        if (parentReportData.id) {
            return parentReportData.id;
        }

        return saveLearningPathAndParentReport({ showSuccessMessage: false });
    };

    const handleParentReportAction = async ({
        endpoint,
        actionLabel,
        loadingSetter,
        successMessage,
        successStateKey
    }) => {
        if (!selectedStudent) {
            Swal.fire({
                title: 'Error',
                text: 'No student selected',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        loadingSetter(true);
        try {
            const parentReportId = await ensureParentReportId();

            if (!parentReportId) {
                throw new Error('Parent report record not found. Please save the parent report first.');
            }

            const response = await apiHandler(endpoint, 'POST', {
                parent_report_id: parentReportId
            });

            if (response?.data?.response?.status === 200) {
                if (successStateKey) {
                    setParentReportData((prev) => ({
                        ...prev,
                        [successStateKey]: 1
                    }));
                }

                Swal.fire({
                    title: 'Success!',
                    text: response?.data?.data?.message || successMessage,
                    icon: 'success',
                    timer: 1800,
                    showConfirmButton: false
                });

                await loadLearningPathAndParentReport(selectedStudent.id, false);
            } else {
                throw new Error(
                    response?.data?.data?.message ||
                    response?.data?.data?.details ||
                    response?.data?.response?.message ||
                    `Failed to ${actionLabel}.`
                );
            }
        } catch (error) {
            console.error(`Error trying to ${actionLabel}:`, error);
            Swal.fire({
                title: 'Error',
                text: error?.message || `Failed to ${actionLabel}.`,
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            loadingSetter(false);
        }
    };

    const handleSendParentReportEmail = async () => {
        await handleParentReportAction({
            endpoint: TEACHERS_PARENT_REPORT_SEND_EMAIL_API,
            actionLabel: 'send parent report email',
            loadingSetter: setParentReportEmailSending,
            successMessage: 'Parent report email sent successfully.',
            successStateKey: 'email_sent'
        });
    };

    const handlePostParentReportToFeed = async () => {
        await handleParentReportAction({
            endpoint: TEACHERS_PARENT_REPORT_POST_TO_FEED_API,
            actionLabel: 'post parent report to feed',
            loadingSetter: setParentReportFeedPosting,
            successMessage: 'Parent report posted to feed successfully.',
            successStateKey: 'posted_to_feed'
        });
    };

    const saveObservation = async () => {
        if (!selectedStudent) {
            Swal.fire({
                title: 'Error',
                text: 'No student selected',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        if (!observationNotes.trim() && !observationText.trim()) {
            Swal.fire({
                title: 'Validation Error',
                text: 'Please enter either notes or observation details',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        setSavingObservation(true);
        try {
            const response = await apiHandler(TEACHERS_OBSERVATION_SAVE_API, 'POST', {
                student_id: selectedStudent.id,
                report_date: getReportDate(),
                notes: observationNotes.trim(),
                observation: observationText.trim()
            });

            if (response.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Success!',
                    text: response.data?.data?.message || 'Observation saved successfully!',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });

                // Keep the user inside the observation workflow after save so
                // they can continue into learning path or parent report without
                // reopening the modal and losing context.
                setObservationNotes(observationNotes.trim());
                setObservationText(observationText.trim());
            } else {
                throw new Error(response.data?.response?.message || 'Failed to save observation');
            }
        } catch (error) {
            console.error('Error saving observation:', error);
            Swal.fire({
                title: 'Error',
                text: error.message || 'Failed to save observation. Please try again.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setSavingObservation(false);
        }
    };

    const openAIContentModalForField = (field) => {
        const configByField = {
            // Uses the dedicated daily report note generator (student-aware
            // prompt), same as the daily report's "Today I Learned" field.
            observationNotes: {
                field: 'observationNotes',
                title: 'AI Observation Notes',
                targetLabel: 'observation notes',
                defaultKeywords: observationNotes,
                generateEndpoint: DAILY_REPORT_GENERATE_NOTE,
                responseContentKey: 'note',
                extraPayload: { user_id: selectedStudent?.id }
            },
            observationText: {
                field: 'observationText',
                title: 'AI Detailed Observation',
                targetLabel: 'detailed observation',
                defaultKeywords: observationText
            },
            learningPathCelebrate: {
                field: 'learningPathCelebrate',
                title: 'AI Learning Path: Celebrate',
                targetLabel: 'celebrate section',
                defaultKeywords: learningPathData.celebrate
            },
            learningPathNurture: {
                field: 'learningPathNurture',
                title: 'AI Learning Path: Nurture',
                targetLabel: 'nurture section',
                defaultKeywords: learningPathData.nurture
            },
            learningPathActivities: {
                field: 'learningPathActivities',
                title: 'AI Learning Path: Activities',
                targetLabel: 'activities section',
                defaultKeywords: learningPathData.activities
            },
            parentReportThriving: {
                field: 'parentReportThriving',
                title: 'AI Parent Report: Thriving',
                targetLabel: 'thriving section',
                defaultKeywords: parentReportData.thriving
            },
            parentReportFocus: {
                field: 'parentReportFocus',
                title: 'AI Parent Report: Focus',
                targetLabel: 'focus section',
                defaultKeywords: parentReportData.focus
            },
            parentReportHomeActivities: {
                field: 'parentReportHomeActivities',
                title: 'AI Parent Report: Home Activities',
                targetLabel: 'home activities section',
                defaultKeywords: parentReportData.home_activities
            },
            // The two daily report fields use their own dedicated generators
            // (student-aware, daily-report-specific prompt) instead of the
            // generic feed-post pilot endpoint every other field uses.
            dailyReportLearned: {
                field: 'dailyReportLearned',
                title: 'AI Daily Report: Today I Learned',
                targetLabel: 'today I learned',
                defaultKeywords: dailyReportFormData.learned,
                generateEndpoint: DAILY_REPORT_GENERATE_NOTE,
                responseContentKey: 'note',
                extraPayload: { user_id: selectedStudent?.id }
            },
            dailyReportComments: {
                field: 'dailyReportComments',
                title: 'AI Daily Report: Comments',
                targetLabel: 'daily report comments',
                defaultKeywords: dailyReportFormData.comments,
                generateEndpoint: DAILY_REPORT_GENERATE_COMMENT,
                responseContentKey: 'comment',
                extraPayload: { user_id: selectedStudent?.id }
            }
        };

        setAiModalConfig(configByField[field] || {
            field,
            title: 'AI Content Creation',
            targetLabel: 'content',
            defaultKeywords: ''
        });
        setShowAIContentModal(true);
    };

    const handleApplyAIContent = (content) => {
        const finalContent = content || '';

        switch (aiModalConfig.field) {
            case 'observationNotes':
                setObservationNotes(finalContent);
                break;
            case 'observationText':
                setObservationText(finalContent);
                break;
            case 'learningPathCelebrate':
                setLearningPathData((prev) => ({ ...prev, celebrate: finalContent }));
                break;
            case 'learningPathNurture':
                setLearningPathData((prev) => ({ ...prev, nurture: finalContent }));
                break;
            case 'learningPathActivities':
                setLearningPathData((prev) => ({ ...prev, activities: finalContent }));
                break;
            case 'parentReportThriving':
                setParentReportData((prev) => ({ ...prev, thriving: finalContent }));
                break;
            case 'parentReportFocus':
                setParentReportData((prev) => ({ ...prev, focus: finalContent }));
                break;
            case 'parentReportHomeActivities':
                setParentReportData((prev) => ({ ...prev, home_activities: finalContent }));
                break;
            case 'dailyReportLearned':
                setDailyReportFormData((prev) => ({ ...prev, learned: finalContent }));
                break;
            case 'dailyReportComments':
                setDailyReportFormData((prev) => ({ ...prev, comments: finalContent }));
                break;
            default:
                break;
        }

        Swal.fire({
            title: 'Content Added',
            text: 'AI-generated content was inserted successfully.',
            icon: 'success',
            timer: 1400,
            showConfirmButton: false
        });
    };

    const [expandedStudents, setExpandedStudents] = useState(new Set());

    const toggleStudentExpand = (studentId) => {
        setExpandedStudents(prev => {
            const newSet = new Set(prev);
            if (newSet.has(studentId)) {
                newSet.delete(studentId);
            } else {
                newSet.add(studentId);
            }
            return newSet;
        });
    };

    const renderStudentItem = (student, index) => {
        const isExpanded = expandedStudents.has(student.id);
        const studentReportStatus = dailyReportStatusByStudent[student.id] || 'not_created';
        const reportStatusMeta = studentReportStatus === 'published'
            ? {
                icon: 'ri-checkbox-circle-fill',
                label: 'Report Published',
                color: '#16a34a',
                bg: '#dcfce7'
            }
            : studentReportStatus === 'draft'
                ? {
                    icon: 'ri-draft-line',
                    label: 'Report Draft',
                    color: '#92400e',
                    bg: '#fef3c7'
                }
                : {
                    icon: 'ri-file-warning-line',
                    label: 'Report Not Created',
                    color: '#6b7280',
                    bg: '#f3f4f6'
                };

        // Room assignment only applies to today's roster (see openRoomModal),
        // so the selection checkbox only makes sense to show then.
        const isRoomSelectable = isToday(selectedDate);
        const isRoomSelected = roomSelectedStudentIds.includes(student.id);

        return (
        <div key={student.id} style={{
            background: isRoomSelected ? '#f0fdff' : '#ffffff',
            borderRadius: '10px',
            marginBottom: '10px',
            border: isRoomSelected ? '1px solid #06b6d4' : '1px solid #e5e7eb',
            boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
            transition: 'all 0.2s ease',
            overflow: 'hidden'
        }}
            onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.06)';
            }}
        >
            {/* Main Compact Row */}
            <div className="att-student-row" style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '12px 14px'
            }}>
                {/* Room selection checkbox — checked students are the target
                    of the Rooms panel's Assign/Swap actions */}
                {isRoomSelectable && (
                    <div style={{ flexShrink: 0 }}>
                        <input
                            type="checkbox"
                            checked={isRoomSelected}
                            onChange={() => toggleRoomStudentSelection(student.id)}
                            title="Select for room assignment"
                            aria-label={`Select ${student.name} for room assignment`}
                            style={{ width: '17px', height: '17px', cursor: 'pointer', accentColor: '#0e7490' }}
                        />
                    </div>
                )}

                {/* Avatar with Status */}
                <div style={{ position: 'relative', flexShrink: 0 }}>
                    <img
                        src={student.avatar}
                        alt={student.name}
                        onClick={() => openStudentProfile(student)}
                        title='Open profile'
                        className="att-avatar"
                        style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '8px',
                            objectFit: 'cover',
                            border: '2px solid #e5e7eb',
                            cursor: 'pointer',
                            transition: 'transform 0.2s ease'
                        }}
                        onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                        onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                    />
                    {student.attendance && (
                        <div style={{
                            position: 'absolute',
                            bottom: '-2px',
                            right: '-2px',
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            background: student.attendance === 'present' ? '#28a745' : '#dc3545',
                            border: '2px solid white',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '8px',
                            color: 'white',
                            fontWeight: 'bold'
                        }}>
                            {student.attendance === 'present' ? '✓' : '✗'}
                        </div>
                    )}
                </div>

                {/* Student Info */}
                <div style={{
                    flex: '1',
                    minWidth: 0,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    <div style={{ minWidth: 0, flex: 1 }}>
                        <div className="att-name" style={{
                            fontSize: '13px',
                            fontWeight: '600',
                            color: '#111827',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            cursor: 'pointer'
                        }}
                        onClick={() => openStudentProfile(student)}>
                            {student.name}
                        </div>
                        <div style={{
                            marginTop: '3px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                            fontSize: '9px',
                            fontWeight: '600',
                            color: reportStatusMeta.color,
                            background: reportStatusMeta.bg,
                            borderRadius: '999px',
                            padding: '2px 7px'
                        }}>
                            <i className={reportStatusMeta.icon} style={{ fontSize: '10px' }}></i>
                            <span>{reportStatusMeta.label}</span>
                        </div>
                    </div>

                    {/* Quick Badges */}
                    <div style={{
                        display: 'flex',
                        gap: '4px',
                        alignItems: 'center',
                        flexShrink: 0
                    }}>
                        {/* At-a-glance "this student is here via a room swap"
                            indicator - previously the only way to see (or
                            undo) a swap was to open Room Management on every
                            student one at a time. Tapping it jumps straight
                            there, where Cancel Swap lives. */}
                        {student.swap_room && (
                            <Badge
                                bg="warning"
                                onClick={(e) => { e.stopPropagation(); openRoomModal(student, 'swap'); }}
                                title="Swapped from another room - tap to view or cancel"
                                style={{
                                    fontSize: '8px',
                                    padding: '2px 6px',
                                    fontWeight: '600',
                                    color: '#78350f',
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '3px'
                                }}
                            >
                                <i className="material-symbols-outlined" style={{ fontSize: '10px' }}>swap_horiz</i>
                                Swapped
                            </Badge>
                        )}
                        {student.is_on_leave && (
                            <Badge bg="secondary" style={{
                                fontSize: '8px',
                                padding: '2px 6px',
                                fontWeight: '600'
                            }}>
                                Leave
                            </Badge>
                        )}
                        {!isStudentOnLeave(student) && student.attendance_time && (
                            <small
                                className="badge"
                                title="Tap to change attendance time"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditAttendanceTime(student);
                                }}
                                style={{
                                    fontSize: '10px',
                                    padding: '6px 10px',
                                    backgroundColor: '#dcfce7',
                                    color: '#166534',
                                    fontWeight: '600',
                                    cursor: canEditAttendance() ? 'pointer' : 'default',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '3px',
                                    lineHeight: 1,
                                }}
                            >
                                <i className="ri-login-circle-line" style={{fontSize: '11px', display: 'inline-flex'}}></i>
                                <span>{formatTime(student.attendance_time)}</span>
                                {canEditAttendance() && (
                                    <i className="ri-pencil-line" style={{ fontSize: '9px', opacity: 0.7, display: 'inline-flex' }}></i>
                                )}
                            </small>
                        )}
                        {!isStudentOnLeave(student) && student.exit_time && (
                            <small className="badge" style={{ fontSize: '10px', padding: '6px 10px', backgroundColor: '#fee2e2', color: '#991b1b', fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '3px', lineHeight: 1 }}>
                                <i className="ri-logout-circle-r-line" style={{fontSize: '11px', display: 'inline-flex'}}></i>
                                <span>{formatTime(student.exit_time)}</span>
                            </small>
                        )}
                    </div>
                </div>

                {/* Attendance Buttons - Inline. Present opens a confirm modal
                    (editable time + parent-notify message); Absent saves
                    immediately - both persist right away instead of waiting
                    for a separate bulk "Save Attendance" click. */}
                {!student.is_on_leave && (
                    <div style={{
                        display: 'flex',
                        gap: '8px',
                        alignItems: 'center',
                        flexShrink: 0
                    }}>
                        {(() => {
                            // Both buttons look identically neutral (white, gray
                            // border) until the teacher has actually confirmed a
                            // status for this student - the underlying data model
                            // still defaults an untouched student to "absent" for
                            // reporting purposes, but that default alone must never
                            // paint the Absent button solid red, or clicking it
                            // produces no visible change since it already looked
                            // active. Only attendance_confirmed (set on load from a
                            // real saved status, or set true after a successful
                            // save) unlocks the green/red "active" look.
                            const isPresent = student.attendance_confirmed && student.attendance === 'present';
                            const isAbsent = student.attendance_confirmed && student.attendance === 'absent';
                            return (
                                <>
                                    <Button
                                        title={isPresent ? 'Marked Present' : 'Mark Present'}
                                        disabled={!canEditAttendance() || savingStudentIds.has(student.id)}
                                        onClick={(e) => {
                                            e.currentTarget.blur();
                                            handlePresentIconClick(student);
                                        }}
                                        style={{
                                            width: '44px',
                                            height: '44px',
                                            padding: '0',
                                            borderRadius: '50%',
                                            border: isPresent ? 'none' : '2px solid #d1d5db',
                                            background: isPresent ? '#10b981' : '#ffffff',
                                            color: isPresent ? '#ffffff' : '#6b7280',
                                            fontSize: '22px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: canEditAttendance() ? 'pointer' : 'not-allowed',
                                            transition: 'all 0.2s ease',
                                            opacity: !canEditAttendance() ? 0.5 : 1,
                                            boxShadow: isPresent ? '0 2px 8px rgba(16, 185, 129, 0.45)' : '0 1px 4px rgba(0,0,0,0.1)'
                                        }}
                                        className="d-flex align-items-center justify-content-center att-btn-round"
                                    >
                                        {savingStudentIds.has(student.id) ? (
                                            <span className="spinner-border spinner-border-sm" style={{ width: '18px', height: '18px' }} role="status" />
                                        ) : (
                                            <i className="ri-checkbox-circle-line"></i>
                                        )}
                                    </Button>

                                    <Button
                                        title={isAbsent ? 'Marked Absent' : 'Mark Absent'}
                                        disabled={!canEditAttendance() || savingStudentIds.has(student.id)}
                                        onClick={(e) => {
                                            e.currentTarget.blur();
                                            handleAbsentIconClick(student);
                                        }}
                                        style={{
                                            width: '44px',
                                            height: '44px',
                                            padding: '0',
                                            borderRadius: '50%',
                                            border: isAbsent ? 'none' : '2px solid #d1d5db',
                                            background: isAbsent ? '#ef4444' : '#ffffff',
                                            color: isAbsent ? '#ffffff' : '#6b7280',
                                            fontSize: '22px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: canEditAttendance() ? 'pointer' : 'not-allowed',
                                            transition: 'all 0.2s ease',
                                            opacity: !canEditAttendance() ? 0.5 : 1,
                                            boxShadow: isAbsent ? '0 2px 8px rgba(239, 68, 68, 0.45)' : '0 1px 4px rgba(0,0,0,0.1)'
                                        }}
                                        className="d-flex align-items-center justify-content-center att-btn-round"
                                    >
                                        {savingStudentIds.has(student.id) ? (
                                            <span className="spinner-border spinner-border-sm" style={{ width: '18px', height: '18px' }} role="status" />
                                        ) : (
                                            <i className="ri-close-circle-line"></i>
                                        )}
                                    </Button>
                                </>
                            );
                        })()}
                    </div>
                )}

                {/* Exit & Expand Buttons — available on any editable date, not
                    just today, so a teacher backfilling a past date's
                    attendance can also record the exit time (handleSetExitTime
                    itself already enforces canEditAttendance()). Exit time only
                    makes sense for a student who is actually marked present. */}
                {!student.is_on_leave && student.attendance === 'present' && (
                    <Button
                        size="sm"
                        title={student.exit_time ? `Exit time: ${formatTime(student.exit_time)} (tap to change)` : 'Set exit time'}
                        disabled={!canEditAttendance()}
                        onClick={(e) => {
                            e.currentTarget.blur();
                            handleSetExitTime(student);
                        }}
                        className="att-exit-btn"
                        style={{
                            fontSize: '10px',
                            padding: '6px 10px',
                            background: student.exit_time ? '#dc2626' : '#fee2e2',
                            border: student.exit_time ? '1px solid #dc2626' : '1px solid #fca5a5',
                            color: student.exit_time ? '#ffffff' : '#991b1b',
                            fontWeight: '600',
                            borderRadius: '5px',
                            cursor: canEditAttendance() ? 'pointer' : 'not-allowed',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '3px',
                            lineHeight: 1,
                            flexShrink: 0,
                            whiteSpace: 'nowrap',
                            opacity: canEditAttendance() ? 1 : 0.6
                        }}
                    >
                        <i className="ri-logout-circle-r-line" style={{fontSize: '11px', display: 'inline-flex'}}></i>
                        {student.exit_time ? formatTime(student.exit_time) : 'Exit'}
                    </Button>
                )}

                {/* Expand/Collapse Button - available even while on leave
                    (present/absent marking above doesn't apply, but the
                    actions strip below - Daily Report, Registration, etc. -
                    still does), matching the mobile app's "Tap to view
                    actions" affordance for a student on leave. */}
                <button
                    onClick={() => toggleStudentExpand(student.id)}
                    className="att-expand-btn"
                    style={{
                        background: 'transparent',
                        border: 'none',
                        borderRadius: '5px',
                        width: '28px',
                        height: '28px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        color: '#6b7280',
                        fontSize: '16px',
                        flexShrink: 0
                    }}
                    onMouseEnter={(e) => e.target.style.background = '#f3f4f6'}
                    onMouseLeave={(e) => e.target.style.background = 'transparent'}
                    title={isExpanded ? 'Hide actions' : 'Show actions'}
                >
                    <i className={`ri-${isExpanded ? 'arrow-up' : 'arrow-down'}-s-line`}></i>
                </button>
            </div>

            {/* Expandable Actions Section - Single Compact Line */}
            {isExpanded && (
                <div
                    className="att-actions-strip"
                    // Used to be a single-row horizontal scroller with its
                    // scrollbar hidden and only a click-drag/wheel gesture to
                    // reach whatever overflowed - the last button or two (e.g.
                    // "Accident") ended up clipped at the right edge with no
                    // visual hint that there was anything to scroll to, which
                    // just looked broken. Wrapping instead means every action
                    // is always fully visible, at the cost of the strip
                    // sometimes taking two rows.
                    style={{
                        padding: '8px 10px',
                        background: '#fafbfc',
                        borderTop: '1px solid #e5e7eb',
                        display: 'flex',
                        gap: '5px',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                    }}>
                    {/* Reports Section */}
                    <Button
                        title="Daily Report"
                        variant="outline-primary"
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            viewDailyReport(student);
                        }}
                        style={{ fontSize: '10px', padding: '4px 7px', borderRadius: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '3px', height: '28px', flexShrink: 0, whiteSpace: 'nowrap', color: '#1d4ed8', borderColor: '#3b82f6' }}
                    >
                        <i style={{ fontSize: '12px' }} className="ri-file-list-3-line"></i>
                        <span>Daily Report</span>
                    </Button>

                    <Button
                        title="Registration"
                        variant="outline-secondary"
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            viewRegistration(student);
                        }}
                        style={{ fontSize: '10px', padding: '4px 7px', borderRadius: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '3px', height: '28px', flexShrink: 0, whiteSpace: 'nowrap', color: '#6d28d9', borderColor: '#8b5cf6' }}
                    >
                        <i style={{ fontSize: '12px' }} className="ri-file-user-line"></i>
                        <span>Registration</span>
                    </Button>

                    <Button
                        title="Observation"
                        variant="outline-secondary"
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            (isTeacherLogin || isToday(selectedDate)) ? handleOpenObservation(student) : viewObservation(student);
                        }}
                        style={{ fontSize: '10px', padding: '4px 7px', borderRadius: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '3px', height: '28px', flexShrink: 0, whiteSpace: 'nowrap', color: '#374151', borderColor: '#9ca3af' }}
                    >
                        <i style={{ fontSize: '12px' }} className="ri-file-edit-line"></i>
                        <span>Observation</span>
                    </Button>

                    {/* Assign Room / Swap Room - plain buttons alongside the
                        other quick actions, same style as Registration/
                        Observation. Both open the existing Room Management
                        modal (it covers assign and swap together), which
                        already refreshes the roster via loadAttendanceData()
                        on success (see submitRoomAssign/submitRoomSwap). */}
                    <Button
                        title="Assign Room"
                        variant="outline-secondary"
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            openRoomModal(student, 'assign');
                        }}
                        style={{ fontSize: '10px', padding: '4px 7px', borderRadius: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '3px', height: '28px', flexShrink: 0, whiteSpace: 'nowrap', color: '#0e7490', borderColor: '#06b6d4' }}
                    >
                        <i style={{ fontSize: '12px' }} className="ri-door-open-line"></i>
                        <span>Assign Room</span>
                    </Button>

                    <Button
                        title="Swap Room"
                        variant="outline-secondary"
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            openRoomModal(student, 'swap');
                        }}
                        style={{ fontSize: '10px', padding: '4px 7px', borderRadius: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '3px', height: '28px', flexShrink: 0, whiteSpace: 'nowrap', color: '#7C3AED', borderColor: '#a78bfa' }}
                    >
                        <i style={{ fontSize: '12px' }} className="ri-swap-line"></i>
                        <span>Swap Room</span>
                    </Button>

                    {/* Health Section - solid/colored + a round count badge
                        whenever the student has an ongoing medication/
                        non-medication today (medication_count/
                        non_medication_count are the ONGOING count, not a
                        total including past/upcoming records - so the
                        badge and the solid coloring always agree). */}
                    <Button
                        title={student.medication_count > 0 ? `Medication (${student.medication_count} ongoing)` : "Medication"}
                        variant={student.medication_count > 0 ? "info" : "outline-info"}
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            viewMedication(student);
                        }}
                        style={{ fontSize: '10px', padding: '4px 7px', borderRadius: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '3px', height: '28px', flexShrink: 0, whiteSpace: 'nowrap', position: 'relative', ...(student.medication_count > 0 ? { color: '#fff', borderColor: '#0ea5e9' } : { color: '#0c4a6e', borderColor: '#0ea5e9' }) }}
                    >
                        <i style={{ fontSize: '12px' }} className="ri-medicine-bottle-line"></i>
                        <span>Medication</span>
                        {student.medication_count > 0 && (
                            <span style={countBadgeStyle}>{student.medication_count}</span>
                        )}
                    </Button>

                    <Button
                        title={student.non_medication_count > 0 ? `Non-Medication (${student.non_medication_count} ongoing)` : "Non-Medication"}
                        variant={student.non_medication_count > 0 ? "success" : "outline-success"}
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            viewNonMedication(student);
                        }}
                        style={{ fontSize: '10px', padding: '4px 7px', borderRadius: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '3px', height: '28px', flexShrink: 0, whiteSpace: 'nowrap', position: 'relative', ...(student.non_medication_count > 0 ? { color: '#fff', borderColor: '#059669' } : { color: '#065f46', borderColor: '#059669' }) }}
                    >
                        <i style={{ fontSize: '12px' }} className="ri-heart-pulse-line"></i>
                        <span>Non-Medication</span>
                        {student.non_medication_count > 0 && (
                            <span style={countBadgeStyle}>{student.non_medication_count}</span>
                        )}
                    </Button>

                    {student.allergy_report_id && (
                        <Button
                            title="Allergy"
                            variant="outline-danger"
                            size="sm"
                            onClick={(e) => {
                                e.currentTarget.blur();
                                viewAllergy(student);
                            }}
                            style={{ fontSize: '10px', padding: '4px 7px', borderRadius: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '3px', height: '28px', flexShrink: 0, whiteSpace: 'nowrap', color: '#991b1b', borderColor: '#ef4444' }}
                        >
                            <i style={{ fontSize: '12px' }} className="ri-alert-line"></i>
                            <span>Allergy</span>
                        </Button>
                    )}

                    {student.lunch_plan_waiver_id && (
                        <Button
                            title="Lunch Plan"
                            variant="outline-success"
                            size="sm"
                            onClick={(e) => {
                                e.currentTarget.blur();
                                viewLunchPlan(student);
                            }}
                            style={{ fontSize: '10px', padding: '4px 7px', borderRadius: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '3px', height: '28px', flexShrink: 0, whiteSpace: 'nowrap', color: '#14532d', borderColor: '#22c55e' }}
                        >
                            <i style={{ fontSize: '12px' }} className="ri-restaurant-line"></i>
                            <span>Lunch Plan</span>
                        </Button>
                    )}

                    {student.peanut_policy_id && (
                        <Button
                            title="Peanut Policy"
                            variant="outline-warning"
                            size="sm"
                            onClick={(e) => {
                                e.currentTarget.blur();
                                viewPeanutPolicy(student);
                            }}
                            style={{ fontSize: '10px', padding: '4px 7px', borderRadius: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '3px', height: '28px', flexShrink: 0, whiteSpace: 'nowrap', color: '#7c2d12', borderColor: '#f97316' }}
                        >
                            <i style={{ fontSize: '12px' }} className="ri-forbid-line"></i>
                            <span>Peanut</span>
                        </Button>
                    )}

                    {/* Incidents Section */}
                    <Button
                        title="Accident Report"
                        variant="outline-danger"
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            viewAccidentReports(student);
                        }}
                        style={{ fontSize: '10px', padding: '4px 7px', borderRadius: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '3px', height: '28px', flexShrink: 0, whiteSpace: 'nowrap', color: '#7f1d1d', borderColor: '#dc2626' }}
                    >
                        <i style={{ fontSize: '12px' }} className="ri-alarm-warning-line"></i>
                        <span>Accident</span>
                    </Button>

                    <Button
                        title="Illness Report"
                        variant="outline-warning"
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            viewIllnessReports(student);
                        }}
                        style={{ fontSize: '10px', padding: '4px 7px', borderRadius: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '3px', height: '28px', flexShrink: 0, whiteSpace: 'nowrap', color: '#78350f', borderColor: '#f59e0b' }}
                    >
                        <i style={{ fontSize: '12px' }} className="ri-virus-line"></i>
                        <span>Illness</span>
                    </Button>

                    <Button
                        title="Games"
                        variant="outline-secondary"
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            viewAssignedGames(student);
                        }}
                        style={{ fontSize: '10px', padding: '4px 7px', borderRadius: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '3px', height: '28px', flexShrink: 0, whiteSpace: 'nowrap', color: '#3730a3', borderColor: '#818cf8' }}
                    >
                        <i style={{ fontSize: '12px' }} className="ri-gamepad-line"></i>
                        <span>Games</span>
                    </Button>

                    <Button
                        title="Game Stats"
                        variant="outline-secondary"
                        size="sm"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            viewGameStats(student);
                        }}
                        style={{ fontSize: '10px', padding: '4px 7px', borderRadius: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '3px', height: '28px', flexShrink: 0, whiteSpace: 'nowrap', color: '#065f46', borderColor: '#34d399' }}
                    >
                        <i style={{ fontSize: '12px' }} className="ri-bar-chart-line"></i>
                        <span>Game Stats</span>
                    </Button>
                </div>
            )}
        </div>
        );
    };

    // renderStudentsList and renderSaveButton merged into renderStudentsPanel above

    const renderEmergencyContactsModal = () => (
        <Modal show={showEmergencyModal} onHide={() => {
            setShowEmergencyModal(false);
            setParentInfoData(null);
        }} centered size="xl" style={{ marginTop: '30px', marginBottom: '30px' }}>
            <Modal.Header closeButton style={{
                background: 'white',
                borderBottom: '1px solid #e9ecef',
                padding: '20px 25px',
                borderRadius: '0'
            }}>
                <Modal.Title style={{ 
                    fontSize: '18px', 
                    fontWeight: '700', 
                    color: '#212529', 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '12px',
                    letterSpacing: '0.3px'
                }}>
                    <div style={{
                        width: '42px',
                        height: '42px',
                        background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 2px 8px rgba(220, 53, 69, 0.3)'
                    }}>
                        <i className="ri-alarm-warning-fill" style={{ fontSize: '22px', color: 'white' }}></i>
                    </div>
                    <span>Emergency Contacts & Parent Information</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '0', background: '#f0f2f5', maxHeight: '75vh', overflowY: 'auto' }}>
                {/* Student Profile Section */}
                {parentInfoData && parentInfoData.user && (
                    <div style={{
                        padding: '25px',
                        background: 'linear-gradient(135deg, var(--bs-primary) 0%, var(--bs-primary) 100%)',
                        borderBottom: '1px solid rgba(255,255,255,0.1)'
                    }}>
                        <div style={{
                            background: 'rgba(255, 255, 255, 0.95)',
                            padding: '20px',
                            borderRadius: '16px',
                            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '18px',
                            position: 'relative',
                            overflow: 'hidden'
                        }}>
                            <div style={{
                                position: 'absolute',
                                top: '-20px',
                                right: '-20px',
                                width: '120px',
                                height: '120px',
                                background: 'linear-gradient(135deg, rgba(var(--bs-primary-rgb), 0.1) 0%, transparent 100%)',
                                borderRadius: '50%'
                            }}></div>
                            <div style={{
                                position: 'absolute',
                                bottom: '-30px',
                                left: '40%',
                                width: '100px',
                                height: '100px',
                                background: 'linear-gradient(135deg, rgba(118, 75, 162, 0.08) 0%, transparent 100%)',
                                borderRadius: '50%'
                            }}></div>
                            
                            <div style={{
                                width: '70px',
                                height: '70px',
                                minWidth: '70px',
                                borderRadius: '50%',
                                overflow: 'hidden',
                                border: '4px solid var(--bs-primary)',
                                boxShadow: '0 4px 12px rgba(var(--bs-primary-rgb), 0.3)',
                                position: 'relative',
                                zIndex: 1
                            }}>
                                <img
                                    src={parentInfoData.user.user_setting?.photo || "https://uzone360live.s3.amazonaws.com/noimage.png"}
                                    alt={`${parentInfoData.user.first_name} ${parentInfoData.user.last_name}`}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                    }}
                                />
                            </div>
                            <div style={{ flex: 1, position: 'relative', zIndex: 1 }}>
                                <div style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: 'var(--bs-primary)',
                                    textTransform: 'uppercase',
                                    letterSpacing: '1px',
                                    marginBottom: '4px'
                                }}>
                                    Student Information
                                </div>
                                <div style={{ fontSize: '20px', fontWeight: '700', color: '#212529', marginBottom: '6px', letterSpacing: '0.3px' }}>
                                    {parentInfoData.user.first_name} {parentInfoData.user.last_name}
                                </div>
                                <div style={{
                                    fontSize: '13px',
                                    color: '#6c757d',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    background: '#f8f9fa',
                                    padding: '6px 12px',
                                    borderRadius: '20px',
                                    width: 'fit-content',
                                    border: '1px solid #e9ecef'
                                }}>
                                    <i className="ri-mail-line"></i>
                                    <span>{parentInfoData.user.email}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Emergency Contacts Section */}
                <div style={{ 
                    padding: '25px',
                    background: 'linear-gradient(180deg, #fff5f5 0%, #f0f2f5 100%)',
                    borderBottom: '1px solid #e0e0e0'
                }}>
                    <div style={{
                        fontSize: '16px',
                        fontWeight: '700',
                        color: '#dc3545',
                        marginBottom: '18px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        paddingBottom: '10px',
                        borderBottom: '3px solid #dc3545',
                        width: 'fit-content'
                    }}>
                        <i className="ri-alarm-warning-line" style={{ fontSize: '20px' }}></i>
                        <span>Emergency Contacts</span>
                    </div>
                    {selectedEmergencyContacts.length > 0 ? (
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px' }}>
                            {selectedEmergencyContacts.map((contact, index) => (
                                <div key={index} style={{
                                    padding: '18px',
                                    background: 'linear-gradient(135deg, #ffffff 0%, #fafafa 100%)',
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 12px rgba(220, 53, 69, 0.15)',
                                    border: '1px solid rgba(220, 53, 69, 0.1)',
                                    transition: 'all 0.3s ease',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        width: '60px',
                                        height: '60px',
                                        background: 'linear-gradient(135deg, rgba(220, 53, 69, 0.1) 0%, transparent 100%)',
                                        borderRadius: '0 0 0 100%'
                                    }}></div>
                                    
                                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px', marginBottom: '16px', position: 'relative' }}>
                                        <div style={{
                                            width: '56px',
                                            height: '56px',
                                            minWidth: '56px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            boxShadow: '0 4px 12px rgba(220, 53, 69, 0.4)',
                                            border: '3px solid white'
                                        }}>
                                            <i className="ri-user-heart-fill" style={{ fontSize: '26px', color: 'white' }}></i>
                                        </div>
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{ 
                                                fontSize: '16px', 
                                                fontWeight: '700', 
                                                color: '#212529', 
                                                marginBottom: '4px',
                                                lineHeight: '1.3'
                                            }}>
                                                {contact.name}
                                            </div>
                                            <div style={{
                                                fontSize: '13px',
                                                color: '#6c757d',
                                                fontWeight: '500',
                                                display: 'inline-block',
                                                padding: '3px 10px',
                                                background: 'rgba(220, 53, 69, 0.08)',
                                                borderRadius: '12px',
                                                border: '1px solid rgba(220, 53, 69, 0.15)'
                                            }}>
                                                <i className="ri-heart-line" style={{ fontSize: '11px', marginRight: '4px' }}></i>
                                                {contact.relationship}
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            padding: '12px 14px',
                                            background: 'linear-gradient(135deg, #fff 0%, #f8f9fa 100%)',
                                            borderRadius: '12px',
                                            border: '1px solid #e9ecef',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.04)'
                                        }}>
                                            <div style={{
                                                width: '36px',
                                                height: '36px',
                                                minWidth: '36px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                boxShadow: '0 2px 8px rgba(40, 167, 69, 0.3)'
                                            }}>
                                                <i className="ri-phone-fill" style={{ fontSize: '16px', color: 'white' }}></i>
                                            </div>
                                            <a href={`tel:${contact.phone}`} style={{
                                                fontSize: '15px',
                                                fontWeight: '700',
                                                color: '#212529',
                                                textDecoration: 'none',
                                                letterSpacing: '0.3px',
                                                flex: 1
                                            }}>
                                                {contact.phone}
                                            </a>
                                            <i className="ri-external-link-line" style={{ fontSize: '16px', color: '#6c757d' }}></i>
                                        </div>

                                        {contact.email && (
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                padding: '12px 14px',
                                                background: 'linear-gradient(135deg, #fff 0%, #f8f9fa 100%)',
                                                borderRadius: '12px',
                                                border: '1px solid #e9ecef',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.04)'
                                            }}>
                                                <div style={{
                                                    width: '36px',
                                                    height: '36px',
                                                    minWidth: '36px',
                                                    borderRadius: '50%',
                                                    background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: '0 2px 8px rgba(0, 123, 255, 0.3)'
                                                }}>
                                                    <i className="ri-mail-fill" style={{ fontSize: '16px', color: 'white' }}></i>
                                                </div>
                                                <a href={`mailto:${contact.email}`} style={{
                                                    fontSize: '14px',
                                                    fontWeight: '600',
                                                    color: '#212529',
                                                    textDecoration: 'none',
                                                    flex: 1,
                                                    wordBreak: 'break-all'
                                                }}>
                                                    {contact.email}
                                                </a>
                                                <i className="ri-external-link-line" style={{ fontSize: '16px', color: '#6c757d' }}></i>
                                            </div>
                                        )}

                                        {contact.address && (
                                            <div style={{
                                                padding: '12px 14px',
                                                background: 'linear-gradient(135deg, #fff 0%, #f8f9fa 100%)',
                                                borderRadius: '12px',
                                                border: '1px solid #e9ecef',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.04)'
                                            }}>
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                    gap: '10px'
                                                }}>
                                                    <div style={{
                                                        width: '36px',
                                                        height: '36px',
                                                        minWidth: '36px',
                                                        borderRadius: '50%',
                                                        background: 'linear-gradient(135deg, #ffc107 0%, #ff9800 100%)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        boxShadow: '0 2px 8px rgba(255, 193, 7, 0.3)'
                                                    }}>
                                                        <i className="ri-map-pin-fill" style={{ fontSize: '16px', color: 'white' }}></i>
                                                    </div>
                                                    <div style={{
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        color: '#495057',
                                                        flex: 1,
                                                        lineHeight: '1.5'
                                                    }}>
                                                        {contact.address}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {contact.work_phone && (
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                padding: '12px 14px',
                                                background: 'linear-gradient(135deg, #fff 0%, #f8f9fa 100%)',
                                                borderRadius: '12px',
                                                border: '1px solid #e9ecef',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.04)'
                                            }}>
                                                <div style={{
                                                    width: '36px',
                                                    height: '36px',
                                                    minWidth: '36px',
                                                    borderRadius: '50%',
                                                    background: 'linear-gradient(135deg, #6c757d 0%, #495057 100%)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: '0 2px 8px rgba(108, 117, 125, 0.3)'
                                                }}>
                                                    <i className="ri-building-fill" style={{ fontSize: '16px', color: 'white' }}></i>
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ fontSize: '10px', color: '#6c757d', marginBottom: '2px', textTransform: 'uppercase', fontWeight: '600' }}>
                                                        Work Phone
                                                    </div>
                                                    <a href={`tel:${contact.work_phone}`} style={{
                                                        fontSize: '14px',
                                                        fontWeight: '700',
                                                        color: '#212529',
                                                        textDecoration: 'none'
                                                    }}>
                                                        {contact.work_phone}
                                                    </a>
                                                </div>
                                                <i className="ri-external-link-line" style={{ fontSize: '16px', color: '#6c757d' }}></i>
                                            </div>
                                        )}

                                        {contact.notes && (
                                            <div style={{
                                                padding: '12px 14px',
                                                background: 'linear-gradient(135deg, #fff3cd 0%, #fff8e1 100%)',
                                                borderRadius: '12px',
                                                border: '1px solid #ffc107',
                                                boxShadow: '0 2px 4px rgba(255, 193, 7, 0.1)'
                                            }}>
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                    gap: '10px'
                                                }}>
                                                    <i className="ri-information-fill" style={{ fontSize: '18px', color: '#ff9800', marginTop: '2px' }}></i>
                                                    <div>
                                                        <div style={{ fontSize: '10px', color: '#856404', marginBottom: '4px', textTransform: 'uppercase', fontWeight: '700', letterSpacing: '0.5px' }}>
                                                            Notes
                                                        </div>
                                                        <div style={{
                                                            fontSize: '13px',
                                                            fontWeight: '500',
                                                            color: '#856404',
                                                            lineHeight: '1.5'
                                                        }}>
                                                            {contact.notes}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div style={{
                            textAlign: 'center',
                            padding: '40px 20px',
                            color: '#6c757d',
                            fontSize: '14px',
                            background: 'white',
                            borderRadius: '16px',
                            border: '2px dashed #dee2e6'
                        }}>
                            <i className="ri-contacts-line" style={{ fontSize: '48px', color: '#dee2e6', marginBottom: '12px', display: 'block' }}></i>
                            <div style={{ fontWeight: '600' }}>No emergency contacts available</div>
                            <div style={{ fontSize: '12px', color: '#adb5bd', marginTop: '4px' }}>Add emergency contacts to ensure quick access in case of emergencies</div>
                        </div>
                    )}
                </div>

                {/* Parent Information Section */}
                {parentInfoData && parentInfoData.user && (
                    <div style={{ padding: '25px', background: '#f0f2f5' }}>
                        <div style={{
                            fontSize: '16px',
                            fontWeight: '700',
                            color: '#495057',
                            marginBottom: '18px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            paddingBottom: '10px',
                            borderBottom: '3px solid #6c63ff',
                            width: 'fit-content'
                        }}>
                            <i className="ri-parent-line" style={{ fontSize: '20px' }}></i>
                            <span>Parent & Guardian Information</span>
                        </div>

                        {parentInfoData.user.user_setting && (
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '16px' }}>
                                {/* Father's Information Card */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #fff 0%, #f8f9ff 100%)',
                                    padding: '20px',
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 12px rgba(var(--bs-primary-rgb), 0.12)',
                                    border: '1px solid rgba(var(--bs-primary-rgb), 0.15)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        width: '80px',
                                        height: '80px',
                                        background: 'linear-gradient(135deg, rgba(var(--bs-primary-rgb), 0.08) 0%, transparent 100%)',
                                        borderRadius: '0 0 0 100%'
                                    }}></div>
                                    
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        marginBottom: '18px',
                                        paddingBottom: '14px',
                                        borderBottom: '2px solid rgba(var(--bs-primary-rgb), 0.2)',
                                        position: 'relative'
                                    }}>
                                        <div style={{
                                            width: '40px',
                                            height: '40px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, var(--bs-primary) 0%, var(--bs-primary) 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            boxShadow: '0 4px 8px rgba(var(--bs-primary-rgb), 0.3)'
                                        }}>
                                            <i className="ri-user-3-fill" style={{ fontSize: '20px', color: 'white' }}></i>
                                        </div>
                                        <span style={{
                                            fontSize: '16px',
                                            fontWeight: '700',
                                            color: 'var(--bs-primary)',
                                            letterSpacing: '0.3px'
                                        }}>
                                            Father's Information
                                        </span>
                                    </div>
                                    
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                                        <div>
                                            <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                Full Name
                                            </div>
                                            <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="ri-user-line" style={{ color: 'var(--bs-primary)' }}></i>
                                                {parentInfoData.user.user_setting.fathers_name || 'N/A'}
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                Phone Number
                                            </div>
                                            <a href={`tel:${parentInfoData.user.user_setting.fathers_phone || ''}`} style={{
                                                fontSize: '14px',
                                                fontWeight: '700',
                                                color: '#212529',
                                                textDecoration: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                padding: '8px 12px',
                                                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                                borderRadius: '8px',
                                                border: '1px solid #dee2e6',
                                                width: 'fit-content'
                                            }}>
                                                <i className="ri-phone-fill" style={{ color: '#28a745' }}></i>
                                                {parentInfoData.user.user_setting.fathers_phone || 'N/A'}
                                            </a>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                Email Address
                                            </div>
                                            <div style={{ fontSize: '13px', fontWeight: '500', color: '#495057', wordBreak: 'break-all', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="ri-mail-line" style={{ color: 'var(--bs-primary)' }}></i>
                                                {parentInfoData.user.user_setting.fathers_email || 'N/A'}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Mother's Information Card */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #fff 0%, #fff5f8 100%)',
                                    padding: '20px',
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 12px rgba(233, 30, 99, 0.12)',
                                    border: '1px solid rgba(233, 30, 99, 0.15)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        width: '80px',
                                        height: '80px',
                                        background: 'linear-gradient(135deg, rgba(233, 30, 99, 0.08) 0%, transparent 100%)',
                                        borderRadius: '0 0 0 100%'
                                    }}></div>
                                    
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        marginBottom: '18px',
                                        paddingBottom: '14px',
                                        borderBottom: '2px solid rgba(233, 30, 99, 0.2)',
                                        position: 'relative'
                                    }}>
                                        <div style={{
                                            width: '40px',
                                            height: '40px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #e91e63 0%, #ad1457 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            boxShadow: '0 4px 8px rgba(233, 30, 99, 0.3)'
                                        }}>
                                            <i className="ri-user-3-fill" style={{ fontSize: '20px', color: 'white' }}></i>
                                        </div>
                                        <span style={{
                                            fontSize: '16px',
                                            fontWeight: '700',
                                            color: '#e91e63',
                                            letterSpacing: '0.3px'
                                        }}>
                                            Mother's Information
                                        </span>
                                    </div>
                                    
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                                        <div>
                                            <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                Full Name
                                            </div>
                                            <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="ri-user-line" style={{ color: '#e91e63' }}></i>
                                                {parentInfoData.user.user_setting.mothers_name || 'N/A'}
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                Phone Number
                                            </div>
                                            <a href={`tel:${parentInfoData.user.user_setting.mothers_phone || ''}`} style={{
                                                fontSize: '14px',
                                                fontWeight: '700',
                                                color: '#212529',
                                                textDecoration: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                padding: '8px 12px',
                                                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                                borderRadius: '8px',
                                                border: '1px solid #dee2e6',
                                                width: 'fit-content'
                                            }}>
                                                <i className="ri-phone-fill" style={{ color: '#28a745' }}></i>
                                                {parentInfoData.user.user_setting.mothers_phone || 'N/A'}
                                            </a>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                Email Address
                                            </div>
                                            <div style={{ fontSize: '13px', fontWeight: '500', color: '#495057', wordBreak: 'break-all', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="ri-mail-line" style={{ color: '#e91e63' }}></i>
                                                {parentInfoData.user.user_setting.mothers_email || 'N/A'}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Guardian's Information Card */}
                                {(parentInfoData.user.user_setting.guardian_name ||
                                    parentInfoData.user.user_setting.guardian_phone ||
                                    parentInfoData.user.user_setting.guardian_email) && (
                                        <div style={{
                                            background: 'linear-gradient(135deg, #fff 0%, #fff8f0 100%)',
                                            padding: '20px',
                                            borderRadius: '16px',
                                            boxShadow: '0 4px 12px rgba(255, 152, 0, 0.12)',
                                            border: '1px solid rgba(255, 152, 0, 0.15)',
                                            position: 'relative',
                                            overflow: 'hidden',
                                            gridColumn: 'span 1'
                                        }}>
                                            <div style={{
                                                position: 'absolute',
                                                top: 0,
                                                right: 0,
                                                width: '80px',
                                                height: '80px',
                                                background: 'linear-gradient(135deg, rgba(255, 152, 0, 0.08) 0%, transparent 100%)',
                                                borderRadius: '0 0 0 100%'
                                            }}></div>
                                            
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '12px',
                                                marginBottom: '18px',
                                                paddingBottom: '14px',
                                                borderBottom: '2px solid rgba(255, 152, 0, 0.2)',
                                                position: 'relative'
                                            }}>
                                                <div style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '50%',
                                                    background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: '0 4px 8px rgba(255, 152, 0, 0.3)'
                                                }}>
                                                    <i className="ri-shield-user-fill" style={{ fontSize: '20px', color: 'white' }}></i>
                                                </div>
                                                <span style={{
                                                    fontSize: '16px',
                                                    fontWeight: '700',
                                                    color: '#ff9800',
                                                    letterSpacing: '0.3px'
                                                }}>
                                                    Guardian's Information
                                                </span>
                                            </div>
                                            
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                                                <div>
                                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                        Full Name
                                                    </div>
                                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <i className="ri-user-line" style={{ color: '#ff9800' }}></i>
                                                        {parentInfoData.user.user_setting.guardian_name || 'N/A'}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                        Phone Number
                                                    </div>
                                                    <a href={`tel:${parentInfoData.user.user_setting.guardian_phone || ''}`} style={{
                                                        fontSize: '14px',
                                                        fontWeight: '700',
                                                        color: '#212529',
                                                        textDecoration: 'none',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px',
                                                        padding: '8px 12px',
                                                        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                                        borderRadius: '8px',
                                                        border: '1px solid #dee2e6',
                                                        width: 'fit-content'
                                                    }}>
                                                        <i className="ri-phone-fill" style={{ color: '#28a745' }}></i>
                                                        {parentInfoData.user.user_setting.guardian_phone || 'N/A'}
                                                    </a>
                                                </div>
                                                <div>
                                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                                        Email Address
                                                    </div>
                                                    <div style={{ fontSize: '13px', fontWeight: '500', color: '#495057', wordBreak: 'break-all', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <i className="ri-mail-line" style={{ color: '#ff9800' }}></i>
                                                        {parentInfoData.user.user_setting.guardian_email || 'N/A'}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                            </div>
                        )}
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );

    const renderObservationModal = () => {
        const isPrimaryObservationTab = observationPrimaryTab === 'observation';
        const isPrimaryNoteTab = observationPrimaryTab === 'note';
        const isDailyObservationTab = observationActiveTab === 'observation';
        const isLearningPathTab = observationActiveTab === 'learningPath';
        const isParentReportTab = observationActiveTab === 'parentReport';
        const activeCategory = observationCategories.find((category) => category.id === activeObservationCategoryId);
        const categoryLinks = activeCategory?.links || [];

        const primaryTabStyle = (isActive) => ({
            border: isActive ? '1px solid #cfd4da' : '1px solid transparent',
            borderBottom: isActive ? '1px solid #f8f9fa' : '1px solid transparent',
            background: isActive ? '#ffffff' : 'transparent',
            color: isActive ? '#374151' : '#6b7280',
            fontWeight: isActive ? '600' : '500',
            fontSize: '12px',
            padding: '6px 12px',
            borderRadius: '4px 4px 0 0',
            boxShadow: 'none',
            transition: 'all 0.2s ease'
        });

        const innerTabStyle = (isActive) => ({
            border: isActive ? '1px solid #cfd4da' : '1px solid transparent',
            borderBottom: isActive ? '1px solid #ffffff' : '1px solid transparent',
            background: isActive ? '#ffffff' : 'transparent',
            color: isActive ? '#374151' : '#6b7280',
            fontWeight: isActive ? '600' : '500',
            fontSize: '12px',
            padding: '5px 10px',
            borderRadius: '4px 4px 0 0',
            boxShadow: 'none',
            transition: 'all 0.2s ease'
        });

        const sectionLabelStyle = {
            fontSize: '10px',
            color: '#6b7280',
            fontWeight: '700',
            letterSpacing: '0.2px',
            textTransform: 'uppercase',
            marginBottom: '6px'
        };

        const reportPanelStyle = {
            border: '1px solid #e5e7eb',
            background: '#f8f9fa',
            borderRadius: '2px'
        };

        const reportPanelHeaderStyle = {
            padding: '10px 12px 0 12px',
            borderBottom: '1px solid #eceff3',
            background: '#f8f9fa'
        };

        const reportHeaderTopLabelStyle = {
            fontSize: '10px',
            color: '#9ca3af',
            fontWeight: '700',
            textTransform: 'uppercase',
            marginBottom: '2px'
        };

        const reportTitleStyle = {
            fontSize: '18px',
            color: '#1f2937',
            fontWeight: '600',
            marginBottom: '6px',
            lineHeight: '1.2'
        };

        const reportTextareaStyle = {
            border: '1px dashed #d1d5db',
            borderRadius: '3px',
            fontSize: '13px',
            color: '#334155',
            lineHeight: '1.5',
            background: '#ffffff'
        };

        const parentReportPanelStyle = {
            border: '1px solid #e5e7eb',
            background: '#f1f3f5',
            borderRadius: '2px'
        };

        const parentReportHeaderStyle = {
            padding: '10px 12px 0 12px',
            borderBottom: '1px solid #eceff3',
            background: '#f1f3f5'
        };

        const parentReportSectionLabelStyle = {
            ...sectionLabelStyle,
            color: '#6b7280'
        };

        const parentReportTextareaStyle = {
            ...reportTextareaStyle,
            border: '1px dashed #d1d5db',
            background: '#ffffff',
            minHeight: '114px'
        };

        const learningPathTextareaStyles = {
            celebrate: {
                border: '1px dashed #d1d5db',
                background: '#eff6ff'
            },
            nurture: {
                border: '1px dashed #d1d5db',
                background: '#fff7ed'
            },
            activities: {
                border: '1px dashed #d1d5db',
                background: '#f0fdf4'
            }
        };

        const foundationMetricsConfig = [
            { key: 'belonging', label: 'Belonging', aliases: ['belonging', 'belong', 'belonging_score', 'bellonging', 'bellonging_score'], color: '#7c3aed', bg: '#f5f3ff' },
            { key: 'wellbeing', label: 'Well-Being', aliases: ['wellbeing', 'well_being', 'well-being', 'wellness', 'well', 'wellbeing_score', 'well-being_score', 'wellbing', 'wellbing_score'], color: '#0d9488', bg: '#f0fdfa' },
            { key: 'engagement', label: 'Engagement', aliases: ['engagement', 'engage', 'engagement_score'], color: '#ea580c', bg: '#fff7ed' },
            { key: 'expression', label: 'Expression', aliases: ['expression', 'express', 'expression_score'], color: '#b91c1c', bg: '#fef2f2' }
        ];

        const normalizeMetricKey = (value = '') => String(value)
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '');

        const toNumericScore = (rawValue) => {
            if (typeof rawValue === 'number' && Number.isFinite(rawValue)) {
                return rawValue;
            }

            if (typeof rawValue === 'string') {
                const extracted = rawValue.match(/[\d.]+/);
                if (extracted) {
                    const parsed = Number(extracted[0]);
                    return Number.isFinite(parsed) ? parsed : null;
                }
            }

            if (rawValue && typeof rawValue === 'object') {
                const nestedValue = rawValue.score ?? rawValue.value ?? rawValue.percentage;
                return toNumericScore(nestedValue);
            }

            return null;
        };

        const getMetricScore = (aliases = []) => {
            const scores = learningPathData?.scores || {};
            const scoreEntries = Object.entries(scores);
            for (let i = 0; i < aliases.length; i += 1) {
                const alias = normalizeMetricKey(aliases[i]);
                const entry = scoreEntries.find(([scoreKey]) => normalizeMetricKey(scoreKey) === alias);
                if (entry) {
                    const numericScore = toNumericScore(entry[1]);
                    if (numericScore !== null) {
                        return numericScore <= 10 ? numericScore * 10 : numericScore;
                    }
                }
            }
            return 0;
        };

        const foundationMetrics = foundationMetricsConfig.map((metric) => {
            const score = getMetricScore(metric.aliases);
            const clampedScore = Math.max(0, Math.min(100, score));
            const outOfTen = clampedScore / 10;
            return {
                ...metric,
                score: clampedScore,
                displayScore: `${outOfTen.toFixed(1)} / 10`
            };
        });

        const foundationScorePercent = foundationMetrics.length > 0
            ? (foundationMetrics.reduce((total, metric) => total + metric.score, 0) / foundationMetrics.length).toFixed(1)
            : 0;

        const getCategoryTheme = (name = '') => {
            const key = name.toLowerCase();
            if (key.includes('belong')) return { chip: '#6d28d9', left: '#ede9fe' };
            if (key.includes('well')) return { chip: '#0d9488', left: '#ccfbf1' };
            if (key.includes('engage')) return { chip: '#ea580c', left: '#ffedd5' };
            if (key.includes('express')) return { chip: '#b91c1c', left: '#fee2e2' };
            return { chip: '#475569', left: '#e2e8f0' };
        };

        return (
            <Modal
                show={showObservationModal}
                onHide={() => setShowObservationModal(false)}
                size="xl"
                fullscreen="md-down"
                className="att-observation-modal"
                dialogClassName="att-observation-dialog"
                backdropClassName="att-observation-backdrop"
            >
                <Modal.Header closeButton style={{ borderBottom: '1px solid #e5e7eb', padding: '10px 14px', background: '#f1f3f5' }}>
                    <Modal.Title style={{ fontSize: '22px', fontWeight: '600', color: '#374151', lineHeight: '1.2' }}>
                        <i className="ri-community-line me-2" style={{ fontSize: '20px', color: '#0ea5e9' }}></i>
                        Observation for {(selectedStudent?.name || 'Student').toUpperCase()}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ padding: '8px 8px 10px 8px', background: '#f4f5f7', maxHeight: 'calc(100vh - 140px)', overflowY: 'auto' }}>
                    {observationModalOpening && (
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px 10px',
                            marginBottom: '8px',
                            border: '1px solid #eef1f4',
                            background: '#fff'
                        }}>
                            <img src={loader} alt="Loading observation" style={{ height: '24px' }} />
                            <span style={{ fontSize: '12px', fontWeight: '600', color: '#6b7280' }}>Loading observation...</span>
                        </div>
                    )}
                    <div style={{ border: '1px solid #eef1f4', background: '#fff' }}>
                        <div style={{ borderBottom: '1px solid #eef1f4', padding: '8px 10px', background: '#f8f9fa', display: 'flex', gap: '8px' }}>
                            <Button
                                size="sm"
                                variant="light"
                                onClick={() => setObservationPrimaryTab('observation')}
                                style={primaryTabStyle(isPrimaryObservationTab)}
                            >
                                <i className="ri-file-list-2-line me-1"></i>
                                Observation
                            </Button>
                            <Button
                                size="sm"
                                variant="light"
                                onClick={() => setObservationPrimaryTab('note')}
                                style={primaryTabStyle(isPrimaryNoteTab)}
                            >
                                <i className="ri-sticky-note-line me-1"></i>
                                Note
                            </Button>
                        </div>

                        {isPrimaryObservationTab && (
                        <div style={{ borderBottom: '1px solid #eef1f4', padding: '8px 10px 0 10px', background: '#fff', display: 'flex', justifyContent: 'space-between', gap: '8px', flexWrap: 'wrap' }}>
                            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                                <Button
                                    size="sm"
                                    variant={isDailyObservationTab ? 'light' : 'outline-light'}
                                    onClick={() => setObservationActiveTab('observation')}
                                    style={innerTabStyle(isDailyObservationTab)}
                                >
                                    <i className="ri-clipboard-line me-1"></i>
                                    Daily Observation
                                </Button>
                                <Button
                                    size="sm"
                                    variant={isLearningPathTab ? 'light' : 'outline-light'}
                                    onClick={() => setObservationActiveTab('learningPath')}
                                    style={innerTabStyle(isLearningPathTab)}
                                >
                                    <i className="ri-route-line me-1"></i>
                                    Learning Path
                                </Button>
                                <Button
                                    size="sm"
                                    variant={isParentReportTab ? 'light' : 'outline-light'}
                                    onClick={() => setObservationActiveTab('parentReport')}
                                    style={innerTabStyle(isParentReportTab)}
                                >
                                    <i className="ri-file-text-line me-1"></i>
                                    Parent Report
                                </Button>
                            </div>

                            <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '600', paddingTop: '6px' }}>
                                {formatDisplayDate(selectedDate)}
                            </div>
                        </div>
                        )}

                        <div style={{ padding: '10px' }}>
                            {isPrimaryObservationTab && isDailyObservationTab && (
                                <div style={{ background: '#fff' }}>
                                    <div style={{ borderBottom: '1px solid #eef1f4', padding: '8px 8px 0 8px', background: '#fff' }}>
                                        {observationPickerLoading ? (
                                            <div style={{ fontSize: '12px', color: '#6b7280', padding: '10px' }}>Loading HDLH links...</div>
                                        ) : observationCategories.length === 0 ? (
                                            <div style={{ padding: '10px' }}>
                                                <Button size="sm" variant="outline-secondary" onClick={() => loadObservationPickerData(true)} style={{ fontSize: '11px', fontWeight: '700' }}>
                                                    Reload HDLH Links
                                                </Button>
                                            </div>
                                        ) : (
                                            <Row className="g-0" style={{ border: '1px solid #eef1f4' }}>
                                                <Col xs={12} md={3} lg={2} style={{ borderRight: '1px solid #eef1f4', background: '#f8f9fa' }}>
                                                    <div style={{ fontSize: '11px', fontWeight: '700', color: '#9ca3af', padding: '10px 10px 6px 10px' }}>CATEGORIES</div>
                                                    {observationCategories.map((category) => {
                                                        const isActive = activeObservationCategoryId === category.id;
                                                        const theme = getCategoryTheme(category.name);
                                                        const count = getSelectedObservationCountByCategory(category);
                                                        return (
                                                            <button
                                                                key={category.id}
                                                                type="button"
                                                                onClick={() => setActiveObservationCategoryId(category.id)}
                                                                style={{
                                                                    width: '100%',
                                                                    border: '0',
                                                                    borderLeft: `3px solid ${theme.chip}`,
                                                                    borderBottom: '1px solid #e5e7eb',
                                                                    background: isActive ? '#e5e7eb' : '#f8f9fa',
                                                                    color: '#374151',
                                                                    fontSize: '12px',
                                                                    fontWeight: isActive ? '700' : '600',
                                                                    padding: '10px 10px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    textAlign: 'left'
                                                                }}
                                                            >
                                                                <span>{category.name}</span>
                                                                <span style={{ fontSize: '12px', background: theme.chip, color: '#fff', borderRadius: '3px', minWidth: '16px', textAlign: 'center', padding: '0 3px' }}>{count}</span>
                                                            </button>
                                                        );
                                                    })}
                                                </Col>

                                                <Col xs={12} md={9} lg={10} style={{ background: '#fff' }}>
                                                    <div style={{ padding: '10px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', gap: '8px', flexWrap: 'wrap' }}>
                                                        <div style={{ fontSize: '22px', fontWeight: '700', color: '#16a34a', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                            <i className="ri-price-tag-3-fill" style={{ fontSize: '18px' }}></i>
                                                            {activeCategory?.name || 'Category'}
                                                        </div>
                                                        <div style={{ fontSize: '11px', color: '#9ca3af', fontWeight: '600' }}>
                                                            Tier: <span style={{ color: '#10b981' }}>1</span> • <span style={{ color: '#3b82f6' }}>2</span> • <span style={{ color: '#a78bfa' }}>3</span>
                                                        </div>
                                                    </div>

                                                    <div style={{ padding: '8px 10px', maxHeight: '300px', overflowY: 'auto' }}>
                                                        {categoryLinks.length === 0 ? (
                                                            <div style={{ fontSize: '12px', color: '#6b7280' }}>No links available in this category.</div>
                                                        ) : (
                                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                                {categoryLinks.map((link, index) => {
                                                                    const checked = selectedObservationLinks.includes(link.id);
                                                                    const dotColor = link?.tier === 1 ? '#10b981' : link?.tier === 2 ? '#3b82f6' : link?.tier === 3 ? '#a78bfa' : (index % 3 === 0 ? '#10b981' : index % 3 === 1 ? '#3b82f6' : '#a78bfa');
                                                                    return (
                                                                        <label key={link.id} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '13px', color: '#374151', cursor: 'pointer' }}>
                                                                            <Form.Check
                                                                                type="checkbox"
                                                                                checked={checked}
                                                                                onChange={() => toggleObservationLink(link.id)}
                                                                                style={{ marginTop: '2px' }}
                                                                            />
                                                                            <span style={{ color: dotColor, fontSize: '10px', marginTop: '7px' }}>●</span>
                                                                            <span>{link.content}</span>
                                                                        </label>
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>
                                        )}
                                    </div>

                                    <div style={{ borderBottom: '1px solid #eef1f4', background: '#f8f9fa', padding: '8px 12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', flexWrap: 'wrap' }}>
                                        <div style={{ fontSize: '14px', fontWeight: '600', color: '#6b7280' }}>
                                            {selectedObservationLinks.length} links selected
                                        </div>
                                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                            {showObservationRegenerateButton && (
                                                <Button size="sm" variant="success" disabled style={{ fontSize: '14px', fontWeight: '700' }}>
                                                    <i className="ri-checkbox-circle-fill me-1"></i>
                                                    Learning Path Generated
                                                </Button>
                                            )}
                                            <Button
                                                size="sm"
                                                variant="success"
                                                onClick={handleGenerateObservationFromLinks}
                                                disabled={observationGenerateLoading || !hasMinimumObservationSelections}
                                                style={{ fontSize: '14px', fontWeight: '700' }}
                                            >
                                                <i className="ri-refresh-line me-1"></i>
                                                {observationGenerateLoading ? 'Generating...' : (showObservationRegenerateButton ? 'Re-generate Learning Path' : 'Generate Learning Path')}
                                            </Button>
                                        </div>
                                    </div>

                                    <div style={{ padding: '10px' }}>
                                        <div style={{ fontSize: '12px', fontWeight: '700', color: '#6b7280', marginBottom: '6px' }}>GENERATED OBSERVATION TEXT</div>
                                        <Form.Control
                                            as="textarea"
                                            rows={5}
                                            value={observationText}
                                            onChange={(e) => setObservationText(e.target.value)}
                                            placeholder="Generated daily observation text will appear here..."
                                            style={{ fontSize: '13px', lineHeight: '1.5', borderRadius: '3px', border: '1px solid #e5e7eb', minHeight: '170px' }}
                                        />
                                    </div>
                                </div>
                            )}

                            {isPrimaryObservationTab && isLearningPathTab && (
                                <div style={reportPanelStyle}>
                                    <div style={reportPanelHeaderStyle}>
                                        <div style={reportHeaderTopLabelStyle}>
                                            Learning Journey Snapshot
                                        </div>
                                        <div style={reportTitleStyle}>
                                            {(selectedStudent?.name || 'Student').toUpperCase()}'s learning this week
                                        </div>
                                    </div>
                                    <div style={{ padding: '0 12px 12px 12px' }}>
                                        <div style={{
                                            border: '1px solid #e5e7eb',
                                            borderRadius: '4px',
                                            background: '#ffffff',
                                            padding: '10px',
                                            margin: '10px 0'
                                        }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', marginBottom: '6px', flexWrap: 'wrap' }}>
                                                <div style={{ fontSize: '11px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.2px' }}>
                                                    Foundation Score Today
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#111827' }}>
                                                    {foundationScorePercent}%
                                                </div>
                                            </div>

                                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '8px' }}>
                                                {foundationMetrics.map((metric) => (
                                                    <div
                                                        key={metric.key}
                                                        style={{
                                                            border: `1px solid ${metric.color}`,
                                                            background: metric.bg,
                                                            borderRadius: '4px',
                                                            padding: '8px'
                                                        }}
                                                    >
                                                        <div style={{ fontSize: '10px', color: '#6b7280', fontWeight: '700', textTransform: 'uppercase', marginBottom: '3px' }}>
                                                            {metric.label}
                                                        </div>
                                                        <div style={{ fontSize: '14px', color: metric.color, fontWeight: '700', marginBottom: '6px' }}>
                                                            {metric.displayScore}
                                                        </div>
                                                        <div style={{ background: '#e5e7eb', borderRadius: '4px', height: '8px', overflow: 'hidden' }}>
                                                            <div
                                                                style={{
                                                                    background: metric.color,
                                                                    height: '100%',
                                                                    width: `${metric.score}%`,
                                                                    transition: 'width 0.3s ease',
                                                                    borderRadius: '4px'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        <div style={{ marginBottom: '10px' }}>
                                            <div style={{ ...sectionLabelStyle, color: '#1d4ed8' }}>Celebrate Learning</div>
                                            <Form.Control
                                                as="textarea"
                                                rows={4}
                                                value={learningPathData.celebrate}
                                                onChange={(e) => setLearningPathData((prev) => ({ ...prev, celebrate: e.target.value }))}
                                                style={{ ...reportTextareaStyle, ...learningPathTextareaStyles.celebrate }}
                                            />
                                        </div>
                                        <div style={{ marginBottom: '8px' }}>
                                            <div style={{ ...sectionLabelStyle, color: '#c2410c' }}>What We Are Focusing On Next</div>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                value={learningPathData.nurture}
                                                onChange={(e) => setLearningPathData((prev) => ({ ...prev, nurture: e.target.value }))}
                                                style={{ ...reportTextareaStyle, ...learningPathTextareaStyles.nurture }}
                                            />
                                        </div>
                                        <div>
                                            <div style={{ ...sectionLabelStyle, color: '#166534' }}>Ways To Continue Learning At Home</div>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                value={learningPathData.activities}
                                                onChange={(e) => setLearningPathData((prev) => ({ ...prev, activities: e.target.value }))}
                                                style={{ ...reportTextareaStyle, ...learningPathTextareaStyles.activities }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {isPrimaryObservationTab && isParentReportTab && (
                                <div style={parentReportPanelStyle}>
                                    <div style={parentReportHeaderStyle}>
                                        <div style={reportHeaderTopLabelStyle}>
                                            Learning Update For Parents
                                        </div>
                                        <div style={reportTitleStyle}>
                                            {(selectedStudent?.name || 'Student').toUpperCase()}'s learning this week
                                        </div>
                                    </div>
                                    <div style={{ padding: '0 12px 12px 12px' }}>
                                        <div style={{ marginBottom: '10px' }}>
                                            <div style={parentReportSectionLabelStyle}>How Your Child Is Thriving</div>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                value={parentReportData.thriving}
                                                onChange={(e) => setParentReportData((prev) => ({ ...prev, thriving: e.target.value }))}
                                                style={parentReportTextareaStyle}
                                            />
                                        </div>
                                        <div style={{ marginBottom: '10px' }}>
                                            <div style={parentReportSectionLabelStyle}>What We're Focusing On Next</div>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                value={parentReportData.focus}
                                                onChange={(e) => setParentReportData((prev) => ({ ...prev, focus: e.target.value }))}
                                                style={parentReportTextareaStyle}
                                            />
                                        </div>
                                        <div>
                                            <div style={parentReportSectionLabelStyle}>Ways To Continue Learning At Home</div>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                value={parentReportData.home_activities}
                                                onChange={(e) => setParentReportData((prev) => ({ ...prev, home_activities: e.target.value }))}
                                                style={parentReportTextareaStyle}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {isPrimaryNoteTab && (
                                <div style={{ border: '1px solid #e5e7eb', background: '#fff' }}>
                                    <div style={{ padding: '12px' }}>
                                        <div style={{ fontSize: '16px', color: '#111827', fontWeight: '600', marginBottom: '6px' }}>Notes</div>
                                        <div style={{ position: 'relative' }}>
                                            <Form.Control
                                                as="textarea"
                                                rows={8}
                                                value={observationNotes}
                                                onChange={(e) => setObservationNotes(e.target.value)}
                                                placeholder="Write notes..."
                                                style={{ fontSize: '14px', borderRadius: '4px', border: '1px solid #e5e7eb', minHeight: '220px', paddingBottom: '40px' }}
                                            />
                                            <Button
                                                size="sm"
                                                variant="outline-primary"
                                                onClick={() => openAIContentModalForField('observationNotes')}
                                                style={{ position: 'absolute', right: '8px', bottom: '8px', fontSize: '13px', fontWeight: '600' }}
                                            >
                                                <span className="material-symbols-outlined me-1" style={{ fontSize: '15px', verticalAlign: 'middle' }}>auto_awesome</span>
                                                Generate
                                            </Button>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '12px' }}>
                                            <Button variant="success" onClick={saveObservation} disabled={savingObservation} style={{ fontSize: '12px', fontWeight: '700' }}>
                                                <i className="ri-save-line me-1"></i>
                                                {savingObservation ? 'Saving...' : 'Save Note'}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {isPrimaryObservationTab && (
                        <div style={{ padding: '10px 12px', borderTop: '1px solid #eef1f4', background: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                            <Button
                                variant="success"
                                onClick={isDailyObservationTab ? saveObservation : saveLearningPathAndParentReport}
                                disabled={learningPathSaving || (isDailyObservationTab && savingObservation)}
                                style={{ fontSize: '12px', fontWeight: '700' }}
                            >
                                <i className="ri-save-line me-1"></i>
                                {isDailyObservationTab ? (savingObservation ? 'Saving...' : 'Save Changes') : (learningPathSaving ? 'Saving...' : 'Save Changes')}
                            </Button>

                            {isParentReportTab && (
                            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={handleSendParentReportEmail}
                                    disabled={learningPathSaving || parentReportEmailSending || parentReportFeedPosting}
                                    style={{ fontSize: '12px', fontWeight: '600' }}
                                >
                                    <i className="ri-mail-line me-1"></i>
                                    {parentReportEmailSending ? 'Sending...' : 'Email to Parent'}
                                </Button>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={handlePostParentReportToFeed}
                                    disabled={learningPathSaving || parentReportEmailSending || parentReportFeedPosting}
                                    style={{ fontSize: '12px', fontWeight: '600' }}
                                >
                                    <i className="ri-share-forward-line me-1"></i>
                                    {parentReportFeedPosting ? 'Posting...' : 'Post to Feed'}
                                </Button>
                            </div>
                            )}
                        </div>
                        )}
                    </div>
                </Modal.Body>

                <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', background: '#f1f3f5', padding: '10px 14px' }}>
                    <Button variant="secondary" size="sm" onClick={() => setShowObservationModal(false)} style={{ fontSize: '12px', fontWeight: '700' }}>
                        <i className="ri-close-line me-1"></i>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    const renderObservationPickerModal = () => {
        const activeCategory = observationCategories.find((category) => category.id === activeObservationCategoryId);
        const categoryLinks = activeCategory?.links || [];
        const activeCategorySelectedCount = getSelectedObservationCountByCategory(activeCategory);
        const getCategoryTheme = (name = '') => {
            const key = name.toLowerCase();
            if (key.includes('belong')) return { chip: '#6d28d9', left: '#ede9fe' };
            if (key.includes('well')) return { chip: '#0d9488', left: '#ccfbf1' };
            if (key.includes('engage')) return { chip: '#ea580c', left: '#ffedd5' };
            if (key.includes('express')) return { chip: '#b91c1c', left: '#fee2e2' };
            return { chip: '#475569', left: '#e2e8f0' };
        };

        return (
            <Modal
                show={showObservationPickerModal}
                onHide={() => setShowObservationPickerModal(false)}
                size="lg"
                fullscreen="md-down"
                style={{ paddingTop: 'clamp(56px, 8vh, 72px)', paddingBottom: '16px' }}
                dialogClassName="mt-2"
            >
                <Modal.Header closeButton style={{ borderBottom: '1px solid #e5e7eb', padding: '12px 16px' }}>
                    <div style={{ width: '100%' }}>
                        <Modal.Title style={{ fontSize: '20px', fontWeight: '700', color: '#1f2937' }}>
                            <i className="ri-links-line me-2" style={{ color: '#3b82f6' }}></i>
                            Add HDLH Links
                        </Modal.Title>
                        <div style={{ marginTop: '8px', fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>
                            Select HDLH links for Daily Observation generation.
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ padding: 0, background: '#fff', maxHeight: 'calc(100vh - 190px)', overflowY: 'auto' }}>
                    {observationPickerLoading ? (
                        <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280' }}>
                            Loading HDLH links...
                        </div>
                    ) : (
                        <Row style={{ margin: 0 }}>
                            <Col xs={12} lg={4} style={{
                                borderRight: '1px solid #e5e7eb',
                                borderBottom: '1px solid #e5e7eb',
                                background: '#f8fafc',
                                padding: '8px 0'
                            }}>
                                {observationCategories.map((category) => {
                                    const isActive = activeObservationCategoryId === category.id;
                                    const shortTag = category.name.length > 4 ? category.name.slice(0, 4) : category.name;
                                    const theme = getCategoryTheme(category.name);
                                    const count = getSelectedObservationCountByCategory(category);

                                    return (
                                        <div
                                            key={category.id}
                                            onClick={() => setActiveObservationCategoryId(category.id)}
                                            style={{
                                                padding: '10px 12px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                borderLeft: isActive ? `4px solid ${theme.chip}` : '4px solid transparent',
                                                background: isActive ? theme.left : 'transparent',
                                                color: '#1f2937',
                                                fontWeight: isActive ? '600' : '500'
                                            }}
                                        >
                                            <span style={{
                                                fontSize: '12px',
                                                background: theme.chip,
                                                color: 'white',
                                                borderRadius: '10px',
                                                padding: '2px 6px',
                                                minWidth: '36px',
                                                textAlign: 'center',
                                                lineHeight: '1.4'
                                            }}>
                                                {shortTag}
                                            </span>
                                            <span style={{ fontSize: '13px', flex: 1 }}>{category.name}</span>
                                            <span style={{
                                                fontSize: '11px',
                                                background: theme.chip,
                                                color: 'white',
                                                borderRadius: '999px',
                                                padding: '2px 7px',
                                                minWidth: '24px',
                                                textAlign: 'center',
                                                lineHeight: '1.4'
                                            }}>
                                                {count}
                                            </span>
                                        </div>
                                    );
                                })}
                            </Col>

                            <Col xs={12} lg={8} style={{ padding: '12px 12px' }}>
                                <h5 style={{
                                    fontSize: '18px',
                                    fontWeight: '700',
                                    color: '#6b46c1',
                                    display: 'flex',
                                    gap: '8px',
                                    marginBottom: '4px'
                                }}>
                                    <i className="ri-price-tag-3-line"></i>
                                    {activeCategory?.name || 'Category'}
                                </h5>
                                <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '10px' }}>
                                    {activeCategorySelectedCount} link{activeCategorySelectedCount === 1 ? '' : 's'} selected in this category
                                </div>

                                {categoryLinks.length === 0 ? (
                                    <div style={{ color: '#6b7280', fontSize: '13px' }}>No links available.</div>
                                ) : (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                        {categoryLinks.map((link) => (
                                            <label
                                                key={link.id}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                    gap: '8px',
                                                    cursor: 'pointer',
                                                    fontSize: '11px',
                                                    color: '#374151',
                                                    lineHeight: '1.3',
                                                    padding: '6px 7px',
                                                    borderRadius: '8px',
                                                    border: selectedObservationLinks.includes(link.id) ? '1px solid #86efac' : '1px solid transparent',
                                                    background: selectedObservationLinks.includes(link.id) ? '#f0fdf4' : 'transparent'
                                                }}
                                            >
                                                <Form.Check
                                                    type="checkbox"
                                                    checked={selectedObservationLinks.includes(link.id)}
                                                    onChange={() => toggleObservationLink(link.id)}
                                                    style={{ marginTop: '1px', minWidth: '14px' }}
                                                />
                                                <span>{link.content}</span>
                                            </label>
                                        ))}
                                    </div>
                                )}
                            </Col>
                        </Row>
                    )}
                </Modal.Body>
                <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '10px 14px', display: 'flex', justifyContent: 'space-between', gap: '8px', flexWrap: 'wrap' }}>
                    <Button
                        variant="outline-secondary"
                        onClick={() => setSelectedObservationLinks([])}
                        disabled={selectedObservationLinks.length === 0 || observationGenerateLoading}
                        style={{ fontSize: '12px', padding: '6px 10px' }}
                    >
                        Clear Selection
                    </Button>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        <Button variant="secondary" onClick={() => setShowObservationPickerModal(false)} style={{ fontSize: '12px', padding: '6px 12px' }}>
                            Cancel
                        </Button>
                        <Button
                            variant="warning"
                            onClick={handleGenerateObservationFromLinks}
                            disabled={observationGenerateLoading || !hasMinimumObservationSelections}
                            style={{ minWidth: '100px', fontSize: '12px', padding: '6px 12px' }}
                        >
                            {observationGenerateLoading ? 'Generating...' : 'Generate'}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    };

    const renderExitTimeModal = () => (
        <Modal show={showExitTimeModal} onHide={() => setShowExitTimeModal(false)} centered style={{ marginTop: 10 }}>
            <Modal.Header closeButton style={{ borderBottom: '1px solid #e9ecef', padding: '16px 20px' }}>
                <Modal.Title style={{ fontSize: '18px', fontWeight: '600', color: '#E74C3C', paddingRight: '30px', lineHeight: '1.4' }}>
                    <i className="material-symbols-outlined" style={{ fontSize: '20px', verticalAlign: 'middle', marginRight: '6px' }}>
                        logout
                    </i>
                    <span style={{ wordBreak: 'break-word' }}>Set Exit Time</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px' }}>
                <div style={{ marginBottom: '12px' }}>
                    <div style={{ fontSize: '14px', color: '#6c757d', marginBottom: '4px' }}>
                        Student
                    </div>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#212529' }}>
                        {selectedStudent?.name}
                    </div>
                </div>
                <Form.Group>
                    <Form.Label style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                        Exit Time
                    </Form.Label>
                    <DatePicker
                        selected={exitTime ? Moment(exitTime, 'HH:mm').toDate() : null}
                        onChange={(time) => setExitTime(time ? Moment(time).format('HH:mm') : '')}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        dateFormat="h:mm aa"
                        minTime={attendanceSchoolHours?.minTime}
                        maxTime={attendanceSchoolHours?.maxTime}
                        placeholderText="Select exit time"
                        className="form-control"
                        style={{
                            fontSize: '14px',
                            borderRadius: '8px',
                            border: '1px solid #e9ecef',
                            padding: '10px',
                            width: '100%'
                        }}
                    />
                </Form.Group>
                <div style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <Button
                        variant="secondary"
                        onClick={() => setShowExitTimeModal(false)}
                        style={{
                            borderRadius: '8px',
                            padding: '10px 24px',
                            fontSize: '14px',
                            fontWeight: '600'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={saveExitTime}
                        style={{
                            borderRadius: '8px',
                            padding: '10px 24px',
                            fontSize: '14px',
                            fontWeight: '600'
                        }}
                    >
                        <i className="material-symbols-outlined" style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '6px' }}>
                            save
                        </i>
                        Save Exit Time
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );

    const renderAttendanceTimeModal = () => (
        <Modal show={showAttendanceTimeModal} onHide={() => setShowAttendanceTimeModal(false)} centered style={{ marginTop: 10 }}>
            <Modal.Header closeButton style={{ borderBottom: '1px solid #e9ecef', padding: '16px 20px' }}>
                <Modal.Title style={{ fontSize: '18px', fontWeight: '600', color: '#166534', paddingRight: '30px', lineHeight: '1.4' }}>
                    <i className="material-symbols-outlined" style={{ fontSize: '20px', verticalAlign: 'middle', marginRight: '6px' }}>
                        login
                    </i>
                    <span style={{ wordBreak: 'break-word' }}>Set Attendance Time</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px' }}>
                <div style={{ marginBottom: '12px' }}>
                    <div style={{ fontSize: '14px', color: '#6c757d', marginBottom: '4px' }}>
                        Student
                    </div>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#212529' }}>
                        {selectedStudent?.name}
                    </div>
                </div>
                <Form.Group>
                    <Form.Label style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                        Attendance Time
                    </Form.Label>
                    <DatePicker
                        selected={attendanceTimeEdit ? Moment(attendanceTimeEdit, 'HH:mm').toDate() : null}
                        onChange={(time) => setAttendanceTimeEdit(time ? Moment(time).format('HH:mm') : '')}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        dateFormat="h:mm aa"
                        minTime={attendanceSchoolHours?.minTime}
                        maxTime={attendanceSchoolHours?.maxTime}
                        placeholderText="Select attendance time"
                        className="form-control"
                        style={{
                            fontSize: '14px',
                            borderRadius: '8px',
                            border: '1px solid #e9ecef',
                            padding: '10px',
                            width: '100%'
                        }}
                    />
                </Form.Group>
                <div style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <Button
                        variant="secondary"
                        onClick={() => setShowAttendanceTimeModal(false)}
                        style={{
                            borderRadius: '8px',
                            padding: '10px 24px',
                            fontSize: '14px',
                            fontWeight: '600'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="success"
                        onClick={saveAttendanceTimeEdit}
                        style={{
                            borderRadius: '8px',
                            padding: '10px 24px',
                            fontSize: '14px',
                            fontWeight: '600'
                        }}
                    >
                        <i className="material-symbols-outlined" style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '6px' }}>
                            save
                        </i>
                        Save Time
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );

    // Present-icon confirmation: editable time + explicit parent-notify
    // consent, per the new individual-save attendance flow.
    const renderPresentConfirmModal = () => (
        <Modal show={showPresentConfirmModal} onHide={() => { setShowPresentConfirmModal(false); setPresentConfirmStudent(null); }} centered style={{ marginTop: 10 }}>
            <Modal.Header closeButton style={{ borderBottom: '1px solid #e9ecef', padding: '16px 20px' }}>
                <Modal.Title style={{ fontSize: '18px', fontWeight: '600', color: '#166534', paddingRight: '30px', lineHeight: '1.4' }}>
                    <i className="material-symbols-outlined" style={{ fontSize: '20px', verticalAlign: 'middle', marginRight: '6px' }}>
                        check_circle
                    </i>
                    <span style={{ wordBreak: 'break-word' }}>Mark Present</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px' }}>
                <div style={{ marginBottom: '12px' }}>
                    <div style={{ fontSize: '14px', color: '#6c757d', marginBottom: '4px' }}>Student</div>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#212529' }}>{presentConfirmStudent?.name}</div>
                </div>
                <Form.Group style={{ marginBottom: '16px' }}>
                    <Form.Label style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                        Attendance Time
                    </Form.Label>
                    <DatePicker
                        selected={presentConfirmTime ? Moment(presentConfirmTime, 'HH:mm').toDate() : null}
                        onChange={(time) => setPresentConfirmTime(time ? Moment(time).format('HH:mm') : '')}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={5}
                        timeCaption="Time"
                        dateFormat="h:mm aa"
                        minTime={attendanceSchoolHours?.minTime}
                        maxTime={attendanceSchoolHours?.maxTime}
                        placeholderText="Select attendance time"
                        className="form-control"
                    />
                </Form.Group>
                <div style={{
                    background: '#f0fdf4',
                    border: '1px solid #bbf7d0',
                    borderRadius: '10px',
                    padding: '14px',
                    fontSize: '14px',
                    color: '#14532d',
                    fontWeight: '500',
                    lineHeight: '1.5'
                }}>
                    Are you marking the attendance as present and confirming that the parent is ready to be notified?
                </div>
                <div style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <Button
                        variant="secondary"
                        onClick={() => { setShowPresentConfirmModal(false); setPresentConfirmStudent(null); }}
                        style={{ borderRadius: '8px', padding: '10px 24px', fontSize: '14px', fontWeight: '600' }}
                    >
                        No
                    </Button>
                    <Button
                        variant="success"
                        onClick={confirmMarkPresent}
                        style={{ borderRadius: '8px', padding: '10px 24px', fontSize: '14px', fontWeight: '600' }}
                    >
                        <i className="material-symbols-outlined" style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '6px' }}>
                            check
                        </i>
                        Yes
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );

    const renderDailyReportModal = () => (
        <Modal show={showDailyReportModal} onHide={() => setShowDailyReportModal(false)} size="lg" centered
            style={{ marginTop: '30px' }}>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#1f2937',
                    lineHeight: '1.3',
                    width: '100%',
                    maxWidth: 'calc(100% - 40px)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <i className="ri-file-text-line" style={{ fontSize: '20px', color: '#6366f1' }}></i>
                            <div>
                                <div style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>
                                    Daily Report
                                </div>
                                <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: '500' }}>
                                    {selectedStudent?.name}
                                </div>
                            </div>
                        </div>
                        <div style={{ 
                            fontSize: '12px', 
                            color: '#6366f1', 
                            fontWeight: '600',
                            background: '#eef2ff',
                            padding: '4px 12px',
                            borderRadius: '6px'
                        }}>
                            {dailyReportData?.report_date ? formatDisplayDate(dailyReportData.report_date) : Moment().format('M/D/YYYY')}
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '0', maxHeight: '65vh', overflowY: 'auto', background: '#f9fafb' }}>
                <div style={{ padding: '16px' }}>
                    {dailyReportData ? (
                        <div>
                            {/* Student & Class Info Card */}
                            <div style={{
                                marginBottom: '12px',
                                background: 'white',
                                borderRadius: '8px',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                border: '1px solid #e5e7eb',
                                padding: '12px'
                            }}>
                                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                    <div style={{
                                        flex: '1',
                                        minWidth: '120px',
                                        padding: '8px 12px',
                                        background: '#f9fafb',
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb'
                                    }}>
                                        <div style={{ fontSize: '10px', color: '#6b7280', fontWeight: '600', marginBottom: '2px' }}>STUDENT</div>
                                        <div style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>{dailyReportData.student?.name || 'N/A'}</div>
                                    </div>
                                    <div style={{
                                        flex: '1',
                                        minWidth: '120px',
                                        padding: '8px 12px',
                                        background: '#f9fafb',
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb'
                                    }}>
                                        <div style={{ fontSize: '10px', color: '#6b7280', fontWeight: '600', marginBottom: '2px' }}>CLASS</div>
                                        <div style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>{dailyReportData.class?.name || 'N/A'}</div>
                                    </div>
                                    <div style={{
                                        flex: '1',
                                        minWidth: '120px',
                                        padding: '8px 12px',
                                        background: '#f9fafb',
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb'
                                    }}>
                                        <div style={{ fontSize: '10px', color: '#6b7280', fontWeight: '600', marginBottom: '2px' }}>STATUS</div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <div style={{
                                                width: '6px',
                                                height: '6px',
                                                borderRadius: '50%',
                                                background: dailyReportData.is_present ? '#10b981' : '#ef4444'
                                            }}></div>
                                            <span style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>
                                                {dailyReportData.is_present ? 'Present' : 'Absent'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {dailyReportData.daily_report ? (
                                <div>
                                    {/* Today I Felt Section */}
                                    {dailyReportData.daily_report.daily_report_fealings && dailyReportData.daily_report.daily_report_fealings.length > 0 && (
                                        <div style={{
                                            marginBottom: '12px',
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                            border: '1px solid #e5e7eb',
                                            padding: '12px'
                                        }}>
                                            <div style={{
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                color: '#374151',
                                                marginBottom: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                                <i className="ri-emotion-happy-line" style={{ fontSize: '14px', color: '#6366f1' }}></i>
                                                Today I Felt
                                            </div>
                                            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                                                {dailyReportData.daily_report.daily_report_fealings.map((feeling, index) => (
                                                    <div key={index} style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        padding: '6px 12px',
                                                        background: feeling.fealing.name === 'Happy' ? '#dcfce7' : '#fee2e2',
                                                        color: feeling.fealing.name === 'Happy' ? '#166534' : '#991b1b',
                                                        borderRadius: '6px',
                                                        border: `1px solid ${feeling.fealing.name === 'Happy' ? '#bbf7d0' : '#fecaca'}`
                                                    }}>
                                                        <i className={feeling.fealing.name === 'Happy' ? 'ri-emotion-happy-line' : 'ri-emotion-unhappy-line'} style={{ fontSize: '14px' }}></i>
                                                        <span style={{ fontSize: '12px', fontWeight: '600' }}>{feeling.fealing.name}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    {/* Today I Learned Section */}
                                    {dailyReportData.daily_report.learned && (
                                        <div style={{
                                            marginBottom: '12px',
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                            border: '1px solid #e5e7eb',
                                            padding: '12px'
                                        }}>
                                            <div style={{
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                color: '#374151',
                                                marginBottom: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                                <i className="ri-lightbulb-line" style={{ fontSize: '14px', color: '#6366f1' }}></i>
                                                Today I Learned
                                            </div>
                                            <div
                                                style={{
                                                    padding: '10px',
                                                    background: '#f9fafb',
                                                    borderRadius: '6px',
                                                    border: '1px solid #e5e7eb',
                                                    fontSize: '12px',
                                                    lineHeight: '1.5',
                                                    color: '#4b5563'
                                                }}
                                                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(dailyReportData.daily_report.learned) }}
                                            />
                                        </div>
                                    )}
                                    {/* Meals Section */}
                                    {getDailyReportMealTypeGroups(dailyReportData.daily_report.daily_report_meals).length > 0 && (
                                        <div style={{
                                            marginBottom: '12px',
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                            overflow: 'hidden',
                                            border: '1px solid #e5e7eb'
                                        }}>
                                            <div style={{
                                                background: 'white',
                                                borderBottom: '1px solid #e5e7eb',
                                                padding: '12px 16px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                                <i className="ri-restaurant-line" style={{ fontSize: '16px', color: 'var(--bs-primary)' }}></i>
                                                <h6 style={{
                                                    fontSize: '13px',
                                                    fontWeight: '700',
                                                    marginBottom: '0',
                                                    color: '#374151'
                                                }}>
                                                    {getDailyReportMealTypeGroups(dailyReportData.daily_report.daily_report_meals).reduce((count, group) => count + group.items.length, 0)} Meal{getDailyReportMealTypeGroups(dailyReportData.daily_report.daily_report_meals).reduce((count, group) => count + group.items.length, 0) !== 1 ? 's' : ''}
                                                </h6>
                                            </div>

                                            <div style={{
                                                background: 'white',
                                                borderBottom: '1px solid #e5e7eb',
                                                overflowX: 'auto',
                                                whiteSpace: 'nowrap',
                                                padding: '0 16px',
                                                display: 'flex',
                                                alignItems: 'flex-end',
                                                gap: '0'
                                            }}>
                                                {getDailyReportMealTypeGroups(dailyReportData.daily_report.daily_report_meals).map((group, index) => {
                                                    const isFilled = group.items.some((meal) => !!meal.meal_time && normalizeMealAmount(meal.meal_amount) > 0);
                                                    const isActive = activeViewMealTab === index;
                                                    return (
                                                        <button
                                                            key={group.key}
                                                            type="button"
                                                            onClick={() => setActiveViewMealTab(index)}
                                                            title={group.mealTypeName}
                                                            style={{
                                                                border: 'none',
                                                                borderBottom: isActive ? '2px solid #e8601c' : '2px solid transparent',
                                                                background: 'transparent',
                                                                color: isActive ? '#e8601c' : '#6b7280',
                                                                fontSize: '13px',
                                                                fontWeight: isActive ? '700' : '500',
                                                                padding: '10px 14px',
                                                                cursor: 'pointer',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                gap: '6px',
                                                                whiteSpace: 'nowrap',
                                                                flexShrink: 0
                                                            }}
                                                        >
                                                            <span>{group.mealTypeName}</span>
                                                            {isFilled && (
                                                                <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#22c55e', display: 'inline-block', flexShrink: 0 }}></span>
                                                            )}
                                                        </button>
                                                    );
                                                })}
                                            </div>

                                            {(() => {
                                                const mealTypeGroups = getDailyReportMealTypeGroups(dailyReportData.daily_report.daily_report_meals);
                                                const groupIndex = Math.min(activeViewMealTab, mealTypeGroups.length - 1);
                                                const activeMealGroup = mealTypeGroups[groupIndex];
                                                if (!activeMealGroup) return null;

                                                return (
                                                    <div style={{ padding: '20px 20px 16px' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px', flexWrap: 'wrap' }}>
                                                            <div style={{ fontSize: '15px', fontWeight: '700', color: '#1f2937' }}>
                                                                {activeMealGroup.mealTypeName}
                                                            </div>
                                                            <span style={{
                                                                padding: '2px 8px',
                                                                borderRadius: '4px',
                                                                fontSize: '11px',
                                                                fontWeight: '700',
                                                                background: '#0ea5e9',
                                                                color: '#ffffff',
                                                                textTransform: 'uppercase'
                                                            }}>
                                                                Menu Type
                                                            </span>
                                                        </div>

                                                        <div style={{
                                                            border: '1px solid #e5e7eb',
                                                            borderRadius: '8px',
                                                            overflow: 'hidden'
                                                        }}>
                                                            <div style={{ width: '100%', overflowX: 'auto' }}>
                                                                <table style={{ width: '100%', minWidth: '600px', borderCollapse: 'collapse' }}>
                                                                <thead>
                                                                    <tr style={{ background: '#f8fafc' }}>
                                                                        <th style={{ textAlign: 'left', fontSize: '12px', color: '#374151', padding: '10px 12px', borderBottom: '1px solid #e5e7eb' }}>Menu Name</th>
                                                                        <th style={{ textAlign: 'left', fontSize: '12px', color: '#374151', padding: '10px 12px', borderBottom: '1px solid #e5e7eb' }}>Time</th>
                                                                        <th style={{ textAlign: 'left', fontSize: '12px', color: '#374151', padding: '10px 12px', borderBottom: '1px solid #e5e7eb' }}>Amount</th>
                                                                        <th style={{ textAlign: 'left', fontSize: '12px', color: '#374151', padding: '10px 12px', borderBottom: '1px solid #e5e7eb' }}>Progress</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {activeMealGroup.items.map((mealItem, itemIndex) => {
                                                                        const mealName = mealItem.menu_name || mealItem.name || mealItem.menu?.name || 'Menu Item';
                                                                        const normalizedAmount = normalizeMealAmount(mealItem.meal_amount);
                                                                        return (
                                                                            <tr key={`${activeMealGroup.key}_${mealItem.menu_meal_id || mealItem.id || itemIndex}`}>
                                                                                <td style={{ fontSize: '13px', color: '#111827', padding: '10px 12px', borderBottom: '1px solid #f1f5f9', verticalAlign: 'top' }}>
                                                                                    <div style={{ fontWeight: '600' }}>{mealName}</div>
                                                                                </td>
                                                                                <td style={{ fontSize: '13px', color: '#111827', padding: '10px 12px', borderBottom: '1px solid #f1f5f9', verticalAlign: 'top' }}>{formatTime(mealItem.meal_time) || 'N/A'}</td>
                                                                                <td style={{ fontSize: '13px', color: '#059669', fontWeight: '600', padding: '10px 12px', borderBottom: '1px solid #f1f5f9', verticalAlign: 'top' }}>{getMealAmountLabel(mealItem.meal_amount)}</td>
                                                                                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f1f5f9', minWidth: '180px' }}>
                                                                                    <input
                                                                                        type="range"
                                                                                        min={0}
                                                                                        max={5}
                                                                                        step={1}
                                                                                        value={normalizedAmount}
                                                                                        readOnly
                                                                                        style={{ width: '100%', accentColor: '#f59e0b', pointerEvents: 'none', opacity: 1, marginBottom: '4px' }}
                                                                                    />
                                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '10px', color: '#6b7280', whiteSpace: 'nowrap' }}>
                                                                                        {DAILY_REPORT_MEAL_AMOUNT_OPTIONS.map((option) => (
                                                                                            <span key={option.value}>{option.label}</span>
                                                                                        ))}
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })()}
                                        </div>
                                    )}
                                    {/* Diapers/Toilet Section */}
                                    {dailyReportData.daily_report.daily_report_diapers && dailyReportData.daily_report.daily_report_diapers.length > 0 && (
                                        <div style={{
                                            marginBottom: '12px',
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                            border: '1px solid #e5e7eb',
                                            padding: '12px'
                                        }}>
                                            <div style={{
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                color: '#374151',
                                                marginBottom: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                                <i className="ri-parent-line" style={{ fontSize: '14px', color: '#6366f1' }}></i>
                                                Diapers/Toilet
                                                <span style={{
                                                    marginLeft: 'auto',
                                                    fontSize: '11px',
                                                    color: '#6b7280',
                                                    background: '#f3f4f6',
                                                    padding: '2px 8px',
                                                    borderRadius: '4px'
                                                }}>
                                                    {dailyReportData.daily_report.daily_report_diapers.length}
                                                </span>
                                            </div>
                                            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                                                {dailyReportData.daily_report.daily_report_diapers.map((diaper, index) => (
                                                    <div key={index} style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px',
                                                        padding: '6px 10px',
                                                        background: '#f9fafb',
                                                        borderRadius: '6px',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <span style={{ fontSize: '11px', fontWeight: '600', color: '#111827' }}>
                                                            {Moment(diaper.diaper_time, 'HH:mm').format('h:mm A')}
                                                        </span>
                                                        <span style={{
                                                            padding: '2px 6px',
                                                            borderRadius: '4px',
                                                            fontSize: '10px',
                                                            fontWeight: '600',
                                                            background: diaper.diaper_check === 1 ? '#fef3c7' :
                                                                diaper.diaper_check === 2 ? '#dcfce7' :
                                                                    diaper.diaper_check === 3 ? '#dbeafe' : '#fecaca',
                                                            color: diaper.diaper_check === 1 ? '#92400e' :
                                                                diaper.diaper_check === 2 ? '#166534' :
                                                                    diaper.diaper_check === 3 ? '#1e40af' : '#991b1b'
                                                        }}>
                                                            {diaper.diaper_check === 1 ? 'D/T' :
                                                                diaper.diaper_check === 2 ? 'Dry' :
                                                                    diaper.diaper_check === 3 ? 'Wet' : 'BM'}
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    {/* Sleep Section */}
                                    {dailyReportData.daily_report.daily_report_sleeps && dailyReportData.daily_report.daily_report_sleeps.length > 0 && (
                                        <div style={{
                                            marginBottom: '12px',
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                            overflow: 'hidden',
                                            border: '1px solid #e5e7eb'
                                        }}>
                                            {/* Section header */}
                                            <div style={{
                                                background: 'white',
                                                borderBottom: '1px solid #e5e7eb',
                                                padding: '12px 16px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}>
                                                <i className="ri-zzz-line" style={{ fontSize: '16px', color: 'var(--bs-primary)' }}></i>
                                                <h6 style={{
                                                    fontSize: '13px',
                                                    fontWeight: '700',
                                                    marginBottom: '0',
                                                    color: '#374151'
                                                }}>
                                                    {dailyReportData.daily_report.daily_report_sleeps.length} Sleep{dailyReportData.daily_report.daily_report_sleeps.length !== 1 ? 's' : ''}
                                                </h6>
                                            </div>

                                            <div style={{ padding: '12px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                {dailyReportData.daily_report.daily_report_sleeps.map((sleep, index) => {
                                                    const start = new Date(`2000-01-01T${sleep.start_time}`);
                                                    const end = new Date(`2000-01-01T${sleep.end_time}`);
                                                    const mins = Math.abs(end - start) / (1000 * 60);
                                                    const h = Math.floor(mins / 60);
                                                    const m = Math.floor(mins % 60);
                                                    const durationLabel = `${h > 0 ? `${h}h ` : ''}${m}m`;

                                                    return (
                                                        <div key={index} style={{
                                                            background: '#f9fafb',
                                                            border: '1px solid #e5e7eb',
                                                            borderRadius: '6px',
                                                            padding: '8px 10px'
                                                        }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                                                                <span style={{ fontSize: '11px', fontWeight: '700', color: '#111827' }}>Sleep {index + 1}</span>
                                                                <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#22c55e', display: 'inline-block' }}></span>
                                                            </div>
                                                            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                                                                <span style={{ fontSize: '11px', fontWeight: '600', color: '#111827' }}>{Moment(sleep.start_time, 'HH:mm').format('h:mm A')}</span>
                                                                <i className="ri-arrow-right-line" style={{ fontSize: '12px', color: '#9ca3af' }}></i>
                                                                <span style={{ fontSize: '11px', fontWeight: '600', color: '#111827' }}>{Moment(sleep.end_time, 'HH:mm').format('h:mm A')}</span>
                                                                <span style={{
                                                                    marginLeft: 'auto',
                                                                    padding: '2px 8px',
                                                                    borderRadius: '999px',
                                                                    fontSize: '10px',
                                                                    fontWeight: '700',
                                                                    background: '#dcfce7',
                                                                    color: '#166534'
                                                                }}>
                                                                    {durationLabel}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                    {/* Please Bring More Section */}
                                    {dailyReportData.daily_report.daily_report_bring_mores && dailyReportData.daily_report.daily_report_bring_mores.length > 0 && (
                                        <div style={{
                                            marginBottom: '12px',
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                            border: '1px solid #e5e7eb',
                                            padding: '12px'
                                        }}>
                                            <div style={{
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                color: '#374151',
                                                marginBottom: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                                <i className="ri-shopping-bag-line" style={{ fontSize: '14px', color: '#6366f1' }}></i>
                                                Please Bring More
                                            </div>
                                            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                                                {dailyReportData.daily_report.daily_report_bring_mores.map((item, index) => {
                                                    const getItemName = (thingId, other) => {
                                                        const names = { 1: 'Diapers', 2: 'Wipes', 3: 'Ointment', 4: 'Clothes', 5: 'Blanket', 6: other || 'Other' };
                                                        return names[thingId] || 'Unknown';
                                                    };
                                                    const getItemIcon = (thingId) => {
                                                        const icons = { 1: 'ri-parent-line', 2: 'ri-drop-line', 3: 'ri-medicine-bottle-line', 4: 'ri-shirt-line', 5: 'ri-hotel-bed-line', 6: 'ri-add-box-line' };
                                                        return icons[thingId] || 'ri-checkbox-circle-line';
                                                    };
                                                    return (
                                                        <div key={index} style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '6px',
                                                            padding: '6px 10px',
                                                            background: '#fef3c7',
                                                            borderRadius: '6px',
                                                            border: '1px solid #fde68a'
                                                        }}>
                                                            <i className={getItemIcon(item.things)} style={{ fontSize: '12px', color: '#92400e' }}></i>
                                                            <span style={{ fontSize: '11px', fontWeight: '600', color: '#92400e' }}>
                                                                {getItemName(item.things, item.other)}
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}

                                    {/* Comments Section */}
                                    {dailyReportData.daily_report.comments && (
                                        <div style={{
                                            marginBottom: '12px',
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                            border: '1px solid #e5e7eb',
                                            padding: '12px'
                                        }}>
                                            <div style={{
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                color: '#374151',
                                                marginBottom: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                                <i className="ri-chat-3-line" style={{ fontSize: '14px', color: '#6366f1' }}></i>
                                                Comments
                                            </div>
                                            <div
                                                style={{
                                                    padding: '10px',
                                                    background: '#f9fafb',
                                                    borderRadius: '6px',
                                                    border: '1px solid #e5e7eb',
                                                    fontSize: '12px',
                                                    lineHeight: '1.5',
                                                    color: '#4b5563'
                                                }}
                                                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(dailyReportData.daily_report.comments) }}
                                            />
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div style={{
                                    textAlign: 'center',
                                    padding: '60px 20px',
                                    background: 'white',
                                    borderRadius: '20px',
                                    margin: '24px',
                                    boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
                                }}>
                                    <i className="ri-file-text-line" style={{
                                        fontSize: '64px',
                                        color: '#cbd5e1',
                                        display: 'block',
                                        marginBottom: '16px'
                                    }}></i>
                                    <div style={{ fontSize: '20px', fontWeight: '600', color: '#475569', marginBottom: '8px' }}>
                                        No Daily Report Found
                                    </div>
                                    <div style={{ fontSize: '16px', color: '#64748b' }}>
                                        No report has been created for this student on this date.
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div style={{
                            textAlign: 'center',
                            padding: '60px 20px',
                            background: 'white',
                            borderRadius: '20px',
                            margin: '24px',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
                        }}>
                            <div className="spinner-border" role="status" style={{ color: 'var(--bs-primary)' }}>
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <div style={{ fontSize: '16px', color: '#64748b', marginTop: '16px' }}>
                                Loading daily report...
                            </div>
                        </div>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer style={{
                borderTop: '2px solid #f0f0f0',
                padding: '12px 16px',
                background: 'white',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    {(isTeacherLogin || isToday(selectedDate)) &&
                        !dailyReportData?.daily_report &&
                        getDailyReportPublishStatusLabel(selectedStudent?.daily_report_status) !== 'published' && (
                        <Button
                            variant="primary"
                            onClick={() => {
                                setShowDailyReportModal(false);
                                handleAddReport(selectedStudent);
                            }}
                            style={{
                                borderRadius: '8px',
                                padding: '10px 18px',
                                fontSize: '13px',
                                fontWeight: '600',
                                backgroundColor: 'var(--bs-primary, #0d6efd)',
                                borderColor: 'var(--bs-primary, #0d6efd)',
                                color: '#ffffff',
                                boxShadow: '0 3px 10px rgba(13, 110, 253, 0.24)',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            <i className="ri-file-add-line" style={{ fontSize: '14px' }}></i>
                            Add New Report
                        </Button>
                    )}
                    {dailyReportData?.daily_report && (
                        <Button
                            variant="success"
                            onClick={printDailyReport}
                            style={{
                                borderRadius: '8px',
                                padding: '10px 18px',
                                fontSize: '13px',
                                fontWeight: '600',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            <i className="ri-printer-line" style={{ fontSize: '14px' }}></i>
                            Print
                        </Button>
                    )}
                    {dailyReportData?.daily_report && (isTeacherLogin || isToday(dailyReportData.report_date)) && (
                        <Button
                            variant="warning"
                            onClick={() => editDailyReport()}
                            style={{
                                borderRadius: '8px',
                                padding: '10px 18px',
                                fontSize: '13px',
                                fontWeight: '600',
                                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                border: 'none',
                                boxShadow: '0 3px 12px rgba(245, 158, 11, 0.35)',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            <i className="ri-edit-line" style={{ fontSize: '14px' }}></i>
                            Edit
                        </Button>
                    )}
                </div>
                <Button
                    variant="outline-secondary"
                    onClick={() => setShowDailyReportModal(false)}
                    style={{
                        borderRadius: '8px',
                        padding: '10px 18px',
                        fontSize: '13px',
                        fontWeight: '600',
                        border: '1px solid #d1d5db',
                        color: '#6b7280',
                        background: 'white'
                    }}
                >
                    <i className="ri-close-line me-1" style={{ fontSize: '14px' }}></i>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );

    const renderPeanutPolicyModal = () => {
        const formatDate = formatDisplayDate;

        return (
            <Modal show={showPeanutPolicyModal} onHide={() => setShowPeanutPolicyModal(false)} size="lg" centered
                style={{ marginTop: '50px' }}>
                <Modal.Header closeButton style={{
                    borderBottom: '1px solid #e5e7eb',
                    padding: '16px 20px',
                    background: 'white'
                }}>
                    <Modal.Title style={{
                        fontSize: '15px',
                        fontWeight: '700',
                        color: '#111827',
                        margin: 0,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <div style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '8px',
                            background: '#f3f4f6',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <i className="ri-forbid-line" style={{
                                fontSize: '18px',
                                color: '#ef4444'
                            }}></i>
                        </div>
                        Peanut Policy - {peanutPolicyData?.student?.name || selectedStudent?.name || 'Student'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{
                    padding: '20px',
                    maxHeight: '70vh',
                    overflowY: 'auto',
                    background: '#f9fafb'
                }}>
                    {peanutPolicyData ? (
                        peanutPolicyData.policy ? (
                            <div className="container-fluid">
                                <Row className="g-3">
                                        {/* Student Information Card */}
                                        <Col xs={12}>
                                            <div style={{
                                                background: 'white',
                                                borderRadius: '8px',
                                                padding: '16px',
                                                border: '1px solid #e5e7eb',
                                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '16px'
                                            }}>
                                                <img
                                                    src={peanutPolicyData?.student?.photo || selectedStudent?.photo || "https://uzone360live.s3.amazonaws.com/noimage.png"}
                                                    alt={peanutPolicyData?.student?.name || selectedStudent?.name || 'Student'}
                                                    style={{
                                                        width: '80px',
                                                        height: '80px',
                                                        borderRadius: '8px',
                                                        objectFit: 'cover',
                                                        border: '2px solid #e5e7eb',
                                                        flexShrink: 0
                                                    }}
                                                    onError={(e) => {
                                                        e.target.src = "https://uzone360live.s3.amazonaws.com/noimage.png";
                                                    }}
                                                />
                                                <div>
                                                    <h6 style={{
                                                        margin: '0 0 6px 0',
                                                        fontSize: '15px',
                                                        fontWeight: '700',
                                                        color: '#111827'
                                                    }}>
                                                        {peanutPolicyData?.student?.name || selectedStudent?.name || 'Student'}
                                                    </h6>
                                                    <p style={{
                                                        margin: '0',
                                                        fontSize: '12px',
                                                        color: '#6b7280'
                                                    }}>
                                                        Student ID: {peanutPolicyData?.student?.id || selectedStudent?.id || 'N/A'}
                                                    </p>
                                                </div>
                                            </div>
                                        </Col>
                                    {/* Policy Information */}
                                    <Col xs={12}>
                                        <div style={{
                                            background: 'white',
                                            borderRadius: '8px',
                                            padding: '16px',
                                            border: '1px solid #e5e7eb',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                        }}>
                                            <h6 style={{
                                                margin: '0 0 12px 0',
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}>
                                                <i className="ri-file-list-3-line" style={{ fontSize: '16px', color: '#6366f1' }}></i>
                                                Policy Information
                                            </h6>

                                            <Row className="g-3">
                                                <Col md={12}>
                                                    <div style={{
                                                        background: '#f9fafb',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            color: '#6b7280',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            marginBottom: '6px'
                                                        }}>Policy Description</div>
                                                        <div style={{
                                                            fontSize: '13px',
                                                            color: '#111827',
                                                            lineHeight: '1.6',
                                                            fontWeight: '400'
                                                        }}>
                                                            {peanutPolicyData.policy.description || 'No description provided'}
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col md={6}>
                                                    <div style={{
                                                        background: '#f9fafb',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            color: '#6b7280',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            marginBottom: '6px'
                                                        }}>Policy Status</div>
                                                        <span style={{
                                                            padding: '4px 10px',
                                                            borderRadius: '12px',
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            backgroundColor: peanutPolicyData.policy.status === 1 ? '#dcfce7' : '#fee2e2',
                                                            color: peanutPolicyData.policy.status === 1 ? '#166534' : '#991b1b'
                                                        }}>
                                                            {peanutPolicyData.policy.status === 1 ? 'Active' : 'Inactive'}
                                                        </span>
                                                    </div>
                                                </Col>

                                                <Col md={6}>
                                                    <div style={{
                                                        background: '#f9fafb',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            color: '#6b7280',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            marginBottom: '6px'
                                                        }}>Created Date</div>
                                                        <div style={{
                                                            fontSize: '13px',
                                                            color: '#111827',
                                                            fontWeight: '500'
                                                        }}>
                                                            {formatDate(peanutPolicyData.policy.created_at)}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>

                                    {/* Signature Section */}
                                    <Col xs={12}>
                                        <div style={{
                                            background: 'white',
                                            borderRadius: '8px',
                                            padding: '16px',
                                            border: '1px solid #e5e7eb',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                        }}>
                                            <h6 style={{
                                                margin: '0 0 12px 0',
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}>
                                                <i className="ri-quill-pen-line" style={{ fontSize: '16px', color: '#6366f1' }}></i>
                                                Parent Signature
                                            </h6>

                                            <Row className="g-3">
                                                <Col md={6}>
                                                    <div style={{
                                                        background: '#f9fafb',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            color: '#6b7280',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            marginBottom: '6px'
                                                        }}>Signature Date</div>
                                                        <div style={{
                                                            fontSize: '13px',
                                                            color: '#111827',
                                                            fontWeight: '500'
                                                        }}>
                                                            {formatDate(peanutPolicyData.policy.parent_signature_date)}
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col md={6}>
                                                    <div style={{
                                                        background: '#f9fafb',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        border: '1px solid #e5e7eb',
                                                        textAlign: 'center'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            color: '#6b7280',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            marginBottom: '8px'
                                                        }}>Digital Signature</div>
                                                        {peanutPolicyData.policy.parent_signature ? (
                                                            <img
                                                                src={peanutPolicyData.policy.parent_signature}
                                                                alt="Parent Signature"
                                                                style={{
                                                                    maxWidth: '100%',
                                                                    maxHeight: '80px',
                                                                    border: '1px solid #e5e7eb',
                                                                    borderRadius: '4px',
                                                                    backgroundColor: 'white'
                                                                }}
                                                                onError={(e) => {
                                                                    e.target.style.display = 'none';
                                                                    e.target.nextSibling.style.display = 'flex';
                                                                }}
                                                            />
                                                        ) : null}
                                                        <div style={{
                                                            display: peanutPolicyData.policy.parent_signature ? 'none' : 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            padding: '16px',
                                                            color: '#6b7280',
                                                            fontSize: '12px'
                                                        }}>
                                                            <i className="ri-image-line" style={{ fontSize: '16px', marginRight: '6px', opacity: 0.5 }}></i>
                                                            No signature available
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>

                                    {/* Student Information */}
                                    <Col xs={12}>
                                        <div style={{
                                            background: 'white',
                                            borderRadius: '8px',
                                            padding: '16px',
                                            border: '1px solid #e5e7eb',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                        }}>
                                            <h6 style={{
                                                margin: '0 0 12px 0',
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}>
                                                <i className="ri-user-line" style={{ fontSize: '16px', color: '#6366f1' }}></i>
                                                Student Information
                                            </h6>

                                            <Row className="g-3">
                                                <Col md={3}>
                                                    <div style={{ textAlign: 'center' }}>
                                                        <img
                                                            src={peanutPolicyData.student?.photo || "https://uzone360live.s3.amazonaws.com/noimage.png"}
                                                            alt={peanutPolicyData.student?.name}
                                                            style={{
                                                                width: '70px',
                                                                height: '70px',
                                                                borderRadius: '50%',
                                                                objectFit: 'cover',
                                                                border: '2px solid #e5e7eb',
                                                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                            }}
                                                            onError={(e) => {
                                                                e.target.src = "https://uzone360live.s3.amazonaws.com/noimage.png";
                                                            }}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col md={4}>
                                                    <div style={{
                                                        background: '#f9fafb',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            color: '#6b7280',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            marginBottom: '6px'
                                                        }}>Student Name</div>
                                                        <div style={{
                                                            fontSize: '13px',
                                                            color: '#111827',
                                                            fontWeight: '600'
                                                        }}>
                                                            {peanutPolicyData.student?.name || 'N/A'}
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col md={5}>
                                                    <div style={{
                                                        background: '#f9fafb',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            color: '#6b7280',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            marginBottom: '6px'
                                                        }}>Student Email</div>
                                                        <div style={{
                                                            fontSize: '13px',
                                                            color: '#111827',
                                                            fontWeight: '500'
                                                        }}>
                                                            {peanutPolicyData.student?.email || 'N/A'}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        ) : (
                            <div style={{
                                textAlign: 'center',
                                padding: '60px 20px',
                                color: '#6c757d'
                            }}>
                                <i className="ri-forbid-line" style={{
                                    fontSize: '48px',
                                    color: '#dc3545',
                                    opacity: 0.3,
                                    display: 'block',
                                    marginBottom: '16px'
                                }}></i>
                                <h6 style={{
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    color: '#495057',
                                    marginBottom: '8px'
                                }}>No Peanut Policy Data</h6>
                                <p style={{
                                    fontSize: '14px',
                                    color: '#6c757d',
                                    margin: 0
                                }}>No peanut policy information is available for this student.</p>
                            </div>
                        )
                    ) : (
                        <div style={{
                            textAlign: 'center',
                            padding: '60px 20px',
                            color: '#6c757d'
                        }}>
                            <div className="spinner-border" style={{ color: '#dc3545' }} role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p style={{
                                fontSize: '14px',
                                marginTop: '16px',
                                margin: 0
                            }}>Loading peanut policy data...</p>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        );
    };

    const renderLunchPlanModal = () => {
        const formatDate = formatDisplayDate;

        const formatDateTime = (dateString) => {
            if (!dateString) return 'N/A';
            return `${formatDisplayDate(dateString)} ${formatDisplayTime(dateString)}`;
        };

        const getFieldDisplayName = (key) => {
            const fieldNames = {
                'fillup_date': 'Application Date',
                'reason': 'Waiver Reason',
                'parents_signature': 'Parent Signature',
                'parent_signature_date': 'Parent Signed Date',
                'supervisor_signature': 'Supervisor Signature',
                'status': 'Status'
            };
            return fieldNames[key] || key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        };

        const getFieldDescription = (key) => {
            const descriptions = {
                'fillup_date': 'When this waiver was submitted',
                'reason': 'Explanation for lunch plan waiver',
                'parents_signature': 'Parent/Guardian authorization',
                'parent_signature_date': 'Date of parent authorization',
                'supervisor_signature': 'Administrative approval',
                'status': 'Current waiver status'
            };
            return descriptions[key] || 'Information details';
        };

        const renderFieldContent = (key, value) => {
            if (!value || (typeof value === 'string' && value.trim() === '')) {
                return <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>Not provided</span>;
            }

            if (key === 'fillup_date') {
                return <span style={{ fontWeight: '600', color: '#059669' }}>{formatDateTime(value)}</span>;
            }

            if (key === 'parent_signature_date') {
                return <span style={{ fontWeight: '600', color: '#059669' }}>{formatDate(value)}</span>;
            }

            if (key === 'status') {
                const statusValue = parseInt(value);
                return (
                    <span style={{
                        padding: '6px 12px',
                        borderRadius: '20px',
                        fontSize: '12px',
                        fontWeight: '700',
                        background: statusValue === 1 ? '#d1fae5' : '#fee2e2',
                        color: statusValue === 1 ? '#065f46' : '#991b1b'
                    }}>
                        {statusValue === 1 ? '✅ Active' : '❌ Inactive'}
                    </span>
                );
            }

            if (key.includes('signature') && typeof value === 'string' && value !== 'N/A') {
                return (
                    <div style={{
                        padding: '16px',
                        background: '#f8fafc',
                        borderRadius: '12px',
                        border: '2px dashed #cbd5e1',
                        textAlign: 'center',
                        minHeight: '80px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <div>
                            <i className="ri-quill-pen-line" style={{ fontSize: '24px', color: '#64748b', marginBottom: '8px', display: 'block' }}></i>
                            <span style={{ color: '#475569', fontSize: '14px', fontWeight: '600' }}>Digital Signature On File</span>
                        </div>
                    </div>
                );
            }

            // Handle object values (like user data)
            if (typeof value === 'object' && value !== null) {
                if (value.name) {
                    return <span style={{ fontWeight: '500', color: '#374151' }}>{value.name}</span>;
                } else if (value.email) {
                    return <span style={{ fontWeight: '500', color: '#374151' }}>{value.email}</span>;
                } else if (Array.isArray(value)) {
                    return <span style={{ fontWeight: '500', color: '#374151' }}>{value.join(', ')}</span>;
                } else {
                    // Try to extract meaningful data from object
                    const objectKeys = Object.keys(value);
                    if (objectKeys.length > 0) {
                        const firstKey = objectKeys[0];
                        const firstValue = value[firstKey];
                        return <span style={{ fontWeight: '500', color: '#374151' }}>{String(firstValue)}</span>;
                    }
                    return <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>Complex data</span>;
                }
            }

            // Ensure value is converted to string
            const displayValue = typeof value === 'string' ? value : String(value);
            return <span style={{ fontWeight: '500', color: '#374151' }}>{displayValue}</span>;
        };

        const filteredData = lunchPlanData ?
            Object.entries(lunchPlanData).filter(([key, value]) => {
                // Filter out unnecessary keys and null/empty values
                const excludeKeys = ['id', 'user_id'];
                return !excludeKeys.includes(key.toLowerCase()) && value != null && value !== '';
            }) : [];

        return (
            <Modal show={showLunchPlanModal} onHide={() => setShowLunchPlanModal(false)} size="lg" centered>
                <Modal.Header closeButton style={{
                    borderBottom: '1px solid #e5e7eb',
                    padding: '16px 20px',
                    background: 'white'
                }}>
                    <Modal.Title style={{
                        fontSize: '15px',
                        fontWeight: '700',
                        color: '#111827',
                        lineHeight: '1.3',
                        width: '100%',
                        maxWidth: 'calc(100% - 40px)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <div style={{
                            background: '#f3f4f6',
                            borderRadius: '8px',
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <i className="ri-restaurant-line" style={{ fontSize: '18px', color: '#10b981' }}></i>
                        </div>
                        <div>
                            <div style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>
                                Lunch Plan Waiver
                            </div>
                            <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '400' }}>
                                {selectedStudent?.name || 'Student'} • Dietary Documentation
                            </div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: '20px', maxHeight: 'calc(75vh - 140px)', overflowY: 'auto', background: '#f9fafb' }}>
                    {lunchPlanData ? (
                        <div>
                            {/* Waiver Information Section */}
                            <div style={{
                                background: 'white',
                                borderRadius: '8px',
                                padding: '16px',
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                marginBottom: '12px'
                            }}>
                                <h6 style={{ color: '#374151', fontSize: '13px', fontWeight: '600', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <i className="ri-file-list-3-line" style={{ fontSize: '16px', color: '#6366f1' }}></i>
                                    Waiver Information
                                </h6>
                                {lunchPlanData.fillup_date && (
                                    <div style={{ marginBottom: '12px' }}>
                                        <div style={{ fontSize: '11px', fontWeight: '600', color: '#6b7280', marginBottom: '4px' }}>Submitted Date</div>
                                        <div style={{ fontSize: '13px', color: '#111827' }}>{formatDate(lunchPlanData.fillup_date)}</div>
                                    </div>
                                )}
                                {lunchPlanData.reason && (
                                    <div>
                                        <div style={{ fontSize: '11px', fontWeight: '600', color: '#6b7280', marginBottom: '4px' }}>Reason</div>
                                        <div style={{ fontSize: '13px', color: '#111827', background: '#f9fafb', padding: '12px', borderRadius: '6px', border: '1px solid #e5e7eb' }}>
                                            {lunchPlanData.reason}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Signatures Section */}
                            <div style={{
                                background: 'white',
                                borderRadius: '8px',
                                padding: '16px',
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                marginBottom: '12px'
                            }}>
                                <h6 style={{ color: '#374151', fontSize: '13px', fontWeight: '600', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <i className="ri-quill-pen-line" style={{ fontSize: '16px', color: '#6366f1' }}></i>
                                    Signatures
                                </h6>
                                <Row>
                                    <Col md="6">
                                        <div style={{ marginBottom: '12px' }}>
                                            <div style={{ fontSize: '11px', fontWeight: '600', color: '#6b7280', marginBottom: '8px' }}>Parent Signature</div>
                                            {lunchPlanData.parents_signature ? (
                                                <div style={{ border: '1px solid #e5e7eb', borderRadius: '6px', padding: '12px', backgroundColor: '#f9fafb', minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img
                                                        src={lunchPlanData.parents_signature}
                                                        alt="Parent Signature"
                                                        style={{
                                                            maxWidth: '100%',
                                                            maxHeight: '80px',
                                                            display: 'block',
                                                            objectFit: 'contain'
                                                        }}
                                                        onError={(e) => {
                                                            e.target.style.display = 'none';
                                                            e.target.nextSibling.style.display = 'block';
                                                        }}
                                                    />
                                                    <div style={{ display: 'none', color: '#6b7280', textAlign: 'center' }}>
                                                        <i className="ri-image-line" style={{ fontSize: '20px', display: 'block', marginBottom: '6px' }}></i>
                                                        <small style={{ fontSize: '11px' }}>Image not available</small>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div style={{ border: '1px solid #e5e7eb', borderRadius: '6px', padding: '12px', backgroundColor: '#f9fafb', minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <div style={{ color: '#6b7280', textAlign: 'center' }}>
                                                        <i className="ri-file-text-line" style={{ fontSize: '20px', display: 'block', marginBottom: '6px' }}></i>
                                                        <small style={{ fontSize: '11px' }}>No signature provided</small>
                                                    </div>
                                                </div>
                                            )}
                                            {lunchPlanData.parent_signature_date && (
                                                <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '6px' }}>
                                                    Signed: {formatDate(lunchPlanData.parent_signature_date)}
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div>
                                            <div style={{ fontSize: '11px', fontWeight: '600', color: '#6b7280', marginBottom: '8px' }}>Supervisor Signature</div>
                                            {lunchPlanData.supervisor_signature ? (
                                                <div style={{ border: '1px solid #e5e7eb', borderRadius: '6px', padding: '12px', backgroundColor: '#f9fafb', minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img
                                                        src={lunchPlanData.supervisor_signature}
                                                        alt="Supervisor Signature"
                                                        style={{
                                                            maxWidth: '100%',
                                                            maxHeight: '80px',
                                                            display: 'block',
                                                            objectFit: 'contain'
                                                        }}
                                                        onError={(e) => {
                                                            e.target.style.display = 'none';
                                                            e.target.nextSibling.style.display = 'block';
                                                        }}
                                                    />
                                                    <div style={{ display: 'none', color: '#6b7280', textAlign: 'center' }}>
                                                        <i className="ri-image-line" style={{ fontSize: '20px', display: 'block', marginBottom: '6px' }}></i>
                                                        <small style={{ fontSize: '11px' }}>Image not available</small>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div style={{ border: '1px solid #e5e7eb', borderRadius: '6px', padding: '12px', backgroundColor: '#f9fafb', minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <div style={{ color: '#6b7280', textAlign: 'center' }}>
                                                        <i className="ri-file-text-line" style={{ fontSize: '20px', display: 'block', marginBottom: '6px' }}></i>
                                                        <small style={{ fontSize: '11px' }}>No signature provided</small>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            {/* Additional waiver details if available */}
                            {lunchPlanData.student && (
                                <div style={{
                                    background: 'white',
                                    borderRadius: '8px',
                                    padding: '16px',
                                    border: '1px solid #e5e7eb',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                }}>
                                    <h6 style={{ color: '#374151', fontSize: '13px', fontWeight: '600', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <i className="ri-user-line" style={{ fontSize: '16px', color: '#6366f1' }}></i>
                                        Student Information
                                    </h6>
                                    <Row>
                                        <Col md="6">
                                            <div style={{ marginBottom: '8px' }}>
                                                <div style={{ fontSize: '11px', fontWeight: '600', color: '#6b7280', marginBottom: '4px' }}>Name</div>
                                                <div style={{ fontSize: '13px', color: '#111827' }}>{lunchPlanData.student.name}</div>
                                            </div>
                                        </Col>
                                        <Col md="6">
                                            <div>
                                                <div style={{ fontSize: '11px', fontWeight: '600', color: '#6b7280', marginBottom: '4px' }}>Email</div>
                                                <div style={{ fontSize: '13px', color: '#111827' }}>{lunchPlanData.student.email}</div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div style={{ textAlign: 'center', padding: '40px 20px', color: '#6c757d' }}>
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        );
    };

    const renderGameModal = () => {
        // Normalize gameData: support both array and object formats
        const gameList = Array.isArray(gameData)
            ? gameData
            : (gameData && typeof gameData === 'object' ? Object.values(gameData).flat() : []);

        const gameCardColors = [
            { bg: '#eff6ff', border: '#bfdbfe', icon: '#2563eb', badge: '#dbeafe', badgeText: '#1d4ed8' },
            { bg: '#f0fdf4', border: '#bbf7d0', icon: '#16a34a', badge: '#dcfce7', badgeText: '#15803d' },
            { bg: '#fdf4ff', border: '#e9d5ff', icon: '#9333ea', badge: '#f3e8ff', badgeText: '#7e22ce' },
            { bg: '#fff7ed', border: '#fed7aa', icon: '#ea580c', badge: '#ffedd5', badgeText: '#c2410c' },
            { bg: '#fdf2f8', border: '#fbcfe8', icon: '#db2777', badge: '#fce7f3', badgeText: '#be185d' },
        ];

        return (
            <Modal show={showGameModal} onHide={() => setShowGameModal(false)} size="lg" centered dialogClassName="att-game-dialog" style={{ marginTop: 10 }}>
                <Modal.Header closeButton style={{ borderBottom: '1px solid #e9ecef', padding: '16px 50px 16px 20px' }}>
                    <Modal.Title style={{ fontSize: '17px', fontWeight: '700', color: '#212529', width: '100%', maxWidth: 'calc(100% - 40px)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="material-symbols-outlined" style={{ fontSize: '20px', color: '#1e3a8a', flexShrink: 0 }}>sports_esports</i>
                            <span style={{ flex: 1, wordBreak: 'break-word' }}>Games - {selectedStudent?.name}</span>
                            {gameList.length > 0 && (
                                <span style={{ background: '#eff6ff', color: '#1d4ed8', fontSize: '11px', fontWeight: '600', padding: '2px 10px', borderRadius: '12px', flexShrink: 0 }}>
                                    {gameList.length} game{gameList.length !== 1 ? 's' : ''}
                                </span>
                            )}
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: '0', background: '#fff' }}>
                    {/* Play Games / Adaptive Games: opens the actual game-playing
                        screen for this student while staying logged in as the
                        teacher - scores/sessions/mastery are all tracked under
                        the student's own account (see
                        TeacherStudentAccessMiddleware). Play Games lands on
                        Learning Zone's static-games tab, Adaptive Games on its
                        AI-adaptive tab - both tabs stay switchable once there,
                        this just picks which one opens first. Only offered when
                        the student is actually checked in today - playing games
                        on behalf of a child who isn't present doesn't make
                        sense and would still work server-side (the
                        authorization check is class membership, not
                        attendance), so it has to be gated here. */}
                    {selectedStudent?.attendance === 'present' && (
                    <div style={{ padding: '18px 22px 0', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '12px' }}>
                        {[
                            { mode: 'static', icon: 'sports_esports', title: 'Play Games', subtitle: 'Fun learning games', gradient: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', shadow: 'rgba(99, 102, 241, 0.35)' },
                            { mode: 'adaptive', icon: 'auto_awesome', title: 'Adaptive Games', subtitle: 'AI adjusts to the child', gradient: 'linear-gradient(135deg, #ec4899 0%, #f97316 100%)', shadow: 'rgba(236, 72, 153, 0.35)' },
                        ].map((opt) => (
                            <button
                                key={opt.mode}
                                type="button"
                                style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px', border: 'none', borderRadius: '14px', background: opt.gradient, color: '#fff', textAlign: 'left', cursor: 'pointer', boxShadow: `0 4px 12px ${opt.shadow}`, transition: 'transform 0.15s ease, box-shadow 0.15s ease' }}
                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = `0 8px 20px ${opt.shadow}`; }}
                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = `0 4px 12px ${opt.shadow}`; }}
                                onClick={() => {
                                    setShowGameModal(false);
                                    navigate(`/dashboard/app/game/game-category?actingStudentId=${selectedStudent?.id}&actingStudentName=${encodeURIComponent(selectedStudent?.name || '')}&mode=${opt.mode}`);
                                }}
                            >
                                <span style={{ width: '42px', height: '42px', borderRadius: '50%', background: 'rgba(255,255,255,0.22)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                    <i className="material-symbols-outlined" style={{ fontSize: '24px' }}>{opt.icon}</i>
                                </span>
                                <span style={{ flex: 1, minWidth: 0 }}>
                                    <span style={{ display: 'block', fontSize: '15px', fontWeight: '700', lineHeight: 1.2 }}>{opt.title}</span>
                                    <span style={{ display: 'block', fontSize: '12px', opacity: 0.9, marginTop: '2px' }}>{opt.subtitle}</span>
                                </span>
                                <i className="material-symbols-outlined" style={{ fontSize: '22px', opacity: 0.9 }}>arrow_forward</i>
                            </button>
                        ))}
                    </div>
                    )}

                    {/* Assign New Game Section */}
                    <div style={{ padding: '20px 22px 16px', borderBottom: '1px solid #e9ecef' }}>
                        <h6 style={{ fontSize: '15px', fontWeight: '600', color: '#212529', marginBottom: '14px' }}>Assign New Learning Games</h6>
                        <div style={{ background: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '8px', padding: '16px' }}>
                            <Form.Group style={{ marginBottom: '14px' }}>
                                <Form.Label style={{ fontSize: '14px', fontWeight: '600', color: '#212529', marginBottom: '6px' }}>Select a game to assign</Form.Label>
                                <Form.Select
                                    value={selectedGame}
                                    onChange={(e) => setSelectedGame(e.target.value)}
                                    style={{ fontSize: '14px', borderRadius: '8px', padding: '10px' }}
                                >
                                    <option value="">-- Choose a game --</option>
                                    {gameNames.map((game) => (
                                        <option key={game.id} value={game.id}>{game.name}</option>
                                    ))}
                                </Form.Select>
                                {gameNames.length === 0 && (
                                    <div style={{ fontSize: '12px', color: '#94a3b8', marginTop: '6px' }}>Loading available games...</div>
                                )}
                            </Form.Group>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                                <Button
                                    variant="primary"
                                    onClick={assignGame}
                                    disabled={!selectedGame || isAssigningGame}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 24px',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        background: '#1e3a8a',
                                        border: 'none',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '6px'
                                    }}
                                >
                                    <i className="material-symbols-outlined" style={{ fontSize: '18px' }}>add_circle</i>
                                    {isAssigningGame ? 'Assigning...' : 'Assign Learning Game'}
                                </Button>
                            </div>
                        </div>
                    </div>

                    {/* Assigned Games Section */}
                    <div style={{ padding: '20px 22px 22px' }}>
                        <h6 style={{ fontSize: '15px', fontWeight: '600', color: '#212529', marginBottom: '14px' }}>Assigned Learning Games</h6>
                        {gameList.length > 0 ? (
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '10px', maxHeight: '42vh', overflowY: 'auto', paddingRight: '4px' }}>
                                {gameList.map((game, idx) => {
                                    const color = gameCardColors[idx % gameCardColors.length];
                                    const name = game?.game_name?.name || game?.name || game?.game || `Game ${idx + 1}`;
                                    const category = game?.game_name?.category?.name || game?.category?.name || game?.category || '';
                                    const level = game?.level ?? game?.game_name?.level ?? null;
                                    const score = game?.score ?? null;
                                    // Clicking a card opens that exact game for this
                                    // student (same autoPlay deep link the student's own
                                    // dashboard uses), signed in as the teacher but with
                                    // every session/score recorded to this student. Not
                                    // gated on check-in - the teacher can hand the device
                                    // to the child any time.
                                    const gameNameId = game?.game_name_id ?? game?.game_name?.id;
                                    const categoryId = game?.game_name?.category?.id ?? game?.game_name?.category_id;
                                    const canPlay = !!selectedStudent?.id && gameNameId != null && categoryId != null;
                                    const playMode = Number(game?.game_name?.is_ai_generated) === 1 ? 'adaptive' : 'static';
                                    const openGame = () => {
                                        if (!canPlay) return;
                                        setShowGameModal(false);
                                        navigate(`/dashboard/app/game/game-category?actingStudentId=${selectedStudent?.id}&actingStudentName=${encodeURIComponent(selectedStudent?.name || '')}&mode=${playMode}&gameNameId=${gameNameId}&categoryId=${categoryId}&autoPlay=1`);
                                    };
                                    return (
                                        <div
                                            key={game?.id || idx}
                                            role={canPlay ? 'button' : undefined}
                                            tabIndex={canPlay ? 0 : undefined}
                                            title={canPlay ? `Play ${name} for ${selectedStudent?.name || 'this student'}` : undefined}
                                            onClick={openGame}
                                            onKeyDown={(e) => { if (canPlay && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); openGame(); } }}
                                            onMouseEnter={(e) => { if (canPlay) { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 16px rgba(15, 23, 42, 0.12)'; } }}
                                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
                                            style={{ background: color.bg, border: `1.5px solid ${color.border}`, borderRadius: '12px', padding: '12px', display: 'flex', alignItems: 'center', gap: '10px', cursor: canPlay ? 'pointer' : 'default', transition: 'transform 0.15s ease, box-shadow 0.15s ease' }}
                                        >
                                            <div style={{ background: color.badge, borderRadius: '8px', padding: '6px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <i className="material-symbols-outlined" style={{ fontSize: '18px', color: color.icon }}>sports_esports</i>
                                            </div>
                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                <div title={name} style={{ fontSize: '13px', fontWeight: '700', color: '#1e293b', lineHeight: '1.3', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{name}</div>
                                                {category ? <div style={{ fontSize: '11px', color: '#64748b', marginTop: '2px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{category}</div> : null}
                                                {(level !== null || score !== null) && (
                                                    <div style={{ display: 'flex', gap: '4px', flexWrap: 'nowrap', marginTop: '6px', overflow: 'hidden' }}>
                                                        {level !== null && (
                                                            <span style={{ background: color.badge, color: color.badgeText, fontSize: '10px', fontWeight: '600', padding: '2px 7px', borderRadius: '10px', whiteSpace: 'nowrap', flexShrink: 0 }}>
                                                                Lv {level}
                                                            </span>
                                                        )}
                                                        {score !== null && (
                                                            <span style={{ background: color.badge, color: color.badgeText, fontSize: '10px', fontWeight: '600', padding: '2px 7px', borderRadius: '10px', whiteSpace: 'nowrap', flexShrink: 0 }}>
                                                                Score {score}
                                                            </span>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            <button
                                                type="button"
                                                disabled={unassigningGameIds.has(game?.game_name_id)}
                                                onClick={(e) => { e.stopPropagation(); unassignGame(game?.game_name_id, name); }}
                                                onKeyDown={(e) => e.stopPropagation()}
                                                style={{ flexShrink: 0, alignSelf: 'center', fontSize: '11px', fontWeight: '600', lineHeight: '1.4', color: '#dc2626', background: '#fff', border: '1px solid #fecaca', borderRadius: '6px', padding: '3px 8px', cursor: unassigningGameIds.has(game?.game_name_id) ? 'not-allowed' : 'pointer', opacity: unassigningGameIds.has(game?.game_name_id) ? 0.5 : 1 }}
                                            >
                                                {unassigningGameIds.has(game?.game_name_id) ? 'Removing...' : 'Unassign'}
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div style={{ textAlign: 'center', padding: '28px 20px', background: '#fff', borderRadius: '12px', border: '1.5px dashed #cbd5e1' }}>
                                <i className="material-symbols-outlined" style={{ fontSize: '36px', color: '#94a3b8', display: 'block', marginBottom: '8px' }}>sports_esports</i>
                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#475569', marginBottom: '4px' }}>No games assigned yet</div>
                                <div style={{ fontSize: '12px', color: '#94a3b8' }}>Use the form above to assign a game</div>
                            </div>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        );
    };

    const renderGameStatsModal = () => {
        // Replay a completed game for this student from the Game Stats modal -
        // the teacher stays signed in, progress is saved to the student.
        const openCompletedGame = (game) => {
            const gameNameId = game?.game_name_id ?? game?.game_name?.id;
            const categoryId = game?.game_name?.category?.id ?? game?.game_name?.category_id;
            if (!selectedStudent?.id || gameNameId == null || categoryId == null) return;
            const playMode = Number(game?.game_name?.is_ai_generated) === 1 ? 'adaptive' : 'static';
            setShowGameStatsModal(false);
            navigate(`/dashboard/app/game/game-category?actingStudentId=${selectedStudent?.id}&actingStudentName=${encodeURIComponent(selectedStudent?.name || '')}&mode=${playMode}&gameNameId=${gameNameId}&categoryId=${categoryId}&autoPlay=1`);
        };

        const games = gameStatsData?.games || [];
        const statsDate = gameStatsData?.date;
        const gameCardColors = [
            { bg: '#eff6ff', border: '#bfdbfe', badge: '#dbeafe', badgeText: '#1d4ed8', icon: '#1d4ed8' },
            { bg: '#f0fdf4', border: '#bbf7d0', badge: '#dcfce7', badgeText: '#15803d', icon: '#15803d' },
            { bg: '#fdf4ff', border: '#f5d0fe', badge: '#fae8ff', badgeText: '#a21caf', icon: '#a21caf' },
        ];

        return (
            <Modal show={showGameStatsModal} onHide={() => setShowGameStatsModal(false)} size="lg" centered dialogClassName="att-game-dialog" style={{ marginTop: 10 }}>
                <Modal.Header closeButton style={{ borderBottom: '1px solid #e9ecef', padding: '16px 50px 16px 20px' }}>
                    <Modal.Title style={{ fontSize: '17px', fontWeight: '700', color: '#212529', width: '100%', maxWidth: 'calc(100% - 40px)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="material-symbols-outlined" style={{ fontSize: '20px', color: '#065f46', flexShrink: 0 }}>bar_chart</i>
                            <span style={{ flex: 1, wordBreak: 'break-word' }}>Game Stats - {selectedStudent?.name}</span>
                            <button
                                type="button"
                                onClick={openWeeklyReports}
                                disabled={weeklyReportsLoading}
                                title="Weekly reports"
                                style={{
                                    display: 'inline-flex', alignItems: 'center', gap: '6px', flexShrink: 0,
                                    border: '1px solid #d8ccf1', background: '#f5f0ff', color: '#6f42c1',
                                    borderRadius: '999px', padding: '5px 12px', fontSize: '13px', fontWeight: 600,
                                    cursor: weeklyReportsLoading ? 'wait' : 'pointer'
                                }}
                            >
                                <i className="material-symbols-outlined" style={{ fontSize: '17px' }}>insights</i>
                                <span className="d-none d-sm-inline">Weekly Reports</span>
                                <span style={{
                                    minWidth: '20px', height: '20px', borderRadius: '999px', padding: '0 6px',
                                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                    background: weeklyReports.length ? '#6f42c1' : '#cbd5e1', color: '#fff', fontSize: '11px'
                                }}>
                                    {weeklyReportsLoading ? '…' : weeklyReports.length}
                                </span>
                            </button>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: '20px 22px 22px', background: '#fff' }}>
                    <div style={{ fontSize: '12px', color: '#94a3b8', marginBottom: '14px' }}>
                        Showing activity for {statsDate || getReportDate()}
                    </div>

                    {gameStatsLoading ? (
                        <div style={{ textAlign: 'center', padding: '40px 20px', color: '#94a3b8' }}>Loading...</div>
                    ) : games.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '28px 20px', background: '#fff', borderRadius: '12px', border: '1.5px dashed #cbd5e1' }}>
                            <i className="material-symbols-outlined" style={{ fontSize: '36px', color: '#94a3b8', display: 'block', marginBottom: '8px' }}>bar_chart</i>
                            <div style={{ fontSize: '14px', fontWeight: '600', color: '#475569', marginBottom: '4px' }}>No games played on this date</div>
                            <div style={{ fontSize: '12px', color: '#94a3b8' }}>Pick a different attendance date to see that day's activity instead.</div>
                        </div>
                    ) : (
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '12px' }}>
                            {games.map((game, idx) => {
                                const color = gameCardColors[idx % gameCardColors.length];
                                return (
                                    <div key={`${game.game_name}-${idx}`} style={{ background: color.bg, border: `1.5px solid ${color.border}`, borderRadius: '12px', padding: '14px' }}>
                                        <div style={{ fontSize: '14px', fontWeight: '700', color: '#1e293b', marginBottom: '2px' }}>{game.game_name}</div>
                                        {game.category_name && (
                                            <div style={{ fontSize: '11px', color: '#64748b', marginBottom: '10px' }}>{game.category_name}</div>
                                        )}
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                            <span style={{ background: color.badge, color: color.badgeText, fontSize: '10px', fontWeight: '600', padding: '3px 9px', borderRadius: '10px' }}>
                                                Played {game.times_played}x
                                            </span>
                                            <span style={{ background: color.badge, color: color.badgeText, fontSize: '10px', fontWeight: '600', padding: '3px 9px', borderRadius: '10px' }}>
                                                Best {game.best_score}%
                                            </span>
                                            <span style={{ background: color.badge, color: color.badgeText, fontSize: '10px', fontWeight: '600', padding: '3px 9px', borderRadius: '10px' }}>
                                                Last {game.last_score}%
                                            </span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {/* Completed Learning Games - every game the student has
                        completed, not just on the selected date. */}
                    <div style={{ borderTop: '1px solid #e9ecef', marginTop: '20px', paddingTop: '18px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px' }}>
                            <i className="material-symbols-outlined" style={{ fontSize: '20px', color: '#1d4ed8' }}>emoji_events</i>
                            <h6 style={{ fontSize: '15px', fontWeight: '600', color: '#212529', margin: 0, flex: 1 }}>Completed Learning Games</h6>
                            {!statsCompletedGamesLoading && !statsCompletedGamesError && (
                                <span style={{ background: '#dbeafe', color: '#1d4ed8', fontSize: '12px', fontWeight: '600', padding: '3px 10px', borderRadius: '12px' }}>
                                    {statsCompletedGames.length} completed
                                </span>
                            )}
                        </div>
                        {statsCompletedGamesLoading ? (
                            <div style={{ textAlign: 'center', padding: '24px 20px', color: '#94a3b8' }}>Loading...</div>
                        ) : statsCompletedGamesError ? (
                            <div style={{ textAlign: 'center', padding: '20px', color: '#b91c1c', fontSize: '13px' }}>{statsCompletedGamesError}</div>
                        ) : statsCompletedGames.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: '24px 20px', borderRadius: '12px', border: '1.5px dashed #cbd5e1' }}>
                                <i className="material-symbols-outlined" style={{ fontSize: '32px', color: '#94a3b8', display: 'block', marginBottom: '6px' }}>emoji_events</i>
                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#475569' }}>No completed learning games yet</div>
                            </div>
                        ) : (
                            <div className="dcl-games-grid" style={{ maxHeight: '40vh', overflowY: 'auto', paddingRight: '4px' }}>
                                {statsCompletedGames.map((game, idx) => (
                                    <LearningGameCard
                                        key={`completed-${game?.id || idx}`}
                                        game={game}
                                        fallbackTitle={`Game ${idx + 1}`}
                                        completed
                                        level={game?.level || game?.game_name?.level || 1}
                                        score={game?.score ?? '--'}
                                        onPlay={openCompletedGame}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        );
    };

    const renderRoomModal = () => {
        // Falls back to the teacher's currently selected room, same as
        // currentMainRoomName below - without this, assign-info not
        // returning mainRoom.id (while still resolving a display name via
        // the selectedRoom fallback) left this null, which silently
        // disabled the "exclude current room" filter on assignRoomOptions
        // below and let the student's current room show up as a pickable
        // target.
        const currentMainRoomId = roomAssignInfo?.mainRoom?.id ?? (selectedRoom ? Number(selectedRoom) : null);
        const currentMainRoomName = roomAssignInfo?.mainRoom?.name || rooms.find((room) => Number(room.id) === Number(selectedRoom))?.room_name || '—';
        const currentSwapRoomName = roomAssignInfo?.swapRoom?.name || null;
        // The Swap section's own "Main Room" display must match what a swap
        // actually submits as main_room_id (roomSwapMainId, which is
        // selectedRoom unless that's unavailable - see openRoomModal). Using
        // currentMainRoomName above there instead showed a *different* room
        // whenever the primary selected student's own backend "main room"
        // field doesn't match the room actually being managed right now
        // (e.g. a bulk selection, or a student already mid-swap) - the name
        // shown must track the same source of truth as the value submitted.
        const swapMainRoomName = (roomSwapMainId && rooms.find((room) => String(room.id) === String(roomSwapMainId))?.room_name)
            || currentMainRoomName;
        const isSingleStudent = roomModalStudents.length === 1;
        const modalSubjectLabel = isSingleStudent
            ? (roomModalStudents[0]?.name || '')
            : `${roomModalStudents.length} students`;

        // Grade-scoped room list (union of every selected student's grade,
        // when more than one) — only rooms their grade's classes actually
        // reach, not every room in the school. Falls back to the teacher's
        // own rooms if the backend didn't return any (see getAssignRoomInfo).
        // Used for "Move to Room" (a persistent move should stay
        // grade-appropriate) - NOT for Swap, which uses the full,
        // unrestricted room list below (a same-day swap is meant to be
        // flexible, and a grade usually maps to only the student's own one
        // room, which would leave "Swap With" empty if it used this list).
        const pickerRooms = roomAssignInfo?.allRooms?.length ? roomAssignInfo.allRooms : rooms;
        const swapPickerRooms = roomAssignInfo?.allSwapRooms?.length ? roomAssignInfo.allSwapRooms : rooms;
        const assignRoomOptions = pickerRooms.filter((room) => currentMainRoomId ? Number(room.id) !== Number(currentMainRoomId) : true);
        const swapTargetOptions = swapPickerRooms.filter((room) => roomSwapMainId ? String(room.id) !== String(roomSwapMainId) : true);

        return (
            <Modal show={showRoomModal} onHide={closeRoomModal} size="lg" centered scrollable dialogClassName="att-room-modal-dialog">
                <Modal.Header closeButton style={{ borderBottom: '1px solid #e9ecef', padding: '16px 50px 16px 20px' }}>
                    <Modal.Title style={{ fontSize: '17px', fontWeight: '700', color: '#212529', width: '100%', maxWidth: 'calc(100% - 40px)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="material-symbols-outlined" style={{ fontSize: '20px', color: '#0e7490', flexShrink: 0 }}>meeting_room</i>
                            <span style={{ flex: 1, wordBreak: 'break-word' }}>
                                {roomModalMode === 'swap' ? 'Swap Room' : roomModalMode === 'assign' ? 'Assign Room' : 'Room Management'} - {modalSubjectLabel}
                            </span>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: '0', background: '#fff' }}>
                    {!isSingleStudent && (
                        <div style={{ padding: '16px 22px 0' }}>
                            <div style={{ background: '#f5f3ff', border: '1.5px solid #ddd6fe', borderRadius: '12px', padding: '12px 16px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                <i className="material-symbols-outlined" style={{ fontSize: '18px', color: '#6d28d9' }}>groups</i>
                                <span style={{ fontSize: '13px', color: '#4c1d95' }}>
                                    Applying to <strong>{roomModalStudents.length} students</strong>: {roomModalStudents.map((student) => student.name).join(', ')}
                                </span>
                            </div>
                        </div>
                    )}

                    {/* Current Assignment — only meaningful for a single student */}
                    {isSingleStudent && (
                        <div style={{ padding: '20px 22px 16px', borderBottom: '1px solid #e9ecef' }}>
                            <h6 style={{ fontSize: '15px', fontWeight: '600', color: '#212529', marginBottom: '14px' }}>Current Assignment</h6>
                            {roomAssignInfoLoading ? (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 10px', border: '1px solid #eef1f4', background: '#fff' }}>
                                    <img src={loader} alt="Loading room assignment" style={{ height: '24px' }} />
                                    <span style={{ fontSize: '12px', fontWeight: '600', color: '#6b7280' }}>Loading current assignment...</span>
                                </div>
                            ) : (
                                <div style={{ background: '#f0fdff', border: '1.5px solid #a5f3fc', borderRadius: '12px', padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <i className="material-symbols-outlined" style={{ fontSize: '18px', color: '#0e7490' }}>meeting_room</i>
                                        <span style={{ fontSize: '13px', color: '#0c4a6e' }}>Main Room: <strong>{currentMainRoomName}</strong></span>
                                    </div>
                                    {currentSwapRoomName && (
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', flexWrap: 'wrap' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="material-symbols-outlined" style={{ fontSize: '18px', color: '#b45309' }}>swap_horiz</i>
                                                <span style={{ fontSize: '13px', color: '#78350f' }}>Currently swapped with: <strong>{currentSwapRoomName}</strong></span>
                                            </div>
                                            <Button
                                                variant="link"
                                                onClick={cancelRoomSwap}
                                                disabled={!!roomActionSaving}
                                                title="Undo this swap - puts the student back in their main room"
                                                style={{
                                                    fontSize: '12.5px',
                                                    fontWeight: '600',
                                                    color: '#b91c1c',
                                                    padding: '4px 8px',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: '4px',
                                                    textDecoration: 'none'
                                                }}
                                            >
                                                <i className="material-symbols-outlined" style={{ fontSize: '16px' }}>cancel</i>
                                                {roomActionSaving === 'cancel-swap' ? 'Cancelling...' : 'Cancel Swap'}
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                    {/* Move to Room (assign) - shown when opened via the
                        Assign Room button/action, or via the bulk "Manage
                        Rooms" action (mode null), which shows both sections
                        since either action can make sense for a selection. */}
                    {(roomModalMode === 'assign' || roomModalMode === null) && (
                        <div style={{ padding: '20px 22px' }}>
                            <h6 style={{ fontSize: '15px', fontWeight: '600', color: '#212529', marginBottom: '14px' }}>Move to Room</h6>
                            <div style={{ background: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '8px', padding: '16px' }}>
                                <Form.Group style={{ marginBottom: '14px' }}>
                                    <Form.Label style={{ fontSize: '14px', fontWeight: '600', color: '#212529', marginBottom: '6px' }}>Select the new room</Form.Label>
                                    {assignRoomOptions.length === 0 ? (
                                        // The only room(s) this call returned are the student's
                                        // current room, filtered out above - there's genuinely
                                        // nowhere else to assign them, not a loading/data bug.
                                        <div style={{ fontSize: '13px', color: '#6b7280', padding: '10px', background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                                            No other rooms available to move this student to.
                                        </div>
                                    ) : (
                                        <Form.Select
                                            value={roomAssignTargetId}
                                            onChange={(e) => setRoomAssignTargetId(e.target.value)}
                                            style={{ fontSize: '14px', borderRadius: '8px', padding: '10px' }}
                                        >
                                            <option value="">-- Choose a room --</option>
                                            {assignRoomOptions.map((room) => (
                                                <option key={room.id} value={room.id}>{room.room_name}</option>
                                            ))}
                                        </Form.Select>
                                    )}
                                </Form.Group>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                                    <Button
                                        variant="primary"
                                        onClick={submitRoomAssign}
                                        disabled={!roomAssignTargetId || !!roomActionSaving}
                                        style={{
                                            borderRadius: '8px',
                                            padding: '10px 24px',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            background: '#0e7490',
                                            border: 'none',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '6px'
                                        }}
                                    >
                                        <i className="material-symbols-outlined" style={{ fontSize: '18px' }}>meeting_room</i>
                                        {roomActionSaving === 'assign' ? 'Assigning...' : 'Assign Room'}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Swap Room - shown when opened via the Swap Room
                        button/action, or via the bulk "Manage Rooms" action
                        (mode null), which shows both sections since either
                        action can make sense for a selection. */}
                    {(roomModalMode === 'swap' || roomModalMode === null) && (
                        <div style={{ padding: '20px 22px' }}>
                            <h6 style={{ fontSize: '15px', fontWeight: '600', color: '#212529', marginBottom: '14px' }}>Swap Room</h6>
                            <div style={{ background: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '8px', padding: '16px' }}>
                                <Row>
                                    {/* Only shown for a bulk (multi-student) selection, where
                                        "Current Assignment" above is hidden (there's no single
                                        student's status to show) and this is the only indication
                                        of which room the swap is FROM. For a single student,
                                        "Current Assignment" already shows their real main room
                                        (and any existing swap) - repeating a *different* room
                                        here under the same "Main Room" label (this one reflects
                                        main_room_id, the room actually being managed/swapped
                                        FROM, which is the swap-destination room if they're
                                        already mid-swap) looked like the two contradicted each
                                        other. */}
                                    {!isSingleStudent && (
                                        <Col xs={12} md={6}>
                                            <Form.Group style={{ marginBottom: '14px' }}>
                                                <Form.Label style={{ fontSize: '14px', fontWeight: '600', color: '#212529', marginBottom: '6px' }}>Main Room</Form.Label>
                                                <div
                                                    style={{
                                                        fontSize: '14px',
                                                        borderRadius: '8px',
                                                        padding: '10px 12px',
                                                        background: '#eef2f5',
                                                        border: '1px solid #dee2e6',
                                                        color: '#374151',
                                                        fontWeight: '600',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px'
                                                    }}
                                                >
                                                    <i className="material-symbols-outlined" style={{ fontSize: '16px', color: '#6b7280' }}>meeting_room</i>
                                                    {swapMainRoomName}
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    )}
                                    <Col xs={12} md={isSingleStudent ? 12 : 6}>
                                        <Form.Group style={{ marginBottom: '14px' }}>
                                            <Form.Label style={{ fontSize: '14px', fontWeight: '600', color: '#212529', marginBottom: '6px' }}>Swap With</Form.Label>
                                            {swapTargetOptions.length === 0 ? (
                                                // The only room(s) this call returned are the
                                                // student's own main room, filtered out above -
                                                // there's genuinely no other room to swap with.
                                                <div style={{ fontSize: '13px', color: '#6b7280', padding: '10px', background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                                                    No other rooms available to swap with.
                                                </div>
                                            ) : (
                                                <Form.Select
                                                    value={roomSwapTargetId}
                                                    onChange={(e) => setRoomSwapTargetId(e.target.value)}
                                                    style={{ fontSize: '14px', borderRadius: '8px', padding: '10px' }}
                                                >
                                                    <option value="">-- Choose a room --</option>
                                                    {swapTargetOptions.map((room) => (
                                                        <option key={room.id} value={room.id}>{room.room_name}</option>
                                                    ))}
                                                </Form.Select>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Form.Group style={{ marginBottom: '14px' }}>
                                    <Form.Label style={{ fontSize: '14px', fontWeight: '600', color: '#212529', marginBottom: '6px' }}>Note (optional)</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={2}
                                        value={roomSwapNote}
                                        onChange={(e) => setRoomSwapNote(e.target.value)}
                                        placeholder="e.g. Outdoor play swap"
                                        style={{ fontSize: '14px', borderRadius: '8px', padding: '10px' }}
                                    />
                                </Form.Group>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                                    <Button
                                        variant="primary"
                                        onClick={submitRoomSwap}
                                        disabled={!roomSwapMainId || !roomSwapTargetId || !!roomActionSaving}
                                        style={{
                                            borderRadius: '8px',
                                            padding: '10px 24px',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            background: '#0e7490',
                                            border: 'none',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '6px'
                                        }}
                                    >
                                        <i className="material-symbols-outlined" style={{ fontSize: '18px' }}>swap_horiz</i>
                                        {roomActionSaving === 'swap' ? 'Swapping...' : 'Swap Room'}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        );
    };

    const renderObservationViewModal = () => (
        <Modal show={showObservationViewModal} onHide={() => setShowObservationViewModal(false)} size="lg" centered
            style={{ marginTop: "50px", marginBottom: "50px" }}>
            <Modal.Header closeButton style={{
                borderBottom: '3px solid #8b5cf6',
                padding: '20px 24px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '24px',
                    fontWeight: '800',
                    color: '#8b5cf6',
                    lineHeight: '1.2',
                    width: '100%',
                    maxWidth: 'calc(100% - 40px)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                        <div style={{
                            background: '#8b5cf6',
                            borderRadius: '12px',
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <i className="ri-eye-line" style={{ fontSize: '24px', color: 'white' }}></i>
                        </div>
                        <div>
                            <div style={{ fontSize: '24px', fontWeight: '800', marginBottom: '4px' }}>
                                View Observation
                            </div>
                            <div style={{ fontSize: '14px', opacity: 0.7, fontWeight: '500' }}>
                                {selectedStudent?.name} • {new Date(selectedDate).toLocaleDateString('en-US', {
                                    weekday: 'long',
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                })}
                            </div>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '32px', maxHeight: '60vh', overflowY: 'auto' }}>
                {observationData ? (
                    <div>
                        {observationData.notes || observationData.observation ? (
                            <div>
                                {/* Notes Section */}
                                {observationData.notes && (
                                    <div style={{ marginBottom: '24px' }}>
                                        <div style={{
                                            background: 'white',
                                            borderRadius: '20px',
                                            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                                            overflow: 'hidden'
                                        }}>
                                            <div style={{
                                                background: 'white',
                                                borderBottom: '3px solid #3498db',
                                                padding: '16px 20px',
                                                color: '#3498db'
                                            }}>
                                                <h6 style={{
                                                    fontSize: '18px',
                                                    fontWeight: '800',
                                                    marginBottom: '0',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '12px'
                                                }}>
                                                    <div style={{
                                                        background: '#3498db',
                                                        borderRadius: '12px',
                                                        padding: '8px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <i className="ri-sticky-note-line" style={{ fontSize: '20px', color: 'white' }}></i>
                                                    </div>
                                                    Notes
                                                </h6>
                                            </div>
                                            <div style={{ padding: '24px' }}>
                                                <div style={{
                                                    padding: '20px',
                                                    background: 'linear-gradient(135deg, #ebf8ff 0%, #dbeafe 100%)',
                                                    borderRadius: '12px',
                                                    border: '1px solid rgba(52, 152, 219, 0.2)',
                                                    fontSize: '16px',
                                                    lineHeight: '1.6',
                                                    color: '#374151',
                                                    fontWeight: '500',
                                                    whiteSpace: 'pre-wrap'
                                                }}>
                                                    {observationData.notes}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Observation Section */}
                                {observationData.observation && (
                                    <div style={{ marginBottom: '24px' }}>
                                        <div style={{
                                            background: 'white',
                                            borderRadius: '20px',
                                            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                                            overflow: 'hidden'
                                        }}>
                                            <div style={{
                                                background: 'white',
                                                borderBottom: '3px solid #e74c3c',
                                                padding: '16px 20px',
                                                color: '#e74c3c'
                                            }}>
                                                <h6 style={{
                                                    fontSize: '18px',
                                                    fontWeight: '800',
                                                    marginBottom: '0',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '12px'
                                                }}>
                                                    <div style={{
                                                        background: '#e74c3c',
                                                        borderRadius: '12px',
                                                        padding: '8px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <i className="ri-eye-line" style={{ fontSize: '20px', color: 'white' }}></i>
                                                    </div>
                                                    Detailed Observation
                                                </h6>
                                            </div>
                                            <div style={{ padding: '24px' }}>
                                                <div style={{
                                                    padding: '20px',
                                                    background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
                                                    borderRadius: '12px',
                                                    border: '1px solid rgba(231, 76, 60, 0.2)',
                                                    fontSize: '16px',
                                                    lineHeight: '1.6',
                                                    color: '#dc2626',
                                                    fontWeight: '500',
                                                    whiteSpace: 'pre-wrap'
                                                }}>
                                                    {observationData.observation}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div style={{
                                textAlign: 'center',
                                padding: '60px 20px',
                                background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                                borderRadius: '20px',
                                border: '2px dashed #cbd5e1'
                            }}>
                                <div style={{
                                    background: '#64748b',
                                    borderRadius: '50%',
                                    width: '80px',
                                    height: '80px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto 20px',
                                    opacity: 0.7
                                }}>
                                    <i className="ri-file-search-line" style={{ fontSize: '36px', color: 'white' }}></i>
                                </div>
                                <h4 style={{ color: '#475569', marginBottom: '8px', fontSize: '20px', fontWeight: '700' }}>
                                    No Observation Available
                                </h4>
                                <p style={{ color: '#64748b', margin: '0', fontSize: '16px' }}>
                                    No observation data has been recorded for this student on this date.
                                </p>
                            </div>
                        )}
                    </div>
                ) : (
                    <div style={{
                        textAlign: 'center',
                        padding: '60px 20px',
                        background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
                        borderRadius: '20px'
                    }}>
                        <div style={{
                            background: '#0ea5e9',
                            borderRadius: '50%',
                            width: '60px',
                            height: '60px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 20px',
                            animation: 'pulse 2s infinite'
                        }}>
                            <i className="ri-loader-4-line" style={{ fontSize: '24px', color: 'white' }}></i>
                        </div>
                        <h4 style={{ color: '#0369a1', marginBottom: '8px', fontSize: '18px', fontWeight: '700' }}>
                            Loading Observation...
                        </h4>
                        <p style={{ color: '#0ea5e9', margin: '0', fontSize: '14px' }}>
                            Please wait while we fetch the observation data.
                        </p>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );

    const renderDailyReportFormModal = () => (
        <Modal show={showDailyReportFormModal} onHide={handleCloseDailyReportModal} size="lg" centered
            style={{ marginTop: '20px', marginBottom: '20px' }}>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#111827',
                    lineHeight: '1.3',
                    width: '100%',
                    maxWidth: 'calc(100% - 40px)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{
                            background: 'linear-gradient(135deg, var(--bs-primary) 0%, var(--bs-primary) 100%)',
                            borderRadius: '8px',
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <i className="ri-file-text-line" style={{ fontSize: '20px', color: 'white' }}></i>
                        </div>
                        <div>
                            <div style={{ fontSize: '16px', fontWeight: '700', marginBottom: '2px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {isEditingDailyReport ? 'Edit Daily Report' : 'Create Daily Report'}
                                {isDraftMode && (
                                    <span style={{
                                        fontSize: '10px',
                                        fontWeight: '600',
                                        background: 'rgba(251, 191, 36, 0.9)',
                                        color: '#78350f',
                                        padding: '3px 8px',
                                        borderRadius: '4px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}>
                                        <i className="ri-draft-line" style={{ fontSize: '10px', marginRight: '2px' }}></i>
                                        Draft
                                    </span>
                                )}
                            </div>
                            <div style={{ fontSize: '11px', opacity: 0.7, fontWeight: '400', color: '#6b7280' }}>
                                {selectedStudent?.name} • {new Date(selectedDate).toLocaleDateString('en-US', {
                                    month: 'short',
                                    day: 'numeric',
                                    year: 'numeric'
                                })}
                            </div>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{
                padding: '0',
                maxHeight: 'calc(75vh - 120px)',
                overflowY: 'auto',
                background: '#f8fafc'
            }}>
                <div style={{ padding: '12px' }}>
                    <Form>
                        {/* Today I Felt Section */}
                        <div style={{
                            marginBottom: '12px',
                            background: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            overflow: 'hidden',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div style={{
                                background: 'white',
                                borderBottom: '1px solid #e5e7eb',
                                padding: '12px 16px'
                            }}>
                                <h6 style={{
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    marginBottom: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    color: '#374151'
                                }}>
                                    <i className="ri-emotion-happy-line" style={{ fontSize: '16px', color: 'var(--bs-primary)' }}></i>
                                    Today I Felt
                                </h6>
                            </div>
                            <div style={{ padding: '16px' }}>
                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                    {getAvailableDailyReportFeelings().map((feeling) => {
                                        const isSelected = Number(dailyReportFormData.feeling_id) === Number(feeling.id);
                                        const isPositive = /happy|good|great|smile/i.test(feeling.name || '');
                                        const iconClass = isPositive ? 'ri-emotion-happy-line' : 'ri-emotion-unhappy-line';

                                        return (
                                            <div
                                                key={feeling.id}
                                                onClick={() => setDailyReportFormData({ ...dailyReportFormData, feeling_id: feeling.id })}
                                                style={{
                                                    flex: 1,
                                                    minWidth: '110px',
                                                    padding: '12px',
                                                    background: isSelected ? 'var(--bs-primary)' : 'white',
                                                    color: isSelected ? 'white' : '#6b7280',
                                                    borderRadius: '8px',
                                                    border: isSelected ? '2px solid var(--bs-primary)' : '2px solid #e5e7eb',
                                                    cursor: 'pointer',
                                                    textAlign: 'center',
                                                    transition: 'all 0.2s ease',
                                                    boxShadow: isSelected ? '0 2px 8px rgba(var(--bs-primary-rgb), 0.3)' : 'none'
                                                }}
                                            >
                                                <i className={iconClass} style={{ fontSize: '24px', display: 'block', marginBottom: '4px' }}></i>
                                                <div style={{ fontSize: '12px', fontWeight: '600' }}>{feeling.name}</div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>

                        {/* Today I Learned Section */}
                        <div style={{
                            marginBottom: '12px',
                            background: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            overflow: 'hidden',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div style={{
                                background: 'white',
                                borderBottom: '1px solid #e5e7eb',
                                padding: '12px 16px'
                            }}>
                                <h6 style={{
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    marginBottom: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    color: '#374151'
                                }}>
                                    <i className="ri-lightbulb-line" style={{ fontSize: '16px', color: 'var(--bs-primary)' }}></i>
                                    Today I Learned
                                </h6>
                            </div>
                            <div style={{ padding: '16px' }}>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '8px' }}>
                                    <Button
                                        variant="primary"
                                        className="ai-create-btn"
                                        onClick={() => openAIContentModalForField('dailyReportLearned')}
                                        style={{
                                            padding: '4px 10px',
                                            fontSize: '11px',
                                            fontWeight: '700'
                                        }}
                                    >
                                        <span className="material-symbols-outlined">auto_awesome</span>
                                        AI Creation
                                    </Button>
                                </div>
                                <Form.Control
                                    as="textarea"
                                    rows={5}
                                    value={dailyReportFormData.learned || ''}
                                    onChange={(e) => setDailyReportFormData({ ...dailyReportFormData, learned: e.target.value })}
                                    style={{
                                        fontSize: '12px',
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb',
                                        padding: '10px',
                                        minHeight: '140px',
                                        paddingBottom: '40px',
                                        fontFamily: 'inherit',
                                        transition: 'border-color 0.2s ease',
                                        resize: 'vertical'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = 'var(--bs-primary)'}
                                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                                />
                            </div>
                        </div>

                        {/* Diapers/Toilet Section */}
                        <div style={{
                            marginBottom: '12px',
                            background: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            overflow: 'hidden',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div style={{
                                background: 'white',
                                borderBottom: '1px solid #e5e7eb',
                                padding: '12px 16px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: '8px',
                                flexWrap: 'wrap'
                            }}>
                                <h6 style={{
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    marginBottom: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    color: '#374151'
                                }}>
                                    <i className="ri-parent-line" style={{ fontSize: '16px', color: 'var(--bs-primary)' }}></i>
                                    Diapers/Toilet
                                </h6>
                                <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={() => setDailyReportFormData({
                                        ...dailyReportFormData,
                                        diapers: [...dailyReportFormData.diapers, { diaper_time: '', diaper_check: 1 }]
                                    })}
                                    style={{
                                        fontSize: '11px',
                                        fontWeight: '600',
                                        borderRadius: '6px',
                                        padding: '5px 10px',
                                        border: 'none',
                                        background: 'var(--bs-primary)'
                                    }}
                                >
                                    <i className="ri-add-line me-1"></i>
                                    Add Entry
                                </Button>
                            </div>
                            <div style={{ padding: '16px' }}>

                                {dailyReportFormData.diapers.length > 0 ? (
                                    <div style={{
                                        background: '#f9fafb',
                                        padding: '12px',
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb'
                                    }}>
                                        <div style={{ overflowX: 'auto' }}>
                                            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 6px' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{
                                                            padding: '8px 10px',
                                                            fontSize: '11px',
                                                            fontWeight: '700',
                                                            color: '#374151',
                                                            background: 'white',
                                                            borderRadius: '8px 0 0 8px',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                        }}>Time</th>
                                                        <th style={{
                                                            padding: '8px 10px',
                                                            fontSize: '11px',
                                                            fontWeight: '700',
                                                            color: '#374151',
                                                            background: 'white',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                        }}>Check</th>
                                                        <th style={{
                                                            padding: '8px 10px',
                                                            fontSize: '11px',
                                                            fontWeight: '700',
                                                            color: '#374151',
                                                            background: 'white',
                                                            borderRadius: '0 8px 8px 0',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                        }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dailyReportFormData.diapers.map((diaper, index) => (
                                                        <tr key={index}>
                                                            <td style={{
                                                                padding: '8px 10px',
                                                                background: 'white',
                                                                borderRadius: '8px 0 0 8px',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                            }}>
                                                                <DatePicker
                                                                    selected={diaper.diaper_time ? Moment(diaper.diaper_time, 'HH:mm').toDate() : null}
                                                                    onChange={(time) => {
                                                                        const updatedDiapers = [...dailyReportFormData.diapers];
                                                                        updatedDiapers[index].diaper_time = time ? Moment(time).format('HH:mm') : '';
                                                                        setDailyReportFormData({ ...dailyReportFormData, diapers: updatedDiapers });
                                                                    }}
                                                                    showTimeSelect
                                                                    showTimeSelectOnly
                                                                    timeIntervals={15}
                                                                    timeCaption="Time"
                                                                    dateFormat="h:mm aa"
                                                                    minTime={attendanceSchoolHours?.minTime}
                                                                    maxTime={attendanceSchoolHours?.maxTime}
                                                                    placeholderText="Select time"
                                                                    className="form-control form-control-sm"
                                                                    style={{
                                                                        fontSize: '11px',
                                                                        border: '1px solid #e5e7eb',
                                                                        borderRadius: '6px',
                                                                        padding: '6px 8px',
                                                                        width: '100%'
                                                                    }}
                                                                />
                                                            </td>
                                                            <td style={{
                                                                padding: '8px 10px',
                                                                background: 'white',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                            }}>
                                                                <Form.Select
                                                                    size="sm"
                                                                    value={diaper.diaper_check}
                                                                    onChange={(e) => {
                                                                        const updatedDiapers = [...dailyReportFormData.diapers];
                                                                        updatedDiapers[index].diaper_check = parseInt(e.target.value);
                                                                        setDailyReportFormData({ ...dailyReportFormData, diapers: updatedDiapers });
                                                                    }}
                                                                    style={{
                                                                        fontSize: '11px',
                                                                        border: '1px solid #e5e7eb',
                                                                        borderRadius: '6px',
                                                                        padding: '6px 8px'
                                                                    }}
                                                                >
                                                                    <option value={1}>D/T</option>
                                                                    <option value={2}>Dry</option>
                                                                    <option value={3}>Wet</option>
                                                                    <option value={4}>BM</option>
                                                                </Form.Select>
                                                            </td>
                                                            <td style={{
                                                                padding: '8px 10px',
                                                                background: 'white',
                                                                borderRadius: '0 8px 8px 0',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                            }}>
                                                                <Button
                                                                    variant="outline-danger"
                                                                    size="sm"
                                                                    onClick={() => {
                                                                        const updatedDiapers = dailyReportFormData.diapers.filter((_, i) => i !== index);
                                                                        setDailyReportFormData({ ...dailyReportFormData, diapers: updatedDiapers });
                                                                    }}
                                                                    style={{
                                                                        fontSize: '10px',
                                                                        padding: '4px 8px',
                                                                        borderRadius: '6px',
                                                                        border: '1px solid #ef4444',
                                                                        color: '#ef4444'
                                                                    }}
                                                                >
                                                                    <i className="ri-delete-bin-line"></i>
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                ) : (
                                    <div style={{
                                        textAlign: 'center',
                                        padding: '25px 15px',
                                        color: '#6b7280',
                                        background: '#f9fafb',
                                        borderRadius: '10px',
                                        border: '2px dashed #d1d5db'
                                    }}>
                                        <i className="ri-parent-line" style={{ fontSize: '32px', opacity: 0.3, display: 'block', marginBottom: '8px' }}></i>
                                        <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '2px' }}>No diaper/toilet entries yet</div>
                                        <div style={{ fontSize: '11px', opacity: 0.7 }}>Click "Add Entry" to start tracking</div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Meals Section */}
                        <div style={{
                            marginBottom: '12px',
                            background: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            overflow: 'hidden',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div style={{
                                background: 'white',
                                borderBottom: '1px solid #e5e7eb',
                                padding: '12px 16px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <h6 style={{
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    marginBottom: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    color: '#374151'
                                }}>
                                    <i className="ri-restaurant-line" style={{ fontSize: '16px', color: 'var(--bs-primary)' }}></i>
                                    {dailyReportFormData.meals.length} Meal{dailyReportFormData.meals.length !== 1 ? 's' : ''}
                                </h6>
                                <span style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: '#6366f1',
                                    background: '#eef2ff',
                                    borderRadius: '999px',
                                    padding: '4px 10px'
                                }}>
                                    {getAvailableWeekMenuMeals().length > 0 ? `${getAvailableWeekMenuMeals().length} menu item${getAvailableWeekMenuMeals().length > 1 ? 's' : ''}` : 'No menu configured'}
                                </span>
                            </div>
                            {dailyReportFormData.meals.length > 0 ? (
                                <>
                                    <div style={{
                                        background: 'white',
                                        borderBottom: '1px solid #e5e7eb',
                                        overflowX: 'auto',
                                        whiteSpace: 'nowrap',
                                        padding: '0 16px',
                                        display: 'flex',
                                        alignItems: 'flex-end',
                                        gap: '0'
                                    }}>
                                        {getDailyReportFormMealTypeGroups(dailyReportFormData.meals, getAvailableWeekMenuMeals()).map((group, index) => {
                                            const isFilled = group.items.some((meal) => !!meal.meal_time && normalizeMealAmount(meal.meal_amount) > 0);
                                            const isActive = activeMealTab === index;
                                            return (
                                                <button
                                                    key={group.key}
                                                    type="button"
                                                    onClick={() => setActiveMealTab(index)}
                                                    style={{
                                                        border: 'none',
                                                        borderBottom: isActive ? '2px solid #e8601c' : '2px solid transparent',
                                                        background: 'transparent',
                                                        color: isActive ? '#e8601c' : '#6b7280',
                                                        fontSize: '13px',
                                                        fontWeight: isActive ? '700' : '500',
                                                        padding: '10px 14px',
                                                        cursor: 'pointer',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        whiteSpace: 'nowrap',
                                                        flexShrink: 0
                                                    }}
                                                >
                                                    <span>{group.mealTypeName}</span>
                                                    {isFilled && (
                                                        <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#22c55e', display: 'inline-block', flexShrink: 0 }}></span>
                                                    )}
                                                </button>
                                            );
                                        })}
                                    </div>

                                    {(() => {
                                        const mealTypeGroups = getDailyReportFormMealTypeGroups(dailyReportFormData.meals, getAvailableWeekMenuMeals());
                                        const groupIndex = Math.min(activeMealTab, mealTypeGroups.length - 1);
                                        const activeMealGroup = mealTypeGroups[groupIndex];
                                        if (!activeMealGroup) return null;

                                        // One time for the whole menu type, set here in the header -
                                        // it's applied to every item below instead of per item.
                                        const groupMealTime = activeMealGroup.items.find((item) => item.meal_time)?.meal_time || '';
                                        const applyGroupMealTime = (time) => {
                                            const newMealTime = time ? Moment(time).format('HH:mm') : '';
                                            const updatedMeals = [...dailyReportFormData.meals];
                                            activeMealGroup.items.forEach((groupItem) => {
                                                const groupItemIndex = typeof groupItem._formIndex === 'number' ? groupItem._formIndex : null;
                                                if (groupItemIndex !== null && updatedMeals[groupItemIndex]) {
                                                    updatedMeals[groupItemIndex] = { ...updatedMeals[groupItemIndex], meal_time: newMealTime };
                                                }
                                            });
                                            setDailyReportFormData({ ...dailyReportFormData, meals: updatedMeals });
                                        };

                                        return (
                                            <div style={{ padding: '20px 20px 16px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px', flexWrap: 'wrap' }}>
                                                    <div style={{ fontSize: '15px', fontWeight: '700', color: '#1f2937' }}>
                                                        {activeMealGroup.mealTypeName}
                                                    </div>
                                                    <span style={{
                                                        padding: '2px 8px',
                                                        borderRadius: '4px',
                                                        fontSize: '11px',
                                                        fontWeight: '700',
                                                        background: '#0ea5e9',
                                                        color: '#ffffff',
                                                        textTransform: 'uppercase'
                                                    }}>
                                                        Menu Type
                                                    </span>
                                                    <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <span style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Time:</span>
                                                        <DatePicker
                                                            selected={groupMealTime ? Moment(groupMealTime, 'HH:mm').toDate() : null}
                                                            onChange={applyGroupMealTime}
                                                            showTimeSelect
                                                            showTimeSelectOnly
                                                            timeIntervals={15}
                                                            timeCaption="Time"
                                                            dateFormat="h:mm aa"
                                                            minTime={attendanceSchoolHours?.minTime}
                                                            maxTime={attendanceSchoolHours?.maxTime}
                                                            placeholderText="Set time"
                                                            className="form-control form-control-sm"
                                                        />
                                                    </div>
                                                </div>

                                                <div style={{
                                                    border: '1px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    overflow: 'hidden'
                                                }}>
                                                    <div style={{ width: '100%', overflowX: 'auto' }}>
                                                        <table style={{ width: '100%', minWidth: '420px', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                                                        <thead>
                                                            <tr style={{ background: '#f8fafc' }}>
                                                                <th style={{ width: '35%', textAlign: 'left', fontSize: '12px', color: '#374151', padding: '10px 12px', borderBottom: '1px solid #e5e7eb' }}>Name</th>
                                                                <th style={{ width: '25%', textAlign: 'left', fontSize: '12px', color: '#374151', padding: '10px 12px', borderBottom: '1px solid #e5e7eb' }}>Time</th>
                                                                <th style={{ width: '40%', textAlign: 'left', fontSize: '12px', color: '#374151', padding: '10px 12px', borderBottom: '1px solid #e5e7eb' }}>Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {activeMealGroup.items.map((mealItem, itemIndex) => {
                                                                const mealIndex = typeof mealItem._formIndex === 'number' ? mealItem._formIndex : itemIndex;
                                                                const currentMeal = dailyReportFormData.meals[mealIndex] || mealItem;
                                                                const matchedWeekMeal = findWeekMealByIdOrName(getAvailableWeekMenuMeals(), currentMeal) || mealItem;
                                                                const mealName = currentMeal.menu_name || matchedWeekMeal.menu_name || matchedWeekMeal.name || 'Menu Item';
                                                                const normalizedAmount = normalizeMealAmount(currentMeal.meal_amount);

                                                                return (
                                                                    <tr key={`${activeMealGroup.key}_${currentMeal.menu_meal_id || matchedWeekMeal.id || itemIndex}`}>
                                                                        <td style={{ fontSize: '13px', color: '#111827', padding: '10px 12px', borderBottom: '1px solid #f1f5f9', verticalAlign: 'top' }}>
                                                                            <div style={{ fontWeight: '600' }}>{mealName}</div>
                                                                        </td>
                                                                        {/* Read-only - the time is set once for the whole menu
                                                                            type via the header control above. */}
                                                                        <td style={{ fontSize: '13px', color: '#6b7280', padding: '10px 12px', borderBottom: '1px solid #f1f5f9', verticalAlign: 'top' }}>
                                                                            {currentMeal.meal_time
                                                                                ? Moment(currentMeal.meal_time, ['HH:mm:ss', 'HH:mm']).format('h:mm A')
                                                                                : 'Not set'}
                                                                        </td>
                                                                        <td style={{ padding: '10px 12px', borderBottom: '1px solid #f1f5f9' }}>
                                                                            <input
                                                                                type="range"
                                                                                min={0}
                                                                                max={5}
                                                                                step={1}
                                                                                value={normalizedAmount}
                                                                                onChange={(e) => {
                                                                                    const updatedMeals = [...dailyReportFormData.meals];
                                                                                    updatedMeals[mealIndex] = { ...updatedMeals[mealIndex], meal_amount: parseInt(e.target.value, 10) || 0 };
                                                                                    setDailyReportFormData({ ...dailyReportFormData, meals: updatedMeals });
                                                                                }}
                                                                                style={{ width: '100%', accentColor: '#f59e0b' }}
                                                                            />
                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '10px', color: '#6b7280', marginTop: '4px', whiteSpace: 'nowrap' }}>
                                                                                {DAILY_REPORT_MEAL_AMOUNT_OPTIONS.map((option) => (
                                                                                    <span key={option.value}>{option.label}</span>
                                                                                ))}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })()}
                                </>
                            ) : (
                                <div style={{
                                    textAlign: 'center',
                                    padding: '25px 15px',
                                    color: '#6b7280',
                                    background: '#f9fafb',
                                    borderRadius: '10px',
                                    border: '2px dashed #d1d5db',
                                    margin: '16px'
                                }}>
                                    <i className="ri-restaurant-line" style={{ fontSize: '32px', opacity: 0.3, display: 'block', marginBottom: '8px' }}></i>
                                    <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '2px' }}>No meals available</div>
                                    <div style={{ fontSize: '11px', opacity: 0.7 }}>Menu items will appear here from the selected date's week menu.</div>
                                </div>
                            )}
                        </div>

                        {/* Sleep Section */}
                        <div style={{
                            marginBottom: '12px',
                            background: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            overflow: 'hidden',
                            border: '1px solid #e5e7eb'
                        }}>
                            {/* Section header */}
                            <div style={{
                                background: 'white',
                                borderBottom: '1px solid #e5e7eb',
                                padding: '12px 16px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <h6 style={{
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    marginBottom: '0',
                                    display: 'flex',
                                    gap: '8px',
                                    color: '#374151'
                                }}>
                                    <i className="ri-zzz-line" style={{ fontSize: '16px', color: 'var(--bs-primary)' }}></i>
                                    {dailyReportFormData.sleeps.length} Sleep{dailyReportFormData.sleeps.length !== 1 ? 's' : ''}
                                </h6>
                                <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={() => {
                                        const newSleeps = [...dailyReportFormData.sleeps, { start_time: '', end_time: '' }];
                                        setDailyReportFormData({ ...dailyReportFormData, sleeps: newSleeps });
                                    }}
                                    style={{
                                        fontSize: '11px',
                                        fontWeight: '600',
                                        borderRadius: '6px',
                                        padding: '5px 10px',
                                        border: 'none',
                                        background: 'var(--bs-primary)'
                                    }}
                                >
                                    <i className="ri-add-line me-1"></i>
                                    Add Sleep
                                </Button>
                            </div>

                            {dailyReportFormData.sleeps.length > 0 ? (
                                <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    {dailyReportFormData.sleeps.map((sleep, index) => {
                                        const bothFilled = sleep.start_time && sleep.end_time;
                                        let durationLabel = '';
                                        if (bothFilled) {
                                            const start = new Date(`2000-01-01T${sleep.start_time}`);
                                            const end = new Date(`2000-01-01T${sleep.end_time}`);
                                            const mins = Math.abs(end - start) / (1000 * 60);
                                            const h = Math.floor(mins / 60);
                                            const m = Math.floor(mins % 60);
                                            durationLabel = `${h > 0 ? `${h}h ` : ''}${m}m`;
                                        }

                                        return (
                                            <div key={index} style={{
                                                background: '#f9fafb',
                                                border: '1px solid #e5e7eb',
                                                borderRadius: '8px',
                                                padding: '10px'
                                            }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                                    <span style={{ fontSize: '12px', fontWeight: '700', color: '#374151' }}>Sleep {index + 1}</span>
                                                    <Button
                                                        variant="outline-danger"
                                                        size="sm"
                                                        onClick={() => {
                                                            const updatedSleeps = dailyReportFormData.sleeps.filter((_, i) => i !== index);
                                                            setDailyReportFormData({ ...dailyReportFormData, sleeps: updatedSleeps });
                                                        }}
                                                        style={{
                                                            fontSize: '10px',
                                                            padding: '2px 8px',
                                                            borderRadius: '6px',
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: '4px'
                                                        }}
                                                        title="Remove this sleep entry"
                                                    >
                                                        <i className="ri-delete-bin-line"></i>
                                                        Delete
                                                    </Button>
                                                </div>

                                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                                    <div style={{ flex: '1 1 220px' }}>
                                                        <div style={{ fontSize: '11px', fontWeight: '700', color: '#e8601c', marginBottom: '6px' }}>Sleep started</div>
                                                        <DatePicker
                                                            selected={sleep.start_time ? Moment(sleep.start_time, 'HH:mm').toDate() : null}
                                                            onChange={(time) => {
                                                                const updatedSleeps = [...dailyReportFormData.sleeps];
                                                                updatedSleeps[index] = { ...updatedSleeps[index], start_time: time ? Moment(time).format('HH:mm') : '' };
                                                                setDailyReportFormData({ ...dailyReportFormData, sleeps: updatedSleeps });
                                                            }}
                                                            showTimeSelect
                                                            showTimeSelectOnly
                                                            timeIntervals={15}
                                                            timeCaption="Time"
                                                            dateFormat="h:mm aa"
                                                            minTime={attendanceSchoolHours?.minTime}
                                                            maxTime={attendanceSchoolHours?.maxTime}
                                                            placeholderText="Select start time"
                                                            className="form-control form-control-sm"
                                                            wrapperClassName="w-100"
                                                        />
                                                    </div>

                                                    <div style={{ flex: '1 1 220px' }}>
                                                        <div style={{ fontSize: '11px', fontWeight: '700', color: '#e8601c', marginBottom: '6px' }}>Sleep ended</div>
                                                        <DatePicker
                                                            selected={sleep.end_time ? Moment(sleep.end_time, 'HH:mm').toDate() : null}
                                                            onChange={(time) => {
                                                                const updatedSleeps = [...dailyReportFormData.sleeps];
                                                                updatedSleeps[index] = { ...updatedSleeps[index], end_time: time ? Moment(time).format('HH:mm') : '' };
                                                                setDailyReportFormData({ ...dailyReportFormData, sleeps: updatedSleeps });
                                                            }}
                                                            showTimeSelect
                                                            showTimeSelectOnly
                                                            timeIntervals={15}
                                                            timeCaption="Time"
                                                            dateFormat="h:mm aa"
                                                            minTime={attendanceSchoolHours?.minTime}
                                                            maxTime={attendanceSchoolHours?.maxTime}
                                                            placeholderText="Select end time"
                                                            className="form-control form-control-sm"
                                                            wrapperClassName="w-100"
                                                        />
                                                    </div>
                                                </div>

                                                {bothFilled && (
                                                    <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center', gap: '6px', color: '#16a34a', fontSize: '12px', fontWeight: '500' }}>
                                                        <i className="ri-checkbox-circle-fill" style={{ fontSize: '14px' }}></i>
                                                        {durationLabel} from {Moment(sleep.start_time, 'HH:mm').format('h:mm A')} to {Moment(sleep.end_time, 'HH:mm').format('h:mm A')}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div style={{
                                    textAlign: 'center',
                                    padding: '25px 15px',
                                    color: '#6b7280',
                                    background: '#f9fafb',
                                    borderRadius: '10px',
                                    border: '2px dashed #d1d5db',
                                    margin: '16px'
                                }}>
                                    <i className="ri-zzz-line" style={{ fontSize: '32px', opacity: 0.3, display: 'block', marginBottom: '8px' }}></i>
                                    <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '2px' }}>No sleep entries yet</div>
                                    <div style={{ fontSize: '11px', opacity: 0.7 }}>Click "Add Sleep" to start tracking</div>
                                </div>
                            )}
                        </div>


                        {/* Please Bring More Section */}
                        <div style={{
                            marginBottom: '12px',
                            background: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            overflow: 'hidden',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div style={{
                                background: 'white',
                                borderBottom: '1px solid #e5e7eb',
                                padding: '12px 16px'
                            }}>
                                <h6 style={{
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    marginBottom: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    color: '#374151'
                                }}>
                                    <i className="ri-shopping-bag-line" style={{ fontSize: '16px', color: 'var(--bs-primary)' }}></i>
                                    Please Bring More
                                </h6>
                            </div>
                            <div style={{ padding: '16px' }}>
                                <Row>
                                    <Col md={6}>
                                        {[
                                            { key: 'bring_diapers', label: 'Diapers', icon: 'ri-parent-line' },
                                            { key: 'bring_ointment', label: 'Ointment', icon: 'ri-medicine-bottle-line' },
                                            { key: 'bring_blanket', label: 'Blanket', icon: 'ri-hotel-bed-line' }
                                        ].map((item) => (
                                            <div
                                                key={item.key}
                                                onClick={() => setDailyReportFormData({
                                                    ...dailyReportFormData,
                                                    [item.key]: !dailyReportFormData[item.key]
                                                })}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    padding: '8px',
                                                    background: dailyReportFormData[item.key] ? '#f3f4f6' : 'white',
                                                    color: '#374151',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    marginBottom: '6px',
                                                    border: dailyReportFormData[item.key] ? '2px solid var(--bs-primary)' : '1px solid #e5e7eb',
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                <div style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    borderRadius: '5px',
                                                    background: dailyReportFormData[item.key] ? 'var(--bs-primary)' : '#e5e7eb',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>
                                                    {dailyReportFormData[item.key] ? (
                                                        <i className="ri-check-line" style={{ fontSize: '13px', color: 'white' }}></i>
                                                    ) : (
                                                        <i className={item.icon} style={{ fontSize: '13px', color: '#9ca3af' }}></i>
                                                    )}
                                                </div>
                                                <span style={{ fontSize: '13px', fontWeight: '600', flex: 1 }}>{item.label}</span>
                                            </div>
                                        ))}
                                    </Col>
                                    <Col md={6}>
                                        {[
                                            { key: 'bring_wipes', label: 'Wipes', icon: 'ri-drop-line' },
                                            { key: 'bring_clothes', label: 'Clothes', icon: 'ri-shirt-line' }
                                        ].map((item) => (
                                            <div
                                                key={item.key}
                                                onClick={() => setDailyReportFormData({
                                                    ...dailyReportFormData,
                                                    [item.key]: !dailyReportFormData[item.key]
                                                })}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    padding: '8px',
                                                    background: dailyReportFormData[item.key] ? '#f3f4f6' : 'white',
                                                    color: '#374151',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    marginBottom: '6px',
                                                    border: dailyReportFormData[item.key] ? '2px solid var(--bs-primary)' : '1px solid #e5e7eb',
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                <div style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    borderRadius: '5px',
                                                    background: dailyReportFormData[item.key] ? 'var(--bs-primary)' : '#e5e7eb',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>
                                                    {dailyReportFormData[item.key] ? (
                                                        <i className="ri-check-line" style={{ fontSize: '13px', color: 'white' }}></i>
                                                    ) : (
                                                        <i className={item.icon} style={{ fontSize: '13px', color: '#9ca3af' }}></i>
                                                    )}
                                                </div>
                                                <span style={{ fontSize: '13px', fontWeight: '600', flex: 1 }}>{item.label}</span>
                                            </div>
                                        ))}
                                    </Col>
                                </Row>
                                <div style={{ marginTop: '10px' }}>
                                    <Form.Group>
                                        <Form.Label style={{ color: '#374151', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Other Item</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Specify other item..."
                                            value={dailyReportFormData.other_item}
                                            onChange={(e) => setDailyReportFormData({ ...dailyReportFormData, other_item: e.target.value })}
                                            style={{
                                                fontSize: '12px',
                                                borderRadius: '8px',
                                                border: '1px solid #e0e0e0',
                                                padding: '8px',
                                                fontFamily: 'inherit',
                                                transition: 'border-color 0.2s ease'
                                            }}
                                            onFocus={(e) => e.target.style.borderColor = '#f59e0b'}
                                            onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                        </div>

                        {/* Comments Section */}
                        <div style={{
                            marginBottom: '12px',
                            background: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            overflow: 'hidden',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div style={{
                                background: 'white',
                                borderBottom: '1px solid #e5e7eb',
                                padding: '12px 16px'
                            }}>
                                <h6 style={{
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    marginBottom: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    color: '#374151'
                                }}>
                                    <i className="ri-chat-3-line" style={{ fontSize: '16px', color: 'var(--bs-primary)' }}></i>
                                    Comments
                                </h6>
                            </div>
                            <div style={{ padding: '16px' }}>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '8px' }}>
                                    <Button
                                        variant="primary"
                                        className="ai-create-btn"
                                        onClick={() => openAIContentModalForField('dailyReportComments')}
                                        style={{
                                            padding: '4px 10px',
                                            fontSize: '11px',
                                            fontWeight: '700'
                                        }}
                                    >
                                        <span className="material-symbols-outlined">auto_awesome</span>
                                        AI Creation
                                    </Button>
                                </div>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    placeholder="Additional comments..."
                                    value={dailyReportFormData.comments}
                                    onChange={(e) => setDailyReportFormData({ ...dailyReportFormData, comments: e.target.value })}
                                    style={{
                                        fontSize: '12px',
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb',
                                        padding: '10px',
                                        fontFamily: 'inherit',
                                        transition: 'border-color 0.2s ease',
                                        resize: 'vertical'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = 'var(--bs-primary)'}
                                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                                />
                            </div>
                        </div>
                    </Form>
                </div>
            </Modal.Body>
            <Modal.Footer style={{
                borderTop: '2px solid #f0f0f0',
                padding: '12px 16px',
                background: 'white',
                display: 'flex',
                gap: '10px',
                position: 'sticky',
                bottom: 0,
                zIndex: 10,
                justifyContent: 'flex-end',
                flexWrap: 'wrap'
            }}>
                {!(
                    isEditingDailyReport &&
                    getDailyReportPublishStatusLabel(
                        currentDailyReportData?.status ?? selectedStudent?.daily_report_status
                    ) === 'published'
                ) && (
                    <Button
                        variant="outline-warning"
                        onClick={() => saveDailyReport(true)}
                        disabled={savingDailyReport}
                        style={{
                            borderRadius: '8px',
                            padding: '10px 20px',
                            fontSize: '13px',
                            fontWeight: '600',
                            border: '2px solid #f59e0b',
                            color: '#f59e0b',
                            background: 'white',
                            minWidth: '140px'
                        }}
                    >
                        <i className="ri-draft-line me-1" style={{ fontSize: '14px' }}></i>
                        {savingDailyReport ? 'Saving...' : 'Save as Draft'}
                    </Button>
                )}
                <Button
                    variant="primary"
                    onClick={() => saveDailyReport(false)}
                    disabled={savingDailyReport}
                    style={{
                        borderRadius: '8px',
                        padding: '10px 24px',
                        fontSize: '13px',
                        fontWeight: '600',
                        minWidth: '140px'
                    }}
                >
                    <i className="ri-send-plane-fill me-1" style={{ fontSize: '14px' }}></i>
                    {savingDailyReport ? 'Saving...' : (isEditingDailyReport ? 'Publish Report' : 'Publish Report')}
                </Button>
            </Modal.Footer>
        </Modal>
    );

    const renderMedicationModal = () => (
        <Modal show={showMedicationModal} onHide={() => { setShowMedicationModal(false); setSelectedMedicationRecordId(null); }} size="xl" centered
            style={{ marginTop: "30px" }}>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#111827',
                    lineHeight: '1.3',
                    width: '100%',
                    maxWidth: 'calc(100% - 40px)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <i className="ri-medicine-bottle-line" style={{ fontSize: '20px', color: '#6366f1' }}></i>
                            <div>
                                <div style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>
                                    Medication Overview
                                </div>
                                <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: '500' }}>
                                    {medicationData?.first_name} {medicationData?.last_name}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '16px', background: '#f9fafb', maxHeight: '65vh', overflowY: 'auto' }}>
                {selectedMedicationRecordId === null ? (
                    <MedicationRecordList records={medicationRecords} onSelect={selectMedicationRecord} />
                ) : medicationData ? (
                    <Row>
                        <Col md={12}>
                            {medicationRecords.length > 1 && (
                                <Button variant="outline-secondary" size="sm" className="mb-3"
                                    onClick={() => setSelectedMedicationRecordId(null)}>
                                    <i className="ri-arrow-left-line me-1"></i> Back to list
                                </Button>
                            )}
                            <Card style={{
                                borderRadius: '8px',
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                marginBottom: '16px',
                                background: 'white'
                            }}>
                                <Card.Header style={{
                                    background: 'white',
                                    borderBottom: '1px solid #e5e7eb',
                                    borderRadius: '8px 8px 0 0',
                                    padding: '12px 16px',
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    color: '#374151'
                                }}>
                                    <i className="ri-medicine-bottle-fill me-2" style={{ color: '#6366f1' }}></i>
                                    Medication Information
                                </Card.Header>
                                <Card.Body style={{ padding: '16px' }}>
                                    <Row>
                                        <Col md={6}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Student Name
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {medicationData.first_name} {medicationData.last_name}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Parent Name
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {medicationData.parent_name || 'N/A'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Medication Name
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: 'var(--bs-primary)' }}>
                                                    {medicationData.medication_name || 'Not specified'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Times to be Administered
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {medicationData.times_to_be_administered || 'Not specified'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Date Range
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {formatDisplayDate(medicationData.date_start)} to {formatDisplayDate(medicationData.date_end)}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Expiry Date
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {formatDisplayDate(medicationData.expiry_date)}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Reason for Administering
                                                </div>
                                                <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>
                                                    {medicationData.reason_for_administering || 'No reason specified'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Parent's Consent & Instructions
                                                </div>
                                                <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>
                                                    {medicationData.parents_consent_and_instruction || 'No instructions provided'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Additional Instructions
                                                </div>
                                                <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>
                                                    {medicationData.additional_instructions || 'No additional instructions'}
                                                </div>
                                            </div>
                                            {medicationData.signiture_of_parent && medicationData.signiture_of_parent !== 'null' && medicationData.signiture_of_parent !== '' && (
                                                <div style={{ marginBottom: '15px' }}>
                                                    <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                        Parent Signature
                                                    </div>
                                                    <img 
                                                        src={medicationData.signiture_of_parent} 
                                                        alt="Parent Signature" 
                                                        onError={(e) => { e.target.style.display = 'none'; }}
                                                        style={{ maxWidth: '200px', maxHeight: '100px', border: '1px solid #dee2e6', borderRadius: '4px', padding: '8px', background: 'white', display: 'block' }}
                                                    />
                                                    <div style={{ fontSize: '12px', color: '#999', marginTop: '4px' }}>
                                                        Signed on: {medicationData.signature_date}
                                                    </div>
                                                </div>
                                            )}
                                            {medicationData.doctor_note && (
                                                <div style={{ marginBottom: '15px' }}>
                                                    <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                        Doctor's Note
                                                    </div>
                                                    <a href={medicationData.doctor_note} target="_blank" rel="noopener noreferrer" style={{ fontSize: '13px', color: 'var(--bs-primary)' }}>
                                                        <i className="ri-file-text-line me-1"></i>
                                                        View Doctor's Note
                                                    </a>
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12}>
                            <Card style={{
                                borderRadius: '12px',
                                border: 'none',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                            }}>
                                <Card.Header style={{
                                    background: 'linear-gradient(135deg, var(--bs-primary) 0%, var(--bs-primary) 100%)',
                                    color: 'white',
                                    borderRadius: '12px 12px 0 0',
                                    padding: '16px 20px',
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}>
                                    <span>
                                        <i className="ri-file-list-line me-2"></i>
                                        Medication Log
                                    </span>
                                    <Button
                                        variant="light"
                                        size="sm"
                                        onClick={() => {
                                            setIsEditingMedicationLog(false);
                                            setMedicationLogData({
                                                medication_date: new Date().toISOString().split('T')[0],
                                                medication: medicationData.medication_name || '',
                                                is_dosage_given: 1,
                                                time_given: new Date().toTimeString().slice(0, 5),
                                                staff_signiture: '',
                                                comments: ''
                                            });
                                            if (medicationSignaturePadRef.current) {
                                                medicationSignaturePadRef.current.clear();
                                            }
                                            setShowMedicationLogFormModal(true);
                                        }}
                                        style={{
                                            borderRadius: '8px',
                                            fontWeight: '600',
                                            padding: '6px 16px'
                                        }}
                                    >
                                        <i className="ri-add-line me-1"></i>
                                        Add Log Entry
                                    </Button>
                                </Card.Header>
                                <Card.Body style={{ padding: '0' }}>
                                    {medicationLogs && medicationLogs.length > 0 ? (
                                        <div style={{ overflowX: 'auto' }}>
                                            <Table hover style={{ margin: 0 }}>
                                                <thead style={{
                                                    background: '#f8f9fa',
                                                    borderBottom: '2px solid #dee2e6'
                                                }}>
                                                    <tr>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Date</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Medication</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Dosage Given</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Time</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Staff Signature</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Comments</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333', textAlign: 'center' }}>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {medicationLogs.map((log, index) => (
                                                        <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                            <td style={{ padding: '16px', color: '#333' }}>
                                                                {formatDisplayDate(log.medication_date)}
                                                            </td>
                                                            <td style={{ padding: '16px', color: '#333', fontWeight: '600' }}>
                                                                {log.medication || 'N/A'}
                                                            </td>
                                                            <td style={{ padding: '16px', textAlign: 'center' }}>
                                                                <span style={{
                                                                    padding: '4px 12px',
                                                                    borderRadius: '12px',
                                                                    fontSize: '12px',
                                                                    fontWeight: '600',
                                                                    background: log.is_dosage_given === 1 || log.is_dosage_given === '1' ? '#d1fae5' : '#fee2e2',
                                                                    color: log.is_dosage_given === 1 || log.is_dosage_given === '1' ? '#065f46' : '#991b1b'
                                                                }}>
                                                                    {log.is_dosage_given === 1 || log.is_dosage_given === '1' ? 'Yes' : 'No'}
                                                                </span>
                                                            </td>
                                                            <td style={{ padding: '16px', color: '#333' }}>
                                                                {log.time_given ? Moment(log.time_given, 'HH:mm:ss').format('h:mm A') : 'N/A'}
                                                            </td>
                                                            <td style={{ padding: '16px', color: '#333' }}>
                                                                {log.staff_signiture ? (
                                                                    <img 
                                                                        src={log.staff_signiture} 
                                                                        alt="Staff Signature" 
                                                                        style={{ maxWidth: '80px', maxHeight: '40px' }}
                                                                    />
                                                                ) : 'N/A'}
                                                            </td>
                                                            <td style={{ padding: '16px', color: '#666', maxWidth: '200px' }}>
                                                                {log.comments && log.comments.length > 40
                                                                    ? `${log.comments.substring(0, 40)}...`
                                                                    : log.comments || '-'
                                                                }
                                                            </td>
                                                            <td style={{ padding: '16px', textAlign: 'center' }}>
                                                                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                                                    <Button
                                                                        variant="outline-primary"
                                                                        size="sm"
                                                                        onClick={() => {
                                                                            setSelectedMedicationLog(log);
                                                                            setShowMedicationLogViewModal(true);
                                                                        }}
                                                                        style={{ borderRadius: '6px' }}
                                                                        title="View Log"
                                                                    >
                                                                        <i className="ri-eye-line"></i>
                                                                    </Button>
                                                                    <Button
                                                                        variant="outline-success"
                                                                        size="sm"
                                                                        onClick={() => editMedicationLog(log)}
                                                                        style={{ borderRadius: '6px' }}
                                                                        title="Edit Log"
                                                                    >
                                                                        <i className="ri-edit-line"></i>
                                                                    </Button>
                                                                    <Button
                                                                        variant="outline-danger"
                                                                        size="sm"
                                                                        onClick={() => deleteMedicationLog(log.id, medicationData.medication_id || medicationData.id)}
                                                                        style={{ borderRadius: '6px' }}
                                                                        title="Delete Log"
                                                                    >
                                                                        <i className="ri-delete-bin-line"></i>
                                                                    </Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    ) : (
                                        <div style={{
                                            padding: '40px',
                                            textAlign: 'center',
                                            color: '#666'
                                        }}>
                                            <i className="ri-medicine-bottle-line" style={{ fontSize: '48px', color: '#ccc', marginBottom: '16px' }}></i>
                                            <p style={{ fontSize: '16px', marginBottom: '8px' }}>No medication logs found</p>
                                            <p style={{ fontSize: '14px', color: '#999' }}>
                                                Click "Add Log Entry" to record medication administration
                                            </p>
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                ) : (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <i className="ri-medicine-bottle-line" style={{ fontSize: '48px', color: '#ccc', marginBottom: '16px' }}></i>
                        <p>No medication data available</p>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );

    const renderMedicationLogFormModal = () => (
        <Modal show={showMedicationLogFormModal} onHide={() => {
            setShowMedicationLogFormModal(false);
            setIsEditingMedicationLog(false);
            if (medicationSignaturePadRef.current) {
                medicationSignaturePadRef.current.clear();
            }
        }} centered
            style={{ marginTop: "30px" }}>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '15px',
                    fontWeight: '700',
                    color: '#111827'
                }}>
                    <i className={isEditingMedicationLog ? "ri-edit-line me-2" : "ri-add-circle-line me-2"} style={{ fontSize: '16px', color: '#6366f1' }}></i>
                    {isEditingMedicationLog ? 'Edit Medication Log' : 'Add Medication Log'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px', background: 'white' }}>
                <Form>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: '600', color: '#374151', marginBottom: '6px', fontSize: '13px' }}>
                                    <span style={{ color: '#dc3545' }}>* </span>Medication Date
                                </Form.Label>
                                <DatePicker
                                    selected={medicationLogData.medication_date ? Moment(medicationLogData.medication_date).toDate() : null}
                                    onChange={(date) => setMedicationLogData({
                                        ...medicationLogData,
                                        medication_date: date ? Moment(date).format('YYYY-MM-DD') : ''
                                    })}
                                    dateFormat="MMM d yyyy"
                                    placeholderText="Dec 17 2025"
                                    className="form-control"
                                    required
                                    style={{
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb',
                                        padding: '10px 12px',
                                        fontSize: '13px',
                                        width: '100%'
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: '600', color: '#374151', marginBottom: '6px', fontSize: '13px' }}>
                                    Time Given
                                </Form.Label>
                                <DatePicker
                                    selected={medicationLogData.time_given ? Moment(medicationLogData.time_given, 'HH:mm').toDate() : null}
                                    onChange={(time) => setMedicationLogData({
                                        ...medicationLogData,
                                        time_given: time ? Moment(time).format('HH:mm') : ''
                                    })}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={15}
                                    timeCaption="Time"
                                    dateFormat="h:mm aa"
                                    placeholderText="2:30 PM"
                                    className="form-control"
                                    style={{
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb',
                                        padding: '10px 12px',
                                        fontSize: '13px',
                                        width: '100%'
                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: '#374151', marginBottom: '6px', fontSize: '13px' }}>
                            <span style={{ color: '#dc3545' }}>* </span>Medication
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter medication name"
                            value={medicationLogData.medication}
                            onChange={(e) => setMedicationLogData({
                                ...medicationLogData,
                                medication: e.target.value
                            })}
                            required
                            style={{
                                borderRadius: '6px',
                                border: '1px solid #e5e7eb',
                                padding: '10px 12px',
                                fontSize: '13px'
                            }}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                            <span style={{ color: '#dc3545' }}>* </span>Is Dosage Given?
                        </Form.Label>
                        <div style={{ display: 'flex', gap: '20px', padding: '12px 0' }}>
                            <Form.Check
                                type="radio"
                                label="Yes"
                                name="is_dosage_given"
                                checked={medicationLogData.is_dosage_given === 1 || medicationLogData.is_dosage_given === '1'}
                                onChange={() => setMedicationLogData({
                                    ...medicationLogData,
                                    is_dosage_given: 1
                                })}
                                style={{ fontSize: '14px', fontWeight: '500' }}
                            />
                            <Form.Check
                                type="radio"
                                label="No"
                                name="is_dosage_given"
                                checked={medicationLogData.is_dosage_given === 0 || medicationLogData.is_dosage_given === '0'}
                                onChange={() => setMedicationLogData({
                                    ...medicationLogData,
                                    is_dosage_given: 0
                                })}
                                style={{ fontSize: '14px', fontWeight: '500' }}
                            />
                        </div>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                            Staff Signature (Optional)
                        </Form.Label>
                        {medicationLogData.staff_signiture && medicationLogData.staff_signiture !== 'null' && medicationLogData.staff_signiture !== '' ? (
                            <div className="mb-2">
                                <img 
                                    src={medicationLogData.staff_signiture} 
                                    alt="Existing Signature" 
                                    style={{ 
                                        maxWidth: '200px', 
                                        maxHeight: '80px',
                                        border: '1px solid #e9ecef',
                                        borderRadius: '8px',
                                        padding: '8px',
                                        background: 'white'
                                    }}
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                />
                                <div className="text-muted small mt-1">Existing signature (will be replaced if you draw a new one)</div>
                            </div>
                        ) : null}
                        <div style={{ 
                            border: '2px solid #e9ecef', 
                            borderRadius: '8px', 
                            padding: '8px', 
                            background: 'white',
                            marginBottom: '8px'
                        }}>
                            <SignatureCanvas
                                ref={medicationSignaturePadRef}
                                canvasProps={{
                                    style: { 
                                        width: '100%', 
                                        height: '150px',
                                        border: '1px dashed #dee2e6',
                                        borderRadius: '4px'
                                    }
                                }}
                            />
                        </div>
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => {
                                if (medicationSignaturePadRef.current) {
                                    medicationSignaturePadRef.current.clear();
                                }
                            }}
                            type="button"
                            style={{ borderRadius: '6px' }}
                        >
                            <i className="ri-eraser-line me-1"></i>
                            Clear Signature
                        </Button>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                            Comments (Optional)
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Any additional comments or observations"
                            value={medicationLogData.comments}
                            onChange={(e) => setMedicationLogData({
                                ...medicationLogData,
                                comments: e.target.value
                            })}
                            style={{
                                borderRadius: '8px',
                                border: '2px solid #e9ecef',
                                padding: '12px 16px',
                                fontSize: '14px'
                            }}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer style={{
                borderTop: 'none',
                padding: '16px 24px',
                background: '#fafbfc'
            }}>
                <Button
                    variant="secondary"
                    onClick={() => {
                        setShowMedicationLogFormModal(false);
                        setIsEditingMedicationLog(false);
                        if (medicationSignaturePadRef.current) {
                            medicationSignaturePadRef.current.clear();
                        }
                    }}
                    style={{
                        borderRadius: '8px',
                        padding: '8px 20px',
                        fontSize: '14px',
                        fontWeight: '500'
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={saveMedicationLog}
                    disabled={isLoadingLogs}
                    style={{
                        borderRadius: '8px',
                        padding: '8px 20px',
                        fontSize: '14px',
                        fontWeight: '600'
                    }}
                >
                    {isLoadingLogs ? (
                        <>
                            <i className="ri-loader-4-line ri-spin me-2"></i>
                            Saving...
                        </>
                    ) : (
                        <>
                            <i className="ri-save-line me-2"></i>
                            Save Log Entry
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );

    // Render Non-Medication Log Form Modal
    const renderNonMedicationLogFormModal = () => (
        <Modal show={showNonMedicationLogFormModal} onHide={() => {
            setShowNonMedicationLogFormModal(false);
            setIsEditingNonMedicationLog(false);
            if (nonMedicationSignaturePadRef.current) {
                nonMedicationSignaturePadRef.current.clear();
            }
        }} centered style={{ marginTop: "30px" }}>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '15px',
                    fontWeight: '700',
                    color: '#111827'
                }}>
                    <i className={isEditingNonMedicationLog ? "ri-edit-line me-2" : "ri-add-circle-line me-2"} style={{ fontSize: '16px', color: '#10b981' }}></i>
                    {isEditingNonMedicationLog ? 'Edit Non-Medication Log' : 'Add Non-Medication Log'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px', background: 'white' }}>
                <Form>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: '600', color: '#374151', marginBottom: '6px', fontSize: '13px' }}>
                                    <span style={{ color: '#dc3545' }}>* </span>Medication Date
                                </Form.Label>
                                <DatePicker
                                    selected={nonMedicationLogData.medication_date ? Moment(nonMedicationLogData.medication_date).toDate() : null}
                                    onChange={(date) => setNonMedicationLogData({
                                        ...nonMedicationLogData,
                                        medication_date: date ? Moment(date).format('YYYY-MM-DD') : ''
                                    })}
                                    dateFormat="MMM d yyyy"
                                    placeholderText="Dec 17 2025"
                                    className="form-control"
                                    required
                                    style={{
                                        borderRadius: '6px',
                                        border: '1px solid #e5e7eb',
                                        padding: '10px 12px',
                                        fontSize: '13px',
                                        width: '100%'
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: '600', color: '#374151', marginBottom: '6px', fontSize: '13px' }}>
                                    Time Given
                                </Form.Label>
                                <DatePicker
                                    selected={nonMedicationLogData.time_given ? Moment(nonMedicationLogData.time_given, 'HH:mm').toDate() : null}
                                    onChange={(time) => setNonMedicationLogData({
                                        ...nonMedicationLogData,
                                        time_given: time ? Moment(time).format('HH:mm') : ''
                                    })}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={15}
                                    timeCaption="Time"
                                    dateFormat="h:mm aa"
                                    placeholderText="2:30 PM"
                                    className="form-control"
                                    style={{
                                        borderRadius: '8px',
                                        border: '2px solid #e9ecef',
                                        padding: '12px 16px',
                                        fontSize: '14px',
                                        width: '100%'
                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                            <span style={{ color: '#dc3545' }}>* </span>Medication
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter medication name"
                            value={nonMedicationLogData.medication}
                            onChange={(e) => setNonMedicationLogData({
                                ...nonMedicationLogData,
                                medication: e.target.value
                            })}
                            required
                            style={{
                                borderRadius: '8px',
                                border: '2px solid #e9ecef',
                                padding: '12px 16px',
                                fontSize: '14px'
                            }}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                            <span style={{ color: '#dc3545' }}>* </span>Is Dosage Given?
                        </Form.Label>
                        <div style={{ display: 'flex', gap: '20px', padding: '12px 0' }}>
                            <Form.Check
                                type="radio"
                                label="Yes"
                                name="is_dosage_given_non_med"
                                checked={nonMedicationLogData.is_dosage_given === 1 || nonMedicationLogData.is_dosage_given === '1'}
                                onChange={() => setNonMedicationLogData({
                                    ...nonMedicationLogData,
                                    is_dosage_given: 1
                                })}
                                style={{ fontSize: '14px', fontWeight: '500' }}
                            />
                            <Form.Check
                                type="radio"
                                label="No"
                                name="is_dosage_given_non_med"
                                checked={nonMedicationLogData.is_dosage_given === 0 || nonMedicationLogData.is_dosage_given === '0'}
                                onChange={() => setNonMedicationLogData({
                                    ...nonMedicationLogData,
                                    is_dosage_given: 0
                                })}
                                style={{ fontSize: '14px', fontWeight: '500' }}
                            />
                        </div>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                            Staff Signature (Optional)
                        </Form.Label>
                        {nonMedicationLogData.staff_signiture && nonMedicationLogData.staff_signiture !== 'null' && nonMedicationLogData.staff_signiture !== '' ? (
                            <div className="mb-2">
                                <img 
                                    src={nonMedicationLogData.staff_signiture} 
                                    alt="Existing Signature" 
                                    style={{ 
                                        maxWidth: '200px', 
                                        maxHeight: '80px',
                                        border: '1px solid #e9ecef',
                                        borderRadius: '8px',
                                        padding: '8px',
                                        background: 'white'
                                    }}
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                />
                                <div className="text-muted small mt-1">Existing signature (will be replaced if you draw a new one)</div>
                            </div>
                        ) : null}
                        <div style={{ 
                            border: '2px solid #e9ecef', 
                            borderRadius: '8px', 
                            padding: '8px', 
                            background: 'white',
                            marginBottom: '8px'
                        }}>
                            <SignatureCanvas
                                ref={nonMedicationSignaturePadRef}
                                canvasProps={{
                                    style: { 
                                        width: '100%', 
                                        height: '150px',
                                        border: '1px dashed #dee2e6',
                                        borderRadius: '4px'
                                    }
                                }}
                            />
                        </div>
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => {
                                if (nonMedicationSignaturePadRef.current) {
                                    nonMedicationSignaturePadRef.current.clear();
                                }
                            }}
                            type="button"
                            style={{ borderRadius: '6px' }}
                        >
                            <i className="ri-eraser-line me-1"></i>
                            Clear Signature
                        </Button>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                            Comments (Optional)
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Any additional comments or observations"
                            value={nonMedicationLogData.comments}
                            onChange={(e) => setNonMedicationLogData({
                                ...nonMedicationLogData,
                                comments: e.target.value
                            })}
                            style={{
                                borderRadius: '8px',
                                border: '2px solid #e9ecef',
                                padding: '12px 16px',
                                fontSize: '14px'
                            }}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer style={{
                borderTop: 'none',
                padding: '16px 24px',
                background: '#fafbfc'
            }}>
                <Button
                    variant="secondary"
                    onClick={() => {
                        setShowNonMedicationLogFormModal(false);
                        setIsEditingNonMedicationLog(false);
                        if (nonMedicationSignaturePadRef.current) {
                            nonMedicationSignaturePadRef.current.clear();
                        }
                    }}
                    style={{
                        borderRadius: '8px',
                        padding: '8px 20px',
                        fontSize: '14px',
                        fontWeight: '500'
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={saveNonMedicationLog}
                    disabled={isLoadingLogs}
                    style={{
                        borderRadius: '8px',
                        padding: '8px 20px',
                        fontSize: '14px',
                        fontWeight: '600'
                    }}
                >
                    {isLoadingLogs ? (
                        <>
                            <i className="ri-loader-4-line ri-spin me-2"></i>
                            Saving...
                        </>
                    ) : (
                        <>
                            <i className="ri-save-line me-2"></i>
                            Save Log Entry
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );

    const renderMedicationLogViewModal = () => (
        <Modal show={showMedicationLogViewModal} onHide={() => setShowMedicationLogViewModal(false)} centered
            style={{ marginTop: "50px" }}>
            <Modal.Header closeButton style={{
                borderBottom: '3px solid var(--bs-primary)',
                padding: '16px 24px',
                background: 'linear-gradient(135deg, var(--bs-primary) 0%, var(--bs-primary) 100%)'
            }}>
                <Modal.Title style={{
                    fontSize: '20px',
                    fontWeight: '800',
                    color: 'white',
                    textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                    <i className="ri-file-text-line me-3"></i>
                    Medication Log Details
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '24px', background: '#fafbfc' }}>
                {selectedMedicationLog ? (
                    <div>
                        <Row className="mb-3">
                            <Col sm={4}>
                                <strong style={{ color: '#333', fontSize: '14px' }}>Medication Date:</strong>
                            </Col>
                            <Col sm={8}>
                                <span style={{ color: '#666' }}>
                                    {formatDisplayDate(selectedMedicationLog.medication_date)}
                                </span>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col sm={4}>
                                <strong style={{ color: '#333', fontSize: '14px' }}>Medication:</strong>
                            </Col>
                            <Col sm={8}>
                                <span style={{ color: '#666', fontWeight: '600' }}>
                                    {selectedMedicationLog.medication || 'N/A'}
                                </span>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col sm={4}>
                                <strong style={{ color: '#333', fontSize: '14px' }}>Dosage Given:</strong>
                            </Col>
                            <Col sm={8}>
                                <span style={{
                                    padding: '4px 12px',
                                    borderRadius: '12px',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    background: selectedMedicationLog.is_dosage_given === 1 || selectedMedicationLog.is_dosage_given === '1' ? '#d1fae5' : '#fee2e2',
                                    color: selectedMedicationLog.is_dosage_given === 1 || selectedMedicationLog.is_dosage_given === '1' ? '#065f46' : '#991b1b',
                                    display: 'inline-block'
                                }}>
                                    {selectedMedicationLog.is_dosage_given === 1 || selectedMedicationLog.is_dosage_given === '1' ? 'Yes' : 'No'}
                                </span>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col sm={4}>
                                <strong style={{ color: '#333', fontSize: '14px' }}>Time Given:</strong>
                            </Col>
                            <Col sm={8}>
                                <span style={{ color: '#666' }}>
                                    {selectedMedicationLog.time_given ? Moment(selectedMedicationLog.time_given, 'HH:mm:ss').format('h:mm A') : 'N/A'}
                                </span>
                            </Col>
                        </Row>
                        {selectedMedicationLog.staff_signiture && selectedMedicationLog.staff_signiture !== 'null' && selectedMedicationLog.staff_signiture !== '' && (
                            <Row className="mb-3">
                                <Col sm={4}>
                                    <strong style={{ color: '#333', fontSize: '14px' }}>Staff Signature:</strong>
                                </Col>
                                <Col sm={8}>
                                    <img 
                                        src={selectedMedicationLog.staff_signiture} 
                                        alt="Staff Signature" 
                                        onError={(e) => { e.target.style.display = 'none'; }}
                                        style={{ maxWidth: '150px', maxHeight: '75px', border: '1px solid #dee2e6', borderRadius: '4px', padding: '4px', background: 'white', display: 'block' }}
                                    />
                                </Col>
                            </Row>
                        )}
                        {selectedMedicationLog.comments && (
                            <Row className="mb-3">
                                <Col sm={4}>
                                    <strong style={{ color: '#333', fontSize: '14px' }}>Comments:</strong>
                                </Col>
                                <Col sm={8}>
                                    <span style={{ color: '#666' }}>
                                        {selectedMedicationLog.comments}
                                    </span>
                                </Col>
                            </Row>
                        )}
                        <Row className="mb-3">
                            <Col sm={4}>
                                <strong style={{ color: '#333', fontSize: '14px' }}>Recorded On:</strong>
                            </Col>
                            <Col sm={8}>
                                <span style={{ color: '#666' }}>
                                    {selectedMedicationLog.created_at
                                        ? `${formatDisplayDate(selectedMedicationLog.created_at)} ${formatDisplayTime(selectedMedicationLog.created_at)}`
                                        : 'Not available'
                                    }
                                </span>
                            </Col>
                        </Row>
                    </div>
                ) : (
                    <p>No log details available</p>
                )}
            </Modal.Body>
        </Modal>
    );

    const renderNonMedicationLogViewModal = () => (
        <Modal show={showNonMedicationLogViewModal} onHide={() => setShowNonMedicationLogViewModal(false)} centered
            style={{ marginTop: "50px" }}>
            <Modal.Header closeButton style={{
                borderBottom: '3px solid var(--bs-primary)',
                padding: '16px 24px',
                background: 'linear-gradient(135deg, var(--bs-primary) 0%, var(--bs-primary) 100%)'
            }}>
                <Modal.Title style={{
                    fontSize: '20px',
                    fontWeight: '800',
                    color: 'white',
                    textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                    <i className="ri-file-text-line me-3"></i>
                    Non-Medication Log Details
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '24px', background: '#fafbfc' }}>
                {selectedNonMedicationLog ? (
                    <div>
                        <Row className="mb-3">
                            <Col sm={4}>
                                <strong style={{ color: '#333', fontSize: '14px' }}>Medication Date:</strong>
                            </Col>
                            <Col sm={8}>
                                <span style={{ color: '#666' }}>
                                    {formatDisplayDate(selectedNonMedicationLog.medication_date)}
                                </span>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col sm={4}>
                                <strong style={{ color: '#333', fontSize: '14px' }}>Medication:</strong>
                            </Col>
                            <Col sm={8}>
                                <span style={{ color: '#666', fontWeight: '600' }}>
                                    {selectedNonMedicationLog.medication || 'N/A'}
                                </span>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col sm={4}>
                                <strong style={{ color: '#333', fontSize: '14px' }}>Dosage Given:</strong>
                            </Col>
                            <Col sm={8}>
                                <span style={{
                                    padding: '4px 12px',
                                    borderRadius: '12px',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    background: selectedNonMedicationLog.is_dosage_given === 1 || selectedNonMedicationLog.is_dosage_given === '1' ? '#d1fae5' : '#fee2e2',
                                    color: selectedNonMedicationLog.is_dosage_given === 1 || selectedNonMedicationLog.is_dosage_given === '1' ? '#065f46' : '#991b1b',
                                    display: 'inline-block'
                                }}>
                                    {selectedNonMedicationLog.is_dosage_given === 1 || selectedNonMedicationLog.is_dosage_given === '1' ? 'Yes' : 'No'}
                                </span>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col sm={4}>
                                <strong style={{ color: '#333', fontSize: '14px' }}>Time Given:</strong>
                            </Col>
                            <Col sm={8}>
                                <span style={{ color: '#666' }}>
                                    {selectedNonMedicationLog.time_given ? Moment(selectedNonMedicationLog.time_given, 'HH:mm:ss').format('h:mm A') : 'N/A'}
                                </span>
                            </Col>
                        </Row>
                        {selectedNonMedicationLog.staff_signiture && selectedNonMedicationLog.staff_signiture !== 'null' && selectedNonMedicationLog.staff_signiture !== '' && (
                            <Row className="mb-3">
                                <Col sm={4}>
                                    <strong style={{ color: '#333', fontSize: '14px' }}>Staff Signature:</strong>
                                </Col>
                                <Col sm={8}>
                                    <img
                                        src={selectedNonMedicationLog.staff_signiture}
                                        alt="Staff Signature"
                                        onError={(e) => { e.target.style.display = 'none'; }}
                                        style={{ maxWidth: '150px', maxHeight: '75px', border: '1px solid #dee2e6', borderRadius: '4px', padding: '4px', background: 'white', display: 'block' }}
                                    />
                                </Col>
                            </Row>
                        )}
                        {selectedNonMedicationLog.comments && (
                            <Row className="mb-3">
                                <Col sm={4}>
                                    <strong style={{ color: '#333', fontSize: '14px' }}>Comments:</strong>
                                </Col>
                                <Col sm={8}>
                                    <span style={{ color: '#666' }}>
                                        {selectedNonMedicationLog.comments}
                                    </span>
                                </Col>
                            </Row>
                        )}
                        <Row className="mb-3">
                            <Col sm={4}>
                                <strong style={{ color: '#333', fontSize: '14px' }}>Recorded On:</strong>
                            </Col>
                            <Col sm={8}>
                                <span style={{ color: '#666' }}>
                                    {selectedNonMedicationLog.created_at
                                        ? `${formatDisplayDate(selectedNonMedicationLog.created_at)} ${formatDisplayTime(selectedNonMedicationLog.created_at)}`
                                        : 'Not available'
                                    }
                                </span>
                            </Col>
                        </Row>
                    </div>
                ) : (
                    <p>No log details available</p>
                )}
            </Modal.Body>
        </Modal>
    );

    const renderNonMedicationModal = () => (
        <Modal show={showNonMedicationModal} onHide={() => { setShowNonMedicationModal(false); setSelectedNonMedicationRecordId(null); }} size="xl" centered
            style={{ marginTop: "30px" }}>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#111827',
                    lineHeight: '1.3',
                    width: '100%',
                    maxWidth: 'calc(100% - 40px)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <i className="ri-shield-check-line" style={{ fontSize: '20px', color: '#10b981' }}></i>
                            <div>
                                <div style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>
                                    Non-Medication Overview
                                </div>
                                <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: '500' }}>
                                    {nonMedicationData?.student_name}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '16px', background: '#f9fafb', maxHeight: '65vh', overflowY: 'auto' }}>
                {selectedNonMedicationRecordId === null ? (
                    <MedicationRecordList records={nonMedicationRecords} onSelect={selectNonMedicationRecord} />
                ) : nonMedicationData ? (
                    <Row>
                        <Col md={12}>
                            {nonMedicationRecords.length > 1 && (
                                <Button variant="outline-secondary" size="sm" className="mb-3"
                                    onClick={() => setSelectedNonMedicationRecordId(null)}>
                                    <i className="ri-arrow-left-line me-1"></i> Back to list
                                </Button>
                            )}
                            <Card style={{
                                borderRadius: '8px',
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                marginBottom: '16px',
                                background: 'white'
                            }}>
                                <Card.Header style={{
                                    background: 'white',
                                    borderBottom: '1px solid #e5e7eb',
                                    borderRadius: '8px 8px 0 0',
                                    padding: '12px 16px',
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    color: '#374151'
                                }}>
                                    <i className="ri-shield-check-line me-2" style={{ color: '#10b981' }}></i>
                                    Non-Medication Information
                                </Card.Header>
                                <Card.Body style={{ padding: '16px' }}>
                                    <Row>
                                        <Col md={6}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Student Name
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {nonMedicationData.student_name}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Parent Name
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {nonMedicationData.parent_name || 'N/A'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Medication Name
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#28a745' }}>
                                                    {nonMedicationData.medication_name || 'Not specified'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Times to be Administered
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {nonMedicationData.times_to_be_administered || 'Not specified'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Date Range
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {formatDisplayDate(nonMedicationData.date_start)} to {formatDisplayDate(nonMedicationData.date_end)}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Expiry Date
                                                </div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    {formatDisplayDate(nonMedicationData.expiry_date)}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Reason for Administering
                                                </div>
                                                <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>
                                                    {nonMedicationData.reason_for_administering || 'No reason specified'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Parent's Consent & Instructions
                                                </div>
                                                <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>
                                                    {nonMedicationData.parents_consent_and_instruction || 'No instructions provided'}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Additional Instructions
                                                </div>
                                                <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>
                                                    {nonMedicationData.additional_instructions || 'No additional instructions'}
                                                </div>
                                            </div>
                                            {nonMedicationData.signiture_of_parent && nonMedicationData.signiture_of_parent !== 'null' && nonMedicationData.signiture_of_parent !== '' && (
                                                <div style={{ marginBottom: '15px' }}>
                                                    <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                        Parent Signature
                                                    </div>
                                                    <img 
                                                        src={nonMedicationData.signiture_of_parent} 
                                                        alt="Parent Signature" 
                                                        onError={(e) => { e.target.style.display = 'none'; }}
                                                        style={{ maxWidth: '200px', maxHeight: '100px', border: '1px solid #dee2e6', borderRadius: '4px', padding: '8px', background: 'white', display: 'block' }}
                                                    />
                                                    <div style={{ fontSize: '12px', color: '#999', marginTop: '4px' }}>
                                                        Signed on: {nonMedicationData.signature_date}
                                                    </div>
                                                </div>
                                            )}
                                            {nonMedicationData.doctor_note && (
                                                <div style={{ marginBottom: '15px' }}>
                                                    <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                        Doctor's Note
                                                    </div>
                                                    <a href={nonMedicationData.doctor_note} target="_blank" rel="noopener noreferrer" style={{ fontSize: '13px', color: '#28a745' }}>
                                                        <i className="ri-file-text-line me-1"></i>
                                                        View Doctor's Note
                                                    </a>
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12}>
                            <Card style={{
                                borderRadius: '12px',
                                border: 'none',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                            }}>
                                <Card.Header style={{
                                    background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                                    color: 'white',
                                    borderRadius: '12px 12px 0 0',
                                    padding: '16px 20px',
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}>
                                    <div>
                                        <i className="ri-file-list-line me-2"></i>
                                        Non-Medication Logs
                                    </div>
                                    <Button
                                        variant="primary"
                                        size="sm"
                                        onClick={() => {
                                            setIsEditingNonMedicationLog(false);
                                            setNonMedicationLogData({
                                                medication_date: new Date().toISOString().split('T')[0],
                                                medication: nonMedicationData.medication_name || '',
                                                is_dosage_given: 1,
                                                time_given: new Date().toTimeString().slice(0, 5),
                                                staff_signiture: '',
                                                comments: ''
                                            });
                                            if (nonMedicationSignaturePadRef.current) {
                                                nonMedicationSignaturePadRef.current.clear();
                                            }
                                            setShowNonMedicationLogFormModal(true);
                                        }}
                                        style={{ borderRadius: '6px' }}
                                    >
                                        <i className="ri-add-line me-1"></i>
                                        Add Log Entry
                                    </Button>
                                </Card.Header>
                                <Card.Body style={{ padding: '0' }}>
                                    {nonMedicationData.non_medication_logs && nonMedicationData.non_medication_logs.length > 0 ? (
                                        <div style={{ overflowX: 'auto' }}>
                                            <Table hover style={{ margin: 0 }}>
                                                <thead style={{
                                                    background: '#f8f9fa',
                                                    borderBottom: '2px solid #dee2e6'
                                                }}>
                                                    <tr>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Date</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Medication</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Dosage Given</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Time</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Staff Signature</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333' }}>Comments</th>
                                                        <th style={{ padding: '16px', fontWeight: '600', color: '#333', textAlign: 'center' }}>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {nonMedicationData.non_medication_logs.map((log, index) => (
                                                        <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                            <td style={{ padding: '16px', color: '#333' }}>
                                                                {formatDisplayDate(log.medication_date)}
                                                            </td>
                                                            <td style={{ padding: '16px', color: '#333', fontWeight: '600' }}>
                                                                {log.medication || 'N/A'}
                                                            </td>
                                                            <td style={{ padding: '16px', textAlign: 'center' }}>
                                                                <span style={{
                                                                    padding: '4px 12px',
                                                                    borderRadius: '12px',
                                                                    fontSize: '12px',
                                                                    fontWeight: '600',
                                                                    background: log.is_dosage_given === 1 || log.is_dosage_given === '1' ? '#d1fae5' : '#fee2e2',
                                                                    color: log.is_dosage_given === 1 || log.is_dosage_given === '1' ? '#065f46' : '#991b1b'
                                                                }}>
                                                                    {log.is_dosage_given === 1 || log.is_dosage_given === '1' ? 'Yes' : 'No'}
                                                                </span>
                                                            </td>
                                                            <td style={{ padding: '16px', color: '#333' }}>
                                                                {log.time_given ? Moment(log.time_given, 'HH:mm:ss').format('h:mm A') : 'N/A'}
                                                            </td>
                                                            <td style={{ padding: '16px', color: '#333' }}>
                                                                {log.staff_signiture && log.staff_signiture !== 'null' && log.staff_signiture !== '' ? (
                                                                    <img 
                                                                        src={log.staff_signiture} 
                                                                        alt="Staff Signature" 
                                                                        onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.textContent = 'N/A'; }}
                                                                        style={{ maxWidth: '80px', maxHeight: '40px', display: 'block' }}
                                                                    />
                                                                ) : 'N/A'}
                                                            </td>
                                                            <td style={{ padding: '16px', color: '#666', maxWidth: '200px' }}>
                                                                {log.comments && log.comments.length > 40
                                                                    ? `${log.comments.substring(0, 40)}...`
                                                                    : log.comments || '-'
                                                                }
                                                            </td>
                                                            <td style={{ padding: '16px', textAlign: 'center' }}>
                                                                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                                                    <Button
                                                                        variant="outline-primary"
                                                                        size="sm"
                                                                        onClick={() => {
                                                                            setSelectedNonMedicationLog(log);
                                                                            setShowNonMedicationLogViewModal(true);
                                                                        }}
                                                                        style={{ borderRadius: '6px' }}
                                                                        title="View Log"
                                                                    >
                                                                        <i className="ri-eye-line"></i>
                                                                    </Button>
                                                                    <Button
                                                                        variant="outline-success"
                                                                        size="sm"
                                                                        onClick={() => editNonMedicationLog(log)}
                                                                        style={{ borderRadius: '6px' }}
                                                                        title="Edit Log"
                                                                    >
                                                                        <i className="ri-edit-line"></i>
                                                                    </Button>
                                                                    <Button
                                                                        variant="outline-danger"
                                                                        size="sm"
                                                                        onClick={() => deleteNonMedicationLog(log.id)}
                                                                        style={{ borderRadius: '6px' }}
                                                                        title="Delete Log"
                                                                    >
                                                                        <i className="ri-delete-bin-line"></i>
                                                                    </Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    ) : (
                                        <div style={{
                                            padding: '40px',
                                            textAlign: 'center',
                                            color: '#666'
                                        }}>
                                            <i className="ri-shield-check-line" style={{ fontSize: '48px', color: '#ccc', marginBottom: '16px' }}></i>
                                            <p style={{ fontSize: '16px', marginBottom: '8px' }}>No logs found</p>
                                            <p style={{ fontSize: '14px', color: '#999' }}>
                                                No non-medication logs have been recorded yet
                                            </p>
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                ) : (
                    <div style={{
                        padding: '60px 24px',
                        textAlign: 'center'
                    }}>
                        <i className="ri-loader-4-line ri-spin" style={{ fontSize: '48px', color: '#28a745' }}></i>
                        <p style={{ marginTop: '16px', color: '#666', fontSize: '16px' }}>Loading non-medication information...</p>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );

    const renderMeditationModal = () => (
        <Modal show={showMeditationModal} onHide={() => {
            setShowMeditationModal(false);
            if (document.activeElement) {
                document.activeElement.blur();
            }
        }} size="lg" centered style={{ marginTop: "50px", marginBottom: "50px" }}>
            <Modal.Header closeButton style={{
                borderBottom: '2px solid var(--bs-primary)',
                padding: '12px 16px',
                background: 'linear-gradient(135deg, var(--bs-primary) 0%, var(--bs-primary) 100%)'
            }}>
                <Modal.Title style={{
                    fontSize: '16px',
                    fontWeight: '800',
                    color: 'white',
                    lineHeight: '1.2',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    <i className="ri-mental-health-line" style={{ fontSize: '20px' }}></i>
                    Medication Exercises
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '15px', background: '#f8f9fa' }}>
                {meditationData && meditationData.student && (
                    <div style={{ marginBottom: '15px' }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            background: 'white',
                            padding: '12px',
                            borderRadius: '10px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                        }}>
                            {meditationData.student.photo && (
                                <img
                                    src={meditationData.student.photo}
                                    alt={meditationData.student.name}
                                    style={{
                                        width: '50px',
                                        height: '50px',
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        border: '2px solid var(--bs-primary)'
                                    }}
                                />
                            )}
                            <div>
                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#333' }}>
                                    {meditationData.student.name}
                                </div>
                                <div style={{ fontSize: '11px', color: '#666' }}>Student</div>
                            </div>
                        </div>
                    </div>
                )}

                <div style={{ marginTop: '15px' }}>
                    <h6 style={{
                        fontSize: '13px',
                        fontWeight: '700',
                        color: 'var(--bs-primary)',
                        marginBottom: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <i className="ri-heart-pulse-line"></i>
                        Recommended Exercises
                    </h6>

                    {meditationData && meditationData.exercises && meditationData.exercises.map((exercise, index) => (
                        <div key={exercise.id} style={{
                            background: 'white',
                            padding: '12px',
                            borderRadius: '10px',
                            marginBottom: '10px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                marginBottom: '8px'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    <div style={{
                                        width: '28px',
                                        height: '28px',
                                        borderRadius: '50%',
                                        background: 'linear-gradient(135deg, var(--bs-primary) 0%, var(--bs-primary) 100%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: 'white',
                                        fontSize: '11px',
                                        fontWeight: '700'
                                    }}>
                                        {index + 1}
                                    </div>
                                    <div>
                                        <div style={{ fontSize: '13px', fontWeight: '700', color: '#333' }}>
                                            {exercise.name}
                                        </div>
                                        <div style={{ fontSize: '11px', color: 'var(--bs-primary)', fontWeight: '600' }}>
                                            <i className="ri-time-line"></i> {exercise.duration}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{
                                fontSize: '12px',
                                color: '#666',
                                lineHeight: '1.5',
                                paddingLeft: '36px'
                            }}>
                                {exercise.description}
                            </div>
                        </div>
                    ))}
                </div>

                <div style={{
                    marginTop: '15px',
                    padding: '12px',
                    background: 'linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%)',
                    borderRadius: '10px',
                    border: '1px solid #bae6fd'
                }}>
                    <div style={{
                        fontSize: '12px',
                        color: '#0c4a6e',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <i className="ri-information-line" style={{ fontSize: '16px' }}></i>
                        <div>
                            <strong>Note:</strong> Practice these exercises in a quiet, comfortable space. Start with 2-3 minutes for younger children.
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );



    const renderAllergyModal = () => (
        <Modal show={showAllergyModal} onHide={() => {
            setShowAllergyModal(false);
            if (document.activeElement) {
                document.activeElement.blur();
            }
        }} size="lg" centered
            style={{ marginTop: "50px", marginBottom: "50px" }}>
            <Modal.Header closeButton style={{
                background: 'white',
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px'
            }}>
                <Modal.Title style={{ fontSize: '15px', fontWeight: '700', color: '#111827', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{
                        background: '#f3f4f6',
                        borderRadius: '8px',
                        padding: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <i className="ri-alert-fill" style={{ fontSize: '18px', color: '#f59e0b' }}></i>
                    </div>
                    Allergy & Food Preference
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '16px', background: '#f9fafb', maxHeight: '70vh', overflowY: 'auto' }}>
                {allergyData && allergyData.student && (
                    <>
                        <div style={{ marginBottom: '12px', fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>
                            <strong>Student:</strong> {allergyData.student.name}
                        </div>

                        {allergyData.allergy_report && (
                            <div style={{
                                background: 'white',
                                padding: '16px',
                                borderRadius: '8px',
                                marginBottom: '12px',
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                            }}>
                                <h6 style={{
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    marginBottom: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: '#374151',
                                    gap: '8px'
                                }}>
                                    <i className="ri-alert-line" style={{ fontSize: '16px', color: '#6366f1' }}></i>
                                    Allergy & Food Preference - {allergyData.student.name}
                                </h6>

                                <Row>
                                    {/* Left Side - Allergies */}
                                    <Col md={6}>
                                        <div style={{
                                            background: '#fef3c7',
                                            padding: '12px',
                                            borderRadius: '6px',
                                            marginBottom: '10px',
                                            border: '1px solid #fde68a'
                                        }}>
                                            <div style={{
                                                fontSize: '12px',
                                                fontWeight: '600',
                                                marginBottom: '8px',
                                                color: '#92400e'
                                            }}>
                                                ⚠️ Allergies
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                                {allergyData.allergy_report.is_peanuts === 1 && (
                                                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
                                                        <span style={{ color: '#92400e', marginRight: '6px' }}>•</span>
                                                        <span>Peanuts</span>
                                                    </div>
                                                )}
                                                {allergyData.allergy_report.is_shellfish === 1 && (
                                                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
                                                        <span style={{ color: '#92400e', marginRight: '6px' }}>•</span>
                                                        <span>Shellfish {allergyData.allergy_report.shellfish_specify ? `(${allergyData.allergy_report.shellfish_specify})` : ''}</span>
                                                    </div>
                                                )}
                                                {allergyData.allergy_report.is_tree_nuts === 1 && (
                                                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
                                                        <span style={{ color: '#92400e', marginRight: '6px' }}>•</span>
                                                        <span>Tree Nuts</span>
                                                    </div>
                                                )}
                                                {allergyData.allergy_report.is_fish === 1 && (
                                                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
                                                        <span style={{ color: '#92400e', marginRight: '6px' }}>•</span>
                                                        <span>Fish {allergyData.allergy_report.fish_specify ? `(${allergyData.allergy_report.fish_specify})` : ''}</span>
                                                    </div>
                                                )}
                                                {allergyData.allergy_report.is_milk === 1 && (
                                                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
                                                        <span style={{ color: '#92400e', marginRight: '6px' }}>•</span>
                                                        <span>Milk/Dairy</span>
                                                    </div>
                                                )}
                                                {allergyData.allergy_report.all_dairy_products === 1 && (
                                                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
                                                        <span style={{ color: '#92400e', marginRight: '6px' }}>•</span>
                                                        <span>All Dairy Products</span>
                                                    </div>
                                                )}
                                                {allergyData.allergy_report.is_food_additives === 1 && (
                                                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
                                                        <span style={{ color: '#92400e', marginRight: '6px' }}>•</span>
                                                        <span>Food Additives {allergyData.allergy_report.food_additives_specify ? `(${allergyData.allergy_report.food_additives_specify})` : ''}</span>
                                                    </div>
                                                )}
                                                {allergyData.allergy_report.insect_stings_bites === 1 && (
                                                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
                                                        <span style={{ color: '#92400e', marginRight: '6px' }}>•</span>
                                                        <span>Insect Stings/Bites {allergyData.allergy_report.insect_stings_bites_specify ? `(${allergyData.allergy_report.insect_stings_bites_specify})` : ''}</span>
                                                    </div>
                                                )}
                                                {allergyData.allergy_report.is_other === 1 && (
                                                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
                                                        <span style={{ color: '#92400e', marginRight: '6px' }}>•</span>
                                                        <span>Other {allergyData.allergy_report.other_specify ? `(${allergyData.allergy_report.other_specify})` : ''}</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Col>

                                    {/* Right Side - Emergency Treatment */}
                                    <Col md={6}>
                                        <div style={{
                                            background: '#fee2e2',
                                            padding: '12px',
                                            borderRadius: '6px',
                                            marginBottom: '10px',
                                            border: '1px solid #fecaca'
                                        }}>
                                            <div style={{
                                                fontSize: '12px',
                                                fontWeight: '600',
                                                marginBottom: '8px',
                                                color: '#991b1b'
                                            }}>
                                                🏥 Emergency Treatment
                                            </div>

                                            {allergyData.allergy_report.emergency_treatment_procedures && (
                                                <div style={{ marginBottom: '8px' }}>
                                                    <div style={{ fontSize: '11px', fontWeight: '600', color: '#991b1b', marginBottom: '4px' }}>
                                                        Procedures:
                                                    </div>
                                                    <div style={{ fontSize: '12px', color: '#374151' }}>
                                                        {allergyData.allergy_report.emergency_treatment_procedures}
                                                    </div>
                                                </div>
                                            )}

                                            {allergyData.allergy_report.insect_stings_bites === 1 && allergyData.allergy_report.insect_stings_bites_medication && (
                                                <div style={{ marginBottom: '8px' }}>
                                                    <div style={{ fontSize: '11px', fontWeight: '600', color: '#991b1b', marginBottom: '4px' }}>
                                                        Insect Sting/Bite Medication:
                                                    </div>
                                                    <div style={{ fontSize: '12px', color: '#374151' }}>
                                                        {allergyData.allergy_report.insect_stings_bites_medication}
                                                    </div>
                                                </div>
                                            )}

                                            {allergyData.allergy_report.require_epi_pen === 1 && (
                                                <div style={{
                                                    background: '#fecaca',
                                                    padding: '8px',
                                                    borderRadius: '6px',
                                                    marginBottom: '8px',
                                                    border: '1px solid #fca5a5'
                                                }}>
                                                    <div style={{
                                                        fontSize: '11px',
                                                        fontWeight: '600',
                                                        color: '#991b1b',
                                                        marginBottom: '4px'
                                                    }}>
                                                        💉 EpiPen Required
                                                    </div>
                                                    {allergyData.allergy_report.location_of_epi_pen && (
                                                        <div style={{ fontSize: '11px', color: '#991b1b' }}>
                                                            Location: {allergyData.allergy_report.location_of_epi_pen}
                                                        </div>
                                                    )}
                                                    {allergyData.allergy_report.location_of_epi_pen_at_daycare && (
                                                        <div style={{ fontSize: '11px', color: '#991b1b', marginTop: '4px' }}>
                                                            Location at Daycare: {allergyData.allergy_report.location_of_epi_pen_at_daycare}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {allergyData.allergy_report.symptoms && (
                                                <div>
                                                    <div style={{ fontSize: '11px', fontWeight: '600', color: '#991b1b', marginBottom: '4px' }}>
                                                        Symptoms:
                                                    </div>
                                                    <div style={{ fontSize: '12px', color: '#374151' }}>
                                                        {allergyData.allergy_report.symptoms}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>

                                {/* Signatures */}
                                <Row style={{ marginTop: '12px' }}>
                                    <Col md={6}>
                                        <div>
                                            <div style={{ fontSize: '11px', fontWeight: '600', marginBottom: '8px', color: '#374151' }}>
                                                Parent Signature:
                                            </div>
                                            {allergyData.allergy_report.parent_signature ? (
                                                <div>
                                                    <div style={{
                                                        border: '1px solid #e5e7eb',
                                                        borderRadius: '6px',
                                                        padding: '8px',
                                                        background: '#f9fafb',
                                                        marginBottom: '6px'
                                                    }}>
                                                        <img
                                                            src={allergyData.allergy_report.parent_signature}
                                                            alt="Parent Signature"
                                                            style={{
                                                                maxWidth: '100%',
                                                                maxHeight: '60px',
                                                                display: 'block'
                                                            }}
                                                        />
                                                    </div>
                                                    {allergyData.allergy_report.parent_signature_date && (
                                                        <div style={{ fontSize: '11px', color: '#6b7280' }}>
                                                            Signed: {formatDisplayDate(allergyData.allergy_report.parent_signature_date)}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <div style={{ fontSize: '11px', color: '#6b7280', fontStyle: 'italic' }}>
                                                    Not signed
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div>
                                            <div style={{ fontSize: '11px', fontWeight: '600', marginBottom: '8px', color: '#374151' }}>
                                                Supervisor Signature:
                                            </div>
                                            {allergyData.allergy_report.supervisor_signature ? (
                                                <div>
                                                    <div style={{
                                                        border: '1px solid #e5e7eb',
                                                        borderRadius: '6px',
                                                        padding: '8px',
                                                        background: '#f9fafb',
                                                        marginBottom: '6px'
                                                    }}>
                                                        <img
                                                            src={allergyData.allergy_report.supervisor_signature}
                                                            alt="Supervisor Signature"
                                                            style={{
                                                                maxWidth: '100%',
                                                                maxHeight: '60px',
                                                                display: 'block'
                                                            }}
                                                        />
                                                    </div>
                                                    {allergyData.allergy_report.supervisor_signature_date && (
                                                        <div style={{ fontSize: '11px', color: '#6b7280' }}>
                                                            Signed: {formatDisplayDate(allergyData.allergy_report.supervisor_signature_date)}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <div style={{ fontSize: '11px', color: '#6b7280', fontStyle: 'italic' }}>
                                                    Not signed
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>

                                {/* Supervisor Notes - field is supervisor_note (singular) on the
                                    model; this checked the plural supervisor_notes, which never
                                    exists on the record, so the block never rendered regardless
                                    of data. Admin edits this via a rich-text (CKEditor) field, so
                                    it's rendered as sanitized HTML like the other CKEditor fields
                                    in this file, not plain text. */}
                                {allergyData.allergy_report.supervisor_note && (
                                    <div style={{
                                        background: '#dbeafe',
                                        padding: '12px',
                                        borderRadius: '6px',
                                        marginTop: '12px',
                                        border: '1px solid #bfdbfe'
                                    }}>
                                        <div style={{ fontSize: '11px', fontWeight: '600', marginBottom: '6px', color: '#1e40af' }}>
                                            Supervisor Notes:
                                        </div>
                                        <div
                                            style={{ fontSize: '12px', color: '#374151' }}
                                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(allergyData.allergy_report.supervisor_note) }}
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </>
                )}
            </Modal.Body>
        </Modal>
    );

    // Helper functions for registration modal
    const formatPhoneNumber = (phone) => {
        if (!phone) return 'N/A';
        return phone;
    };

    const formatDateLong = (date) => {
        if (!date) return 'N/A';
        try {
            const d = new Date(date);
            if (isNaN(d.getTime())) return 'N/A';
            return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
        } catch (error) {
            return 'N/A';
        }
    };

    const calculateAge = (dob) => {
        if (!dob) return 'N/A';
        const birthDate = new Date(dob);
        const today = new Date();
        const age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            return age - 1;
        }
        return age;
    };

    // Render Accident Reports Modal
    const renderAccidentReportsModal = () => (
        <Modal show={showAccidentReportsModal} onHide={() => setShowAccidentReportsModal(false)} size="xl" centered>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#1f2937',
                    lineHeight: '1.3',
                    width: '100%',
                    maxWidth: 'calc(100% - 40px)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <i className="ri-first-aid-kit-line" style={{ fontSize: '20px', color: '#ef4444' }}></i>
                            <div>
                                <div style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>
                                    Accident Reports
                                </div>
                                <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: '500' }}>
                                    {selectedStudent?.name}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px', maxHeight: '70vh', overflowY: 'auto' }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '14px' }}>
                    <Button
                        variant="danger"
                        size="sm"
                        onClick={() => {
                            if (!selectedStudent) return;
                            setShowAccidentReportsModal(false);
                            handleCreateAccidentReport(selectedStudent);
                        }}
                        className="d-flex align-items-center gap-1"
                        style={{ fontSize: '12px', fontWeight: '600', padding: '6px 10px' }}
                    >
                        <i className="ri-add-line"></i>
                        Add New Accident Report
                    </Button>
                </div>
                {loadingAccidentReports ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <div className="spinner-border text-danger" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p style={{ marginTop: '16px', color: '#6c757d' }}>Loading accident reports...</p>
                    </div>
                ) : accidentReports.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <i className="ri-file-search-line" style={{ fontSize: '48px', color: '#cbd5e1' }}></i>
                        <p style={{ marginTop: '16px', color: '#6c757d', fontSize: '15px' }}>No accident reports found for this student.</p>
                    </div>
                ) : (
                    <div className="row g-3">
                        {accidentReports.map((report) => (
                            <div key={report.id} className="col-12">
                                <Card style={{ border: '1px solid #fee2e2', boxShadow: '0 2px 8px rgba(239, 68, 68, 0.1)' }}>
                                    <Card.Body>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '12px' }}>
                                            <div>
                                                <Badge bg="danger" style={{ fontSize: '11px', marginBottom: '8px' }}>
                                                    Report #{report.id}
                                                </Badge>
                                                <h6 style={{ fontSize:'14px', fontWeight: '600', color: '#111827', marginBottom: '4px' }}>
                                                    {formatDisplayDate(report.incident_date)} at {formatTime(report.incident_time)}
                                                </h6>
                                                <p style={{ fontSize: '12px', color: '#6b7280', margin: 0 }}>
                                                    <i className="ri-map-pin-line"></i> {report.location}
                                                </p>
                                            </div>
                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                {profileData?.user_type === 2 && !report.parent_signature && (
                                                    <Button
                                                        variant="outline-danger"
                                                        size="sm"
                                                        onClick={() => handleSignAccidentReport(report)}
                                                        style={{ fontSize: '11px', padding: '4px 12px' }}
                                                    >
                                                        <i className="ri-quill-pen-line"></i> Sign
                                                    </Button>
                                                )}
                                                {profileData?.user_type !== 2 && (
                                                    <>
                                                        <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            onClick={() => {
                                                                setShowAccidentReportsModal(false);
                                                                handleEditAccidentReport(report);
                                                            }}
                                                            style={{ fontSize: '11px', padding: '4px 12px' }}
                                                        >
                                                            <i className="ri-edit-line"></i> Edit
                                                        </Button>
                                                        <Button
                                                            variant="outline-danger"
                                                            size="sm"
                                                            onClick={() => deleteAccidentReport(report.id)}
                                                            style={{ fontSize: '11px', padding: '4px 12px' }}
                                                        >
                                                            <i className="ri-delete-bin-line"></i> Delete
                                                        </Button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        
                                        <Row className="g-2">
                                            <Col md={12}>
                                                <div style={{ background: '#fef2f2', borderRadius: '6px', padding: '12px', marginBottom: '8px' }}>
                                                    <strong style={{ fontSize: '12px', color: '#991b1b' }}>Incident Description:</strong>
                                                    <div style={{ fontSize: '12px', color: '#374151', marginTop: '4px' }}
                                                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(report.incident_description) }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div style={{ background: '#f0fdf4', borderRadius: '6px', padding: '12px', marginBottom: '8px' }}>
                                                    <strong style={{ fontSize: '12px', color: '#166534' }}>First Aid Provided:</strong>
                                                    <div style={{ fontSize: '12px', color: '#374151', marginTop: '4px' }}
                                                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(report.first_aid) }}
                                                    />
                                                </div>
                                            </Col>
                                            {report.follow_up_information && (
                                                <Col md={12}>
                                                    <div style={{ background: '#eff6ff', borderRadius: '6px', padding: '12px' }}>
                                                        <strong style={{ fontSize: '12px', color: '#1e40af' }}>Follow-up Information:</strong>
                                                        <div style={{ fontSize: '12px', color: '#374151', marginTop: '4px' }}
                                                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(report.follow_up_information) }}
                                                        />
                                                    </div>
                                                </Col>
                                            )}
                                            <Col md={6}>
                                                <div style={{ fontSize: '12px' }}>
                                                    <strong>Parent Contacted:</strong> {report.parent_contacted === 1 ? 'Yes' : 'No'}
                                                    {report.parent_contacted === 1 && report.parent_contacted_time && (
                                                        <span> at {formatTime(report.parent_contacted_time)}</span>
                                                    )}
                                                </div>
                                            </Col>
                                            {report.staff_name && (
                                                <Col md={6}>
                                                    <div style={{ fontSize: '12px' }}>
                                                        <strong>Staff:</strong> {report.staff_name} ({report.staff_position})
                                                    </div>
                                                </Col>
                                            )}
                                        </Row>

                                        {/* Signatures */}
                                        <div style={{ marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #e5e7eb' }}>
                                            <Row className="g-2">
                                                {report.staff_signature && (
                                                    <Col md={4}>
                                                        <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>Staff Signature:</div>
                                                        <img src={report.staff_signature} alt="Staff Signature" style={{ maxWidth: '100%', height: '60px', border: '1px solid #e5e7eb', borderRadius: '4px' }} />
                                                    </Col>
                                                )}
                                                {report.supervisor_signature && (
                                                    <Col md={4}>
                                                        <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>Supervisor Signature:</div>
                                                        <img src={report.supervisor_signature} alt="Supervisor Signature" style={{ maxWidth: '100%', height: '60px', border: '1px solid #e5e7eb', borderRadius: '4px' }} />
                                                    </Col>
                                                )}
                                                {report.parent_signature && (
                                                    <Col md={4}>
                                                        <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>
                                                            Parent Signature ({formatDisplayDate(report.parent_signature_date)}):
                                                        </div>
                                                        <img src={report.parent_signature} alt="Parent Signature" style={{ maxWidth: '100%', height: '60px', border: '1px solid #e5e7eb', borderRadius: '4px' }} />
                                                    </Col>
                                                )}
                                            </Row>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        ))}
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );

    // Render Illness Reports Modal
    const renderIllnessReportsModal = () => (
        <Modal show={showIllnessReportsModal} onHide={() => setShowIllnessReportsModal(false)} size="xl" centered>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#1f2937',
                    lineHeight: '1.3',
                    width: '100%',
                    maxWidth: 'calc(100% - 40px)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <i className="ri-thermometer-line" style={{ fontSize: '20px', color: '#f59e0b' }}></i>
                            <div>
                                <div style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>
                                    Illness Reports
                                </div>
                                <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: '500' }}>
                                    {selectedStudent?.name}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px', maxHeight: '70vh', overflowY: 'auto' }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '14px' }}>
                    <Button
                        variant="warning"
                        size="sm"
                        onClick={() => {
                            if (!selectedStudent) return;
                            setShowIllnessReportsModal(false);
                            handleCreateIllnessReport(selectedStudent);
                        }}
                        className="d-flex align-items-center gap-1"
                        style={{ fontSize: '12px', fontWeight: '600', padding: '6px 10px', color: '#fff' }}
                    >
                        <i className="ri-add-line"></i>
                        Add New Illness Report
                    </Button>
                </div>
                {loadingIllnessReports ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <div className="spinner-border text-warning" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p style={{ marginTop: '16px', color: '#6c757d' }}>Loading illness reports...</p>
                    </div>
                ) : illnessReports.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <i className="ri-file-search-line" style={{ fontSize: '48px', color: '#cbd5e1' }}></i>
                        <p style={{ marginTop: '16px', color: '#6c757d', fontSize: '15px' }}>No illness reports found for this student.</p>
                    </div>
                ) : (
                    <div className="row g-3">
                        {illnessReports.map((report) => (
                            <div key={report.id} className="col-12">
                                <Card style={{ border: '1px solid #fef3c7', boxShadow: '0 2px 8px rgba(245, 158, 11, 0.1)' }}>
                                    <Card.Body>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '12px' }}>
                                            <div>
                                                <Badge bg="warning" text="dark" style={{ fontSize: '11px', marginBottom: '8px' }}>
                                                    Report #{report.id}
                                                </Badge>
                                                <h6 style={{ fontSize: '14px', fontWeight: '600', color: '#111827', marginBottom: '4px' }}>
                                                    Return Date: {formatDisplayDate(report.return_date)}
                                                </h6>
                                            </div>
                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                {profileData?.user_type === 2 && !report.parent_signature && (
                                                    <Button
                                                        variant="outline-warning"
                                                        size="sm"
                                                        onClick={() => handleSignIllnessReport(report)}
                                                        style={{ fontSize: '11px', padding: '4px 12px' }}
                                                    >
                                                        <i className="ri-quill-pen-line"></i> Sign
                                                    </Button>
                                                )}
                                                {profileData?.user_type !== 2 && (
                                                    <>
                                                        <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            onClick={() => {
                                                                setShowIllnessReportsModal(false);
                                                                handleEditIllnessReport(report);
                                                            }}
                                                            style={{ fontSize: '11px', padding: '4px 12px' }}
                                                        >
                                                            <i className="ri-edit-line"></i> Edit
                                                        </Button>
                                                        <Button
                                                            variant="outline-danger"
                                                            size="sm"
                                                            onClick={() => deleteIllnessReport(report.id)}
                                                            style={{ fontSize: '11px', padding: '4px 12px' }}
                                                        >
                                                            <i className="ri-delete-bin-line"></i> Delete
                                                        </Button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        
                                        <Row className="g-2">
                                            <Col md={12}>
                                                <div style={{ background: '#fef3c7', borderRadius: '6px', padding: '12px', marginBottom: '8px' }}>
                                                    <strong style={{ fontSize: '12px', color: '#92400e' }}>Symptoms:</strong>
                                                    <div style={{ fontSize: '12px', color: '#374151', marginTop: '4px' }}
                                                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(report.symptoms) }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div style={{ background: '#eff6ff', borderRadius: '6px', padding: '12px' }}>
                                                    <strong style={{ fontSize: '12px', color: '#1e40af' }}>Requested Action from Parent:</strong>
                                                    <div style={{ fontSize: '12px', color: '#374151', marginTop: '4px' }}
                                                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(report.requested_action_parent) }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Signatures */}
                                        <div style={{ marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #e5e7eb' }}>
                                            <Row className="g-2">
                                                {report.teacher_signature && (
                                                    <Col md={6}>
                                                        <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>
                                                            Teacher Signature ({formatDisplayDate(report.teacher_signature_date)}):
                                                        </div>
                                                        <img src={report.teacher_signature} alt="Teacher Signature" style={{ maxWidth: '100%', height: '60px', border: '1px solid #e5e7eb', borderRadius: '4px' }} />
                                                    </Col>
                                                )}
                                                {report.parent_signature && (
                                                    <Col md={6}>
                                                        <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>
                                                            Parent Signature ({formatDisplayDate(report.parent_signature_date)}):
                                                        </div>
                                                        <img src={report.parent_signature} alt="Parent Signature" style={{ maxWidth: '100%', height: '60px', border: '1px solid #e5e7eb', borderRadius: '4px' }} />
                                                    </Col>
                                                )}
                                            </Row>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        ))}
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );

    // Render Accident Report Signature Modal
    const renderAccidentSignatureModal = () => (
        <Modal show={showAccidentSignatureModal} onHide={() => setShowAccidentSignatureModal(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: '16px', fontWeight: '600' }}>Sign Accident Report</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Signature Date</Form.Label>
                    <Form.Control
                        type="date"
                        value={accidentSignatureDate}
                        onChange={(e) => setAccidentSignatureDate(e.target.value)}
                        style={{ fontSize: '13px' }}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Parent Signature</Form.Label>
                    <div style={{ border: '1px solid #dee2e6', borderRadius: '4px', background: '#fff' }}>
                        <SignatureCanvas
                            ref={accidentSignaturePadRef}
                            canvasProps={{
                                style: { width: '100%', height: '200px' }
                            }}
                        />
                    </div>
                    <Button
                        variant="link"
                        size="sm"
                        onClick={() => accidentSignaturePadRef.current?.clear()}
                        style={{ fontSize: '12px', padding: '4px 0', marginTop: '4px' }}
                    >
                        Clear Signature
                    </Button>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" size="sm" onClick={() => setShowAccidentSignatureModal(false)}>
                    Cancel
                </Button>
                <Button variant="danger" size="sm" onClick={submitAccidentReportSignature}>
                    Submit Signature
                </Button>
            </Modal.Footer>
        </Modal>
    );

    // Render Illness Report Signature Modal
    const renderIllnessSignatureModal = () => (
        <Modal show={showIllnessSignatureModal} onHide={() => setShowIllnessSignatureModal(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: '16px', fontWeight: '600' }}>Sign Illness Report</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Signature Date</Form.Label>
                    <Form.Control
                        type="date"
                        value={illnessSignatureDate}
                        onChange={(e) => setIllnessSignatureDate(e.target.value)}
                        style={{ fontSize: '13px' }}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Parent Signature</Form.Label>
                    <div style={{ border: '1px solid #dee2e6', borderRadius: '4px', background: '#fff' }}>
                        <SignatureCanvas
                            ref={illnessSignaturePadRef}
                            canvasProps={{
                                style: { width: '100%', height: '200px' }
                            }}
                        />
                    </div>
                    <Button
                        variant="link"
                        size="sm"
                        onClick={() => illnessSignaturePadRef.current?.clear()}
                        style={{ fontSize: '12px', padding: '4px 0', marginTop: '4px' }}
                    >
                        Clear Signature
                    </Button>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" size="sm" onClick={() => setShowIllnessSignatureModal(false)}>
                    Cancel
                </Button>
                <Button variant="warning" size="sm" onClick={submitIllnessReportSignature}>
                    Submit Signature
                </Button>
            </Modal.Footer>
        </Modal>
    );

    // Render Create/Edit Accident Report Modal
    const renderCreateAccidentModal = () => (
        <Modal show={showCreateAccidentModal} onHide={() => {
            setShowCreateAccidentModal(false);
            setIsEditingAccidentReport(false);
            setEditingAccidentReportId(null);
            setAccidentClassroomOptions([]);
        }} size="xl" centered style={{ marginTop: '20px' }}>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#1f2937',
                    lineHeight: '1.3',
                    width: '100%',
                    maxWidth: 'calc(100% - 40px)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <i className={isEditingAccidentReport ? "ri-edit-line" : "ri-file-add-line"} style={{ fontSize: '20px', color: '#ef4444' }}></i>
                            <div>
                                <div style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>
                                    {isEditingAccidentReport ? 'Edit Accident Report' : 'Indoor/Outdoor Accident Report'}
                                </div>
                                <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: '500' }}>
                                    {selectedStudent?.name || accidentFormData.child_name || 'Student'}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px', maxHeight: '60vh', overflowY: 'auto' }}>
                <Form>
                    <Row className="g-3">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Classroom:</Form.Label>
                                {!isEditingAccidentReport && accidentClassroomOptions.length > 1 ? (
                                    <Form.Select
                                        value={accidentFormData.classroom}
                                        onChange={(e) => setAccidentFormData({ ...accidentFormData, classroom: e.target.value })}
                                        style={{ fontSize: '13px' }}
                                    >
                                        {accidentClassroomOptions.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </Form.Select>
                                ) : (
                                    <Form.Control
                                        type="text"
                                        placeholder="Classroom"
                                        value={accidentFormData.classroom}
                                        onChange={(e) => setAccidentFormData({...accidentFormData, classroom: e.target.value})}
                                        readOnly={!isEditingAccidentReport}
                                        style={{
                                            fontSize: '13px',
                                            backgroundColor: !isEditingAccidentReport ? '#f8f9fa' : undefined
                                        }}
                                    />
                                )}
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Child's Name:</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={isEditingAccidentReport ? (selectedStudent?.name || accidentFormData.child_name) : accidentFormData.child_name}
                                    readOnly
                                    style={{ fontSize: '13px', backgroundColor: '#f8f9fa' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Date: <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={accidentFormData.incident_date}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, incident_date: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Time: <span style={{ color: 'red' }}>*</span></Form.Label>
                                {/* A native <input type="time"> renders in whatever hour
                                    format the browser/OS locale uses - 24-hour here - with
                                    no markup-level way to force AM/PM. Swapped for the same
                                    react-datepicker time-only picker already used elsewhere
                                    in this file (e.g. the Exit Time modal) for exactly this
                                    reason. Still stores/submits a plain "HH:mm" string -
                                    only the displayed picker format changes. */}
                                <DatePicker
                                    selected={accidentFormData.incident_time ? Moment(accidentFormData.incident_time, ['HH:mm:ss', 'HH:mm']).toDate() : null}
                                    onChange={(time) => setAccidentFormData({...accidentFormData, incident_time: time ? Moment(time).format('HH:mm') : ''})}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={5}
                                    timeCaption="Time"
                                    dateFormat="h:mm aa"
                                    minTime={accidentSchoolHours?.minTime}
                                    maxTime={accidentSchoolHours?.maxTime}
                                    placeholderText="Select time"
                                    className="form-control"
                                    style={{ fontSize: '13px' }}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Location: <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g., Playground, Classroom, etc."
                                    value={accidentFormData.location}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, location: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Detailed Description of what happened: <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Form.Control
                                    as="textarea"
                                                rows={3}
                                    value={accidentFormData.incident_description}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, incident_description: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Any First Aid applied:</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={accidentFormData.first_aid}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, first_aid: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Check
                                    type="checkbox"
                                    label="Parent contacted:"
                                    checked={accidentFormData.parent_contacted}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, parent_contacted: e.target.checked})}
                                    style={{ fontSize: '13px', fontWeight: '600' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Time:</Form.Label>
                                <DatePicker
                                    selected={accidentFormData.parent_contacted_time ? Moment(accidentFormData.parent_contacted_time, ['HH:mm:ss', 'HH:mm']).toDate() : null}
                                    onChange={(time) => setAccidentFormData({...accidentFormData, parent_contacted_time: time ? Moment(time).format('HH:mm') : ''})}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={5}
                                    timeCaption="Time"
                                    dateFormat="h:mm aa"
                                    minTime={accidentSchoolHours?.minTime}
                                    maxTime={accidentSchoolHours?.maxTime}
                                    placeholderText="Select time"
                                    className="form-control"
                                    style={{ fontSize: '13px' }}
                                    disabled={!accidentFormData.parent_contacted}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Follow up information:</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={accidentFormData.follow_up_information}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, follow_up_information: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <hr />
                            <h6 style={{ fontSize: '14px', fontWeight: '600', marginBottom: '12px' }}>Staff Signature</h6>
                            {isEditingAccidentReport && accidentFormData.existing_staff_signature && (
                                <div style={{ marginBottom: '12px', padding: '12px', background: '#f8f9fa', borderRadius: '6px', border: '1px solid #dee2e6' }}>
                                    <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '6px', fontWeight: '600' }}>Existing Signature:</div>
                                    <img 
                                        src={accidentFormData.existing_staff_signature} 
                                        alt="Staff Signature" 
                                        style={{ maxWidth: '100%', height: '80px', border: '1px solid #dee2e6', borderRadius: '4px', background: '#fff' }}
                                    />
                                    <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '6px' }}>Leave signature pad empty to keep existing signature</div>
                                </div>
                            )}
                            <div style={{ border: '1px solid #dee2e6', borderRadius: '4px', background: '#fff', marginBottom: '12px' }}>
                                <SignatureCanvas
                                    ref={accidentStaffSignaturePadRef}
                                    canvasProps={{
                                        style: { width: '100%', height: '150px' }
                                    }}
                                />
                            </div>
                            <Button
                                variant="link"
                                size="sm"
                                onClick={() => accidentStaffSignaturePadRef.current?.clear()}
                                style={{ fontSize: '12px', padding: '0', marginBottom: '12px' }}
                            >
                                Clear Signature Above
                            </Button>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Staff Name:</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Staff name"
                                    value={accidentFormData.staff_name}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, staff_name: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Staff Position:</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g., Teacher, Supervisor"
                                    value={accidentFormData.staff_position}
                                    onChange={(e) => setAccidentFormData({...accidentFormData, staff_position: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                />
                            </Form.Group>
                        </Col>
                        {accidentFormData.existing_supervisor_signature && (
                            <Col md={12}>
                                <hr />
                                <h6 style={{ fontSize: '14px', fontWeight: '600', marginBottom: '12px' }}>Supervisor Signature</h6>
                                <div style={{ marginBottom: '12px', padding: '12px', background: '#f8f9fa', borderRadius: '6px', border: '1px solid #dee2e6' }}>
                                    <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '6px', fontWeight: '600' }}>Signature:</div>
                                    <img 
                                        src={accidentFormData.existing_supervisor_signature} 
                                        alt="Supervisor Signature" 
                                        style={{ maxWidth: '100%', height: '80px', border: '1px solid #dee2e6', borderRadius: '4px', background: '#fff' }}
                                    />
                                </div>
                            </Col>
                        )}
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    setShowCreateAccidentModal(false);
                    setIsEditingAccidentReport(false);
                    setEditingAccidentReportId(null);
                }}>
                    Cancel
                </Button>
                <Button variant="success" onClick={submitAccidentReport} disabled={submittingAccidentReport}>
                    <i className={isEditingAccidentReport ? "ri-check-line" : "ri-save-line"}></i> {submittingAccidentReport ? 'Saving...' : (isEditingAccidentReport ? 'Update Report' : 'Save Report')}
                </Button>
            </Modal.Footer>
        </Modal>
    );

    // Render Create/Edit Illness Report Modal
    const renderCreateIllnessModal = () => (
        <Modal show={showCreateIllnessModal} onHide={() => {
            setShowCreateIllnessModal(false);
            setIsEditingIllnessReport(false);
            setEditingIllnessReportId(null);
        }} size="lg" centered style={{ marginTop: '20px' }}>
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e5e7eb',
                padding: '16px 20px',
                background: 'white'
            }}>
                <Modal.Title style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#1f2937',
                    lineHeight: '1.3',
                    width: '100%',
                    maxWidth: 'calc(100% - 40px)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <i className={isEditingIllnessReport ? "ri-edit-line" : "ri-file-add-line"} style={{ fontSize: '20px', color: '#f59e0b' }}></i>
                            <div>
                                <div style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>
                                    {isEditingIllnessReport ? 'Edit Illness Report' : 'Harmony Illness Report'}
                                </div>
                                <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: '500' }}>
                                    {selectedStudent?.name || illnessFormData.student_name || 'Student'}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px', maxHeight: '60vh', overflowY: 'auto' }}>
                <Form>
                    <Row className="g-3">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Classroom:</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Select Classroom"
                                    value={illnessFormData.classroom}
                                    readOnly
                                    style={{ fontSize: '13px', backgroundColor: '#f8f9fa' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Student Name:</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={illnessFormData.student_name}
                                    readOnly
                                    style={{ fontSize: '13px', backgroundColor: '#f8f9fa' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600', color: '#2563eb' }}>Symptoms: <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    placeholder="Describe the symptoms observed..."
                                    value={illnessFormData.symptoms}
                                    onChange={(e) => setIllnessFormData({...illnessFormData, symptoms: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600', color: '#2563eb' }}>Requested action by parent: <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    placeholder="What action is being requested from the parent..."
                                    value={illnessFormData.requested_action_parent}
                                    onChange={(e) => setIllnessFormData({...illnessFormData, requested_action_parent: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Return date: <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={illnessFormData.return_date}
                                    onChange={(e) => setIllnessFormData({...illnessFormData, return_date: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: '13px', fontWeight: '600' }}>Date:</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={illnessFormData.teacher_signature_date}
                                    onChange={(e) => setIllnessFormData({...illnessFormData, teacher_signature_date: e.target.value})}
                                    style={{ fontSize: '13px' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <hr />
                            <h6 style={{ fontSize: '14px', fontWeight: '600', marginBottom: '8px' }}>Teacher Signature: {!isEditingIllnessReport && <span style={{ color: 'red' }}>*</span>}</h6>
                            {isEditingIllnessReport && illnessFormData.existing_teacher_signature && (
                                <div style={{ marginBottom: '12px', padding: '12px', background: '#f8f9fa', borderRadius: '6px', border: '1px solid #dee2e6' }}>
                                    <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '6px', fontWeight: '600' }}>Existing Signature:</div>
                                    <img 
                                        src={illnessFormData.existing_teacher_signature} 
                                        alt="Teacher Signature" 
                                        style={{ maxWidth: '100%', height: '80px', border: '1px solid #dee2e6', borderRadius: '4px', background: '#fff' }}
                                    />
                                    <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '6px' }}>Leave signature pad empty to keep existing signature</div>
                                </div>
                            )}
                            <div style={{ border: '2px solid #3b82f6', borderRadius: '4px', background: '#fff', marginBottom: '8px' }}>
                                <SignatureCanvas
                                    ref={illnessTeacherSignaturePadRef}
                                    canvasProps={{
                                        style: { width: '100%', height: '150px' }
                                    }}
                                />
                            </div>
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <Button
                                    variant="warning"
                                    size="sm"
                                    onClick={() => illnessTeacherSignaturePadRef.current?.clear()}
                                    style={{ fontSize: '12px' }}
                                >
                                    <i className="ri-eraser-line"></i> Clear Signature
                                </Button>
                            </div>
                            <small style={{ color: '#6b7280', fontSize: '11px', display: 'block', marginTop: '8px' }}>
                                Draw your signature above
                            </small>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    setShowCreateIllnessModal(false);
                    setIsEditingIllnessReport(false);
                    setEditingIllnessReportId(null);
                }}>
                    Cancel
                </Button>
                <Button variant="success" onClick={submitIllnessReport} disabled={submittingIllnessReport}>
                    <i className={isEditingIllnessReport ? "ri-check-line" : "ri-save-line"}></i> {submittingIllnessReport ? 'Saving...' : (isEditingIllnessReport ? 'Update Report' : 'Save Report')}
                </Button>
            </Modal.Footer>
        </Modal>
    );

    return (
        <>
            {viewDataLoading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0,0,0,0.3)',
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        background: 'white',
                        borderRadius: '12px',
                        padding: '24px 32px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '14px',
                        boxShadow: '0 10px 40px rgba(0,0,0,0.25)'
                    }}>
                        <img src={loader} alt="Loading..." style={{ height: '36px' }} />
                        <span style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>Loading...</span>
                    </div>
                </div>
            )}
            <style>{`
                .att-toolbar-shell {
                    display: flex;
                    flex-direction: column;
                    gap: 5px;
                }

                .att-top-row {
                    align-items: flex-start;
                }

                .att-top-card {
                    height: auto;
                }

                .att-top-card.card,
                .att-control-card.card {
                    border: none !important;
                    border-radius: 14px !important;
                    box-shadow: 0 4px 10px rgba(15, 42, 88, 0.08);
                    overflow: visible;
                    background: #ffffff;
                }

                .att-top-card .card-title {
                    font-weight: 700 !important;
                    letter-spacing: 0;
                    color: #1f2937;
                    font-size: 17px;
                    line-height: 1.2;
                }

                .att-head-caption {
                    display: none;
                }

                .att-title-with-icon {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                }

                .att-title-with-icon i {
                    font-size: 15px;
                    color: var(--bs-primary);
                }

                .att-total-students {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    padding: 4px 10px;
                    border-radius: 999px;
                    background: rgba(var(--bs-primary-rgb), 0.12);
                    color: var(--bs-primary);
                    border: 1px solid rgba(var(--bs-primary-rgb), 0.24);
                    font-size: 11px;
                    font-weight: 700;
                    line-height: 1;
                }

                .att-top-card .card-header {
                    padding: 6px 10px !important;
                    border-bottom: 1px solid #e6edf7;
                    background: linear-gradient(180deg, #f8fbff 0%, #f2f7ff 100%);
                }

                .att-top-card .card-body {
                    padding: 7px 10px !important;
                }

                .att-stats-card .card-body {
                    padding: 8px !important;
                    background: #fafbfd;
                }

                .att-control-card .card-body {
                    display: flex;
                    flex-direction: column;
                }

                .att-date-panel,
                .att-room-panel {
                    border: 1px solid #e8eef8;
                    border-radius: 12px;
                    background: #fbfdff;
                    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
                    padding: 6px 8px;
                }

                @media (min-width: 992px) {
                    .att-toolbar-shell {
                        display: grid;
                        grid-template-columns: minmax(220px, 0.75fr) minmax(0, 1.25fr);
                        gap: 8px;
                        align-items: center;
                    }
                }

                .att-panel-kicker {
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    margin-bottom: 2px;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 0;
                    text-transform: none;
                    color: var(--bs-primary);
                }

                .att-date-panel-row {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 8px;
                }

                .att-date-action {
                    margin-left: auto;
                    flex: 0 0 auto;
                }

                .att-date-value {
                    font-size: 14px;
                    font-weight: 700;
                    color: #1f2937;
                    line-height: 1.2;
                    text-transform: none;
                }

                .att-date-change-btn {
                    display: inline-flex;
                    align-items: center;
                    border: 1px solid rgba(var(--bs-primary-rgb), 0.24);
                    border-radius: 999px;
                    width: 30px;
                    height: 30px;
                    padding: 0;
                    justify-content: center;
                    background: rgba(var(--bs-primary-rgb), 0.12);
                    color: var(--bs-primary);
                    font-size: 12px;
                    box-shadow: 0 1px 2px rgba(var(--bs-primary-rgb), 0.18);
                }

                .att-date-change-btn i {
                    line-height: 1;
                }

                .att-date-change-btn:hover {
                    background: var(--bs-primary);
                    color: #ffffff;
                    border-color: var(--bs-primary);
                }

                .att-top-date-popper {
                    z-index: 3000;
                }

                .att-top-date-popper .react-datepicker {
                    margin-top: 0;
                    border: none;
                    border-radius: 10px;
                    box-shadow: none;
                    overflow: hidden;
                }

                .att-top-date-popper .react-datepicker__triangle {
                    display: none;
                }

                .att-room-panel-header {
                    display: flex;
                    align-items: center;
                    margin-bottom: 4px;
                }

                .att-room-scroll-wrap {
                    border: none;
                    border-radius: 999px;
                    background: transparent;
                    padding: 1px 3px;
                }

                .att-room-scroll {
                    display: flex;
                    align-items: stretch;
                    gap: 4px;
                    overflow-x: auto;
                    padding-bottom: 1px;
                    scrollbar-width: thin;
                }

                .att-room-scroll::-webkit-scrollbar {
                    height: 6px;
                }

                .att-room-scroll::-webkit-scrollbar-thumb {
                    background: #c7c7c7;
                    border-radius: 999px;
                }

                .att-room-chip {
                    min-width: max-content;
                    border: none;
                    border-radius: 999px;
                    background: transparent;
                    padding: 5px 12px;
                    display: inline-flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    gap: 0;
                    transition: all 0.2s ease;
                    box-shadow: none;
                    white-space: nowrap;
                    color: #4b5563;
                }

                .att-room-chip:hover {
                    border-color: transparent;
                    color: var(--bs-primary);
                    background: transparent;
                }

                .att-room-chip.is-active {
                    border-color: transparent;
                    background: var(--bs-primary);
                    color: #ffffff;
                    box-shadow: none;
                }

                .att-room-chip-name {
                    font-size: 10px;
                    font-weight: 700;
                    line-height: 1.2;
                    color: inherit;
                    text-align: center;
                    text-transform: none;
                }

                .att-inline-status-pill {
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                    padding: 4px 9px;
                    border-radius: 999px;
                    border: 1px solid rgba(var(--bs-primary-rgb), 0.24);
                    background: rgba(var(--bs-primary-rgb), 0.12);
                    color: var(--bs-primary);
                    font-size: 11px;
                    font-weight: 700;
                }

                .att-inline-status-pill strong {
                    font-weight: 700;
                    letter-spacing: 0;
                }

                .att-inline-status-pill-warning {
                    background: rgba(var(--bs-warning-rgb), 0.2);
                    color: #7a5a1c;
                }

                .att-inline-status-pill i {
                    font-size: 12px;
                }

                .att-overview-shell {
                    margin-top: 4px;
                    display: grid;
                    grid-template-columns: minmax(0, 1.8fr) minmax(210px, 0.75fr);
                    gap: 8px;
                    align-items: stretch;
                }

                .att-overview-left {
                    border: 1px solid #e8eef8;
                    border-radius: 12px;
                    background: #fbfdff;
                    padding: 8px;
                }

                .att-overview-meta {
                    margin-top: 7px;
                    display: flex;
                    flex-wrap: wrap;
                    gap: 6px;
                }

                .att-overview-right {
                    border: 1px solid #e8eef8;
                    border-radius: 14px;
                    background: #fbfdff;
                    padding: 7px;
                    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
                }

                .att-overview-right-title {
                    font-size: 12px;
                    font-weight: 700;
                    color: #1f2937;
                    margin: 0 0 6px;
                }

                .att-summary-grid {
                    display: grid;
                    /* 3 tiles (Present/Absent/On Leave) since Late was removed — a
                       single 3-across row instead of the old 2x2 grid, so there's
                       no empty cell dangling after the last tile. */
                    grid-template-columns: repeat(3, minmax(0, 1fr));
                    gap: 8px;
                }

                .att-summary-square {
                    min-height: 78px;
                    border-radius: 12px;
                    border: 1px solid #eef1f6;
                    background: #ffffff;
                    padding: 10px 4px 8px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 5px;
                    text-align: center;
                    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
                    transition: transform 0.15s ease, box-shadow 0.15s ease;
                }

                .att-summary-square:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 14px rgba(15, 23, 42, 0.1);
                }

                .att-summary-icon {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 15px;
                    line-height: 1;
                }

                .att-summary-square-label {
                    font-size: 10px;
                    font-weight: 700;
                    color: #6b7280;
                    text-transform: uppercase;
                    letter-spacing: 0.03em;
                    line-height: 1;
                }

                .att-summary-square strong {
                    font-size: 20px;
                    font-weight: 800;
                    line-height: 1;
                }

                .att-summary-square.att-stat-primary .att-summary-icon {
                    background: rgba(13, 110, 253, 0.12);
                    color: #0d6efd;
                }

                .att-summary-square.att-stat-primary strong {
                    color: #0d6efd;
                }

                .att-summary-square.att-stat-danger .att-summary-icon {
                    background: rgba(220, 38, 38, 0.12);
                    color: #dc2626;
                }

                .att-summary-square.att-stat-danger strong {
                    color: #dc2626;
                }

                .att-summary-square.att-stat-warning .att-summary-icon {
                    background: rgba(245, 158, 11, 0.14);
                    color: #d97706;
                }

                .att-summary-square.att-stat-warning strong {
                    color: #d97706;
                }

                .att-summary-square.att-stat-secondary .att-summary-icon {
                    background: rgba(100, 116, 139, 0.14);
                    color: #64748b;
                }

                .att-summary-square.att-stat-secondary strong {
                    color: #475569;
                }

                .att-summary-right {
                    border: 1px solid #e8eef8;
                    border-radius: 10px;
                    background: #fbfdff;
                    padding: 8px;
                    display: grid;
                    gap: 6px;
                    align-content: start;
                }

                .att-summary-right-item {
                    min-height: 28px;
                    border-radius: 999px;
                    border: none;
                    background: #ffffff;
                    padding: 4px 9px;
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                    font-size: 10px;
                    font-weight: 600;
                    color: #445269;
                }

                .att-summary-right-item i {
                    font-size: 12px;
                }

                .att-summary-right-total {
                    justify-content: space-between;
                    background: rgba(var(--bs-primary-rgb), 0.08);
                    color: var(--bs-primary);
                }

                .att-summary-right-total strong {
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 1;
                }

                .att-summary-chip-time {
                    border-color: transparent;
                    background: rgba(var(--bs-primary-rgb), 0.08);
                    color: var(--bs-primary);
                }

                .att-summary-chip-view {
                    border-color: transparent;
                    background: rgba(var(--bs-warning-rgb), 0.14);
                    color: #7a5a1c;
                }

                .att-summary-chip-editable {
                    border-color: transparent;
                    background: rgba(var(--bs-success-rgb), 0.12);
                    color: var(--bs-success);
                }

                @media (max-width: 991.98px) {
                    .att-overview-shell {
                        grid-template-columns: 1fr;
                    }
                }

                .att-summary-chip-stat {
                    min-width: 112px;
                    justify-content: space-between;
                }

                .att-stat-inline-list {
                    margin-top: 4px;
                    display: grid;
                    grid-template-columns: repeat(4, minmax(0, 1fr));
                    gap: 5px;
                }

                .att-stat-inline-item {
                    border: 1px solid rgba(15, 23, 42, 0.1);
                    border-radius: 999px;
                    padding: 4px 8px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    min-height: 34px;
                    background: #ffffff;
                }

                .att-stat-inline-left {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    min-width: 0;
                }

                .att-stat-dot {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    flex: 0 0 auto;
                }

                .att-stat-inline-label {
                    font-size: 11px;
                    font-weight: 600;
                    color: #55637a;
                    line-height: 1;
                    margin: 0;
                }

                .att-stat-inline-item strong {
                    font-size: 14px;
                    line-height: 1;
                }

                .att-stat-primary .att-stat-dot {
                    background: var(--bs-primary);
                }

                .att-stat-danger .att-stat-dot {
                    background: var(--bs-danger);
                }

                .att-stat-warning .att-stat-dot {
                    background: var(--bs-warning);
                }

                .att-stat-secondary .att-stat-dot {
                    background: var(--bs-secondary);
                }

                .att-room-empty-state {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                    min-height: 52px;
                    border: none;
                    border-radius: 12px;
                    background: rgba(var(--bs-primary-rgb), 0.05);
                    color: #6b7280;
                    font-size: 11px;
                    font-weight: 600;
                }

                .att-stat-num {
                    font-size: 18px !important;
                    font-weight: 700 !important;
                    line-height: 1;
                    font-variant-numeric: tabular-nums;
                }

                .att-stat-tile {
                    min-height: 58px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    gap: 4px;
                    border-radius: 9px;
                    border: 1px solid transparent;
                    padding: 5px 6px;
                }

                .att-stat-top {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                }

                .att-stat-content {
                    display: flex;
                    justify-content: flex-start;
                    width: 100%;
                    line-height: 1;
                }

                .att-stat-icon {
                    width: 20px;
                    height: 20px;
                    border-radius: 6px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    background: #ffffff;
                    border: 1px solid rgba(20, 31, 56, 0.08);
                    font-size: 12px;
                    flex: 0 0 auto;
                }

                .att-stat-primary {
                    background: rgba(var(--bs-primary-rgb), 0.08);
                    border-color: rgba(var(--bs-primary-rgb), 0.2);
                }

                .att-stat-danger {
                    background: rgba(var(--bs-danger-rgb), 0.08);
                    border-color: rgba(var(--bs-danger-rgb), 0.2);
                }

                .att-stat-warning {
                    background: rgba(var(--bs-warning-rgb), 0.14);
                    border-color: rgba(var(--bs-warning-rgb), 0.28);
                }

                .att-stat-secondary {
                    background: rgba(var(--bs-secondary-rgb), 0.12);
                    border-color: rgba(var(--bs-secondary-rgb), 0.24);
                }

                .att-stat-label {
                    font-size: 9px !important;
                    font-weight: 600;
                    text-transform: none;
                    letter-spacing: 0;
                    color: #55637a !important;
                }

                /* ── Attendance responsive overrides ── */
                @media (max-width: 575px) {
                    .att-top-card {
                        height: auto;
                    }

                    .att-page-wrap { padding: 0 !important; }
                    .att-content-page { padding-left: 0 !important; padding-right: 0 !important; }

                    .att-top-card .card-header {
                        padding: 5px 7px !important;
                    }

                    .att-top-card .card-body {
                        padding: 4px 7px !important;
                    }

                    .att-date-panel,
                    .att-room-panel {
                        border-radius: 10px !important;
                        padding: 4px !important;
                    }

                    .att-room-scroll-wrap {
                        border-radius: 999px !important;
                        padding: 2px 3px !important;
                    }

                    .att-date-panel-row,
                    .att-room-panel-header {
                        flex-direction: column !important;
                        align-items: stretch !important;
                    }

                    .att-date-value {
                        font-size: 13px !important;
                    }

                    .att-date-change-btn {
                        width: 26px !important;
                        height: 26px !important;
                        margin-left: auto !important;
                        justify-content: center !important;
                    }

                    .att-room-chip { min-width: max-content !important; padding: 3px 7px !important; }

                    .att-summary-chip {
                        min-height: 32px;
                        font-size: 11px;
                    }

                    .att-summary-chip-stat {
                        min-width: 104px;
                    }

                    /* Student row */
                    .att-student-row { padding: 9px 10px !important; gap: 7px !important; }
                    .att-avatar     { width: 40px !important; height: 40px !important; }
                    .att-name       { font-size: 12px !important; }
                    .att-roll       { font-size: 9px !important; }
                    .att-btn-round  { width: 26px !important; height: 26px !important; font-size: 12px !important; }
                    .att-exit-btn   { font-size: 10px !important; padding: 3px 6px !important; gap: 2px !important; }
                    .att-expand-btn { width: 26px !important; height: 26px !important; }

                    /* Date selector schedule/lock alerts */
                    .att-date-alerts { flex-direction: column !important; }

                    /* Stats cards – keep 2×2 grid */
                    .att-stat-icon { width: 22px !important; height: 22px !important; font-size: 12px !important; }
                    .att-stat-num  { font-size: 16px !important; }

                    /* Expandable action buttons strip */
                    .att-actions-strip { padding: 7px 8px !important; gap: 5px !important; }
                    .att-actions-strip::-webkit-scrollbar { display: none; }

                    /* Save button */
                    .att-save-btn   { font-size: 13px !important; }

                    /* Search bar */
                    .att-search-bar { padding: 8px 10px !important; }
                }

                @media (max-width: 360px) {
                    .att-student-row { padding: 7px 8px !important; gap: 5px !important; }
                    .att-avatar      { width: 34px !important; height: 34px !important; }
                    .att-btn-round   { width: 24px !important; height: 24px !important; font-size: 11px !important; }
                }

                @media (min-width: 576px) and (max-width: 767px) {
                    .att-student-row { padding: 10px 12px !important; gap: 8px !important; }
                }

                /* Prevent registration modal from sitting under fixed header */
                .att-registration-dialog {
                    margin-top: 84px !important;
                }

                /* Keep observation modal below sticky site header and above page content */
                .att-observation-dialog {
                    margin-top: 84px !important;
                    z-index: 1061 !important;
                }

                .att-observation-backdrop {
                    z-index: 1055 !important;
                }

                .att-observation-modal {
                    z-index: 1060 !important;
                }

                .att-observation-modal .modal-content {
                    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.25) !important;
                }

                /* Assign game modal close button alignment */
                .att-game-dialog .modal-header {
                    position: relative;
                }

                .att-game-dialog .modal-header .btn-close {
                    position: absolute;
                    top: 50%;
                    right: 16px;
                    transform: translateY(-50%);
                    margin: 0 !important;
                    padding: 0.35rem !important;
                }

                /* Room management modal close button alignment */
                .att-room-modal-dialog .modal-header {
                    position: relative;
                }

                .att-room-modal-dialog .modal-header .btn-close {
                    position: absolute;
                    top: 50%;
                    right: 16px;
                    transform: translateY(-50%);
                    margin: 0 !important;
                    padding: 0.35rem !important;
                }

                /* Keep room management modal below the sticky site header and
                   fully within the viewport — body scrolls internally
                   (via the scrollable prop) instead of the dialog
                   overflowing past the bottom of the screen. */
                .att-room-modal-dialog {
                    margin-top: 84px !important;
                    margin-bottom: 24px !important;
                }

                .att-room-modal-dialog.modal-dialog-scrollable {
                    height: calc(100vh - 108px) !important;
                }

                @media (max-width: 767px) {
                    .att-room-modal-dialog {
                        margin-top: 68px !important;
                        margin-bottom: 16px !important;
                    }

                    .att-room-modal-dialog.modal-dialog-scrollable {
                        height: calc(100vh - 84px) !important;
                    }
                }

                @media (max-width: 767px) {
                    .att-registration-dialog {
                        margin-top: 72px !important;
                    }

                    .att-observation-dialog {
                        margin-top: 68px !important;
                    }
                }

                /* Student list action buttons: force readable white text/icon on interaction */
                .att-actions-strip .btn:hover,
                .att-actions-strip .btn:focus,
                .att-actions-strip .btn:active,
                .att-actions-strip .btn.active {
                    color: #ffffff !important;
                }

                .att-actions-strip .btn:hover span,
                .att-actions-strip .btn:focus span,
                .att-actions-strip .btn:active span,
                .att-actions-strip .btn.active span,
                .att-actions-strip .btn:hover i,
                .att-actions-strip .btn:focus i,
                .att-actions-strip .btn:active i,
                .att-actions-strip .btn.active i {
                    color: #ffffff !important;
                }

                /* Observation modal HDLH button contrast tuning */
                .att-hdlh-btn {
                    color: #166534 !important;
                    border-color: #22c55e !important;
                    background: #f0fdf4 !important;
                    transition: all 0.2s ease !important;
                }

                .att-hdlh-btn:hover,
                .att-hdlh-btn:focus,
                .att-hdlh-btn:active,
                .att-hdlh-btn.active,
                .show > .att-hdlh-btn.dropdown-toggle {
                    color: #166534 !important;
                    border-color: #22c55e !important;
                    background: #f0fdf4 !important;
                    box-shadow: none !important;
                }

                .att-hdlh-btn:hover i,
                .att-hdlh-btn:focus i,
                .att-hdlh-btn:active i,
                .att-hdlh-btn.active i {
                    color: #166534 !important;
                }

                /* Attendance modal theme consistency */
                .modal .btn-primary,
                .modal .btn-success,
                .modal .btn-danger,
                .modal .btn-warning,
                .modal .btn-info {
                    color: #ffffff !important;
                    background-color: var(--bs-primary, #0d6efd) !important;
                    border-color: var(--bs-primary, #0d6efd) !important;
                }

                .modal .btn-primary:hover,
                .modal .btn-success:hover,
                .modal .btn-danger:hover,
                .modal .btn-warning:hover,
                .modal .btn-info:hover,
                .modal .btn-primary:focus,
                .modal .btn-success:focus,
                .modal .btn-danger:focus,
                .modal .btn-warning:focus,
                .modal .btn-info:focus,
                .modal .btn-primary:active,
                .modal .btn-success:active,
                .modal .btn-danger:active,
                .modal .btn-warning:active,
                .modal .btn-info:active {
                    color: #ffffff !important;
                    background-color: var(--bs-btn-hover-bg, #0b5ed7) !important;
                    border-color: var(--bs-btn-hover-border-color, #0a58ca) !important;
                }

                .modal .btn-outline-primary,
                .modal .btn-outline-secondary,
                .modal .btn-outline-success,
                .modal .btn-outline-danger,
                .modal .btn-outline-warning,
                .modal .btn-outline-info {
                    color: var(--bs-primary, #0d6efd) !important;
                    border-color: var(--bs-primary, #0d6efd) !important;
                }

                .modal .btn-outline-primary:hover,
                .modal .btn-outline-secondary:hover,
                .modal .btn-outline-success:hover,
                .modal .btn-outline-danger:hover,
                .modal .btn-outline-warning:hover,
                .modal .btn-outline-info:hover,
                .modal .btn-outline-primary:focus,
                .modal .btn-outline-secondary:focus,
                .modal .btn-outline-success:focus,
                .modal .btn-outline-danger:focus,
                .modal .btn-outline-warning:focus,
                .modal .btn-outline-info:focus,
                .modal .btn-outline-primary:active,
                .modal .btn-outline-secondary:active,
                .modal .btn-outline-success:active,
                .modal .btn-outline-danger:active,
                .modal .btn-outline-warning:active,
                .modal .btn-outline-info:active {
                    color: #ffffff !important;
                    background-color: var(--bs-primary, #0d6efd) !important;
                    border-color: var(--bs-primary, #0d6efd) !important;
                }
            `}</style>
            <div id='content-page' className='content-page att-content-page'>
                <Container fluid="xl" className="px-2 px-sm-3 px-md-4 att-page-wrap">
                    <Announcement maxWidth="100%" outerPadding="12px 0 6px" showAuthorMeta={false} showCloseButton={true} />
                    {loading ? (
                        <Row>
                            <Col lg={12}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minHeight: '400px',
                                    background: '#ffffff',
                                    borderRadius: '8px'
                                }}>
                                    <img src={loader} alt="loader" style={{ height: "100px" }} />
                                    <p style={{
                                        color: '#6c757d',
                                        fontSize: '14px',
                                        marginTop: '16px'
                                    }}>
                                        Loading attendance...
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    ) : (
                        <>
                            <Row className="g-2 g-md-3 mb-1 mb-md-2 att-top-row">
                                <Col xs={12}>
                                    {renderDateSelector()}
                                </Col>
                            </Row>
                            <Row className="g-2 g-md-3">
                                <Col xs={12}>
                                    {renderStudentsPanel()}
                                </Col>
                            </Row>
                        </>
                    )}
                    {renderEmergencyContactsModal()}
                    {renderObservationModal()}
                    {renderObservationPickerModal()}
                    {renderExitTimeModal()}
                    {renderAttendanceTimeModal()}
                    {renderPresentConfirmModal()}
                    {renderDailyReportModal()}
                    {renderDailyReportFormModal()}
                    <MedicationModal
                        show={showMedicationModal}
                        onHide={() => setShowMedicationModal(false)}
                        studentId={selectedStudent?.id}
                        studentName={selectedStudent?.name}
                    />
                    <NonMedicationModal
                        show={showNonMedicationModal}
                        onHide={() => setShowNonMedicationModal(false)}
                        studentId={selectedStudent?.id}
                        studentName={selectedStudent?.name}
                    />
                    {renderMeditationModal()}
                    <AllergyModal
                        show={showAllergyModal}
                        onHide={() => {
                            setShowAllergyModal(false);
                            if (document.activeElement) {
                                document.activeElement.blur();
                            }
                        }}
                        studentId={selectedStudent?.id}
                        studentName={selectedStudent?.name}
                    />
                    <RegistrationDetailModal 
                        show={showRegistrationModal}
                        onHide={() => {
                            setShowRegistrationModal(false);
                            setRegistrationData(null);
                            setRegistrationLoading(false);
                            if (document.activeElement) {
                                document.activeElement.blur();
                            }
                        }}
                        data={registrationData}
                        loading={registrationLoading}
                        showEditButton={false}
                        dialogClassName="att-registration-dialog"
                    />
                    <PeanutPolicyModal
                        show={showPeanutPolicyModal}
                        onHide={() => setShowPeanutPolicyModal(false)}
                        studentId={selectedStudent?.id}
                        studentName={selectedStudent?.name}
                    />
                    <LunchPlanWaiverModal
                        show={showLunchPlanModal}
                        onHide={() => setShowLunchPlanModal(false)}
                        studentId={selectedStudent?.id}
                        studentName={selectedStudent?.name}
                    />
                    {renderGameModal()}
                    {renderGameStatsModal()}
                    <TeacherWeeklyReportModal
                        show={showWeeklyReportModal}
                        onHide={closeWeeklyReports}
                        studentName={selectedStudent?.name}
                        reports={weeklyReports}
                        onReportsChange={setWeeklyReports}
                    />
                    {renderRoomModal()}
                    {renderObservationViewModal()}
                    {renderAccidentReportsModal()}
                    {renderIllnessReportsModal()}
                    {renderAccidentSignatureModal()}
                    {renderIllnessSignatureModal()}
                    {renderCreateAccidentModal()}
                    {renderCreateIllnessModal()}
                    <AIContentCreatorModal
                        show={showAIContentModal}
                        onHide={() => setShowAIContentModal(false)}
                        onApply={handleApplyAIContent}
                        title={aiModalConfig.title}
                        targetLabel={aiModalConfig.targetLabel}
                        defaultKeywords={aiModalConfig.defaultKeywords}
                        generateEndpoint={aiModalConfig.generateEndpoint}
                        responseContentKey={aiModalConfig.responseContentKey}
                        extraPayload={aiModalConfig.extraPayload}
                    />
                </Container>
            </div>
        </>
    );
};

export default AttendancePage;
